/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return _extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  _extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var BoxKind;
(function (BoxKind) {
  BoxKind[BoxKind["Document"] = 0] = "Document";
  BoxKind[BoxKind["Column"] = 1] = "Column";
  BoxKind[BoxKind["TextPage"] = 2] = "TextPage";
  BoxKind[BoxKind["Paragraph"] = 3] = "Paragraph";
  BoxKind[BoxKind["BlockContainer"] = 4] = "BlockContainer";
  BoxKind[BoxKind["InlineContainer"] = 5] = "InlineContainer";
  BoxKind[BoxKind["TextLine"] = 6] = "TextLine";
  BoxKind[BoxKind["Text"] = 7] = "Text";
  BoxKind[BoxKind["Inline"] = 8] = "Inline";
})(BoxKind || (BoxKind = {}));
var Point$1 = function () {
  function Point(point) {
    if (point === void 0) {
      point = {
        x: 0,
        y: 0
      };
    }
    this.x = 0;
    this.y = 0;
    this.x = point.x;
    this.y = point.y;
  }
  Point.prototype.offset = function (dx, dy) {
    this.x += dx;
    this.y += dy;
  };
  return Point;
}();
var Size = function () {
  function Size(size) {
    if (size === void 0) {
      size = {
        width: 0,
        height: 0
      };
    }
    this.width = 0;
    this.height = 0;
    this.width = size.width;
    this.height = size.height;
  }
  Size.zeroSize = function () {
    return new Size();
  };
  Size.prototype.clone = function () {
    return new Size(this);
  };
  Size.prototype.isZero = function () {
    return this.width === 0 && this.height === 0;
  };
  return Size;
}();
var Rect = function () {
  function Rect(rect) {
    if (rect === void 0) {
      rect = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    } // inner point

    this.x = 0;
    this.y = 0; // inner size

    this.width = 0;
    this.height = 0;
    this.x = rect.x;
    this.y = rect.y;
    this.width = rect.width;
    this.height = rect.height;
  }
  Rect.zeroRect = function () {
    return new Rect();
  };
  Rect.prototype.clone = function () {
    return new Rect(this);
  };
  Rect.prototype.isZero = function () {
    return this.width === 0 && this.height === 0;
  };
  Rect.prototype.getLeftTop = function () {
    return new Point$1(this);
  };
  Rect.prototype.getSize = function () {
    return new Size(this);
  };
  Rect.prototype.getRight = function () {
    return this.x + this.width;
  };
  Rect.prototype.getBottom = function () {
    return this.y + this.height;
  };
  Rect.prototype.offset = function (dx, dy) {
    this.x += dx;
    this.y += dy;
  };
  /**
   * 判断是否包含
   * @param point 坐标点
   */

  Rect.prototype.contains = function (point) {
    return point.x >= this.x && point.x <= this.getRight() && point.y >= this.y && point.y <= this.getBottom();
  };
  /**
   * 判断是否与指定区域有交集
   * @param rect 区域
   */

  Rect.prototype.intersect = function (rect) {
    return rect.getRight() >= this.x && this.getRight() >= rect.x && rect.getBottom() >= this.y && this.getBottom() >= rect.y;
  };
  return Rect;
}();

/**
 * 遍历 layoutBox 数组及其子节点，执行 handler 对象中对应的方法
 * @param layoutBoxes
 * @param handler
 */

function traverseLayoutBoxesWithHandlers(layoutBoxes, handler, offset, path) {
  if (offset === void 0) {
    offset = {
      x: 0,
      y: 0
    };
  }
  if (path === void 0) {
    path = [];
  }
  layoutBoxes.forEach(function (layoutBox, index) {
    traverseLayoutBoxWithHandlers(layoutBox, handler, offset, __spreadArray(__spreadArray([], __read(path)), [index]));
  });
}
/**
 * 遍历 layoutBox 及其子节点，执行 handler 对象中对应的方法
 * @param layoutBox
 * @param handler
 */

function traverseLayoutBoxWithHandlers(layoutBox, handler, offset, path) {
  var _a, _b, _c, _d;
  if (offset === void 0) {
    offset = {
      x: 0,
      y: 0
    };
  }
  if (path === void 0) {
    path = [];
  }
  var kind = layoutBox.kind,
    _e = layoutBox.rect,
    rect = _e === void 0 ? Rect.zeroRect() : _e;
  switch (kind) {
    case BoxKind.Column:
      {
        (_a = handler[BoxKind.Column]) === null || _a === void 0 ? void 0 : _a.call(handler, layoutBox, offset, path);
        break;
      }
    case BoxKind.Paragraph:
      {
        (_b = handler[BoxKind.Paragraph]) === null || _b === void 0 ? void 0 : _b.call(handler, layoutBox, offset, path);
        break;
      }
    case BoxKind.TextLine:
      {
        (_c = handler[BoxKind.TextLine]) === null || _c === void 0 ? void 0 : _c.call(handler, layoutBox, offset, path);
        break;
      }
    case BoxKind.Text:
      {
        (_d = handler[BoxKind.Text]) === null || _d === void 0 ? void 0 : _d.call(handler, layoutBox, offset, path);
        break;
      }
  }
  if ('children' in layoutBox) {
    var newOffset = {
      x: offset.x + rect.x,
      y: offset.y + rect.y
    };
    traverseLayoutBoxesWithHandlers(layoutBox.children, handler, newOffset, path);
  }
}
function styleInject$1(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = "@charset \"UTF-8\";\ncanvas {\n  /* chrome 120 版本之后新增的样式（https://developer.chrome.com/blog/css-i18n-features?hl=zh-cn#cjk_punctuation_kerning_text-spacing-trim）*/\n  /* 这个样式是用于控制多个连续的 CJK 标点符号渲染时额外空间的压缩情况，默认是会压缩，具体规则：https://drafts.csswg.org/css-text-4/#text-spacing-trim-property */\n  /* 按照默认设置，在测量多个连续的 CJK 标点符号时，拆开测量后相加和统一测量最终的宽度会不一致，而目前排版时的测量单位是由数据中文字节点决定的，\n     这样就导致相同的字符串在不同的节点拆分情况下测量结果不一致，同理也影响了文本光标和选区位置的计算 */\n  /* 所以目前统一都设置为不压缩，在测量和渲染上表现和 chrome 120 之前一致 */\n  text-spacing-trim: space-all;\n}";
styleInject$1(css_248z);
var LayoutUnit;
(function (LayoutUnit) {
  LayoutUnit[LayoutUnit["TWIPS"] = 0] = "TWIPS";
  LayoutUnit[LayoutUnit["PX"] = 1] = "PX";
})(LayoutUnit || (LayoutUnit = {}));
/**
 * 坐标原点位置
 */

var CoordinateZero;
(function (CoordinateZero) {
  CoordinateZero[CoordinateZero["LEFT_TOP"] = 0] = "LEFT_TOP";
  CoordinateZero[CoordinateZero["RIGHT_TOP"] = 1] = "RIGHT_TOP";
  CoordinateZero[CoordinateZero["RIGHT_BOTTOM"] = 2] = "RIGHT_BOTTOM";
  CoordinateZero[CoordinateZero["LEFT_BOTTOM"] = 3] = "LEFT_BOTTOM";
})(CoordinateZero || (CoordinateZero = {}));
/**
 * 行扩张的方向，也就是从第一行到第二行是往哪个方向延伸的
 */

var LineExpandDirection;
(function (LineExpandDirection) {
  LineExpandDirection["HORIZONTAL"] = "horizontal";
  LineExpandDirection["VERTICAL"] = "vertical";
})(LineExpandDirection || (LineExpandDirection = {}));
/**
 * 因在某些方面 word 和 ppt有较大差异，如项目编号
 * 因此需要做品类区分
 */

var DocType;
(function (DocType) {
  DocType[DocType["WORD"] = 0] = "WORD";
  DocType[DocType["PPT"] = 1] = "PPT";
})(DocType || (DocType = {}));
var PropertyBag = function () {
  function PropertyBag(otherMap) {
    this.propType = null;
    if (otherMap) {
      this.bagMap = _assign({}, otherMap);
    } else {
      this.bagMap = {};
    }
  }
  Object.defineProperty(PropertyBag.prototype, "propertyType", {
    get: function get() {
      return this.propType;
    },
    set: function set(type) {
      this.propType = type;
    },
    enumerable: false,
    configurable: true
  });
  PropertyBag.prototype.get = function (key, defaultValue) {
    var val = this.bagMap[key];
    return val !== undefined ? val : defaultValue;
  };
  PropertyBag.prototype.set = function (key, value) {
    this.bagMap[key] = value;
    return this;
  };
  PropertyBag.prototype.has = function (key) {
    return this.bagMap[key] !== undefined;
  };
  PropertyBag.prototype["delete"] = function (key) {
    var result = this.has(key);
    if (result) {
      this.bagMap[key] = undefined;
    }
    return result;
  };
  Object.defineProperty(PropertyBag.prototype, "size", {
    get: function get() {
      var count = 0; // eslint-disable-next-line no-restricted-syntax

      for (var key in this.bagMap) {
        if (this.has(key)) {
          count += 1;
        }
      }
      return count;
    },
    enumerable: false,
    configurable: true
  });
  return PropertyBag;
}();
var BaseProperty = function () {
  function BaseProperty(otherProp) {
    if (otherProp) {
      this.propBag = otherProp;
    } else {
      this.propBag = new PropertyBag();
    }
  }
  BaseProperty.prototype.getPropBag = function () {
    return this.propBag;
  };
  BaseProperty.prototype.has = function (key) {
    return this.propBag.has(key);
  };
  BaseProperty.prototype["delete"] = function (key) {
    return this.propBag["delete"](key);
  };
  return BaseProperty;
}();
var CommonPropKey;
(function (CommonPropKey) {
  CommonPropKey["hidden"] = "common_hidden";
  CommonPropKey["propId"] = "prop_id_data";
})(CommonPropKey || (CommonPropKey = {}));
var CommonProperty = function (_super) {
  __extends(CommonProperty, _super);
  function CommonProperty() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(CommonProperty.prototype, "hidden", {
    // hidden：标识当前层属性是否隐藏
    get: function get() {
      return this.propBag.get(CommonPropKey.hidden, false);
    },
    set: function set(val) {
      this.propBag.set(CommonPropKey.hidden, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonProperty.prototype, "propId", {
    get: function get() {
      return this.propBag.get(CommonPropKey.propId, '');
    },
    set: function set(val) {
      this.propBag.set(CommonPropKey.propId, val);
    },
    enumerable: false,
    configurable: true
  });
  return CommonProperty;
}(BaseProperty);
var ListType;
(function (ListType) {
  ListType[ListType["Bullet"] = 0] = "Bullet";
  ListType[ListType["Numbered"] = 1] = "Numbered";
  ListType[ListType["Task"] = 2] = "Task";
  ListType[ListType["None"] = 3] = "None";
})(ListType || (ListType = {}));
var STTaskState;
(function (STTaskState) {
  STTaskState["undefined"] = "STTaskState_undefined";
  STTaskState["todo"] = "STTaskState_todo";
  STTaskState["done"] = "STTaskState_done";
})(STTaskState || (STTaskState = {}));
var TaskStateChar;
(function (TaskStateChar) {
  TaskStateChar["Done"] = "\u2611";
  TaskStateChar["Todo"] = "\u2610";
})(TaskStateChar || (TaskStateChar = {}));
var STNumberFormat;
(function (STNumberFormat) {
  STNumberFormat["undefined"] = "STNumberFormat_undefined";
  STNumberFormat["decimal"] = "STNumberFormat_decimal";
  STNumberFormat["upperRoman"] = "STNumberFormat_upperRoman";
  STNumberFormat["lowerRoman"] = "STNumberFormat_lowerRoman";
  STNumberFormat["upperLetter"] = "STNumberFormat_upperLetter";
  STNumberFormat["lowerLetter"] = "STNumberFormat_lowerLetter";
  STNumberFormat["ordinal"] = "STNumberFormat_ordinal";
  STNumberFormat["cardinalText"] = "STNumberFormat_cardinalText";
  STNumberFormat["ordinalText"] = "STNumberFormat_ordinalText";
  STNumberFormat["hex"] = "STNumberFormat_hex";
  STNumberFormat["chicago"] = "STNumberFormat_chicago";
  STNumberFormat["ideographDigital"] = "STNumberFormat_ideographDigital";
  STNumberFormat["japaneseCounting"] = "STNumberFormat_japaneseCounting";
  STNumberFormat["aiueo"] = "STNumberFormat_aiueo";
  STNumberFormat["iroha"] = "STNumberFormat_iroha";
  STNumberFormat["decimalFullWidth"] = "STNumberFormat_decimalFullWidth";
  STNumberFormat["decimalHalfWidth"] = "STNumberFormat_decimalHalfWidth";
  STNumberFormat["japaneseLegal"] = "STNumberFormat_japaneseLegal";
  STNumberFormat["japaneseDigitalTenThousand"] = "STNumberFormat_japaneseDigitalTenThousand";
  STNumberFormat["decimalEnclosedCircle"] = "STNumberFormat_decimalEnclosedCircle";
  STNumberFormat["decimalFullWidth2"] = "STNumberFormat_decimalFullWidth2";
  STNumberFormat["aiueoFullWidth"] = "STNumberFormat_aiueoFullWidth";
  STNumberFormat["irohaFullWidth"] = "STNumberFormat_irohaFullWidth";
  STNumberFormat["decimalZero"] = "STNumberFormat_decimalZero";
  STNumberFormat["bullet"] = "STNumberFormat_bullet";
  STNumberFormat["ganada"] = "STNumberFormat_ganada";
  STNumberFormat["chosung"] = "STNumberFormat_chosung";
  STNumberFormat["decimalEnclosedFullstop"] = "STNumberFormat_decimalEnclosedFullstop";
  STNumberFormat["decimalEnclosedParen"] = "STNumberFormat_decimalEnclosedParen";
  STNumberFormat["decimalEnclosedCircleChinese"] = "STNumberFormat_decimalEnclosedCircleChinese";
  STNumberFormat["ideographEnclosedCircle"] = "STNumberFormat_ideographEnclosedCircle";
  STNumberFormat["ideographTraditional"] = "STNumberFormat_ideographTraditional";
  STNumberFormat["ideographZodiac"] = "STNumberFormat_ideographZodiac";
  STNumberFormat["ideographZodiacTraditional"] = "STNumberFormat_ideographZodiacTraditional";
  STNumberFormat["taiwaneseCounting"] = "STNumberFormat_taiwaneseCounting";
  STNumberFormat["ideographLegalTraditional"] = "STNumberFormat_ideographLegalTraditional";
  STNumberFormat["taiwaneseCountingThousand"] = "STNumberFormat_taiwaneseCountingThousand";
  STNumberFormat["taiwaneseDigital"] = "STNumberFormat_taiwaneseDigital";
  STNumberFormat["chineseCounting"] = "STNumberFormat_chineseCounting";
  STNumberFormat["chineseLegalSimplified"] = "STNumberFormat_chineseLegalSimplified";
  STNumberFormat["chineseCountingThousand"] = "STNumberFormat_chineseCountingThousand";
  STNumberFormat["koreanDigital"] = "STNumberFormat_koreanDigital";
  STNumberFormat["koreanCounting"] = "STNumberFormat_koreanCounting";
  STNumberFormat["koreanLegal"] = "STNumberFormat_koreanLegal";
  STNumberFormat["koreanDigital2"] = "STNumberFormat_koreanDigital2";
  STNumberFormat["vietnameseCounting"] = "STNumberFormat_vietnameseCounting";
  STNumberFormat["russianLower"] = "STNumberFormat_russianLower";
  STNumberFormat["russianUpper"] = "STNumberFormat_russianUpper";
  STNumberFormat["none"] = "STNumberFormat_none";
  STNumberFormat["numberInDash"] = "STNumberFormat_numberInDash";
  STNumberFormat["hebrew1"] = "STNumberFormat_hebrew1";
  STNumberFormat["hebrew2"] = "STNumberFormat_hebrew2";
  STNumberFormat["arabicAlpha"] = "STNumberFormat_arabicAlpha";
  STNumberFormat["arabicAbjad"] = "STNumberFormat_arabicAbjad";
  STNumberFormat["hindiVowels"] = "STNumberFormat_hindiVowels";
  STNumberFormat["hindiConsonants"] = "STNumberFormat_hindiConsonants";
  STNumberFormat["hindiNumbers"] = "STNumberFormat_hindiNumbers";
  STNumberFormat["hindiCounting"] = "STNumberFormat_hindiCounting";
  STNumberFormat["thaiLetters"] = "STNumberFormat_thaiLetters";
  STNumberFormat["thaiNumbers"] = "STNumberFormat_thaiNumbers";
  STNumberFormat["thaiCounting"] = "STNumberFormat_thaiCounting";
  STNumberFormat["bahtText"] = "STNumberFormat_bahtText";
  STNumberFormat["dollarText"] = "STNumberFormat_dollarText";
  STNumberFormat["custom"] = "STNumberFormat_custom";
  STNumberFormat["task"] = "STNumberFormat_task";
})(STNumberFormat || (STNumberFormat = {}));

/**
 * 竖排类型
 */
var VerticalType;
(function (VerticalType) {
  VerticalType[VerticalType["Vertical"] = 1] = "Vertical";
  VerticalType[VerticalType["Vertical90"] = 2] = "Vertical90";
  VerticalType[VerticalType["Vertical270"] = 3] = "Vertical270";
  VerticalType[VerticalType["WordArtVerticalRtl"] = 4] = "WordArtVerticalRtl";
  VerticalType[VerticalType["WordArtVerticalLtr"] = 5] = "WordArtVerticalLtr";
})(VerticalType || (VerticalType = {}));
/**
 * 垂直文字位置，上，中，下
 */

var AnchorType;
(function (AnchorType) {
  AnchorType[AnchorType["Top"] = 1] = "Top";
  AnchorType[AnchorType["Center"] = 2] = "Center";
  AnchorType[AnchorType["Bottom"] = 3] = "Bottom";
})(AnchorType || (AnchorType = {}));
/** 对齐方式 */

var TextAlignmentType;
(function (TextAlignmentType) {
  /** 左对齐 */
  TextAlignmentType[TextAlignmentType["Left"] = 0] = "Left";
  /** 居中对齐 */

  TextAlignmentType[TextAlignmentType["Center"] = 1] = "Center";
  /** 右对齐 */

  TextAlignmentType[TextAlignmentType["Right"] = 2] = "Right";
  /** 两端对齐 */

  TextAlignmentType[TextAlignmentType["Justify"] = 3] = "Justify";
  /** 分散对齐 */

  TextAlignmentType[TextAlignmentType["Distribute"] = 4] = "Distribute";
})(TextAlignmentType || (TextAlignmentType = {}));
/** 行距类型 */

var LineSpacingType;
(function (LineSpacingType) {
  /** 倍数行距 */
  LineSpacingType[LineSpacingType["Multiple"] = 0] = "Multiple";
  /** 固定值 */

  LineSpacingType[LineSpacingType["Exactly"] = 1] = "Exactly";
  /** 最小值 */

  LineSpacingType[LineSpacingType["AtLeast"] = 2] = "AtLeast";
})(LineSpacingType || (LineSpacingType = {}));
var FontWeightType;
(function (FontWeightType) {
  FontWeightType[FontWeightType["normal"] = 400] = "normal";
  FontWeightType[FontWeightType["bold"] = 700] = "bold";
  FontWeightType[FontWeightType["Light"] = 300] = "Light";
  FontWeightType[FontWeightType["Medium"] = 500] = "Medium";
})(FontWeightType || (FontWeightType = {}));
/** 文本上下标 */

var SuperSubScriptType;
(function (SuperSubScriptType) {
  /** 无上下标 */
  SuperSubScriptType[SuperSubScriptType["None"] = 0] = "None";
  /** 上标 */

  SuperSubScriptType[SuperSubScriptType["Super"] = 1] = "Super";
  /** 下标 */

  SuperSubScriptType[SuperSubScriptType["Sub"] = 2] = "Sub";
})(SuperSubScriptType || (SuperSubScriptType = {}));
/** 断行规则 */

var WhiteSpaceType;
(function (WhiteSpaceType) {
  /** 默认情况，自动断行 */
  WhiteSpaceType[WhiteSpaceType["Normal"] = 0] = "Normal";
  /** 不自动断行 */

  WhiteSpaceType[WhiteSpaceType["Nowrap"] = 1] = "Nowrap";
  /** 不自动断行, 除非遇到强制换行符如\n等 */

  WhiteSpaceType[WhiteSpaceType["NowrapExceptForceBreak"] = 2] = "NowrapExceptForceBreak";
})(WhiteSpaceType || (WhiteSpaceType = {}));
/** 基线位置，基线不同返回的box的坐标不同 */

var TextBaselineType;
(function (TextBaselineType) {
  /** 默认情况，基于基线对齐 */
  TextBaselineType["Alphabetic"] = "alphabetic";
  /** 顶部对齐 */

  TextBaselineType["Top"] = "top";
})(TextBaselineType || (TextBaselineType = {}));
/** 单词断点规则 */

var WordBreakType;
(function (WordBreakType) {
  WordBreakType[WordBreakType["BreakAll"] = 0] = "BreakAll";
  WordBreakType[WordBreakType["BreakWord"] = 1] = "BreakWord";
  WordBreakType[WordBreakType["KeepAll"] = 2] = "KeepAll";
})(WordBreakType || (WordBreakType = {}));
/** 返回的Document box尺寸, 主要是inline方向 */

var DocSizeType;
(function (DocSizeType) {
  /** measure尺寸至少为传入尺寸大小，为默认值 */
  DocSizeType[DocSizeType["AtLeast"] = -1] = "AtLeast";
  /** measure尺寸为自身内容大小 */

  DocSizeType[DocSizeType["WrapContent"] = -2] = "WrapContent";
})(DocSizeType || (DocSizeType = {}));
/** 在计算文本宽度时，是否包含尾部空白的宽度。 */

var TailWhitespaceCalculation;
(function (TailWhitespaceCalculation) {
  /** 所有情况都包含 */
  TailWhitespaceCalculation["Include"] = "include";
  /** 所有情况都不包含 */

  TailWhitespaceCalculation["Exclude"] = "exclude";
  /** 根据 office 表现，在不换行时需要包括，在换行时需要忽略 */

  TailWhitespaceCalculation["Auto"] = "auto";
})(TailWhitespaceCalculation || (TailWhitespaceCalculation = {}));
var PropertyType;
(function (PropertyType) {
  PropertyType["DocumentProperty"] = "DocumentProperty";
  PropertyType["ParaProperty"] = "ParaProperty";
  PropertyType["TextSpan"] = "TextSpan";
  PropertyType["InLineProperty"] = "InlineProperty";
})(PropertyType || (PropertyType = {}));

/**
 * 排版数据类型定义，由调用方继承实现
 */
var LayoutInputNode = function () {
  function LayoutInputNode(nodeType, parent) {
    this.type = nodeType;
    this.parentNode = parent;
    this.rootNode = parent ? parent.rootNode : this;
  }
  LayoutInputNode.prototype.setParentNode = function (parentNode) {
    this.parentNode = parentNode;
    if (this.rootNode === this) {
      this.rootNode = parentNode.rootNode;
    }
  };
  LayoutInputNode.prototype.getType = function () {
    return this.type;
  };
  LayoutInputNode.prototype.getParentNode = function () {
    return this.parentNode;
  };
  LayoutInputNode.prototype.getRootNode = function () {
    return this.rootNode;
  };
  return LayoutInputNode;
}();
var LayoutInputNodeType;
(function (LayoutInputNodeType) {
  LayoutInputNodeType[LayoutInputNodeType["Document"] = 0] = "Document";
  LayoutInputNodeType[LayoutInputNodeType["Column"] = 1] = "Column";
  LayoutInputNodeType[LayoutInputNodeType["BlockContainer"] = 2] = "BlockContainer";
  LayoutInputNodeType[LayoutInputNodeType["Paragraph"] = 3] = "Paragraph";
  LayoutInputNodeType[LayoutInputNodeType["TextGroup"] = 4] = "TextGroup";
  LayoutInputNodeType[LayoutInputNodeType["Text"] = 5] = "Text";
  LayoutInputNodeType[LayoutInputNodeType["InLine"] = 6] = "InLine";
  LayoutInputNodeType[LayoutInputNodeType["Empty"] = 7] = "Empty";
})(LayoutInputNodeType || (LayoutInputNodeType = {}));

/**
 * 文档节点，属于根节点。正常情况获取文档节点即可获取整个文档内容。
 */

var DocumentNode = function (_super) {
  __extends(DocumentNode, _super);
  function DocumentNode() {
    return _super.call(this, LayoutInputNodeType.Document) || this;
  }
  DocumentNode.prototype.getNextSibling = function () {
    return null;
  };
  DocumentNode.prototype.getPrevSibling = function () {
    return null;
  };
  return DocumentNode;
}(LayoutInputNode);
var GroupNode = function (_super) {
  __extends(GroupNode, _super);
  function GroupNode(childNodes, nodeType, parent) {
    var _this = this;
    if (childNodes.length <= 0) {
      throw new Error('Group Node Must at least have one child node');
    }
    _this = _super.call(this, nodeType, parent) || this;
    childNodes.forEach(function (node) {
      node.setParentNode(_this);
    });
    _this.childNodes = childNodes;
    return _this;
  }
  GroupNode.prototype.getNextSibling = function () {
    return null;
  };
  GroupNode.prototype.getPrevSibling = function () {
    return null;
  };
  GroupNode.prototype.getProperty = function () {
    var parent = this.getParentNode();
    return parent ? parent.getProperty() : null;
  };
  GroupNode.prototype.getBeginChild = function () {
    return this.childNodes[0];
  };
  GroupNode.prototype.getChildNodeNextSibling = function (childNode) {
    var childIndex = this.childNodes.indexOf(childNode);
    if (childIndex >= 0 && childIndex < this.childNodes.length - 1) {
      return this.childNodes[childIndex + 1];
    }
    return null;
  };
  GroupNode.prototype.getChildNodePrevSibling = function (childNode) {
    var childIndex = this.childNodes.indexOf(childNode);
    if (childIndex >= 1 && childIndex < this.childNodes.length) {
      return this.childNodes[childIndex - 1];
    }
    return null;
  };
  return GroupNode;
}(LayoutInputNode);
var LeafNode = function (_super) {
  __extends(LeafNode, _super);
  function LeafNode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 排版时会在paraNode和LeafNode之间动态添加一层TextGroupNode。
   * 所以指向parent时需要再多向上找一层。如果想找TextGroupNode直接指向parent即可
   */

  LeafNode.prototype.getParentNode = function () {
    var parent = _super.prototype.getParentNode.call(this);
    if (parent instanceof GroupNode) {
      return parent.getParentNode();
    }
    return parent;
  };
  LeafNode.prototype.getGroupNode = function () {
    return _super.prototype.getParentNode.call(this);
  };
  LeafNode.prototype.getBeginChild = function () {
    return null;
  };
  Object.defineProperty(LeafNode.prototype, "range", {
    get: function get() {
      return this.mRange;
    },
    set: function set(r) {
      this.mRange = r;
    },
    enumerable: false,
    configurable: true
  });
  return LeafNode;
}(LayoutInputNode);

/**
 * 文本节点
 */

var TextNode = function (_super) {
  __extends(TextNode, _super);
  function TextNode(parent) {
    return _super.call(this, LayoutInputNodeType.Text, parent) || this;
  }
  return TextNode;
}(LeafNode);
var InlineNodeType;
(function (InlineNodeType) {
  InlineNodeType[InlineNodeType["InlinePictrue"] = 0] = "InlinePictrue";
  InlineNodeType[InlineNodeType["InlineShape"] = 1] = "InlineShape";
  InlineNodeType[InlineNodeType["InlineFormula"] = 2] = "InlineFormula";
})(InlineNodeType || (InlineNodeType = {}));
/**
 * 内联节点
 */

var InlineNode = function (_super) {
  __extends(InlineNode, _super);
  function InlineNode(parent) {
    return _super.call(this, LayoutInputNodeType.InLine, parent) || this;
  }
  InlineNode.prototype.getText = function () {
    return '*'; // 默认占位符
  };
  InlineNode.prototype.getDrawingSrc = function () {
    return this.getInlineProperty().drawingSrc;
  };
  /**
   * 获取当前节点尺寸
   */

  InlineNode.prototype.getContainerSize = function () {
    var containerSize = this.getInlineProperty().containerSize;
    if (this.getInlineProperty().baselineOffset) {
      containerSize = {
        width: containerSize.width *= TextBaselineFontScale,
        height: containerSize.height *= TextBaselineFontScale
      };
    }
    return new Size(containerSize);
  };
  InlineNode.prototype.isRotateInVertLayout = function () {
    return this.getInlineProperty().isRotateInVertLayout;
  };
  InlineNode.prototype.getInlineType = function () {
    return this.getInlineProperty().inlineType;
  };
  /**
   * 获取当前节点的margin
   */

  InlineNode.prototype.getContainerMargin = function () {
    return this.getInlineProperty().containerMargin;
  };
  return InlineNode;
}(LeafNode);
var TextGroupNode = function (_super) {
  __extends(TextGroupNode, _super);
  function TextGroupNode(childNodes, parent) {
    return _super.call(this, childNodes, LayoutInputNodeType.TextGroup, parent) || this;
  }
  /**
   * 获取group节点中所有文本
   */

  TextGroupNode.prototype.getTextContent = function () {
    var e_1, _a;
    var content = '';
    try {
      for (var _b = __values(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var node = _c.value;
        content += node.getText();
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return content;
  };
  /**
   * 获取第一个指定类型的child
   */

  TextGroupNode.prototype.getFirstChild = function () {
    var first = this.getBeginChild();
    return first;
  };
  return TextGroupNode;
}(GroupNode);

/**
 * 块节点，类似div
 */

var BlockNode = function (_super) {
  __extends(BlockNode, _super);
  function BlockNode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return BlockNode;
}(LayoutInputNode);

/**
 * 段落节点。特殊的块节点
 */

var ParagraphNode = function (_super) {
  __extends(ParagraphNode, _super);
  function ParagraphNode(parent) {
    return _super.call(this, LayoutInputNodeType.Paragraph, parent) || this;
  }
  return ParagraphNode;
}(BlockNode);

/**
 * 块容器
 */

(function (_super) {
  __extends(BlockContainerNode, _super);
  function BlockContainerNode(parent) {
    return _super.call(this, LayoutInputNodeType.BlockContainer, parent) || this;
  }
  return BlockContainerNode;
})(BlockNode);

/**
 * 模型所有属性默认值定义
 */

var Defaults = function () {
  function Defaults() {}
  Defaults.fontSize = 240;
  Defaults.tabSize = 8; // 段落的 indent 属性中以 chars 字符数为单位时，chars 的值应该除于 100 之后才是字符数

  Defaults.indentCharsUnit = 100; // 列表最大级别

  Defaults.listLevelLimit = 8; // 列表可支持自定义的最大级别

  Defaults.maxSupportListLevelLimit = 9; // 较小的编号的对应字符个数(宽度，用来设置悬挂)

  Defaults.smallListFontNum = 1.6; // 中等

  Defaults.mediumListFontNum = 2.2; // 较大

  Defaults.bigListFontNum = 3.2; // 列表模板默认悬挂缩进字符值单位

  Defaults.listDefaultHangingCharsNum = Defaults.smallListFontNum; // 列表模板默认悬挂缩进字符值单位

  Defaults.listDefaultHangingChars = Defaults.listDefaultHangingCharsNum * Defaults.indentCharsUnit; // 列表模板默认悬挂缩进数值单位

  Defaults.listDefaultHanging = Defaults.listDefaultHangingCharsNum * Defaults.fontSize;
  Defaults.inlineProperty = {
    containerSize: {
      width: 0,
      height: 0
    },
    containerMargin: {
      before: 0,
      start: 0,
      after: 0,
      end: 0
    },
    isRotateInVertLayout: false,
    inlineType: InlineNodeType.InlinePictrue,
    baselineOffset: 0,
    drawingSrc: {
      width: 0,
      height: 0,
      picSrc: ''
    }
  }; // 所有容器默认外边距，便于选区框选容器（该样式不协同）

  Defaults.containerMargin = {
    start: 30,
    before: 30,
    end: 30,
    after: 0
  };
  Defaults.document = {
    vertical: '',
    anchor: AnchorType.Top,
    padding: 0,
    isWrap: true,
    docSizeType: DocSizeType.AtLeast
  };
  Defaults.column = {
    columnNumber: 1,
    columnSpace: 0
  };
  /**
   * 文字font相关属性默认值
   */

  Defaults.font = {
    fontSize: Defaults.fontSize,
    fontWeight: 400,
    underline: false,
    strike: false,
    italic: false,
    textColor: '#000000',
    textBackground: 'transparent',
    letterSpacing: 0,
    baselineOffset: 0
  };
  Defaults.paragraph = {
    textAlignment: TextAlignmentType.Left,
    marginLeft: 0,
    indent: 0,
    hangingChars: 0,
    lineSpacing: 1.3,
    lineSpacingRule: LineSpacingType.Multiple,
    spaceBefore: 0,
    spaceAfter: 0,
    defaultTabSize: 2160,
    tabList: [],
    spaceZeroInEdge: true,
    isList: false,
    indentInfo: {
      start: 0,
      startChars: Defaults.fontSize,
      end: 0,
      endChars: Defaults.fontSize,
      left: 0,
      leftChars: Defaults.fontSize,
      right: 0,
      rightChars: Defaults.fontSize,
      hanging: 0,
      hangingChars: Defaults.fontSize,
      firstLine: 0,
      firstLineChars: Defaults.fontSize
    },
    spanProperty: Defaults.font,
    listInfo: {
      numId: 0,
      level: 0,
      listHangingIndent: 0,
      listLeftIndent: 0,
      format: ListType.None
    }
  };
  return Defaults;
}();
var SpanPropKey;
(function (SpanPropKey) {
  SpanPropKey["fontWeight"] = "span_fontWeight";
  SpanPropKey["fontSize"] = "span_fontSize";
  SpanPropKey["fontFamily"] = "span_fontFamily";
  SpanPropKey["underline"] = "span_underline";
  SpanPropKey["strike"] = "span_strike";
  SpanPropKey["italic"] = "span_italic";
  SpanPropKey["textColor"] = "span_textColor";
  SpanPropKey["textBackground"] = "span_textBackground";
  SpanPropKey["letterSpacing"] = "span_letterSpacing";
  SpanPropKey["baselineOffset"] = "baselineOffset";
})(SpanPropKey || (SpanPropKey = {})); // 有 baselineOffset 属性时，文字大小的缩放比例

var TextBaselineFontScale = 2 / 3;
var SpanProperty = function (_super) {
  __extends(SpanProperty, _super);
  function SpanProperty() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(SpanProperty.prototype, "propertyType", {
    get: function get() {
      return PropertyType.TextSpan;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SpanProperty.prototype, "fontWeight", {
    // font-weight
    get: function get() {
      return this.propBag.get(SpanPropKey.fontWeight, Defaults.font.fontWeight);
    },
    set: function set(val) {
      this.propBag.set(SpanPropKey.fontWeight, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SpanProperty.prototype, "fontSize", {
    /**
     * 获取最终的 fontSize
     */
    get: function get() {
      var fontSize = this.propBag.get(SpanPropKey.fontSize, Defaults.font.fontSize);
      if (Number.isNaN(fontSize)) {
        fontSize = Defaults.font.fontSize;
      }
      if (this.baselineOffset) {
        fontSize *= TextBaselineFontScale;
      }
      return fontSize;
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(SpanPropKey.fontSize, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SpanProperty.prototype, "originFontSize", {
    /**
     * 获取原始的 fontSize
     */
    get: function get() {
      if (this.baselineOffset) {
        return this.fontSize / TextBaselineFontScale;
      }
      return this.fontSize;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SpanProperty.prototype, "fontFamily", {
    // font-family
    get: function get() {
      return this.propBag.get(SpanPropKey.fontFamily, ''); // 不返回默认值，现在直接使用全局默认字体
    },
    set: function set(val) {
      this.propBag.set(SpanPropKey.fontFamily, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SpanProperty.prototype, "underline", {
    // text-decoration
    get: function get() {
      return this.propBag.get(SpanPropKey.underline, Defaults.font.underline);
    },
    set: function set(val) {
      this.propBag.set(SpanPropKey.underline, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SpanProperty.prototype, "strike", {
    get: function get() {
      return this.propBag.get(SpanPropKey.strike, Defaults.font.strike);
    },
    set: function set(val) {
      this.propBag.set(SpanPropKey.strike, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SpanProperty.prototype, "italic", {
    // font-style
    get: function get() {
      return this.propBag.get(SpanPropKey.italic, Defaults.font.italic);
    },
    set: function set(val) {
      this.propBag.set(SpanPropKey.italic, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SpanProperty.prototype, "textColor", {
    // color
    get: function get() {
      var color = this.propBag.get(SpanPropKey.textColor, Defaults.font.textColor);
      if (color.length <= 0) {
        color = Defaults.font.textColor;
      }
      return color;
    },
    set: function set(val) {
      this.propBag.set(SpanPropKey.textColor, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SpanProperty.prototype, "textBackground", {
    // background
    get: function get() {
      var color = this.propBag.get(SpanPropKey.textBackground, Defaults.font.textBackground);
      if (color.length <= 0) {
        color = Defaults.font.textBackground;
      }
      return color;
    },
    set: function set(val) {
      this.propBag.set(SpanPropKey.textBackground, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SpanProperty.prototype, "letterSpacing", {
    // letter-spacing
    get: function get() {
      return this.propBag.get(SpanPropKey.letterSpacing, Defaults.font.letterSpacing);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(SpanPropKey.letterSpacing, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SpanProperty.prototype, "baselineOffset", {
    get: function get() {
      return this.propBag.get(SpanPropKey.baselineOffset, Defaults.font.baselineOffset);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(SpanPropKey.baselineOffset, val);
    },
    enumerable: false,
    configurable: true
  });
  return SpanProperty;
}(CommonProperty);
var TextRunMeasureEngine = function () {
  function TextRunMeasureEngine() {}
  TextRunMeasureEngine.getDefaultEngine = function () {
    return this.instance;
  };
  TextRunMeasureEngine.prototype.setTextRunMeasureImp = function (textRunMeasure) {
    this.textRunMeasureImp = textRunMeasure;
  };
  TextRunMeasureEngine.prototype.measureAttributedText = function (text, textAttr) {
    return this.textRunMeasureImp.measureAttributedText(text, textAttr);
  };
  TextRunMeasureEngine.prototype.measureChar = function (text, textAttr, startPos, endPos) {
    return this.textRunMeasureImp.measureChar(text, textAttr, startPos, endPos);
  };
  /**
   * 清除测量缓存
   */

  TextRunMeasureEngine.prototype.clearCache = function () {
    this.textRunMeasureImp.clearCache();
  };
  /**
   * 清理单一字体测量缓存
   * @param fontFamily 待清理缓存的字体名称
   */

  TextRunMeasureEngine.prototype.invalidateMeasureCache = function (fontFamily) {
    var _a;
    (_a = this.textRunMeasureImp) === null || _a === void 0 ? void 0 : _a.invalidateMeasureCache(fontFamily);
  };
  /**
   * 修改文字精确测量状态
   * @param preciseMeasurement
   */

  TextRunMeasureEngine.prototype.setPreciseMeasurement = function (preciseMeasurement) {
    var _a;
    (_a = this.textRunMeasureImp) === null || _a === void 0 ? void 0 : _a.setPreciseMeasurement(preciseMeasurement);
  };
  TextRunMeasureEngine.instance = new TextRunMeasureEngine();
  return TextRunMeasureEngine;
}();

/*
 * File: /src/defines/placeholder_char_define.ts
 * Project: @melo/model
 * Created Date: Wednesday January 9th 2019
 * Author: vinnyxiong
 * -----
 * Copyright (c) 2019 Tencent
 */

/**
 * @enum PlaceholderCharCode
 * 文档（编码）中的各种占位符/特殊符号的定义
 */
var PlaceholderCharCode;
(function (PlaceholderCharCode) {
  /** 空字符 */
  PlaceholderCharCode[PlaceholderCharCode["Null"] = 0] = "Null";
  /** 子文档开始符 */

  PlaceholderCharCode[PlaceholderCharCode["StoryBegin"] = 2] = "StoryBegin";
  /** 子文档结束符 */

  PlaceholderCharCode[PlaceholderCharCode["StoryEnd"] = 3] = "StoryEnd";
  /** 分节符 */

  PlaceholderCharCode[PlaceholderCharCode["SectionBreak"] = 15] = "SectionBreak";
  /** 硬回车/段落标记，腾讯文档目前用这个符号 '\n' */

  PlaceholderCharCode[PlaceholderCharCode["ParagraphBreak"] = 10] = "ParagraphBreak";
  /** 硬回车/段落标记，MS Office Word 用这个符号 '\r' */

  PlaceholderCharCode[PlaceholderCharCode["ParagraphReturn"] = 13] = "ParagraphReturn";
  /** 软回车/自动换行符 */

  PlaceholderCharCode[PlaceholderCharCode["LineBreak"] = 11] = "LineBreak";
  /** 分栏符 */

  PlaceholderCharCode[PlaceholderCharCode["ColumnBreak"] = 14] = "ColumnBreak";
  /** 分页符 */

  PlaceholderCharCode[PlaceholderCharCode["PageBreak"] = 12] = "PageBreak";
  /** 表格行结束占位符或表格单元格结束占位符 */

  PlaceholderCharCode[PlaceholderCharCode["TableCellStart"] = 28] = "TableCellStart";
  PlaceholderCharCode[PlaceholderCharCode["TableCellBreak"] = 7] = "TableCellBreak";
  PlaceholderCharCode[PlaceholderCharCode["TableRowStart"] = 18] = "TableRowStart";
  PlaceholderCharCode[PlaceholderCharCode["TableRowBreak"] = 6] = "TableRowBreak";
  PlaceholderCharCode[PlaceholderCharCode["TableStart"] = 16] = "TableStart";
  PlaceholderCharCode[PlaceholderCharCode["TableEnd"] = 17] = "TableEnd";
  /** 内联图片的占位符 */

  PlaceholderCharCode[PlaceholderCharCode["InlineAnchor"] = 1] = "InlineAnchor";
  /** 浮动图片或图形的占位符 */

  PlaceholderCharCode[PlaceholderCharCode["FloatingAnchor"] = 8] = "FloatingAnchor";
  /** 域开始符 */

  PlaceholderCharCode[PlaceholderCharCode["FieldBegin"] = 19] = "FieldBegin";
  /** 域分割符 */

  PlaceholderCharCode[PlaceholderCharCode["FieldSep"] = 20] = "FieldSep";
  /** 域结束符 */

  PlaceholderCharCode[PlaceholderCharCode["FieldEnd"] = 21] = "FieldEnd";
  /** 制表符 */

  PlaceholderCharCode[PlaceholderCharCode["Tab"] = 9] = "Tab";
  /** 空格 */

  PlaceholderCharCode[PlaceholderCharCode["Space"] = 32] = "Space";
  /** 全角空格 */

  PlaceholderCharCode[PlaceholderCharCode["FullWidthSpace"] = 12288] = "FullWidthSpace";
  /** 0也认为是空格 */

  PlaceholderCharCode[PlaceholderCharCode["ZeroSpace"] = 0] = "ZeroSpace";
  /** 无间断空格 */

  PlaceholderCharCode[PlaceholderCharCode["NonBreakSpace"] = 160] = "NonBreakSpace";
  /** 零宽度空格 */

  PlaceholderCharCode[PlaceholderCharCode["NoWidthOptionalBreak"] = 8204] = "NoWidthOptionalBreak";
  /** 零宽度非间断空格 */

  PlaceholderCharCode[PlaceholderCharCode["NoWidthNoBreak"] = 8205] = "NoWidthNoBreak";
  /** 可选连字符 */

  PlaceholderCharCode[PlaceholderCharCode["OptionalHyphen"] = 31] = "OptionalHyphen";
  /** ===== 以下为历史原因所采用的符号 * ===== */

  /** 图片 */

  PlaceholderCharCode[PlaceholderCharCode["Image"] = 42] = "Image";
  /** 表格 */

  PlaceholderCharCode[PlaceholderCharCode["Table"] = 42] = "Table";
  /** 分隔线 */

  PlaceholderCharCode[PlaceholderCharCode["Splitline"] = 42] = "Splitline";
})(PlaceholderCharCode || (PlaceholderCharCode = {}));
/**
 * @class PlaceholderChar
 * 文档（字符串）中的各种占位符/特殊符号的定义
 */

var PlaceholderChar = function () {
  function PlaceholderChar() {}
  Object.defineProperty(PlaceholderChar, "Null", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.Null);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "StoryBegin", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.StoryBegin);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "StoryEnd", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.StoryEnd);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "SectionBreak", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.SectionBreak);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "ParagraphBreak", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.ParagraphBreak);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "ParagraphReturn", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.ParagraphReturn);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "LineBreak", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.LineBreak);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "ColumnBreak", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.ColumnBreak);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "PageBreak", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.PageBreak);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "TableCellBreak", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.TableCellBreak);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "TableCellStart", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.TableCellStart);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "TableRowBreak", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.TableRowBreak);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "TableRowStart", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.TableRowStart);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "TableStart", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.TableStart);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "TableEnd", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.TableEnd);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "InlineAnchor", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.InlineAnchor);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "FloatingAnchor", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.FloatingAnchor);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "FieldBegin", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.FieldBegin);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "FieldSep", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.FieldSep);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "FieldEnd", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.FieldEnd);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "Tab", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.Tab);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "Space", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.Space);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "FullWidthSpace", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.FullWidthSpace);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "ZeroSpace", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.ZeroSpace);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "NonBreakSpace", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.NonBreakSpace);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "NoWidthOptionalBreak", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.NoWidthOptionalBreak);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "NoWidthNoBreak", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.NoWidthNoBreak);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "OptionalHyphen", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.OptionalHyphen);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "Image", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.Image);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "Table", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.Table);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PlaceholderChar, "Splitline", {
    get: function get() {
      return String.fromCharCode(PlaceholderCharCode.Splitline);
    },
    enumerable: false,
    configurable: true
  });
  return PlaceholderChar;
}();
/**
 * 是否是换行符（软回车，硬回车，表格单元格结束符）
 */

function isLineBreaker(charCode) {
  return charCode === PlaceholderCharCode.ParagraphBreak || charCode === PlaceholderCharCode.LineBreak || charCode === PlaceholderCharCode.TableCellBreak;
}
/**
 * 是否是分节符
 */

function isSectionBreak(charCode) {
  return charCode === PlaceholderCharCode.SectionBreak;
}
/**
 * 是否是分页符
 */

function isPageBreak(charCode) {
  return charCode === PlaceholderCharCode.PageBreak;
}
/**
 * 是否是分节符、分页符
 */

function isSeparator(charCode) {
  return isSectionBreak(charCode) || isPageBreak(charCode);
}
/**
 * 是否是制表符
 */

function isTab(charCode) {
  return charCode === PlaceholderCharCode.Tab;
}
/**
 * 既是空白字符，又是分隔字符。
 * @param charCode
 */

function isWhiteBreakChar(charCode) {
  return charCode === 8232 ||
  // Line Separator行分隔符
  charCode === 8233; // Paragraph Separator段分隔符
}
var FONT_SIZE_PERCENT = 1.3; // 字体高度字号百分比

var ASCENT_RATIO = 0.8; // ascent占整体高度比例
// 最大宽度。暂时无法设置Number.Max_VALUE，因为MeasureSpec合并后会变为0。

var MAX_MEASURE = 99999999;

/**
 * A shaper takes a list of Typeset Nodes and some
 * typesetting options to produce a Glyph String.
 *
 * @export
 * @class BaseTextShaper
 */

var BaseTextShaper = function () {
  function BaseTextShaper() {
    this.defaultTextStyle = new SpanProperty();
  }
  BaseTextShaper.prototype.setDefaultTextStyle = function (defaultStyle) {
    this.defaultTextStyle = defaultStyle;
  };
  BaseTextShaper.prototype.shapeToken = function (token, attribute) {
    return this.measureToken(token, attribute);
  };
  return BaseTextShaper;
}();
var DOMTextShaper = function (_super) {
  __extends(DOMTextShaper, _super);
  function DOMTextShaper() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  DOMTextShaper.prototype.measureToken = function (token, attribute) {
    var attr = attribute || this.defaultTextStyle;
    var measureEngine = TextRunMeasureEngine.getDefaultEngine(); // 没有字符时，用0宽度字符进行占位测量

    var metric = measureEngine.measureAttributedText(token || PlaceholderChar.NoWidthOptionalBreak, attr);
    return {
      width: metric.width,
      height: metric.height,
      ascent: metric.ascent ? metric.ascent : metric.height * ASCENT_RATIO,
      descent: metric.descent ? metric.descent : metric.height * (1 - ASCENT_RATIO),
      actualWidth: metric.actualWidth || 0,
      actualHeight: metric.actualHeight || 0,
      textMetrics: metric.textMetrics
    };
  };
  return DOMTextShaper;
}(BaseTextShaper);
var ColumnPropKey;
(function (ColumnPropKey) {
  // 分栏数
  ColumnPropKey["ColumnNumber"] = "column_number"; // 分栏间距

  ColumnPropKey["ColumnSpace"] = "column_space";
})(ColumnPropKey || (ColumnPropKey = {}));
/**
 * 和分栏相关的属性集
 */

var ColumnProperty = function (_super) {
  __extends(ColumnProperty, _super);
  function ColumnProperty() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(ColumnProperty.prototype, "columnNumber", {
    get: function get() {
      return this.propBag.get(ColumnPropKey.ColumnNumber, Defaults.column.columnNumber);
    },
    set: function set(value) {
      this.propBag.set(ColumnPropKey.ColumnNumber, value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ColumnProperty.prototype, "columnSpace", {
    get: function get() {
      return this.propBag.get(ColumnPropKey.ColumnSpace, Defaults.column.columnSpace);
    },
    set: function set(value) {
      this.propBag.set(ColumnPropKey.ColumnSpace, value);
    },
    enumerable: false,
    configurable: true
  });
  return ColumnProperty;
}(CommonProperty);
var DocumentPropKey;
(function (DocumentPropKey) {
  DocumentPropKey["Vertical"] = "vertical";
  DocumentPropKey["Anchor"] = "anchor";
  DocumentPropKey["AnchorCenter"] = "AnchorCenter";
  DocumentPropKey["LeftPadding"] = "left_padding";
  DocumentPropKey["RightPadding"] = "right_padding";
  DocumentPropKey["TopPadding"] = "top_padding";
  DocumentPropKey["BottomPadding"] = "bottom_padding";
  DocumentPropKey["whiteSpaceType"] = "white_space";
  DocumentPropKey["TextBaseLine"] = "text_base_line";
  DocumentPropKey["DocSizeType"] = "doc_size_type";
  DocumentPropKey["HandingChar4OneLine"] = "handing_char_4_one_line";
  DocumentPropKey["HandingMaxSpace"] = "handing_max_space";
  DocumentPropKey["TailWhitespaceCalculation"] = "tail_whitespace_calculation";
})(DocumentPropKey || (DocumentPropKey = {}));
var DocumentProperty = function (_super) {
  __extends(DocumentProperty, _super);
  function DocumentProperty() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(DocumentProperty.prototype, "propertyType", {
    get: function get() {
      return PropertyType.DocumentProperty;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "vertical", {
    // vert
    get: function get() {
      return this.propBag.get(DocumentPropKey.Vertical, Defaults.document.vertical);
    },
    set: function set(val) {
      this.propBag.set(DocumentPropKey.Vertical, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "docSizeType", {
    get: function get() {
      return this.propBag.get(DocumentPropKey.DocSizeType, Defaults.document.docSizeType);
    },
    set: function set(val) {
      this.propBag.set(DocumentPropKey.DocSizeType, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "anchor", {
    // anchor
    get: function get() {
      return this.propBag.get(DocumentPropKey.Anchor, Defaults.document.anchor);
    },
    set: function set(val) {
      this.propBag.set(DocumentPropKey.Anchor, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "anchorCenter", {
    get: function get() {
      return this.propBag.get(DocumentPropKey.AnchorCenter, false);
    },
    set: function set(val) {
      this.propBag.set(DocumentPropKey.AnchorCenter, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "leftPadding", {
    // leftPadding
    get: function get() {
      return this.propBag.get(DocumentPropKey.LeftPadding, Defaults.document.padding);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(DocumentPropKey.LeftPadding, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "rightPadding", {
    // rightPadding
    get: function get() {
      return this.propBag.get(DocumentPropKey.RightPadding, Defaults.document.padding);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(DocumentPropKey.RightPadding, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "topPadding", {
    // topPadding
    get: function get() {
      return this.propBag.get(DocumentPropKey.TopPadding, Defaults.document.padding);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(DocumentPropKey.TopPadding, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "bottomPadding", {
    // bottomPadding
    get: function get() {
      return this.propBag.get(DocumentPropKey.BottomPadding, Defaults.document.padding);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(DocumentPropKey.BottomPadding, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "whiteSpaceType", {
    get: function get() {
      return this.propBag.get(DocumentPropKey.whiteSpaceType, WhiteSpaceType.Normal);
    },
    set: function set(whiteSpaceType) {
      this.propBag.set(DocumentPropKey.whiteSpaceType, whiteSpaceType);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "textBaseLine", {
    get: function get() {
      return this.propBag.get(DocumentPropKey.TextBaseLine, TextBaselineType.Alphabetic);
    },
    set: function set(baseLine) {
      this.propBag.set(DocumentPropKey.TextBaseLine, baseLine);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "handingChar4OneLine", {
    get: function get() {
      return this.propBag.get(DocumentPropKey.HandingChar4OneLine, false);
    },
    set: function set(val) {
      this.propBag.set(DocumentPropKey.HandingChar4OneLine, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "handingMaxSpace", {
    get: function get() {
      return this.propBag.get(DocumentPropKey.HandingMaxSpace, -1);
    },
    set: function set(val) {
      this.propBag.set(DocumentPropKey.HandingMaxSpace, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DocumentProperty.prototype, "tailWhitespaceCalculation", {
    get: function get() {
      // 默认值和现网表现一致，即不计算尾部空格的宽度
      return this.propBag.get(DocumentPropKey.TailWhitespaceCalculation, TailWhitespaceCalculation.Exclude);
    },
    set: function set(val) {
      this.propBag.set(DocumentPropKey.TailWhitespaceCalculation, val);
    },
    enumerable: false,
    configurable: true
  });
  return DocumentProperty;
}(ColumnProperty);

/* eslint-disable @typescript-eslint/naming-convention */
var DimensionUnit;
(function (DimensionUnit) {
  DimensionUnit[DimensionUnit["twips"] = 0] = "twips";
  DimensionUnit[DimensionUnit["inch"] = 1] = "inch";
  DimensionUnit[DimensionUnit["cm"] = 2] = "cm";
  DimensionUnit[DimensionUnit["mm"] = 3] = "mm";
  DimensionUnit[DimensionUnit["pt"] = 4] = "pt";
  DimensionUnit[DimensionUnit["pica"] = 5] = "pica";
  DimensionUnit[DimensionUnit["px"] = 6] = "px";
  DimensionUnit[DimensionUnit["emu"] = 7] = "emu";
})(DimensionUnit || (DimensionUnit = {}));
var TwipsPerPt = 20;
var PtPerInch = 72;
var PxPerInch = 96;
var PtPerPx = PtPerInch / PxPerInch;
var TwipsPerPx = TwipsPerPt * PtPerPx;
function twipsToPx(twipsValue) {
  return twipsValue / TwipsPerPx;
}
function twipsToPt(twipsValue) {
  return twipsValue / TwipsPerPt;
}
function pxToTwips(pxValue) {
  return pxValue * TwipsPerPx;
}
var TEN = 10;
var TWENTY = 20;
var THOUSAND = 1000;
var TEN_THOUSAND = 10000;
/** 有序编号文本转换工具类 */

var NumberedListUtil = function () {
  function NumberedListUtil() {}
  /** 转化为拉丁字母计数 */

  NumberedListUtil.number2Letter = function (start, isUpper) {
    var result = [];
    var num = start;
    var alphabetLen = 26;
    while (num) {
      var remain = num % alphabetLen;
      if (!remain) {
        remain = alphabetLen;
        num -= 1;
      }
      result.push(String.fromCharCode(remain + (isUpper ? 64 : 96)));
      num = ~~(num / alphabetLen);
    }
    return result.reverse().join('');
  };
  /** 获取编号显示文字 */

  NumberedListUtil.getNumberListText = function (list) {
    var _this = this;
    var lists = [list];
    var matchs = list.levelText.match(/%([1-9])/g);
    if (Array.isArray(matchs)) {
      // 对格式反转，使得office多个编号格式对齐腾讯文档原逻辑，使得 %1.%2.  =>  %2.%1.
      matchs.reverse();
    }
    var matchIndex = 0;
    return list.levelText.replace(/%([1-9])/g, function (_, indexStr) {
      // 格式数字的相对偏移，对齐office，单个编号格式下（%1），用偏移offset算出index为0，多个模式下（%1.%2.%3.），不参与计算
      var offset = (matchs === null || matchs === void 0 ? void 0 : matchs.length) && (matchs === null || matchs === void 0 ? void 0 : matchs.length) > 1 ? 0 : list.listLevel;
      var str = (matchs === null || matchs === void 0 ? void 0 : matchs[matchIndex]) ? matchs[matchIndex].slice(1) : indexStr;
      matchIndex += 1;
      var index = parseInt(str, 10) - 1 - offset;
      if (index > 0 && lists.length === 1) {
        var current = list.parent;
        while (current) {
          lists.push(current);
          current = current.parent;
        }
      }
      if (lists[index]) {
        return _this.numeric2ListText(lists[index].order + lists[index].start, lists[index].listFmt);
      }
      return '';
    });
  };
  /** 获取用于测量编号宽度的字符串 */

  NumberedListUtil.getNumberListMeasureText = function (text) {
    var measureText = text.replace(/\d/g, '0');
    return measureText !== text ? measureText : undefined;
  };
  /** 数值转化为编号文字 */

  NumberedListUtil.numeric2ListText = function (numeric, listFormat) {
    switch (listFormat) {
      case STNumberFormat.decimal:
        return numeric.toString();
      case STNumberFormat.lowerLetter:
        return this.number2Letter(numeric, false);
      case STNumberFormat.lowerRoman:
        return this.number2Roman(numeric, false);
      case STNumberFormat.chineseCountingThousand:
        return this.number2Chinese(numeric);
      case STNumberFormat.upperLetter:
        return this.number2Letter(numeric, true);
      case STNumberFormat.upperRoman:
        return this.number2Roman(numeric, true);
      default:
        return numeric.toString();
    }
  };
  /** 转化为简体中文计数 */

  NumberedListUtil.number2Chinese = function (numeric) {
    var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    var chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];
    var chnUnitChar = ['', '十', '百', '千'];
    var num = numeric;
    var unitPos = 0;
    var strIns = '';
    var chnStr = '';
    var needZero = false;
    if (num === 0) {
      return chnNumChar[0];
    }
    var origin = num;
    while (num > 0) {
      var section = num % TEN_THOUSAND;
      if (needZero) {
        chnStr = chnNumChar[0] + chnStr;
      }
      strIns = this.sectionToChinese(section, chnNumChar, chnUnitChar);
      strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0];
      chnStr = strIns + chnStr;
      needZero = section < THOUSAND && section > 0;
      num = Math.floor(num / TEN_THOUSAND);
      unitPos += 1;
    }
    if (origin >= TEN && origin < TWENTY) {
      chnStr = chnStr.substring(1);
    }
    return chnStr;
  };
  /**
   * 按每万级别分割，处理里面的中文展示
   * @param  {number} section 按万取余的数字
   * @param  {string[]} chnNumChar 单个位展示的中文 零-九
   * @param  {string[]} chnUnitChar 单位，十百千
   */

  NumberedListUtil.sectionToChinese = function (section, chnNumChar, chnUnitChar) {
    var strIns = '';
    var chnStr = '';
    var unitPos = 0;
    var zero = true;
    var sec = section;
    while (sec > 0) {
      var vi = sec % TEN;
      if (vi === 0) {
        if (!zero) {
          zero = true;
          chnStr = chnNumChar[vi] + chnStr;
        }
      } else {
        zero = false;
        strIns = chnNumChar[vi];
        strIns += chnUnitChar[unitPos];
        chnStr = strIns + chnStr;
      }
      unitPos += 1;
      sec = Math.floor(sec / TEN);
    }
    return chnStr;
  };
  /** 转换为罗马数字 */

  NumberedListUtil.number2Roman = function (start, isUpper) {
    var num = start;
    var lookup = {
      M: 1000,
      CM: 900,
      D: 500,
      CD: 400,
      C: 100,
      XC: 90,
      L: 50,
      XL: 40,
      X: 10,
      IX: 9,
      V: 5,
      IV: 4,
      I: 1
    };
    if (!isUpper) {
      lookup = {
        m: 1000,
        cm: 900,
        d: 500,
        cd: 400,
        c: 100,
        xc: 90,
        l: 50,
        xl: 40,
        x: 10,
        ix: 9,
        v: 5,
        iv: 4,
        i: 1
      };
    }
    var romanStr = '';
    Object.keys(lookup).forEach(function (key) {
      while (num >= lookup[key]) {
        romanStr += key;
        num -= lookup[key];
      }
    });
    return romanStr;
  };
  return NumberedListUtil;
}();
var ListFormat;
(function (ListFormat) {
  ListFormat[ListFormat["Task"] = 0] = "Task";
  ListFormat[ListFormat["Bullet"] = 1] = "Bullet";
  ListFormat[ListFormat["Numbered"] = 2] = "Numbered";
})(ListFormat || (ListFormat = {}));
/**
 * 列表相关工具方法
 */

var ListUtils = function () {
  function ListUtils() {}
  ListUtils.getTaskStateText = function (taskState) {
    return taskState === STTaskState.done ? TaskStateChar.Done : TaskStateChar.Todo;
  };
  return ListUtils;
}();
var SpanPropertyUtil = function () {
  function SpanPropertyUtil() {} // eslint-disable-next-line complexity

  SpanPropertyUtil.initSpanProperty = function (spanProps) {
    var spanProperty = new SpanProperty();
    if (spanProps) {
      spanProperty.fontWeight = spanProps.bold === 1 ? FontWeightType.bold : Defaults.font.fontWeight;
      if (spanProps.fontFamily) {
        spanProperty.fontFamily = spanProps.fontFamily;
      }
      if (spanProps.fontSize) {
        spanProperty.fontSize = pxToTwips(spanProps.fontSize);
      }
      if (spanProps.textColor) {
        spanProperty.textColor = spanProps.textColor;
      }
      if (spanProps.strike) {
        spanProperty.strike = spanProps.strike;
      }
      if (spanProps.italic) {
        spanProperty.italic = spanProps.italic;
      }
      if (spanProps.underline) {
        spanProperty.underline = spanProps.underline;
      }
      if (spanProps.textBackground) {
        spanProperty.textBackground = spanProps.textBackground;
      }
      if (spanProps.letterSpacing) {
        spanProperty.letterSpacing = pxToTwips(spanProps.letterSpacing);
      }
      if (spanProps.baselineOffset) {
        spanProperty.baselineOffset = spanProps.baselineOffset;
      }
    }
    return spanProperty;
  };
  return SpanPropertyUtil;
}();
var ParaPropKey;
(function (ParaPropKey) {
  ParaPropKey["TextAlignment"] = "alignment";
  ParaPropKey["MarginLeft"] = "margin_left";
  ParaPropKey["Indent"] = "indent";
  ParaPropKey["HangingChars"] = "hangingChars";
  ParaPropKey["LineSpacing"] = "line_spacing";
  ParaPropKey["LineSpacingRule"] = "line_spacing_rule";
  ParaPropKey["SpaceBefore"] = "space_before";
  ParaPropKey["SpaceAfter"] = "space_after";
  ParaPropKey["SpaceZeroInEdge"] = "space_zero_in_edge";
  ParaPropKey["IsList"] = "is_list";
  ParaPropKey["IndentInfo"] = "indent_info";
  ParaPropKey["SpanProperty"] = "span_property";
  ParaPropKey["DefaultTabSize"] = "default_tab_size";
  ParaPropKey["TabList"] = "tab_list";
})(ParaPropKey || (ParaPropKey = {}));
var ParaProperty = function (_super) {
  __extends(ParaProperty, _super);
  function ParaProperty() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(ParaProperty.prototype, "propertyType", {
    get: function get() {
      return PropertyType.ParaProperty;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "textAlignment", {
    /** 对齐方式 */
    get: function get() {
      return this.propBag.get(ParaPropKey.TextAlignment, Defaults.paragraph.textAlignment);
    },
    set: function set(val) {
      this.propBag.set(ParaPropKey.TextAlignment, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "marginLeft", {
    /** 文本之前 */
    get: function get() {
      return this.propBag.get(ParaPropKey.MarginLeft, Defaults.paragraph.marginLeft);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(ParaPropKey.MarginLeft, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "indent", {
    /** 缩进 */
    get: function get() {
      return this.propBag.get(ParaPropKey.Indent, Defaults.paragraph.indent);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(ParaPropKey.Indent, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "defaultTabSize", {
    get: function get() {
      return this.propBag.get(ParaPropKey.DefaultTabSize, Defaults.paragraph.defaultTabSize);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(ParaPropKey.DefaultTabSize, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "tabList", {
    get: function get() {
      return this.propBag.get(ParaPropKey.TabList, Defaults.paragraph.tabList);
    },
    set: function set(tabList) {
      if (!tabList) return;
      tabList.sort(function (tabA, tabB) {
        return tabA.position - tabB.position;
      });
      this.propBag.set(ParaPropKey.TabList, tabList);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "hangingChars", {
    /** 悬挂缩进的字符表示形式， word独有，默认是0 */
    get: function get() {
      return this.propBag.get(ParaPropKey.HangingChars, Defaults.paragraph.hangingChars);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(ParaPropKey.HangingChars, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "lineSpacing", {
    /** 行间距 */
    get: function get() {
      return this.propBag.get(ParaPropKey.LineSpacing, Defaults.paragraph.lineSpacing);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(ParaPropKey.LineSpacing, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "lineSpacingRule", {
    /** 行间距规则 */
    get: function get() {
      return this.propBag.get(ParaPropKey.LineSpacingRule, Defaults.paragraph.lineSpacingRule);
    },
    set: function set(val) {
      this.propBag.set(ParaPropKey.LineSpacingRule, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "lineSpacingConfig", {
    get: function get() {
      return {
        rule: this.lineSpacingRule,
        value: this.lineSpacing
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "spaceBefore", {
    /** 段前间距 */
    get: function get() {
      return this.propBag.get(ParaPropKey.SpaceBefore, Defaults.paragraph.spaceBefore);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(ParaPropKey.SpaceBefore, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "spaceAfter", {
    /** 段后间距 */
    get: function get() {
      return this.propBag.get(ParaPropKey.SpaceAfter, Defaults.paragraph.spaceBefore);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(ParaPropKey.SpaceAfter, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "spaceZeroInEdge", {
    get: function get() {
      return this.propBag.get(ParaPropKey.SpaceZeroInEdge, Defaults.paragraph.spaceZeroInEdge);
    },
    /**
     * 段前，段后间距，在首尾段落是否生效，默认不生效
     * @param value
     */
    set: function set(value) {
      this.propBag.set(ParaPropKey.SpaceZeroInEdge, value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "isList", {
    /**
     * 是否是列表
     */
    get: function get() {
      return this.propBag.get(ParaPropKey.IsList, Defaults.paragraph.isList);
    },
    set: function set(value) {
      this.propBag.set(ParaPropKey.IsList, value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "indentInfo", {
    get: function get() {
      return this.propBag.get(ParaPropKey.IndentInfo, Defaults.paragraph.indentInfo);
    },
    set: function set(value) {
      this.propBag.set(ParaPropKey.IndentInfo, value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParaProperty.prototype, "spanProperty", {
    get: function get() {
      var spanProps = _assign(_assign({}, Defaults.paragraph.spanProperty), {
        fontSize: twipsToPx(Defaults.fontSize),
        letterSpacing: twipsToPx(Defaults.paragraph.spanProperty.letterSpacing)
      });
      var defaultSpanProperty = SpanPropertyUtil.initSpanProperty(spanProps);
      return this.propBag.get(ParaPropKey.SpanProperty, defaultSpanProperty);
    },
    set: function set(value) {
      this.propBag.set(ParaPropKey.SpanProperty, value);
    },
    enumerable: false,
    configurable: true
  });
  return ParaProperty;
}(CommonProperty);

/**
 * 当前编号的编号属性信息（模版及段落属性合并的值）
 */

var ListProperty = function (_super) {
  __extends(ListProperty, _super);
  function ListProperty() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.dirty = true; // 列表的排序

    _this.order = -1; // 所在段落结束的gcp位置

    _this.gcp = -1; // 是否为虚拟节点（编号可以跨级，此时子级编号的父节点实际上不存在于正文

    _this.isVirtual = false; // 子节点计数，仅用于用于删除无效虚拟节点

    _this.virtualChildCount = 0;
    return _this;
  }
  Object.defineProperty(ListProperty.prototype, "leftIndent", {
    // 左缩进
    get: function get() {
      return this.indentInfo.left;
    },
    set: function set(val) {
      this.indentInfo.left = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ListProperty.prototype, "isBullet", {
    // 是否是无序编号
    get: function get() {
      return this.listFmt === STNumberFormat.bullet;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ListProperty.prototype, "isNumbered", {
    // 是否是有序编号
    get: function get() {
      return !this.isBullet && !this.isTask;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ListProperty.prototype, "isTask", {
    // 是否是任务编号
    get: function get() {
      return this.listFmt === STNumberFormat.task;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ListProperty.prototype, "listType", {
    // 编号类型
    get: function get() {
      if (this.isBullet) {
        return ListType.Bullet;
      }
      if (this.isNumbered) {
        return ListType.Numbered;
      }
      if (this.isTask) {
        return ListType.Task;
      }
      return ListType.None;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ListProperty.prototype, "measureText", {
    get: function get() {
      if (this.isNumbered) {
        var result = NumberedListUtil.getNumberListMeasureText(this.actualText);
        return result !== null && result !== void 0 ? result : this.actualText;
      }
      if (this.isBullet) {
        return this.levelText;
      }
      if (this.isTask) {
        return this.actualText;
      }
      return this.levelText;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ListProperty.prototype, "actualText", {
    get: function get() {
      if (this.isNumbered) {
        return NumberedListUtil.getNumberListText(this);
      }
      if (this.isBullet) {
        return this.levelText;
      }
      if (this.isTask) {
        return ListUtils.getTaskStateText(this.taskState ? STTaskState.todo : STTaskState.done);
      }
      return this.levelText;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ListProperty.prototype, "listFmt", {
    get: function get() {
      switch (this.listFormat) {
        case ListFormat.Bullet:
          return STNumberFormat.bullet;
        case ListFormat.Task:
          return STNumberFormat.task;
        default:
          return STNumberFormat.undefined;
      }
    },
    enumerable: false,
    configurable: true
  });
  return ListProperty;
}(ParaProperty);
var InlinePropKey;
(function (InlinePropKey) {
  InlinePropKey["containerSize"] = "inline_container_size";
  InlinePropKey["containerMargin"] = "inline_contianer_margin";
  InlinePropKey["isRotateInVertLayout"] = "is_rotate_in_vert_layout";
  InlinePropKey["inlineType"] = "inline_type";
  InlinePropKey["drawingSrc"] = "drawing_src";
  InlinePropKey["baselineOffset"] = "baselineOffset";
})(InlinePropKey || (InlinePropKey = {}));
var InlineProperty = function (_super) {
  __extends(InlineProperty, _super);
  function InlineProperty() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(InlineProperty.prototype, "propertyType", {
    get: function get() {
      return PropertyType.InLineProperty;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(InlineProperty.prototype, "containerSize", {
    get: function get() {
      return this.propBag.get(InlinePropKey.containerSize, Defaults.inlineProperty.containerSize);
    },
    set: function set(val) {
      this.propBag.set(InlinePropKey.containerSize, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(InlineProperty.prototype, "isRotateInVertLayout", {
    get: function get() {
      return this.propBag.get(InlinePropKey.isRotateInVertLayout, Defaults.inlineProperty.isRotateInVertLayout);
    },
    set: function set(val) {
      this.propBag.set(InlinePropKey.isRotateInVertLayout, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(InlineProperty.prototype, "inlineType", {
    get: function get() {
      return this.propBag.get(InlinePropKey.inlineType, Defaults.inlineProperty.inlineType);
    },
    set: function set(val) {
      this.propBag.set(InlinePropKey.inlineType, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(InlineProperty.prototype, "containerMargin", {
    get: function get() {
      return this.propBag.get(InlinePropKey.containerMargin, Defaults.inlineProperty.containerMargin);
    },
    set: function set(val) {
      this.propBag.set(InlinePropKey.containerMargin, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(InlineProperty.prototype, "drawingSrc", {
    get: function get() {
      return this.propBag.get(InlinePropKey.drawingSrc, Defaults.inlineProperty.drawingSrc);
    },
    set: function set(val) {
      this.propBag.set(InlinePropKey.drawingSrc, val);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(InlineProperty.prototype, "baselineOffset", {
    get: function get() {
      return this.propBag.get(InlinePropKey.baselineOffset, Defaults.font.baselineOffset);
    },
    set: function set(val) {
      if (isNaN(val)) return;
      this.propBag.set(InlinePropKey.baselineOffset, val);
    },
    enumerable: false,
    configurable: true
  });
  return InlineProperty;
}(CommonProperty);
var MAX_HANDING_MEASURE_SPACE = 11 * 2;
var MAX_HANDING_EXTENT_SPACE = 0;
/**
 * 整个排版上下文。会从上层传递到下层
 */

var LayoutContext = function () {
  // 文字测量
  function LayoutContext(adapter) {
    this.mAdapter = adapter;
    this.mDocumentNode = adapter.getRootNode();
    this.shaper = new DOMTextShaper();
    this.docType = adapter.getDocType();
  }
  Object.defineProperty(LayoutContext.prototype, "coordinateZero", {
    /**
     * 获取坐标原点位置方向
     */
    get: function get() {
      var coordinate = CoordinateZero.LEFT_TOP;
      if (this.isVertEast() || this.isVert90() || this.isWordArtVerticalRtl()) {
        coordinate = CoordinateZero.RIGHT_TOP;
      } else if (this.isVert270()) {
        coordinate = CoordinateZero.LEFT_BOTTOM;
      }
      return coordinate;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LayoutContext.prototype, "lineExpandDirection", {
    /**
     * 获取行扩张方向
     */
    get: function get() {
      if (this.isWordArtVerticalLtr()) {
        return LineExpandDirection.HORIZONTAL;
      }
      return LineExpandDirection.VERTICAL;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LayoutContext.prototype, "verticalType", {
    /**
     * 获取竖排类型
     */
    get: function get() {
      return this.docStyle.vertical;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 是否是竖排版
   */

  LayoutContext.prototype.isVert = function () {
    return this.isVertEast() || this.isVert90() || this.isVert270() || this.isWordArtVertical();
  };
  /**
   * 是否是竖排版, 其他字符旋转90度，亚洲方形字竖着(不旋转)显示
   */

  LayoutContext.prototype.isVertEast = function () {
    var vertical = this.docStyle.vertical;
    return vertical === VerticalType.Vertical;
  };
  /**
   * 是否是竖排版，所有字符旋转90度显示
   */

  LayoutContext.prototype.isVert90 = function () {
    var vertical = this.docStyle.vertical;
    return vertical === VerticalType.Vertical90;
  };
  /**
   * 是否是竖排版， 所有字符旋转270度显示
   */

  LayoutContext.prototype.isVert270 = function () {
    var vertical = this.docStyle.vertical;
    return vertical === VerticalType.Vertical270;
  };
  /**
   * 是否是堆积，所有文字竖着显示
   */

  LayoutContext.prototype.isWordArtVertical = function () {
    return this.isWordArtVerticalRtl() || this.isWordArtVerticalLtr();
  };
  /**
   * 是否是堆积从右向左
   */

  LayoutContext.prototype.isWordArtVerticalRtl = function () {
    var vertical = this.docStyle.vertical;
    return vertical === VerticalType.WordArtVerticalRtl;
  };
  /**
   * 是否是堆积从左向右
   */

  LayoutContext.prototype.isWordArtVerticalLtr = function () {
    var vertical = this.docStyle.vertical;
    return vertical === VerticalType.WordArtVerticalLtr;
  };
  /**
   * 是否不自动断行。包含两种不换行场景，一种所有情况都不断行，一种遇到强制换行符还是会断行
   * 根据 office 的表现，分栏的时候忽略强制不换行的逻辑
   */

  LayoutContext.prototype.isNowrap = function () {
    if (this.columnNumber > 1) {
      return false;
    }
    var whiteSpaceType = this.docStyle.whiteSpaceType;
    return whiteSpaceType === WhiteSpaceType.Nowrap || whiteSpaceType === WhiteSpaceType.NowrapExceptForceBreak;
  };
  Object.defineProperty(LayoutContext.prototype, "textBaseLine", {
    get: function get() {
      var textBaseLine = this.docStyle.textBaseLine;
      return textBaseLine;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LayoutContext.prototype, "columnNumber", {
    get: function get() {
      return this.docStyle.columnNumber;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 是否是所有场景都换行的情况
   * 根据 office 的表现，分栏的时候忽略强制不换行的逻辑
   */

  LayoutContext.prototype.isNowrapState = function () {
    // 根据 office 的表现，分栏的时候忽略强制不换行的逻辑
    if (this.columnNumber > 1) {
      return false;
    }
    var whiteSpaceType = this.docStyle.whiteSpaceType;
    return whiteSpaceType === WhiteSpaceType.Nowrap;
  };
  /**
   * 设置该属性后，会挤压横向padding，尽量使文字显示在一行，避免第二行出现一个字的情况
   */

  LayoutContext.prototype.isHandingChar4OneLine = function () {
    return this.docStyle.handingChar4OneLine;
  };
  /**
   * 设置handingChar4OneLine之后的最大挤压空间
   */

  LayoutContext.prototype.getMaxHandingSpace = function () {
    var handingMaxSpace = this.docStyle.handingMaxSpace;
    if (handingMaxSpace >= 0) return handingMaxSpace;
    return pxToTwips(this.isVert() ? MAX_HANDING_EXTENT_SPACE : MAX_HANDING_MEASURE_SPACE);
  };
  LayoutContext.prototype.isPPT = function () {
    return this.docType === DocType.PPT;
  };
  /**
   * 在计算行宽度时，是否包括尾部空格
   * @returns
   */

  LayoutContext.prototype.includeTailWhitespaceWidth = function () {
    var tailWhitespaceCalculation = this.docStyle.tailWhitespaceCalculation;
    if (tailWhitespaceCalculation === TailWhitespaceCalculation.Auto) {
      return this.isNowrap();
    }
    return tailWhitespaceCalculation === TailWhitespaceCalculation.Include;
  };
  Object.defineProperty(LayoutContext.prototype, "docStyle", {
    get: function get() {
      var docStyle = this.mAdapter.getRootNode().getProperty();
      return docStyle ? docStyle : new DocumentProperty();
    },
    enumerable: false,
    configurable: true
  });
  return LayoutContext;
}();

/**
 * 对象池中的节点基类
 */
var PoolNode = function () {
  function PoolNode() {}
  return PoolNode;
}();
/**
 * 对象池
 */

var ObjectPool = function () {
  function ObjectPool(size) {
    if (size === void 0) {
      size = 50;
    }
    this.size = 0;
    this.maxPoolSize = size;
  }
  ObjectPool.prototype.obtain = function () {
    if (this.head) {
      var obj = this.head;
      this.head = obj.next;
      obj.next = undefined;
      obj.recycled = undefined;
      this.size -= 1;
      return obj;
    }
    return undefined;
  };
  ObjectPool.prototype.recycle = function (obj) {
    if (obj === null || obj === void 0 ? void 0 : obj.recycled) {
      return;
    }
    if (this.size < this.maxPoolSize) {
      obj.next = this.head;
      obj.recycled = true;
      this.head = obj;
      this.size += 1;
    }
  };
  ObjectPool.prototype.release = function () {
    this.head = undefined;
    this.size = 0;
  };
  ObjectPool.prototype.resize = function (size) {
    this.maxPoolSize = size;
  };
  return ObjectPool;
}();

/**
 * The Logical Size, Different from the physical size.
 * It measures in the axis of inline direction and
 * block direction. The value is invariant from the writing mode
 *
 * @export
 * @class LogicalSize
 */

var LogicalSize = function (_super) {
  __extends(LogicalSize, _super);
  function LogicalSize(value) {
    var _this = _super.call(this) || this;
    _this.measure = value.measure;
    _this.extent = value.extent;
    return _this;
  }
  LogicalSize.obtain = function (value) {
    var size = LogicalSize.sPool.obtain();
    if (!value) return size || LogicalSize.zero;
    if (size) {
      size.measure = value.measure;
      size.extent = value.extent;
    } else {
      size = new LogicalSize(value);
    }
    return size;
  };
  LogicalSize.prototype.recycle = function () {
    this.measure = 0;
    this.extent = 0;
    LogicalSize.sPool.recycle(this);
  };
  Object.defineProperty(LogicalSize, "zero", {
    get: function get() {
      return new LogicalSize({
        measure: 0,
        extent: 0
      });
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 与目标box比较是否大小相等
   * @param size 目标box
   */

  LogicalSize.prototype.equal = function (size) {
    return this.measure === size.measure && this.extent === size.extent;
  };
  /**
   * 判断当前空间是否容得下目标空间
   * @param size 目标空间大小
   */

  LogicalSize.prototype.contain = function (size) {
    return this.measure >= size.measure && this.extent >= size.extent;
  };
  LogicalSize.prototype.isZero = function () {
    return this.measure === 0 && this.extent === 0;
  };
  LogicalSize.prototype.toString = function () {
    return "(m=" + this.measure + ", e=" + this.extent + ")";
  };
  LogicalSize.sPool = new ObjectPool(100);
  return LogicalSize;
}(PoolNode);
var LogicalPoint = function () {
  function LogicalPoint(start, before) {
    this.start = start;
    this.before = before;
  }
  Object.defineProperty(LogicalPoint, "zero", {
    get: function get() {
      return new LogicalPoint(0, 0);
    },
    enumerable: false,
    configurable: true
  }); // eslint-disable-next-line @typescript-eslint/member-ordering

  LogicalPoint.sZero = LogicalPoint.zero;
  return LogicalPoint;
}();
var LayoutDisplay;
(function (LayoutDisplay) {
  LayoutDisplay["Inline"] = "inline";
  LayoutDisplay["Block"] = "block";
  LayoutDisplay["InlineBlock"] = "inline-block";
  LayoutDisplay["None"] = "none";
})(LayoutDisplay || (LayoutDisplay = {}));
var LogicalEdge = function () {
  function LogicalEdge(value) {
    this.before = value.before;
    this.start = value.start;
    this.after = value.after;
    this.end = value.end;
  }
  return LogicalEdge;
}();
/**
 * 描述edge的尺寸，如padding-left,margin-top,border-bottom-width
 */

var LogicalEdgeSize = function (_super) {
  __extends(LogicalEdgeSize, _super);
  function LogicalEdgeSize() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(LogicalEdgeSize, "zero", {
    get: function get() {
      return new LogicalEdgeSize({
        before: 0,
        start: 0,
        after: 0,
        end: 0
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LogicalEdgeSize.prototype, "measure", {
    get: function get() {
      return this.start + this.end;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LogicalEdgeSize.prototype, "extent", {
    get: function get() {
      return this.before + this.after;
    },
    enumerable: false,
    configurable: true
  });
  LogicalEdgeSize.sZero = LogicalEdgeSize.zero;
  return LogicalEdgeSize;
}(LogicalEdge);
var LogicalBorder = function () {
  function LogicalBorder(value) {
    this.width = value.width;
  }
  Object.defineProperty(LogicalBorder, "none", {
    get: function get() {
      return new LogicalBorder({
        width: LogicalEdgeSize.zero
      });
    },
    enumerable: false,
    configurable: true
  }); // eslint-disable-next-line @typescript-eslint/member-ordering

  LogicalBorder.sNone = LogicalBorder.none;
  return LogicalBorder;
}();
var LogicalBoxEdge = function (_super) {
  __extends(LogicalBoxEdge, _super);
  function LogicalBoxEdge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  LogicalBoxEdge.obtain = function (edge) {
    var obj = LogicalBoxEdge.sPool.obtain() || new LogicalBoxEdge();
    if (edge) {
      if (edge.margin) obj.margin = new LogicalEdgeSize(edge.margin);
      if (edge.border) obj.border = new LogicalBorder(edge.border);
      if (edge.padding) obj.padding = new LogicalEdgeSize(edge.padding);
    }
    return obj;
  };
  Object.defineProperty(LogicalBoxEdge.prototype, "rMargin", {
    get: function get() {
      return this.margin || LogicalEdgeSize.sZero;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LogicalBoxEdge.prototype, "rBorder", {
    get: function get() {
      return this.border || LogicalBorder.sNone;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LogicalBoxEdge.prototype, "rPadding", {
    get: function get() {
      return this.padding || LogicalEdgeSize.sZero;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LogicalBoxEdge.prototype, "start", {
    // padding调整为自身属性。已存储在measure和extent中
    get: function get() {
      var margin = this.margin ? this.margin.start : 0;
      var border = this.border ? this.border.width.start : 0;
      return margin + border;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LogicalBoxEdge.prototype, "end", {
    get: function get() {
      var margin = this.margin ? this.margin.end : 0;
      var border = this.border ? this.border.width.end : 0;
      return margin + border;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LogicalBoxEdge.prototype, "before", {
    get: function get() {
      var margin = this.margin ? this.margin.before : 0;
      var border = this.border ? this.border.width.before : 0;
      return margin + border;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LogicalBoxEdge.prototype, "after", {
    get: function get() {
      var margin = this.margin ? this.margin.after : 0;
      var border = this.border ? this.border.width.after : 0;
      return margin + border;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LogicalBoxEdge.prototype, "measure", {
    get: function get() {
      return this.start + this.end;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LogicalBoxEdge.prototype, "extent", {
    get: function get() {
      return this.before + this.after;
    },
    enumerable: false,
    configurable: true
  });
  LogicalBoxEdge.prototype.recycle = function () {
    this.margin = undefined;
    this.border = undefined;
    this.padding = undefined;
    LogicalBoxEdge.sPool.recycle(this);
  };
  LogicalBoxEdge.sPool = new ObjectPool(50);
  LogicalBoxEdge.sNone = new LogicalBoxEdge();
  return LogicalBoxEdge;
}(PoolNode);
var PhysicalEdge = function () {
  function PhysicalEdge(value) {
    this.top = value.top;
    this.left = value.left;
    this.bottom = value.bottom;
    this.right = value.right;
  }
  PhysicalEdge.getNone = function (initial) {
    return new PhysicalEdge({
      top: initial,
      left: initial,
      bottom: initial,
      right: initial
    });
  };
  PhysicalEdge.prototype.reset = function (initial) {
    this.top = initial;
    this.left = initial;
    this.bottom = initial;
    this.right = initial;
  };
  return PhysicalEdge;
}();
var PhysicalBorder = function () {
  function PhysicalBorder(value) {
    this.width = value.width;
  }
  PhysicalBorder.prototype.reset = function () {
    this.width.reset(0);
  };
  Object.defineProperty(PhysicalBorder, "none", {
    get: function get() {
      return new PhysicalBorder({
        width: PhysicalEdge.getNone(0)
      });
    },
    enumerable: false,
    configurable: true
  });
  return PhysicalBorder;
}();
var PhysicalBoxEdge = function (_super) {
  __extends(PhysicalBoxEdge, _super);
  function PhysicalBoxEdge(value) {
    var _this = _super.call(this) || this;
    _this.margin = value.margin;
    _this.padding = value.padding;
    _this.border = value.border;
    return _this;
  }
  PhysicalBoxEdge.obtain = function () {
    return PhysicalBoxEdge.sPool.obtain() || PhysicalBoxEdge.none;
  };
  Object.defineProperty(PhysicalBoxEdge, "none", {
    get: function get() {
      return new PhysicalBoxEdge({
        margin: PhysicalEdge.getNone(0),
        padding: PhysicalEdge.getNone(0),
        border: PhysicalBorder.none
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PhysicalBoxEdge.prototype, "left", {
    /**
     * 左边框值之和（margin,border,padding）
     */
    get: function get() {
      return this.margin.left + this.border.width.left + this.padding.left;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PhysicalBoxEdge.prototype, "right", {
    /**
     * 右边框值之和（margin,border,padding）
     */
    get: function get() {
      return this.margin.right + this.border.width.right + this.padding.right;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PhysicalBoxEdge.prototype, "top", {
    /**
     * 上边框值之和（margin,border,padding）
     */
    get: function get() {
      return this.margin.top + this.border.width.top + this.padding.top;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PhysicalBoxEdge.prototype, "bottom", {
    /**
     * 下边框值之和（margin,border,padding）
     */
    get: function get() {
      return this.margin.bottom + this.border.width.bottom + this.padding.bottom;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PhysicalBoxEdge.prototype, "width", {
    /**
     * 左右边框值之和（margin,border,padding）
     */
    get: function get() {
      return this.left + this.right;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PhysicalBoxEdge.prototype, "height", {
    /**
     * 上下边框值之和（margin,border,padding）
     */
    get: function get() {
      return this.top + this.bottom;
    },
    enumerable: false,
    configurable: true
  });
  PhysicalBoxEdge.prototype.recycle = function () {
    this.margin.reset(0);
    this.padding.reset(0);
    this.border.reset();
    PhysicalBoxEdge.sPool.recycle(this);
  };
  PhysicalBoxEdge.sPool = new ObjectPool(5);
  return PhysicalBoxEdge;
}(PoolNode);

/** 获取box的edge，若为空则返回享元对象，返回的结果不能修改 */

var logicEdge = function logicEdge(box) {
  return box.logicEdge || LogicalBoxEdge.sNone;
};
var EdgeUtil = function () {
  function EdgeUtil() {}
  /**
   * 由逻辑edge得到物理edge
   * @param edge 逻辑edge，与writingMode无关
   */

  EdgeUtil.obtain = function (edge) {
    var obj = PhysicalBoxEdge.obtain();
    if (!edge) return obj;
    var margin = edge.margin,
      border = edge.border,
      padding = edge.padding;
    if (margin) {
      this.copy(obj.margin, margin);
    }
    if (border) {
      this.copyBorder(obj.border, border);
    }
    if (padding) {
      this.copy(obj.padding, padding);
    }
    return obj;
  };
  EdgeUtil.copyBorder = function (physicalBorder, logicBorder) {
    if (logicBorder.width) {
      this.copy(physicalBorder.width, logicBorder.width);
    }
  };
  EdgeUtil.copy = function (physicalEdge, logicEdge) {
    Object.assign(physicalEdge, {
      top: logicEdge.before,
      left: logicEdge.start,
      bottom: logicEdge.after,
      right: logicEdge.end
    });
  };
  return EdgeUtil;
}();
var BaseLayoutBox = function () {
  function BaseLayoutBox(size) {
    /** 内容区域左上角位置 */
    this.contentPoint = LogicalPoint.sZero; // Box的唯一标识

    this._uuid = ''; // 当前节点在兄弟节点中的位置

    this._siblingIndex = 0;
    this._logicSize = LogicalSize.obtain(size);
    this.refreshUUID();
  }
  Object.defineProperty(BaseLayoutBox.prototype, "edge", {
    /**
     * 获取Box Edge模型(pdding,border,margin)
     */
    get: function get() {
      // const writingMode = new WritingMode();
      return EdgeUtil.obtain(this._logicEdge);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "totalWidth", {
    /**
     * 获取整个Box的宽度
     */
    get: function get() {
      // TODO 根据writingMode选择返回measure或者extent
      return this.totalMeasure;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "totalHeight", {
    /**
     * 获取整个Box的高度
     */
    get: function get() {
      // TODO 根据writingMode选择返回measure或者extent
      return this.totalExtent;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "totalBoxSize", {
    /**
     * 返回Box的大小：包括内容，内边距，边框和外边距，即整个Box的大小
     */
    get: function get() {
      return new Size({
        width: this.measure + (this.logicEdge ? this.logicEdge.measure : 0),
        height: this.extent + (this.logicEdge ? this.logicEdge.extent : 0)
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "borderBoxSize", {
    /**
     * 返回Box的大小：包括内容，内边距和边框，但不包括外边距
     */
    get: function get() {
      var width = this.measure;
      var height = this.extent;
      if (this.logicEdge && this.logicEdge.padding) {
        width += this.logicEdge.padding.measure;
        height += this.logicEdge.padding.extent;
      }
      if (this.logicEdge && this.logicEdge.border) {
        width += this.logicEdge.border.width.measure;
        height += this.logicEdge.border.width.extent;
      }
      return new Size({
        width: width,
        height: height
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "paddingBoxSize", {
    /**
     * 返回Box的大小：包括内容，内边距，但不包括边框，外边距
     */
    get: function get() {
      var width = this.measure;
      var height = this.extent;
      if (this.logicEdge && this.logicEdge.padding) {
        width += this.logicEdge.padding.measure;
        height += this.logicEdge.padding.extent;
      }
      return new Size({
        width: width,
        height: height
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "measure", {
    /**
     * ⚠️排版内部使用接口，上层模块使用rect.width
     */
    get: function get() {
      return this._logicSize ? this._logicSize.measure : 0;
    },
    enumerable: false,
    configurable: true
  });
  BaseLayoutBox.prototype.setMeasure = function (measure) {
    if (!this._logicSize) this._logicSize = LogicalSize.obtain();
    this._logicSize.measure = measure;
  };
  Object.defineProperty(BaseLayoutBox.prototype, "extent", {
    /**
     * ⚠️排版内部使用接口，上层模块使用rect.height
     * @inner
     */
    get: function get() {
      return this._logicSize ? this._logicSize.extent : 0;
    },
    enumerable: false,
    configurable: true
  });
  BaseLayoutBox.prototype.setExtent = function (extent) {
    if (!this._logicSize) this._logicSize = LogicalSize.obtain();
    this._logicSize.extent = extent;
  };
  Object.defineProperty(BaseLayoutBox.prototype, "totalMeasure", {
    /**
     * ⚠️排版内部使用接口，上层模块使用totalWidth
     * @inner
     */
    get: function get() {
      return this.measure + (this.logicEdge ? this.logicEdge.measure : 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "totalExtent", {
    /**
     * ⚠️排版内部使用接口，上层模块使用totalHeight
     * @inner
     */
    get: function get() {
      return this.extent + (this.logicEdge ? this.logicEdge.extent : 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "logicPoint", {
    /**
     * ⚠️排版内部使用接口，上层模块使用rect.x/y
     * @inner
     */
    get: function get() {
      if (this._logicPoint) {
        return this._logicPoint;
      }
      return LogicalPoint.sZero;
    },
    /**
     * ⚠️排版内部使用接口
     * @inner
     */
    set: function set(point) {
      this._logicPoint = point;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "logicEdge", {
    /**
     * ⚠️排版内部使用接口，上层模块使用edge
     * @inner
     */
    get: function get() {
      return this._logicEdge;
    },
    /**
     * ⚠️排版内部使用接口，上层模块使用edge
     * @inner
     */
    set: function set(edge) {
      this._logicEdge = edge;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "totalLogicSize", {
    /**
     * ⚠️排版内部使用接口，上层模块使用xxBoxSize()接口
     * @inner
     */
    get: function get() {
      return LogicalSize.obtain({
        measure: this.totalMeasure,
        extent: this.totalExtent
      });
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 判断该Box的大小是否为0（宽或者高为0）
   */

  BaseLayoutBox.prototype.isZero = function () {
    return this.measure === 0 || this.extent === 0;
  };
  BaseLayoutBox.prototype.setParentBox = function (box) {
    this._parentBox = box;
  };
  Object.defineProperty(BaseLayoutBox.prototype, "parentBox", {
    get: function get() {
      return this._parentBox;
    },
    enumerable: false,
    configurable: true
  });
  BaseLayoutBox.prototype.setSiblingIndex = function (index) {
    this._siblingIndex = index;
  };
  BaseLayoutBox.prototype.getSiblingIndex = function () {
    return this._siblingIndex;
  };
  Object.defineProperty(BaseLayoutBox.prototype, "nextSibling", {
    get: function get() {
      if (this._parentBox) {
        var next = this._siblingIndex + 1;
        var sibling = this._parentBox.children;
        if (next < sibling.length) {
          return sibling[next];
        }
      }
      return undefined;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "prevSibling", {
    get: function get() {
      if (this._parentBox) {
        var pre = this._siblingIndex - 1;
        if (pre >= 0) {
          var sibling = this._parentBox.children;
          return sibling[pre];
        }
      }
      return undefined;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "display", {
    get: function get() {
      return LayoutDisplay.Block;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "name", {
    get: function get() {
      var constr = this.constructor;
      return constr ? constr.name : '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayoutBox.prototype, "uuid", {
    get: function get() {
      return this._uuid;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 对象回收
   * @inner
   */

  BaseLayoutBox.prototype.recycle = function () {
    if (this._logicEdge) {
      this._logicEdge.recycle();
      this._logicEdge = undefined;
    }
    if (this._logicSize) {
      this._logicSize.recycle();
      this._logicSize = undefined;
    }
  };
  BaseLayoutBox.prototype.refreshUUID = function () {
    this._uuid = "" + BaseLayoutBox.UUID;
    BaseLayoutBox.UUID += 1;
  };
  BaseLayoutBox.UUID = 0;
  return BaseLayoutBox;
}();
var BaseParentBox = function (_super) {
  __extends(BaseParentBox, _super);
  function BaseParentBox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._children = [];
    return _this;
  }
  /**
   * Box子类实例构造工厂方法
   * @param BoxType 子类类型（类名）
   * @param size    需创建实例的box逻辑大小
   */

  BaseParentBox.create = function (BoxType, size) {
    return new BoxType(size);
  };
  Object.defineProperty(BaseParentBox.prototype, "firstChild", {
    get: function get() {
      return this._children.length > 0 ? this._children[0] : undefined;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseParentBox.prototype, "firstVisibleChild", {
    get: function get() {
      return this.firstChild;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseParentBox.prototype, "lastChild", {
    get: function get() {
      var size = this._children.length;
      return size > 0 ? this._children[size - 1] : undefined;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseParentBox.prototype, "lastVisibleChild", {
    get: function get() {
      return this.lastChild;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseParentBox.prototype, "children", {
    get: function get() {
      return this._children;
    },
    enumerable: false,
    configurable: true
  });
  BaseParentBox.prototype.append = function () {
    var _this = this;
    var boxes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      boxes[_i] = arguments[_i];
    }
    if (!boxes || boxes.length < 1) {
      return;
    }
    var size = this._children.length;
    boxes.forEach(function (box, index) {
      _this._children.push(box);
      _this.onAppendChild(box, size + index);
    });
  };
  BaseParentBox.prototype.clearChildren = function () {
    this._children = [];
  };
  BaseParentBox.prototype.onAppendChild = function (box, index) {
    box.setParentBox(this);
    box.setSiblingIndex(index);
  };
  return BaseParentBox;
}(BaseLayoutBox);

/**
 * @class ParagraphBox
 * 自然段，文档逻辑结构的段落跨页时可能会分到不同的ParagraphBox
 */

var ParagraphBox = function (_super) {
  __extends(ParagraphBox, _super);
  function ParagraphBox(size, paragraphId) {
    var _this = _super.call(this, size) || this;
    _this.kind = BoxKind.Paragraph;
    _this.paragraphId = paragraphId;
    return _this;
  }
  Object.defineProperty(ParagraphBox.prototype, "paraProps", {
    get: function get() {
      return this._paraProps || new ParaProperty();
    },
    set: function set(prop) {
      this._paraProps = prop;
    },
    enumerable: false,
    configurable: true
  });
  return ParagraphBox;
}(BaseParentBox);
var LayoutSizeSpec;
(function (LayoutSizeSpec) {
  /**
   * MATCH_PARENT意思是该layout大小和父layout一样大
   */
  LayoutSizeSpec[LayoutSizeSpec["MATCH_PARENT"] = -1] = "MATCH_PARENT";
  /**
   * WRAP_CONTENT意思是该layout大小自适应自身大小
   */

  LayoutSizeSpec[LayoutSizeSpec["WRAP_CONTENT"] = -2] = "WRAP_CONTENT";
})(LayoutSizeSpec || (LayoutSizeSpec = {}));
/**
 * 该layout在父layout中的对齐方式，可以处理垂直对齐和左右对齐
 * inline方向：start->end
 * block方向：before->after
 */

var LayoutGravity;
(function (LayoutGravity) {
  LayoutGravity[LayoutGravity["START"] = 0] = "START";
  LayoutGravity[LayoutGravity["CENTER"] = 1] = "CENTER";
  LayoutGravity[LayoutGravity["END"] = 2] = "END";
  LayoutGravity[LayoutGravity["BEFORE"] = 3] = "BEFORE";
  LayoutGravity[LayoutGravity["AFTER"] = 4] = "AFTER";
})(LayoutGravity || (LayoutGravity = {}));
/**
 * 主要用来告诉父layout，当前child Layout该如何排版。
 * 逻辑尺寸，不用专门区分横竖排。
 */

var LayoutParams = function () {
  function LayoutParams(measure, extent) {
    /**
     * inline方向大小
     */
    this.measure = 0;
    /**
     * block方向大小
     */

    this.extent = 0;
    this.measure = measure;
    this.extent = extent;
    this.margin = LogicalEdgeSize.zero;
  }
  /**
   * 设置margin
   * @param start
   * @param end
   * @param before
   * @param after
   */

  LayoutParams.prototype.setMargins = function (start, end, before, after) {
    this.margin.start = start;
    this.margin.end = end;
    this.margin.before = before;
    this.margin.after = after;
  };
  Object.defineProperty(LayoutParams.prototype, "marginMeasure", {
    get: function get() {
      return this.margin.start + this.margin.end;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LayoutParams.prototype, "marginExtent", {
    get: function get() {
      return this.margin.before + this.margin.after;
    },
    enumerable: false,
    configurable: true
  });
  return LayoutParams;
}();

// 对数字使用位移存储mode和size
var MODE_SHIFT = 30;
var MODE_MASK = 0x3 << MODE_SHIFT;
/**
 * 测量尺寸时，指定的测量模式
 */

var MeasureSpecMode;
(function (MeasureSpecMode) {
  MeasureSpecMode[MeasureSpecMode["UNSPECIFIED"] = 0 << MODE_SHIFT] = "UNSPECIFIED";
  MeasureSpecMode[MeasureSpecMode["EXACTLY"] = 1 << MODE_SHIFT] = "EXACTLY";
  MeasureSpecMode[MeasureSpecMode["AT_MOST"] = 2 << MODE_SHIFT] = "AT_MOST";
})(MeasureSpecMode || (MeasureSpecMode = {}));
/**
 * 封装了从父级到子级的布局要求。每个MeasureSpec表示了对宽度或高度的要求。
 */

var MeasureSpec = function () {
  function MeasureSpec() {}
  /**
   * 封装size和model到MeasureSpecValue
   * @param size
   * @param mode
   */

  MeasureSpec.makeMeasureSpec = function (size, mode) {
    return size & ~MODE_MASK | mode & MODE_MASK;
  };
  MeasureSpec.getMode = function (measureSpec) {
    return measureSpec & MODE_MASK;
  };
  MeasureSpec.getSize = function (measureSpec) {
    return measureSpec & ~MODE_MASK;
  };
  return MeasureSpec;
}();

/**
 * 获取根据parent尺寸计算出的可能排版空间
 * @param docSize 调用方提供的文档尺寸
 * @param rootDimension document layout所要求的尺寸
 */

function getRootMeasureSpec(docSize, rootDimension) {
  var measureSpec;
  switch (rootDimension) {
    case LayoutSizeSpec.MATCH_PARENT:
      measureSpec = MeasureSpec.makeMeasureSpec(docSize, MeasureSpecMode.EXACTLY);
      break;
    case LayoutSizeSpec.WRAP_CONTENT:
      measureSpec = MeasureSpec.makeMeasureSpec(docSize, MeasureSpecMode.AT_MOST);
      break;
    default:
      measureSpec = MeasureSpec.makeMeasureSpec(rootDimension, MeasureSpecMode.EXACTLY);
      break;
  }
  return measureSpec;
}
/**
 * 根据父layout可能的尺寸，获取子layout可能尺寸大小
 * @param parentSpec 父layout可能尺寸大小
 * @param edge 父layout的padding和子layout的margin之和
 * @param childDimension child layout所要求的尺寸
 */

function getChildMeasureSpec(parentSpec, edge, childDimension) {
  var specMode = MeasureSpec.getMode(parentSpec);
  var specSize = MeasureSpec.getSize(parentSpec);
  var size = Math.max(0, specSize - edge);
  var resultSize = 0;
  var resultMode = 0;
  switch (specMode) {
    case MeasureSpecMode.EXACTLY:
      if (childDimension >= 0) {
        // child指定了固定尺寸
        resultSize = childDimension;
        resultMode = MeasureSpecMode.EXACTLY;
      } else if (childDimension === LayoutSizeSpec.MATCH_PARENT) {
        // child指定和父级相同尺寸
        resultSize = size;
        resultMode = MeasureSpecMode.EXACTLY;
      } else if (childDimension === LayoutSizeSpec.WRAP_CONTENT) {
        // child的尺寸依赖其本身大小
        resultSize = size;
        resultMode = MeasureSpecMode.AT_MOST;
      }
      break;
    case MeasureSpecMode.AT_MOST:
      if (childDimension >= 0) {
        // child指定了固定尺寸
        resultSize = childDimension;
        resultMode = MeasureSpecMode.EXACTLY;
      } else if (childDimension === LayoutSizeSpec.MATCH_PARENT) {
        // child指定和父级相同尺寸, 由于父级也是依赖child，所以child也是at most
        resultSize = size;
        resultMode = MeasureSpecMode.AT_MOST;
      } else if (childDimension === LayoutSizeSpec.WRAP_CONTENT) {
        // child的尺寸依赖其本身大小
        resultSize = size;
        resultMode = MeasureSpecMode.AT_MOST;
      }
      break;
  }
  return MeasureSpec.makeMeasureSpec(resultSize, resultMode);
}
/**
 * 把measureSpec转换为最终具体尺寸
 * @param size
 * @param measureSpec
 */

function resolveSize(size, measureSpec) {
  var specMode = MeasureSpec.getMode(measureSpec);
  var specSize = MeasureSpec.getSize(measureSpec);
  var result = 0;
  switch (specMode) {
    case MeasureSpecMode.AT_MOST:
      result = size;
      break;
    case MeasureSpecMode.EXACTLY:
      result = specSize;
      break;
    default:
      result = size;
  }
  return result;
}
var LogicalCursor = function () {
  function LogicalCursor(inlinePos, blockPos) {
    this.inlinePos = 0;
    this.blockPos = 0;
    this.inlinePos = inlinePos;
    this.blockPos = blockPos;
  }
  LogicalCursor.zero = function () {
    return new LogicalCursor(0, 0);
  };
  return LogicalCursor;
}();
var FlowContent = function () {
  function FlowContent() {
    this.inlines = [];
    this.blocks = [];
    this.cursor = LogicalCursor.zero();
  }
  Object.defineProperty(FlowContent.prototype, "blockPos", {
    get: function get() {
      return this.cursor.blockPos;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FlowContent.prototype, "inlinePos", {
    get: function get() {
      return this.cursor.inlinePos;
    },
    enumerable: false,
    configurable: true
  });
  FlowContent.prototype.isEmpty = function () {
    return this.isInlineEmpty() && this.isBlockEmpty();
  };
  FlowContent.prototype.isInlineEmpty = function () {
    return this.inlines.length === 0;
  };
  FlowContent.prototype.isBlockEmpty = function () {
    return this.blocks.length === 0;
  };
  FlowContent.prototype.pushInline = function (box) {
    this.inlines.push(box);
    this.cursor.inlinePos += box.totalMeasure || 0;
  };
  FlowContent.prototype.pushBlock = function (block) {
    this.blocks.push(block);
    this.cursor.blockPos += block.totalExtent || 0;
  };
  FlowContent.prototype.getInlines = function () {
    return this.inlines;
  };
  FlowContent.prototype.getBlocks = function () {
    return this.blocks;
  };
  FlowContent.prototype.clearInlines = function () {
    this.inlines = [];
    this.cursor.inlinePos = 0;
  };
  FlowContent.prototype.clearBlocks = function () {
    this.blocks = [];
    this.cursor.blockPos = 0;
  };
  FlowContent.prototype.getLineExtent = function () {
    return this.inlines.reduce(function (maxExtent, inline) {
      var extent = inline.borderBoxSize.height;
      return Math.max(maxExtent, extent);
    }, 0);
  };
  FlowContent.prototype.getLineMeasure = function () {
    return this.inlines.reduce(function (measure, inline) {
      return measure + inline.borderBoxSize.width;
    }, 0);
  };
  return FlowContent;
}();

/**
 * layout基类，子类和继承实现不同的布局方式。
 * 布局完成后返回对应的box模型
 */

var BaseLayout = function () {
  function BaseLayout(context, node) {
    this.mNode = node;
    this.mContext = context;
    this.mGenerator = this.createGenerator(context, node);
    this.mOffset = LogicalPoint.zero;
    this.mPadding = LogicalEdgeSize.zero;
    this.setLayoutParams(this.generateDefaultLayoutParams());
  }
  /**
   * 触发排版
   * @param start 相对 parent inline方向 offset
   * @param before 相对 parent block方向 offset
   * @param inlineMeasureSpec 根据parent尺寸计算出的inline方向排版空间
   * @param blockMeasureSpec 根据parent尺寸计算出的block方向排版空间
   */

  BaseLayout.prototype.layout = function (start, before, inlineMeasureSpec, blockMeasureSpec) {
    var offset = new LogicalPoint(start, before);
    this.updateOffsetAndSize(offset, inlineMeasureSpec, blockMeasureSpec);
    return this.onLayout();
  };
  BaseLayout.prototype.hasNext = function () {
    return this.mGenerator.hasNext();
  };
  BaseLayout.prototype.getNextNode = function () {
    return this.mNode.getNextSibling();
  };
  BaseLayout.prototype.getLayoutParams = function () {
    return this.mLayoutParams;
  };
  BaseLayout.prototype.setLayoutParams = function (params) {
    this.mLayoutParams = params;
  };
  BaseLayout.prototype.onDestroy = function () {
    // 子类继承实现
    this.mParentLayout = undefined;
  };
  /**
   * 设置padding
   * @param start
   * @param end
   * @param before
   * @param after
   */

  BaseLayout.prototype.setPadding = function (start, end, before, after) {
    this.mPadding.start = start;
    this.mPadding.end = end;
    this.mPadding.before = before;
    this.mPadding.after = after;
  };
  BaseLayout.prototype.getPadding = function () {
    return this.mPadding;
  };
  Object.defineProperty(BaseLayout.prototype, "paddingStart", {
    get: function get() {
      return this.mPadding.start;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayout.prototype, "paddingEnd", {
    get: function get() {
      return this.mPadding.end;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayout.prototype, "paddingBefore", {
    get: function get() {
      return this.mPadding.before;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayout.prototype, "paddingAfter", {
    get: function get() {
      return this.mPadding.after;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayout.prototype, "paddingMeasure", {
    get: function get() {
      return this.mPadding.start + this.mPadding.end;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLayout.prototype, "paddingExtent", {
    get: function get() {
      return this.mPadding.before + this.mPadding.after;
    },
    enumerable: false,
    configurable: true
  });
  BaseLayout.prototype.getParent = function () {
    return this.mParentLayout;
  };
  BaseLayout.prototype.setParent = function (parent) {
    this.mParentLayout = parent;
  };
  BaseLayout.prototype.getSizeSpec = function () {
    return {
      inlineSpec: this.mInlineMeasureSpec,
      blockSpec: this.mBlockMeasureSpec
    };
  };
  BaseLayout.prototype.generateDefaultLayoutParams = function () {
    return new LayoutParams(LayoutSizeSpec.WRAP_CONTENT, LayoutSizeSpec.WRAP_CONTENT);
  };
  /**
   * 更新当前排版段、行的相对偏移和尺寸大小
   * @param offset
   * @param inlineSpec
   * @param blockSpec
   */

  BaseLayout.prototype.updateOffsetAndSize = function (offset, inlineSpec, blockSpec) {
    this.mOffset = offset;
    this.mInlineMeasureSpec = inlineSpec;
    this.mBlockMeasureSpec = blockSpec;
  };
  return BaseLayout;
}();

/**
 * 含有childLayout的父容器布局
 */

var BaseParentLayout = function (_super) {
  __extends(BaseParentLayout, _super);
  function BaseParentLayout() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BaseParentLayout.prototype.getParentOffset = function () {
    return this.mOffset;
  };
  /**
   * 具体排版逻辑，子类可重写
   */

  BaseParentLayout.prototype.onLayout = function () {
    var _this = this;
    while (true) {
      var next = this.mGenerator.getNext();
      if (next.done || next.value.layoutBoxes.length < 1) {
        break;
      }
      next.value.layoutBoxes.forEach(function (value) {
        _this.addBox(value);
      });
    }
    return this.reduceLayout();
  };
  return BaseParentLayout;
}(BaseLayout);

/**
 * 横向或纵向流式排版时，子元素是从左向右(从上到下)或从右向左(从下到上)
 * 逻辑方向
 */

var Direction;
(function (Direction) {
  Direction[Direction["LTR"] = 5] = "LTR";
  Direction[Direction["RTL"] = 6] = "RTL";
})(Direction || (Direction = {}));
/**
 * 流式排版，支持横向纵向排版。同时支持排版方向从左到右或从右到左
 * 文本排版的layout基本都是流式排版
 */

var FlowLayout = function (_super) {
  __extends(FlowLayout, _super);
  function FlowLayout(context, node) {
    var _this = _super.call(this, context, node) || this;
    _this.mContent = new FlowContent();
    return _this;
  }
  FlowLayout.prototype.setDirection = function (direaction) {
    if (this.mDirection !== direaction) {
      this.mDirection = direaction;
    }
  };
  FlowLayout.prototype.getDirection = function () {
    return this.mDirection;
  };
  FlowLayout.prototype.isEmpty = function () {
    return this.mContent.isEmpty();
  };
  /**
   * 对child layout进行布局通用逻辑。
   * 注意：对齐等需要排版完child才能计算box位置
   * @param childLayout
   */

  FlowLayout.prototype.layoutChild = function (childLayout) {
    var childLp = childLayout.getLayoutParams();
    var childInlineMeasureSpec = getChildMeasureSpec(this.mInlineMeasureSpec, this.paddingMeasure + childLp.marginMeasure + this.mContent.inlinePos, childLp.measure);
    var childBlockMeasureSpec = getChildMeasureSpec(this.mBlockMeasureSpec, this.paddingExtent + childLp.marginExtent + this.mContent.blockPos, childLp.extent);
    var start = this.paddingStart + childLp.margin.start + this.mContent.inlinePos;
    var before = this.paddingBefore + childLp.margin.before + this.mContent.blockPos;
    return childLayout.layout(start, before, childInlineMeasureSpec, childBlockMeasureSpec);
  };
  FlowLayout.prototype.generateDefaultLayoutParams = function () {
    // 流式布局默认inline方向自适应（textBody可设置左右居中），block方向自适应
    return new LayoutParams(LayoutSizeSpec.WRAP_CONTENT, LayoutSizeSpec.WRAP_CONTENT);
  };
  /**
   * 计算box内容区域大小
   * @param layoutBox
   * @protected
   */

  FlowLayout.prototype.updateBoxContentLogicFrame = function (layoutBox) {
    var box = layoutBox;
    var contentStart = Infinity;
    var contentBefore = Infinity;
    var contentEnd = 0;
    var array = __spreadArray(__spreadArray([], __read(this.mContent.getBlocks())), __read(this.mContent.getInlines()));
    array.forEach(function (block) {
      var blockBox = block; // 计算当前段落内容区域的左上角

      var _a = blockBox.contentPoint,
        start = _a.start,
        before = _a.before;
      contentEnd = Math.max(contentEnd, start + blockBox.contentMeasure);
      contentStart = Math.min(contentStart, start);
      contentBefore = Math.min(contentBefore, before);
    });
    box.contentMeasure = contentEnd - contentStart;
    contentStart += box.logicPoint.start;
    contentBefore += box.logicPoint.before;
    box.contentPoint = new LogicalPoint(contentStart, contentBefore);
  };
  return FlowLayout;
}(BaseParentLayout);
var BlockLayout = function (_super) {
  __extends(BlockLayout, _super);
  function BlockLayout() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return BlockLayout;
}(FlowLayout);

/**
 * 相对左上角坐标系原点，对child的坐标进行转换为物理坐标
 * @param coordinate 坐标系位置
 * @param childPoint child相对位置
 * @param childLogicSize
 * @param parentLogicSize
 */

function transChildRectToPhysical(coordinate, lineExpandDirection, childPoint, childLogicSize, parentLogicSize) {
  // 默认left top
  var childMeasure = childLogicSize.measure,
    childExtent = childLogicSize.extent;
  var parentMeasure = parentLogicSize.measure,
    parentExtent = parentLogicSize.extent;
  var left = childPoint.start;
  var top = childPoint.before;
  var width = childMeasure;
  var height = childExtent;
  if (coordinate === CoordinateZero.RIGHT_TOP) {
    left = parentExtent - childPoint.before - childExtent;
    top = childPoint.start;
    width = childExtent;
    height = childMeasure;
  } else if (coordinate === CoordinateZero.RIGHT_BOTTOM) {
    left = parentMeasure - childPoint.start - childMeasure;
    top = parentExtent - childPoint.before - childExtent;
    width = childMeasure;
    height = childExtent;
  } else if (coordinate === CoordinateZero.LEFT_BOTTOM) {
    left = childPoint.before;
    top = parentMeasure - childPoint.start - childMeasure;
    width = childExtent;
    height = childMeasure;
  } else if (coordinate === CoordinateZero.LEFT_TOP) {
    if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
      left = childPoint.before;
      top = childPoint.start;
      width = childExtent;
      height = childMeasure;
    }
  }
  return new Rect({
    x: left,
    y: top,
    width: width,
    height: height
  });
}
/**
 * 转换offset偏移大小逻辑尺寸为物理尺寸
 * @param coordinate
 * @param offsetMeasure
 * @param offsetExtent
 */

function transOffsetToPhysical(coordinate, lineExpandDirection, offsetMeasure, offsetExtent) {
  // 默认left top
  var offsetX = offsetMeasure;
  var offsetY = offsetExtent;
  if (coordinate === CoordinateZero.RIGHT_TOP) {
    offsetX = -offsetExtent;
    offsetY = offsetMeasure;
  } else if (coordinate === CoordinateZero.RIGHT_BOTTOM) {
    offsetX = -offsetMeasure;
    offsetY = -offsetExtent;
  } else if (coordinate === CoordinateZero.LEFT_BOTTOM) {
    offsetX = offsetExtent;
    offsetY = -offsetMeasure;
  } else if (coordinate === CoordinateZero.LEFT_TOP) {
    if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
      offsetX = -offsetExtent;
      offsetY = offsetMeasure;
    }
  }
  return {
    offsetX: offsetX,
    offsetY: offsetY
  };
}
/**
 * 转换物理尺寸point为逻辑尺寸
 * @param coordinate 坐标系原点位置
 * @param dimension  坐标系尺寸大小
 * @param point 相对左上角坐标系上的点
 */

function transPointToLogic(coordinate, lineExpandDirection, dimension, point) {
  var x = point.x,
    y = point.y;
  var width = dimension.width,
    height = dimension.height;
  var start = x;
  var before = y;
  if (coordinate === CoordinateZero.RIGHT_TOP) {
    start = y;
    before = width - x;
  } else if (coordinate === CoordinateZero.RIGHT_BOTTOM) {
    start = width - x;
    before = height - y;
  } else if (coordinate === CoordinateZero.LEFT_BOTTOM) {
    start = height - y;
    before = x;
  } else if (coordinate === CoordinateZero.LEFT_TOP) {
    if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
      start = y;
      before = x;
    }
  }
  return {
    start: start,
    before: before
  };
}

/**
 * @class ColumnBox
 * 文本分栏
 */

var ColumnBox = function (_super) {
  __extends(ColumnBox, _super);
  function ColumnBox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.kind = BoxKind.Column;
    return _this;
  }
  Object.defineProperty(ColumnBox.prototype, "display", {
    get: function get() {
      return LayoutDisplay.InlineBlock;
    },
    enumerable: false,
    configurable: true
  });
  return ColumnBox;
}(BaseParentBox);
var BaseColumnLayout = function (_super) {
  __extends(BaseColumnLayout, _super);
  function BaseColumnLayout(context, node) {
    var _this = _super.call(this, context, node) || this;
    _this.maxParagraphMeasure = 0;
    return _this;
  }
  Object.defineProperty(BaseColumnLayout.prototype, "currentColumnIndex", {
    get: function get() {
      var _a;
      return ((_a = this.mParentLayout) === null || _a === void 0 ? void 0 : _a.currentColumnIndex) || 0;
    },
    enumerable: false,
    configurable: true
  });
  BaseColumnLayout.prototype.layoutChild = function (childLayout) {
    var childLp = childLayout.getLayoutParams();
    var childInlineMeasureSpec = getChildMeasureSpec(this.mInlineMeasureSpec, this.paddingMeasure + childLp.marginMeasure + this.mContent.inlinePos, childLp.measure);
    var childBlockMeasureSpec = getChildMeasureSpec(this.mBlockMeasureSpec,
    // 在计算排版空间时不需要考虑段后间距
    this.paddingExtent + this.getChildMarginBefore(childLp) + this.mContent.blockPos, childLp.extent);
    var start = this.paddingStart + childLp.margin.start + this.mContent.inlinePos;
    var before = this.paddingBefore + this.getChildMarginBefore(childLp) + this.mContent.blockPos;
    return childLayout.layout(start, before, childInlineMeasureSpec, childBlockMeasureSpec);
  };
  /**
   * 更新当前 margin
   * @param columnSpace
   * @returns
   */

  BaseColumnLayout.prototype.updateMargin = function (columnSpace) {
    var layoutParams = this.getLayoutParams();
    var _a = layoutParams.margin,
      start = _a.start,
      end = _a.end,
      before = _a.before,
      after = _a.after;
    var currentIndex = this.currentColumnIndex;
    if (this.mContext.columnNumber === 1) {
      // 只有一栏，栏间距不生效，直接返回
      return;
    }
    if (currentIndex === 0) {
      // 第一栏的时候把 columnSpace 加在右侧 margin 上
      // 由于所有栏共享一个 columnLayout，所以后续的栏的右侧 margin 都会有 columnSpace
      layoutParams.setMargins(start, end + columnSpace, before, after);
      return;
    } // 最后一栏右侧不需要 columnSpace，所以在右侧 margin 中减去 columnSpace

    if (currentIndex === this.mContext.columnNumber - 1) {
      layoutParams.setMargins(start, end - columnSpace, before, after);
    }
  };
  BaseColumnLayout.prototype.addBox = function (box) {
    this.mContent.pushBlock(box); // 记录段落最大 inline 方向 size

    var totalMeasure = box.totalMeasure;
    if (totalMeasure > this.maxParagraphMeasure) {
      this.maxParagraphMeasure = totalMeasure;
    }
  };
  BaseColumnLayout.prototype.reduceLayout = function () {
    var _this = this;
    var totalExtent = this.mContent.blockPos;
    var measure = this.maxParagraphMeasure + this.paddingMeasure;
    /**
     * 这是预期的 measure，由于栏 measure 方向的排版空间是根据栏数量和间距计算的，当排版空间小于一个字的宽度时
     * 栏的实际 measure 就会大于设置的排版空间，所以需要压缩 margin 保证文字不超出预定的排版空间
     * 要求 (实际 measure + 实际 margin) = (预期 measure + 预期 margin)
     * 那么 实际 margin = 预期 measure + 预期 margin - 实际 measure
     * 栏的 margin 都是在右侧，所以直接压缩 margin.end 就可以
     */

    var expectMeasure = resolveSize(this.maxParagraphMeasure + this.paddingMeasure, this.mInlineMeasureSpec);
    var layoutMargin = this.getLayoutParams().margin;
    var boxMargin = new LogicalEdgeSize(layoutMargin); // 在分栏情况下，如果实际 measure 和 预期 measure 不一致，需要重新计算 margin，保证栏最终占据的空间和预期 measure 一致

    if (this.mContext.columnNumber > 1 && measure !== expectMeasure) {
      boxMargin = new LogicalEdgeSize(_assign(_assign({}, layoutMargin), {
        end: layoutMargin.end + (expectMeasure - measure)
      }));
    }
    var extent = resolveSize(totalExtent + this.paddingExtent, this.mBlockMeasureSpec);
    var box = new ColumnBox({
      measure: measure,
      extent: extent
    });
    box.logicPoint = this.mOffset; // 设置相对位置

    box.logicEdge = LogicalBoxEdge.obtain();
    box.logicEdge.margin = boxMargin;
    box.logicEdge.padding = new LogicalEdgeSize(this.mPadding); // 更新children的真实相对坐标

    this.mContent.getBlocks().forEach(function (block) {
      var blockBox = block;
      blockBox.rect = transChildRectToPhysical(_this.mContext.coordinateZero, _this.mContext.lineExpandDirection, block.logicPoint, {
        measure: block.measure,
        extent: block.extent
      }, {
        measure: measure,
        extent: extent
      });
    }); // 更新content logic rect

    this.updateBoxContentLogicFrame(box);
    box.append.apply(box, __spreadArray([], __read(this.mContent.getBlocks())));
    return {
      layoutBoxes: [box]
    };
  };
  /**
   * 每一栏的第一段不需要考虑段前间距
   * @param childLp
   * @returns
   */

  BaseColumnLayout.prototype.getChildMarginBefore = function (childLp) {
    if (this.mContent.isBlockEmpty()) {
      return 0;
    }
    return childLp.margin.before;
  };
  return BaseColumnLayout;
}(BlockLayout);
var BaseLayoutGenerator = function () {
  function BaseLayoutGenerator(context, node) {
    this.mContext = context;
    this.mNode = node;
    this.mIterator = this.createIterator();
  }
  BaseLayoutGenerator.prototype.hasNext = function () {
    return false;
  };
  BaseLayoutGenerator.prototype.getNext = function () {
    return this.mIterator.next();
  };
  BaseLayoutGenerator.prototype.pause = function () {
    this.mIsPaused = true;
  };
  BaseLayoutGenerator.prototype.resume = function () {
    this.mIsPaused = false;
  };
  BaseLayoutGenerator.prototype.onDestroy = function () {// 子类继承实现
  };
  /**
   * 获取开始布局的节点。子类可以重写
   */

  BaseLayoutGenerator.prototype.getBeginChild = function () {
    return this.mNode.getBeginChild();
  };
  BaseLayoutGenerator.prototype.createIterator = function () {
    return __generator(this, function (_a) {
      throw new Error('LayoutGenerator.createIterator must be overrided.');
    });
  };
  return BaseLayoutGenerator;
}();

/**
 * 含有child layout的父级Generator
 */

var LayoutParentGenerator = function (_super) {
  __extends(LayoutParentGenerator, _super);
  function LayoutParentGenerator(context, node, layoutParent) {
    var _this = _super.call(this, context, node) || this;
    _this.mSeekFirst = true;
    _this.mLayoutParent = layoutParent;
    return _this;
  }
  LayoutParentGenerator.prototype.hasNext = function () {
    if (this.mSeekFirst) {
      this.seekBegin();
    }
    if (this.mCurChildLayout) {
      if (this.mCurChildLayout.hasNext()) {
        return true;
      }
      var node = this.mCurChildLayout.getNextNode();
      this.mCurChildLayout.onDestroy();
      if (node) {
        this.mCurChildLayout = this.createChild(node);
        return true;
      }
    }
    return false;
  };
  LayoutParentGenerator.prototype.createIterator = function () {
    var childLayout, layoutValue;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!this.hasNext()) return [3
          /*break*/, 3];
          childLayout = this.mCurChildLayout;
          if (!childLayout) return [3
          /*break*/, 2];
          layoutValue = this.mLayoutParent.layoutChild(childLayout);
          return [4
          /*yield*/, layoutValue];
        case 1:
          _a.sent();
          _a.label = 2;
        case 2:
          return [3
          /*break*/, 0];
        case 3:
          return [2
          /*return*/];
      }
    });
  };
  LayoutParentGenerator.prototype.seekBegin = function () {
    // 初始化childLayout
    var beginModel = this.getBeginChild();
    if (beginModel) {
      this.mCurChildLayout = this.createChild(beginModel);
    }
    this.mSeekFirst = false;
  };
  LayoutParentGenerator.prototype.createChild = function (childNode) {
    var parent = this.createChildLayout(this.mContext, childNode);
    parent.setParent(this.mLayoutParent); // 设置parent

    return parent;
  };
  return LayoutParentGenerator;
}(BaseLayoutGenerator);
var ColumnGenerator = function (_super) {
  __extends(ColumnGenerator, _super);
  function ColumnGenerator(context, node, layoutParent) {
    return _super.call(this, context, node, layoutParent) || this;
  }
  Object.defineProperty(ColumnGenerator.prototype, "isCurrentColumnEnd", {
    /**
     * 当前栏是否结束
     * 如果当前段落没排版完成，说明跨栏了，表示当前栏结束
     */
    get: function get() {
      return this.isCurrentParagraphUnfinished;
    },
    enumerable: false,
    configurable: true
  });
  ColumnGenerator.prototype.hasNext = function () {
    if (this.isCurrentParagraphUnfinished) {
      // 有未排版完成的段落，说明跨栏了，不需要重新生成 paragraphLayout，复用当前 paragraphLayout 继续排剩余内容
      return true;
    }
    return _super.prototype.hasNext.call(this);
  };
  ColumnGenerator.prototype.createChildLayout = function (context, node) {
    return new ParagraphLayout$1(context, node);
  };
  Object.defineProperty(ColumnGenerator.prototype, "isCurrentParagraphUnfinished", {
    /**
     * 当前段落是否排版完成
     */
    get: function get() {
      if (this.mCurChildLayout) {
        return this.mCurChildLayout.isCurrentParagraphUnfinished;
      }
      return false;
    },
    enumerable: false,
    configurable: true
  });
  return ColumnGenerator;
}(LayoutParentGenerator);
var ColumnLayout = function (_super) {
  __extends(ColumnLayout, _super);
  function ColumnLayout() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ColumnLayout.prototype.onLayout = function () {
    var _this = this;
    while (true) {
      var next = this.mGenerator.getNext();
      if (next.done || next.value.layoutBoxes.length < 1) {
        break;
      }
      next.value.layoutBoxes.forEach(function (value) {
        _this.addBox(value);
      }); // 如果当前栏排完了，退出循环生成 columnBox

      if (this.mGenerator.isCurrentColumnEnd) {
        break;
      }
    }
    var columnLayoutValue = this.reduceLayout(); // 清除目前保存的内容，下一栏就是新的内容了

    this.mContent.clearBlocks();
    return columnLayoutValue;
  };
  ColumnLayout.prototype.createGenerator = function (context, node) {
    return new ColumnGenerator(context, node, this);
  };
  return ColumnLayout;
}(BaseColumnLayout);
var id = 0;
function getIncrementId() {
  return id += 1;
}
var BaseParagraphLayout = function (_super) {
  __extends(BaseParagraphLayout, _super);
  function BaseParagraphLayout(context, node) {
    var _this = _super.call(this, context, node) || this;
    _this.maxLineMeasure = 0;
    _this.id = getIncrementId();
    var paraStyle = node.getProperty();
    _this.mParaStyle = paraStyle ? paraStyle : new ParaProperty();
    _this.setParaSpace(node.getPrevSibling() === null, node.getNextSibling() === null);
    return _this;
  }
  BaseParagraphLayout.prototype.addBox = function (box) {
    this.mContent.pushBlock(box); // 记录行最大inline方向size

    var totalMeasure = box.totalMeasure;
    if (totalMeasure > this.maxLineMeasure) {
      this.maxLineMeasure = totalMeasure;
    }
  };
  BaseParagraphLayout.prototype.reduceLayout = function () {
    var _this = this;
    /**
     * 分栏之后可能就会出现空段落的情况
     * 比如刚好排一个新段落的时候，当前栏放不下了
     */

    if (!this.mContent.getBlocks().length) {
      return {
        layoutBoxes: []
      };
    }
    var totalExtent = this.mContent.blockPos;
    var measure = resolveSize(this.maxLineMeasure + this.paddingMeasure, this.mInlineMeasureSpec);
    var extent = resolveSize(totalExtent + this.paddingExtent, this.mBlockMeasureSpec);
    var box = new ParagraphBox({
      measure: measure,
      extent: extent
    }, this.id);
    box.paraProps = this.mParaStyle;
    box.logicPoint = this.mOffset; // 设置相对位置

    box.logicEdge = LogicalBoxEdge.obtain();
    box.logicEdge.margin = this.getParagraphBoxMargin();
    box.logicEdge.padding = new LogicalEdgeSize(this.mPadding); // 更新children的真实相对坐标

    this.mContent.getBlocks().forEach(function (block) {
      var blockBox = block;
      blockBox.rect = transChildRectToPhysical(_this.mContext.coordinateZero, _this.mContext.lineExpandDirection, block.logicPoint, {
        measure: block.measure,
        extent: block.extent
      }, {
        measure: measure,
        extent: extent
      });
    }); // 更新content logic rect

    this.updateBoxContentLogicFrame(box);
    box.append.apply(box, __spreadArray([], __read(this.mContent.getBlocks())));
    return {
      layoutBoxes: [box]
    };
  };
  /**
   * 设置段前，段后间距
   * @param isFirst 是否是首段
   * @param isLast 是否是段尾
   */

  BaseParagraphLayout.prototype.setParaSpace = function (isFirst, isLast) {
    var lp = this.getLayoutParams();
    var _a = this.mParaStyle,
      spaceBefore = _a.spaceBefore,
      spaceAfter = _a.spaceAfter,
      spaceZeroInEdge = _a.spaceZeroInEdge;
    var spcBef = spaceZeroInEdge && isFirst ? 0 : spaceBefore;
    var spcAft = spaceZeroInEdge && isLast ? 0 : spaceAfter;
    lp.setMargins(0, 0, spcBef, spcAft);
  };
  return BaseParagraphLayout;
}(BlockLayout);
var BlockGenerator = function (_super) {
  __extends(BlockGenerator, _super);
  function BlockGenerator(context, node, layoutParent) {
    return _super.call(this, context, node, layoutParent) || this;
  }
  return BlockGenerator;
}(LayoutParentGenerator);
var MAX_PENALTY = 100000;
/**
 * Minimum cost for a breakpoint.
 *
 * Values <= `MIN_COST` force a break.
 */

var MIN_PENALTY = -MAX_PENALTY;
var BaseNodeKind;
(function (BaseNodeKind) {
  BaseNodeKind[BaseNodeKind["Box"] = 0] = "Box";
  BaseNodeKind[BaseNodeKind["Glue"] = 1] = "Glue";
  BaseNodeKind[BaseNodeKind["Penalty"] = 2] = "Penalty";
})(BaseNodeKind || (BaseNodeKind = {}));

/**
 * 区分会影响排版处理逻辑的字符类型
 */

var TokenType;
(function (TokenType) {
  // 特殊类型标记字符遍历的开始
  TokenType[TokenType["Start"] = 0] = "Start"; // 默认字符类型，普通的token，比如拉丁字母，CJK字符等

  TokenType[TokenType["Default"] = 1] = "Default"; // 占位符，一般为嵌入式对象

  TokenType[TokenType["PlaceHolder"] = 2] = "PlaceHolder"; // 空白字符

  TokenType[TokenType["Whitespace"] = 3] = "Whitespace"; // 分页

  TokenType[TokenType["PageBreak"] = 4] = "PageBreak"; // 断行

  TokenType[TokenType["LineBreak"] = 5] = "LineBreak"; // 分节

  TokenType[TokenType["SectionBreak"] = 6] = "SectionBreak"; // 制表位

  TokenType[TokenType["Tabstop"] = 7] = "Tabstop"; // 特指亚洲方形字，包括CJK

  TokenType[TokenType["EAST"] = 8] = "EAST";
})(TokenType || (TokenType = {}));
/**
 * 行内文字最小排版单元
 */

var TypesetBox = function (_super) {
  __extends(TypesetBox, _super);
  function TypesetBox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.kind = BaseNodeKind.Box;
    _this.type = TokenType.Default;
    _this.hanging = false;
    _this.isSeparate = false;
    _this.width = 0;
    _this.height = 0;
    /** width调整值，>0拉伸值, <0压缩值，=0保持原始值，对token而言一般只有标点符号可以压缩 */

    _this.widthAdj = 0;
    return _this;
  }
  TypesetBox.obtain = function (width, range) {
    var obj = TypesetBox.sPool.obtain();
    if (!obj) {
      obj = new TypesetBox();
    }
    obj.range = range;
    obj.width = width;
    return obj;
  };
  TypesetBox.prototype.setSize = function (size) {
    this.width = size.measure;
    this.height = size.extent;
  };
  /**
   * 调整值会累加到width上，并记录widthAdj的值
   */

  TypesetBox.prototype.adjustWidth = function (adj) {
    this.widthAdj = adj;
    this.width += adj;
  };
  TypesetBox.prototype.setBox = function (box) {
    this.box = box;
    this.setSize(box.totalLogicSize);
  };
  TypesetBox.prototype.recycle = function () {
    this.type = TokenType.Default;
    this.range = undefined;
    this.text = undefined;
    this.glyph = undefined;
    this.hanging = false;
    this.width = 0;
    this.widthAdj = 0;
    this.height = 0;
    this.box = undefined;
    TypesetBox.sPool.recycle(this);
  };
  TypesetBox.sPool = new ObjectPool(600);
  return TypesetBox;
}(PoolNode);
var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var inited = false;
function init() {
  inited = true;
  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  for (var i = 0, len = code.length; i < len; ++i) {
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
  }
  revLookup['-'.charCodeAt(0)] = 62;
  revLookup['_'.charCodeAt(0)] = 63;
}
function toByteArray(b64) {
  if (!inited) {
    init();
  }
  var i, j, l, tmp, placeHolders, arr;
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

  // base64 is 4/3 + up to two characters of the original data
  arr = new Arr(len * 3 / 4 - placeHolders);

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len;
  var L = 0;
  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[L++] = tmp >> 16 & 0xFF;
    arr[L++] = tmp >> 8 & 0xFF;
    arr[L++] = tmp & 0xFF;
  }
  if (placeHolders === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[L++] = tmp & 0xFF;
  } else if (placeHolders === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[L++] = tmp >> 8 & 0xFF;
    arr[L++] = tmp & 0xFF;
  }
  return arr;
}
function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}
function fromByteArray(uint8) {
  if (!inited) {
    init();
  }
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var output = '';
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    output += lookup[tmp >> 2];
    output += lookup[tmp << 4 & 0x3F];
    output += '==';
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    output += lookup[tmp >> 10];
    output += lookup[tmp >> 4 & 0x3F];
    output += lookup[tmp << 2 & 0x3F];
    output += '=';
  }
  parts.push(output);
  return parts.join('');
}
function read(buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];
  i += d;
  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
}
function write(buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
  buffer[offset + i - d] |= s * 128;
}
var toString = {}.toString;
var isArray = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

var INSPECT_MAX_BYTES = 50;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined ? global$1.TYPED_ARRAY_SUPPORT : true;
function kMaxLength() {
  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length');
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length);
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length);
    }
    that.length = length;
  }
  return that;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length);
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error('If encoding is specified then the first argument must be a string');
    }
    return allocUnsafe(this, arg);
  }
  return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192; // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype;
  return arr;
};
function from(that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number');
  }
  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length);
  }
  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset);
  }
  return fromObject(that, value);
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;
}
function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number');
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative');
  }
}
function alloc(that, size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
  }
  return createBuffer(that, size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that;
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }
  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding');
  }
  var length = byteLength(string, encoding) | 0;
  that = createBuffer(that, length);
  var actual = that.write(string, encoding);
  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
  }
  return that;
}
function fromArrayLike(that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length);
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255;
  }
  return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds');
  }
  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds');
  }
  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array);
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length);
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array;
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
  }
  return that;
}
function fromObject(that, obj) {
  if (internalIsBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);
    if (that.length === 0) {
      return that;
    }
    obj.copy(that, 0, 0, len);
    return that;
  }
  if (obj) {
    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0);
      }
      return fromArrayLike(that, obj);
    }
    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data);
    }
  }
  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function checked(length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
  }
  return length | 0;
}
Buffer.isBuffer = isBuffer;
function internalIsBuffer(b) {
  return !!(b != null && b._isBuffer);
}
Buffer.compare = function compare(a, b) {
  if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
    throw new TypeError('Arguments must be Buffers');
  }
  if (a === b) return 0;
  var x = a.length;
  var y = b.length;
  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};
Buffer.concat = function concat(list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }
  if (list.length === 0) {
    return Buffer.alloc(0);
  }
  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }
  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (!internalIsBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer;
};
function byteLength(string, encoding) {
  if (internalIsBuffer(string)) {
    return string.length;
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    string = '' + string;
  }
  var len = string.length;
  if (len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }
  if (end === undefined || end > this.length) {
    end = this.length;
  }
  if (end <= 0) {
    return '';
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;
  if (end <= start) {
    return '';
  }
  if (!encoding) encoding = 'utf8';
  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);
      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);
      case 'ascii':
        return asciiSlice(this, start, end);
      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);
      case 'base64':
        return base64Slice(this, start, end);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};
Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};
Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};
Buffer.prototype.toString = function toString() {
  var length = this.length | 0;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
  if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    if (this.length > max) str += ' ... ';
  }
  return '<Buffer ' + str + '>';
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (!internalIsBuffer(target)) {
    throw new TypeError('Argument must be a Buffer');
  }
  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }
  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }
  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }
  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;
  if (this === target) return 0;
  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);
  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);
  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (internalIsBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }
  throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;
  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }
  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }
  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }
  return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }

  // must be an even number of digits
  var strLen = string.length;
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}
function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0;
    if (isFinite(length)) {
      length = length | 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
    // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }
  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;
  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }
  if (!encoding) encoding = 'utf8';
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);
      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);
      case 'ascii':
        return asciiWrite(this, string, offset, length);
      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length);
      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};
Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return fromByteArray(buf);
  } else {
    return fromByteArray(buf.slice(start, end));
  }
}
function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];
  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;
      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }
    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }
    res.push(codePoint);
    i += bytesPerSequence;
  }
  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}
function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}
function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}
function hexSlice(buf, start, end) {
  var len = buf.length;
  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;
  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }
  return out;
}
function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}
Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;
  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }
  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }
  if (end < start) end = start;
  var newBuf;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer.prototype;
  } else {
    var sliceLen = end - start;
    newBuf = new Buffer(sliceLen, undefined);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start];
    }
  }
  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }
  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }
  return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
  if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset] = value & 0xff;
  return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
  }
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
  }
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4);
  }
  write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8);
  }
  write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }
  var len = end - start;
  var i;
  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
  }
  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }
  if (end <= start) {
    return this;
  }
  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;
  if (!val) val = 0;
  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = internalIsBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }
  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}
function stringtrim(str) {
  if (str.trim) return str.trim();
  return str.replace(/^\s+|\s+$/g, '');
}
function toHex(n) {
  if (n < 16) return '0' + n.toString(16);
  return n.toString(16);
}
function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];
  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;
        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }
    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }
  return bytes;
}
function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}
function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;
    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }
  return byteArray;
}
function base64ToBytes(str) {
  return toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}
function isnan(val) {
  return val !== val; // eslint-disable-line no-self-compare
}

// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function isBuffer(obj) {
  return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj));
}
function isFastBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0));
}
function e(e, t) {
  var r = t || 0,
    n = e.charCodeAt(r);
  if (55296 <= n && n <= 56319) {
    var i = n;
    return 56320 <= (a = e.charCodeAt(r + 1)) && a <= 57343 ? 1024 * (i - 55296) + (a - 56320) + 65536 : i;
  }
  if (56320 <= n && n <= 57343) {
    var a = n;
    return 55296 <= (i = e.charCodeAt(r - 1)) && i <= 56319 ? 1024 * (i - 55296) + (a - 56320) + 65536 : a;
  }
  return n;
}
function t$1(e) {
  for (var t = [], r = 0, n = e.length; r < n;) {
    var i = e.charCodeAt(r);
    if (r += 1, i >= 55296 && i <= 56319 && r < n) {
      var a = e.charCodeAt(r);
      r += 1, 56320 == (64512 & a) ? t.push(((1023 & i) << 10) + (1023 & a) + 65536) : (t.push(i), r -= 1);
    } else t.push(i);
  }
  return t;
}
function r$1() {
  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
  if (String.fromCodePoint) return String.fromCodePoint.apply(String, e);
  var r = e.length;
  if (!r) return "";
  for (var n = [], i = 0, a = ""; i < r;) {
    var o = e[i];
    o <= 65535 ? n.push(o) : (o -= 65536, n.push(55296 + (o >> 10), o % 1024 + 56320)), (i + 1 === r || n.length > 26434) && (a += String.fromCharCode.apply(String, n), n.length = 0), i += 1;
  }
  return a;
}
function n$1(e) {
  return 55296 <= e && e <= 56319;
}
function i$1(e) {
  return 56320 <= e && e <= 57343;
}
var a$1 = {
    isEmojiShift: 0,
    isEmojiPresentationShift: 1,
    isEmojiModifierShift: 2,
    isEmojiModifierBaseShift: 3,
    isEmojiComponentShift: 4,
    isExtPictographicShift: 5
  },
  o$1 = Object.freeze({
    __proto__: null,
    isEmojiShift: 0,
    isEmojiPresentationShift: 1,
    isEmojiModifierShift: 2,
    isEmojiModifierBaseShift: 3,
    isEmojiComponentShift: 4,
    isExtPictographicShift: 5,
    "default": a$1
  });
function u$1() {
  var e = null === navigator || void 0 === navigator ? void 0 : navigator.userAgent;
  return /msie/i.test(e) && !function () {
    var e = null === navigator || void 0 === navigator ? void 0 : navigator.userAgent;
    return /opera/i.test(e);
  }() || /trident/i.test(e);
}
function f$1() {
  this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
}
function d$1(e, t) {
  this.source = e, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = t, this.destLen = 0, this.ltree = new f$1(), this.dtree = new f$1();
}
var s$1 = new f$1(),
  c$1 = new f$1(),
  h$1 = new Uint8Array(30),
  l$1 = new Uint16Array(30),
  v$1 = new Uint8Array(30),
  p$1 = new Uint16Array(30),
  C = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
  g$1 = new f$1(),
  x$1 = new Uint8Array(320);
function A$1(e, t, r, n) {
  var i, a;
  for (i = 0; i < r; ++i) e[i] = 0;
  for (i = 0; i < 30 - r; ++i) e[i + r] = i / r | 0;
  for (a = n, i = 0; i < 30; ++i) t[i] = a, a += 1 << e[i];
}
var y$1 = new Uint16Array(16);
function P$1(e, t, r, n) {
  var i, a;
  for (i = 0; i < 16; ++i) e.table[i] = 0;
  for (i = 0; i < n; ++i) e.table[t[r + i]]++;
  for (e.table[0] = 0, a = 0, i = 0; i < 16; ++i) y$1[i] = a, a += e.table[i];
  for (i = 0; i < n; ++i) t[r + i] && (e.trans[y$1[t[r + i]]++] = i);
}
function m(e) {
  e.bitcount-- || (e.tag = e.source[e.sourceIndex++], e.bitcount = 7);
  var t = 1 & e.tag;
  return e.tag >>>= 1, t;
}
function b$1(e, t, r) {
  if (!t) return r;
  for (; e.bitcount < 24;) e.tag |= e.source[e.sourceIndex++] << e.bitcount, e.bitcount += 8;
  var n = e.tag & 65535 >>> 16 - t;
  return e.tag >>>= t, e.bitcount -= t, n + r;
}
function L$1(e, t) {
  for (; e.bitcount < 24;) e.tag |= e.source[e.sourceIndex++] << e.bitcount, e.bitcount += 8;
  var r = 0,
    n = 0,
    i = 0,
    a = e.tag;
  do {
    n = 2 * n + (1 & a), a >>>= 1, ++i, r += t.table[i], n -= t.table[i];
  } while (n >= 0);
  return e.tag = a, e.bitcount -= i, t.trans[r + n];
}
function N$1(e, t, r) {
  var n, i, a, o, u, f;
  for (n = b$1(e, 5, 257), i = b$1(e, 5, 1), a = b$1(e, 4, 4), o = 0; o < 19; ++o) x$1[o] = 0;
  for (o = 0; o < a; ++o) {
    var d = b$1(e, 3, 0);
    x$1[C[o]] = d;
  }
  for (P$1(g$1, x$1, 0, 19), u = 0; u < n + i;) {
    var s = L$1(e, g$1);
    switch (s) {
      case 16:
        var c = x$1[u - 1];
        for (f = b$1(e, 2, 3); f; --f) x$1[u++] = c;
        break;
      case 17:
        for (f = b$1(e, 3, 3); f; --f) x$1[u++] = 0;
        break;
      case 18:
        for (f = b$1(e, 7, 11); f; --f) x$1[u++] = 0;
        break;
      default:
        x$1[u++] = s;
    }
  }
  P$1(t, x$1, 0, n), P$1(r, x$1, n, i);
}
function O$1(e, t, r) {
  for (;;) {
    var n,
      i,
      a,
      o,
      u = L$1(e, t);
    if (256 === u) return 0;
    if (u < 256) e.dest[e.destLen++] = u;else for (n = b$1(e, h$1[u -= 257], l$1[u]), i = L$1(e, r), o = a = e.destLen - b$1(e, v$1[i], p$1[i]); o < a + n; ++o) e.dest[e.destLen++] = e.dest[o];
  }
}
function I$1(e) {
  for (var t, r; e.bitcount > 8;) e.sourceIndex--, e.bitcount -= 8;
  if ((t = 256 * (t = e.source[e.sourceIndex + 1]) + e.source[e.sourceIndex]) !== (65535 & ~(256 * e.source[e.sourceIndex + 3] + e.source[e.sourceIndex + 2]))) return -3;
  for (e.sourceIndex += 4, r = t; r; --r) e.dest[e.destLen++] = e.source[e.sourceIndex++];
  return e.bitcount = 0, 0;
}
!function (e, t) {
  var r;
  for (r = 0; r < 7; ++r) e.table[r] = 0;
  for (e.table[7] = 24, e.table[8] = 152, e.table[9] = 112, r = 0; r < 24; ++r) e.trans[r] = 256 + r;
  for (r = 0; r < 144; ++r) e.trans[24 + r] = r;
  for (r = 0; r < 8; ++r) e.trans[168 + r] = 280 + r;
  for (r = 0; r < 112; ++r) e.trans[176 + r] = 144 + r;
  for (r = 0; r < 5; ++r) t.table[r] = 0;
  for (t.table[5] = 32, r = 0; r < 32; ++r) t.trans[r] = r;
}(s$1, c$1), A$1(h$1, l$1, 4, 3), A$1(v$1, p$1, 2, 1), h$1[28] = 0, l$1[28] = 258;
var S$1,
  w$1,
  T,
  k$1 = function k(e, t) {
    var r,
      n,
      i = new d$1(e, t);
    do {
      switch (r = m(i), b$1(i, 2, 0)) {
        case 0:
          n = I$1(i);
          break;
        case 1:
          n = O$1(i, s$1, c$1);
          break;
        case 2:
          N$1(i, i.ltree, i.dtree), n = O$1(i, i.ltree, i.dtree);
          break;
        default:
          n = -3;
      }
      if (0 !== n) throw new Error("Data error");
    } while (!r);
    return i.destLen < i.dest.length ? "function" == typeof i.dest.slice ? i.dest.slice(0, i.destLen) : i.dest.subarray(0, i.destLen) : i.dest;
  },
  W$1 = function () {
    function e(e) {
      var t = e,
        r = "function" == typeof t.readUInt32BE && "function" == typeof t.slice;
      if (r || t instanceof Uint8Array) {
        var n = void 0;
        if (r) this.highStart = t.readUInt32BE(0), this.errorValue = t.readUInt32BE(4), n = t.readUInt32BE(8), t = t.slice(12);else {
          var i = new DataView(t.buffer);
          this.highStart = i.getUint32(0), this.errorValue = i.getUint32(4), n = i.getUint32(8), t = t.subarray(12);
        }
        var a = k$1(t, new Uint8Array(n));
        if ((a = k$1(a, new Uint8Array(n))).length !== n) throw new Error("Data unzip failed.!!!");
        this.data = new Uint32Array(a.buffer);
      } else this.data = t.data, this.highStart = t.highStart, this.errorValue = t.errorValue;
    }
    return e.prototype.get = function (e) {
      if (e < 0 || e > 1114111) return this.errorValue;
      if (e < 55296 || e > 56319 && e <= 65535) {
        var t = (this.data[e >> 5] << 2) + (31 & e);
        return this.data[t];
      }
      if (e <= 65535) {
        t = (this.data[2048 + (e - 55296 >> 5)] << 2) + (31 & e);
        return this.data[t];
      }
      if (e < this.highStart) {
        t = this.data[2080 + (e >> 11)];
        return t = ((t = this.data[t + (e >> 5 & 63)]) << 2) + (31 & e), this.data[t];
      }
      return this.data[this.data.length - 4];
    }, e;
  }(),
  z$1 = function () {
    function e(e) {
      this.init = e;
    }
    return e.prototype.getValue = function () {
      return void 0 === this.value && (this.value = this.init()), this.value;
    }, e.prototype.doIdly = function (e) {
      this.init = e(this.init);
    }, e;
  }(),
  H$1 = "function" == typeof Proxy && ("undefined" != typeof window ? (w$1 = null === navigator || void 0 === navigator ? void 0 : navigator.userAgent, /chrome/i.test(w$1) ? ((S$1 = (null === navigator || void 0 === navigator ? void 0 : navigator.userAgent).match(/Chrom(e|ium)\/([0-9]+)\./)) ? parseInt(S$1[2], 10) : 0) >= 53 : !u$1()) : "undefined" != typeof global$1);
!function (e) {
  e[e.CommonProps = 0] = "CommonProps", e[e.Emoji = 1] = "Emoji", e[e.GraphemeBreak = 2] = "GraphemeBreak", e[e.LineBreak = 3] = "LineBreak";
}(T || (T = {}));
var E$1 = new (function () {
    function e() {
      this.idleValues = [];
    }
    return e.prototype.bindIdleWrapper = function (e) {
      this.wrapper = e;
      for (var t = this.idleValues; t.length > 0;) {
        var r = t.pop();
        null == r || r.doIdly(e);
      }
    }, e.prototype.createTrie = function (e) {
      var t = this;
      if (!H$1) return new W$1(this.readData(e));
      var r = this.createIdleValue(function () {
        return new W$1(t.readData(e));
      });
      return new Proxy(Object.create(null), {
        get: function get(e, t) {
          if (t in e) return e[t];
          if ("constructor" === t) return W$1;
          if ("prototype" === t) return W$1.prototype;
          var n = r.getValue(),
            i = n[t];
          return "function" != typeof i || (i = i.bind(n), e[t] = i), i;
        },
        set: function set(e, t, n) {
          return e[t] = n, r.getValue()[t] = n, !0;
        },
        defineProperty: function defineProperty(e, t, n) {
          var i = r.getValue();
          return Object.defineProperty(i, t, n), !0;
        },
        getPrototypeOf: function getPrototypeOf() {
          return W$1.prototype;
        }
      });
    }, e.prototype.createIdleValue = function (e) {
      var t = new z$1(e);
      return this.wrapper ? t.doIdly(this.wrapper) : this.idleValues.push(t), t;
    }, e.prototype.readData = function (e) {
      switch (e) {
        case T.CommonProps:
          return Buffer("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", "base64");
        case T.Emoji:
          return Buffer("AA4IAAAAAAAAAF4wAW8EkPvtmj1oFEEUgCd4q8QkogSxEGGXQ/A4rGKnlWIhaGEhCBaijURttDNpIlroKSiKKCKaIAhBSKEokkIhZaxi5U+jNmohFhYWFvqOm/HGyZv/2Z07nQcfMzs/72/ezrnByRWEnAMuAdeBGWAWaAHX/oN2UqCFjPULou+6WPo51l6n1Sf5nQMeAfPI3AJtF7mxJeC1hf53wEfu+TNtvwLfFft+KuYGaoQMAkPAKLARqANNYAzYDuwC9gD7gYPAYeAYcBw4XbPL0YTlep6zdO9FDx02Neey70lAH65UEGcikUgkEolEIpFIJBKm9MPfZhKJRCJRHq3IxI4/kUiUQxXv94seiNOHk2s6nAe2RKBYTcgRYAb4ABRD0A4Scndlp91Ln3kuw9gU6fISWTM0TEhzuPt8Avo3gFngC9AYIWR85G89IViV6ddM09huDy/3O5FIJBLVMDsS/xskNr7/ZvL5pqrans1+LDem9kzW2ebf9Cx151vWN7CpPpv6863XlkaXbN4m77bx2tRfGfVQ1vm71IrLfRGTsnIQw75JjZWVc5taqKpOY9dWiLP3yVXs+Fzjj20/RK5d11RJ7PPvtbqbROar9MXX/5ahnps1Qu4A05T7wEPgMfCM/n/z57RdgHax1tW7BP03wHvgE/Cttlz/Dxj7Veu0WUbISNbpr4d2E+1vhnYrsA3YAeyk47tpuw/aA8Ah4CgwDpwCztD5NlNZx692/wL0rwK3Mnl+7mX6/LV5AOvmgKfAPLW3AO0i7fOxvsri17NLzb3Nuti8H//CvTGxYuAPvSTrHObWGZIkiUwKwzFXWRtQl624xBEydpX0W156RTeGi44qpU7RSdl+5SXr5yVULHUB/tzrQh/zweS8q64HzL6ND6ZrY8fFC39OdWGMJ6dzuYIC6RNON7aO0UDmC4LrVD1jujE/VWsLIvczJ8trX4fOH1UMWC5MYrSxx/dV/pqKqA+rJdkZm/jBkOXXtA5MdGFzqrrA4rOtAd2+gpuvC2vZXEPYL8sTP8+E6WhSGqT7for1QpAWE9WcyW+w6JuNFJK+aB/zg3+PZWt0tsV6qUJEv3Vim1PRVoy9MnGtEZd9OrE5AxudJmNliMm7ngu43H8+6PypGlsJYctXh+teVoc+9m1j9ZEQegri/jcNl31M6kLfBJWMVgTz1yd2EwlxJ+pyXBD731oTmz66cglVie33URm0zyWnFAaY6owZj2q+6aFbzJOYM3Get8nA/OC/HVR5Njkf27OyiZmvF1H/BoTYdc1aLPemhPBFp7MpWafzR6arKdFZVe6rtIWdex7Rfhud5ER+VzBCxJArwO4s8Q5iNDW6ckQXdi82kH2sNnX6WT5EOyZ+maxT6cNiMcVmL7a2IHLfVDrFOd1ak7tLNs7wldB3iO3dJ1sn5qsNey/4M8P22Ij43mB1w56xu0asG9f7yUdygZBic97Yb6DtuZvol9kkwh6V/yaxhUKWSzHPOp9cZExAPBvdPeJr3+YMsbsjdySUrI2MKL8B", "base64");
        case T.GraphemeBreak:
          return Buffer("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", "base64");
        case T.LineBreak:
          return Buffer("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", "base64");
        default:
          throw Error();
      }
    }, e;
  }())(),
  j$1 = o$1;
j$1.isEmojiShift;
j$1.isEmojiPresentationShift;
j$1.isEmojiModifierShift;
j$1.isEmojiModifierBaseShift;
j$1.isEmojiComponentShift;
var M$1 = j$1.isExtPictographicShift,
  D$1 = 1 << M$1,
  K = E$1.createTrie(T.Emoji);
function re(e) {
  return 0 != (K.get(e) & D$1);
}
var ne = {
    Other: 0,
    Control: 1,
    LF: 2,
    CR: 3,
    Extend: 4,
    Prepend: 5,
    SpacingMark: 6,
    L: 7,
    V: 8,
    T: 9,
    ZWJ: 10,
    LV: 11,
    LVT: 12,
    Regional_Indicator: 13
  },
  ie = Object.freeze({
    __proto__: null,
    Other: 0,
    Control: 1,
    LF: 2,
    CR: 3,
    Extend: 4,
    Prepend: 5,
    SpacingMark: 6,
    L: 7,
    V: 8,
    T: 9,
    ZWJ: 10,
    LV: 11,
    LVT: 12,
    Regional_Indicator: 13,
    "default": ne
  }),
  ae = ie.Control,
  oe = ie.LF,
  ue = ie.CR,
  fe = ie.Extend,
  de = ie.Prepend,
  se = ie.SpacingMark,
  ce = ie.L,
  he = ie.V,
  le = ie.T,
  ve = ie.ZWJ,
  pe = ie.LV,
  Ce = ie.LVT,
  ge = ie.Regional_Indicator,
  xe = E$1.createTrie(T.GraphemeBreak);
function Ae(e, t, r) {
  var n = t[0],
    i = r[0];
  if (n === ue && i === oe) return !1;
  if (n === ae || n === ue || n === oe) return !0;
  if (i === ae || i === ue || i === oe) return !0;
  if (n === ce && (i === ce || i === he || i === pe || i === Ce)) return !1;
  if (!(n !== pe && n !== he || i !== he && i !== le)) return !1;
  if ((n === Ce || n === le) && i === le) return !1;
  if (i === fe || i === ve) return !1;
  if (i === se) return !1;
  if (n === de) return !1;
  if (n === ve && r[1]) {
    for (var a = 0, o = !1, u = e.length - 1; u >= 0; u--) {
      if ((d = e[u])[0] !== fe) {
        o = d[1];
        break;
      }
      a += 1;
    }
    return !(a >= 0 && o);
  }
  if (i === ge && n === ge) {
    var f = 0;
    for (u = e.length - 1; u >= 0; u--) {
      var d;
      if ((d = e[u])[0] !== ge) break;
      f += 1;
    }
    return f % 2 != 0;
  }
  return !0;
}
function ye(t, r) {
  if (void 0 === r && (r = 0), r < 0) return 0;
  if (r >= t.length - 1) return t.length;
  for (var n = [], i = e(t, r), a = xe.get(i), o = re(i), u = r + 1; u < t.length; u++) if (!(t.charCodeAt(u - 1) <= 56319 && t.charCodeAt(u - 1) >= 55296 && t.charCodeAt(u) <= 57343 && t.charCodeAt(u) >= 56320)) {
    var f = e(t, u),
      d = xe.get(f),
      s = re(f);
    if (Ae(n, [a, o], [d, s])) return u;
    n.push([a, o]), a = d, o = s;
  }
  return t.length;
}
var Le = E$1.createTrie(T.CommonProps),
  Ne = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Mende_Kikakui","Adlam"],"eastAsiaWidths":["N","Na","A","W","H","F"]}'),
  Oe = Math.log2 || function (e) {
    return Math.log(e) / Math.LN2;
  },
  Ie = function Ie(e) {
    return Oe(e) + 1 | 0;
  },
  Se = Ie(Ne.categories.length - 1),
  we = Ie(Ne.combiningClasses.length - 1),
  Te = Ie(Ne.scripts.length - 1),
  ke = Ie(Ne.eastAsiaWidths.length - 1),
  We = we + Te + ke + 10,
  He = ke + 10,
  Ee = (1 << Se) - 1,
  je = (1 << Te) - 1,
  Ue = function Ue(e) {
    var t = Le.get(e);
    return Ne.categories[t >> We & Ee];
  },
  Be = function Be(e) {
    var t = Le.get(e);
    return Ne.scripts[t >> He & je];
  },
  Ke = function Ke(e) {
    var t = Ue(e);
    return "Zs" === t || "Zl" === t || "Zp" === t;
  },
  $e = function () {
    function e(e) {
      this.codePoints = e;
    }
    return e.fromStringSlice = function (r, n, i) {
      return new e(t$1(r.slice(n, i + 1)));
    }, e.prototype.toString = function () {
      return r$1.apply(void 0, this.codePoints);
    }, e;
  }(),
  et = function () {
    function e(e) {
      this.codePointGenerated = !1, this.codePoint2CharCodeIndexMap = [], this.charCode2CodePointIndexMap = [], this.graphemeGenerated = !1, this.graphemeIndecies = [], this.str = e;
    }
    return e.prototype.codePoints = function () {
      return this.generateCodePoints(), this._codePoints || [];
    }, e.prototype.toString = function () {
      return this.str;
    }, e.prototype.graphemes = function () {
      var e = this;
      return this.generateGraphemes(), this.graphemeIndecies.map(function (t) {
        return $e.fromStringSlice(e.str, t.start, t.end);
      });
    }, e.prototype.charCodeCount = function () {
      return this.str.length;
    }, e.prototype.codePointCount = function () {
      return this.codePoints().length;
    }, e.prototype.graphemeCount = function () {
      return this.generateGraphemes(), this.graphemeIndecies.length;
    }, e.prototype.codePointAt = function (e) {
      return this.codePoints()[e];
    }, e.prototype.codePointAtCharCodePoint = function (e) {
      var t = this.charCodeIndex2CodePointIndex(e);
      return this.codePointAt(t);
    }, e.prototype.charCodeAt = function (e) {
      return this.str.charCodeAt(e);
    }, e.prototype.graphemeAt = function (e) {
      this.generateGraphemes();
      var t = this.graphemeIndecies[e];
      return $e.fromStringSlice(this.str, t.start, t.end);
    }, e.prototype.codePointIndex2CharCodeIndexRange = function (e) {
      return this.generateCodePoints(), this.codePoint2CharCodeIndexMap[e];
    }, e.prototype.graphemeIndex2CharCodeIndexRange = function (e) {
      return this.generateGraphemes(), this.graphemeIndecies[e];
    }, e.prototype.charCodeIndex2CodePointIndex = function (e) {
      return this.generateCodePoints(), this.charCode2CodePointIndexMap[e];
    }, e.prototype.charCodeIndex2GraphemeIndex = function (e) {
      this.generateGraphemes();
      for (var t = 0, r = this.graphemeIndecies.length - 1; t <= r;) {
        var n = t + Math.floor((r - t) / 2),
          i = this.graphemeIndecies[n];
        if (i.start <= e && i.end >= e) return n;
        if (e < i.start) r = n - 1;else {
          if (!(e > i.end)) throw new Error("Error binary search grapheme index from char code index. Must be a bug.");
          t = n + 1;
        }
      }
      return -1;
    }, e.prototype.sliceByCharCode = function (t, r) {
      var n = void 0 === r ? this.charCodeCount() : r;
      return new e(this.str.slice(t, n));
    }, e.prototype.sliceByGrapheme = function (t, r) {
      this.generateGraphemes();
      var n = void 0 === r ? this.graphemeCount() : r,
        i = this.graphemeIndex2CharCodeIndexRange(t).start,
        a = this.graphemeIndex2CharCodeIndexRange(n - 1).end;
      return new e(this.str.slice(i, a + 1));
    }, e.prototype.sliceByCodePoint = function (t, r) {
      var n = void 0 === r ? this.codePointCount() : r,
        i = this.codePointIndex2CharCodeIndexRange(t).start,
        a = this.codePointIndex2CharCodeIndexRange(n - 1).end;
      return new e(this.str.slice(i, a + 1));
    }, e.prototype.generateCodePoints = function () {
      if (!this.codePointGenerated) {
        for (var e = [], t = [], r = [], a = this.str.length, o = 0; o < a; o++) {
          var u = this.str.charCodeAt(o);
          if (n$1(u) && o <= a - 1) {
            var f = this.str.charCodeAt(o + 1);
            if (i$1(f)) {
              o += 1, r.push(((1023 & u) << 10) + (1023 & f) + 65536), e.push({
                start: o - 1,
                end: o
              });
              var d = r.length - 1;
              t[o - 1] = d, t[o] = d;
              continue;
            }
          }
          r.push(u), e.push({
            start: o,
            end: o
          }), t[o] = r.length - 1;
        }
        this._codePoints = r, this.codePoint2CharCodeIndexMap = e, this.charCode2CodePointIndexMap = t, this.codePointGenerated = !0;
      }
    }, e.prototype.generateGraphemes = function () {
      if (!this.graphemeGenerated) {
        for (var e = this.str.length, t = [], r = 0; r < e;) {
          var n = ye(this.str, r);
          t.push({
            start: r,
            end: n - 1
          }), r = n;
        }
        this.graphemeIndecies = t, this.graphemeGenerated = !0;
      }
    }, e;
  }(),
  tt = {
    XX: 0,
    CM: 1,
    BA: 2,
    LF: 3,
    BK: 4,
    CR: 5,
    SP: 6,
    EX: 7,
    QU: 8,
    AL: 9,
    PR: 10,
    PO: 11,
    OP: 12,
    CP: 13,
    IS: 14,
    HY: 15,
    SY: 16,
    NU: 17,
    CL: 18,
    NL: 19,
    GL: 20,
    AI: 21,
    BB: 22,
    HL: 23,
    SA: 24,
    JL: 25,
    JV: 26,
    JT: 27,
    NS: 28,
    ZW: 29,
    ZWJ: 30,
    B2: 31,
    IN: 32,
    WJ: 33,
    ID: 34,
    EB: 35,
    CJ: 36,
    H2: 37,
    H3: 38,
    SG: 39,
    CB: 40,
    RI: 41,
    EM: 42
  },
  rt = Object.freeze({
    __proto__: null,
    XX: 0,
    CM: 1,
    BA: 2,
    LF: 3,
    BK: 4,
    CR: 5,
    SP: 6,
    EX: 7,
    QU: 8,
    AL: 9,
    PR: 10,
    PO: 11,
    OP: 12,
    CP: 13,
    IS: 14,
    HY: 15,
    SY: 16,
    NU: 17,
    CL: 18,
    NL: 19,
    GL: 20,
    AI: 21,
    BB: 22,
    HL: 23,
    SA: 24,
    JL: 25,
    JV: 26,
    JT: 27,
    NS: 28,
    ZW: 29,
    ZWJ: 30,
    B2: 31,
    IN: 32,
    WJ: 33,
    ID: 34,
    EB: 35,
    CJ: 36,
    H2: 37,
    H3: 38,
    SG: 39,
    CB: 40,
    RI: 41,
    EM: 42,
    "default": tt
  }),
  nt = rt.XX,
  it = rt.CM,
  at = rt.BA,
  ot = rt.LF,
  ut = rt.BK,
  ft = rt.CR,
  dt = rt.SP,
  st = rt.EX,
  ct = rt.QU,
  ht = rt.AL,
  lt = rt.PR,
  vt = rt.PO,
  pt = rt.OP,
  Ct = rt.CP,
  gt = rt.IS,
  xt = rt.HY,
  At = rt.SY,
  yt = rt.NU,
  Pt = rt.CL,
  mt = rt.NL,
  bt = rt.GL,
  Lt = rt.AI,
  Nt = rt.BB,
  Ot = rt.HL,
  It = rt.SA,
  St = rt.JL,
  wt = rt.JV,
  Tt = rt.JT,
  kt = rt.NS,
  Wt = rt.ZW,
  zt = rt.ZWJ,
  Ht = rt.B2,
  Et = rt.IN,
  Xt = rt.WJ,
  jt = rt.ID,
  Rt = rt.EB,
  Ut = rt.CJ,
  Vt = rt.H2,
  Bt = rt.H3;
rt.SG;
var Jt,
  Mt = rt.CB,
  Zt = rt.RI,
  Ft = rt.EM,
  qt = [ht, Ot],
  Yt = [ut, ft, ot, mt],
  Gt = [dt, Wt],
  Dt = [lt, vt],
  Kt = [St, wt, Tt, Vt, Bt],
  Qt = [xt, at],
  _t = Yt.concat(Gt, Wt);
function $t(e, t) {
  for (var r = e; r >= 0;) {
    var n = t[r];
    if (n !== dt) return n;
    r -= 1;
  }
  return -1;
}
function er(e, t, r, n) {
  var i = n[r];
  if (Array.isArray(e) ? -1 !== e.indexOf(i) : e === i) for (var a = r; a <= n.length;) {
    if ((f = n[a += 1]) === t) return !0;
    if (f !== dt) break;
  }
  if (i === dt) for (a = r; a > 0;) {
    var o = n[a -= 1];
    if (Array.isArray(e) ? -1 !== e.indexOf(o) : e === o) for (var u = r; u <= n.length;) {
      var f;
      if ((f = n[u += 1]) === t) return !0;
      if (f !== dt) break;
    }
    if (o !== dt) break;
  }
  return !1;
}
!function (e) {
  e[e.Mandatory = 0] = "Mandatory", e[e.Allowed = 1] = "Allowed", e[e.NotAllowed = 2] = "NotAllowed";
}(Jt || (Jt = {}));
var tr,
  rr,
  nr,
  ir = [function (e) {
    var t = e.current,
      r = e.next;
    if (t === ft && r === ot) return Jt.NotAllowed;
  }, function (e) {
    var t = e.current;
    if (-1 !== Yt.indexOf(t)) return Jt.Mandatory;
  }, function (e) {
    var t = e.next;
    if (-1 !== Yt.indexOf(t)) return Jt.NotAllowed;
  }, function (e) {
    var t = e.next;
    if (-1 !== Gt.indexOf(t)) return Jt.NotAllowed;
  }, function (e) {
    if ($t(e.index, e.types) === Wt) return Jt.Allowed;
  }, function (e) {
    if (e.current === zt) return Jt.NotAllowed;
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (t === Xt || r === Xt) return Jt.NotAllowed;
  }, function (e) {
    if (e.current === bt) return Jt.NotAllowed;
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (-1 === [dt, at, xt].indexOf(t) && r === bt) return Jt.NotAllowed;
  }, function (e) {
    var t = e.next;
    if (-1 !== [Pt, Ct, st, gt, At].indexOf(t)) return Jt.NotAllowed;
  }, function (e) {
    if ($t(e.index, e.types) === pt) return Jt.NotAllowed;
  }, function (e) {
    var t = e.index,
      r = e.types;
    if (er(ct, pt, t, r)) return Jt.NotAllowed;
  }, function (e) {
    var t = e.index,
      r = e.types;
    if (er([Pt, Ct], kt, t, r)) return Jt.NotAllowed;
  }, function (e) {
    var t = e.index,
      r = e.types;
    if (er(Ht, Ht, t, r)) return Jt.NotAllowed;
  }, function (e) {
    if (e.current === dt) return Jt.Allowed;
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (t === ct || r === ct) return Jt.NotAllowed;
  }, function (e) {
    var t = e.next,
      r = e.current;
    if (t === Mt || r === Mt) return Jt.Allowed;
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (-1 !== [at, xt, kt].indexOf(r) || t === Nt) return Jt.NotAllowed;
  }, function (e) {
    var t = e.index,
      r = e.types,
      n = e.current,
      i = t - 1;
    if ((i >= 0 ? r[i] : 0) === Ot && -1 !== Qt.indexOf(n)) return Jt.NotAllowed;
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (t === At && r === Ot) return Jt.NotAllowed;
  }, function (e) {
    var t = e.current;
    if (e.next === Et && -1 !== qt.concat(Et, st, yt, jt, Rt, Ft).indexOf(t)) return Jt.NotAllowed;
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (-1 !== qt.indexOf(r) && t === yt || -1 !== qt.indexOf(t) && r === yt) return Jt.NotAllowed;
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (t === lt && -1 !== [jt, Rt, Ft].indexOf(r) || -1 !== [jt, Rt, Ft].indexOf(t) && r === vt) return Jt.NotAllowed;
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (-1 !== qt.indexOf(t) && -1 !== Dt.indexOf(r) || -1 !== Dt.indexOf(t) && -1 !== qt.indexOf(r)) return Jt.NotAllowed;
  }, function (e) {
    var t = e.index,
      r = e.types,
      n = e.current,
      i = e.next,
      a = t - 1,
      o = t + 1;
    if (-1 !== [lt, vt].indexOf(n) && (i === yt || -1 !== [pt, xt].indexOf(i) && r[o + 1] === yt) || -1 !== [pt, xt].indexOf(n) && i === yt || n === yt && -1 !== [yt, At, gt].indexOf(i)) return Jt.NotAllowed;
    if (-1 !== [yt, At, gt, Pt, Ct].indexOf(i)) for (var u = t; u >= 0;) {
      if ((f = r[u]) === yt) return Jt.NotAllowed;
      if (-1 === [At, gt].indexOf(f)) break;
      u -= 1;
    }
    if (-1 !== [lt, vt].indexOf(i)) for (u = -1 !== [Pt, Ct].indexOf(n) ? a : t; u >= 0;) {
      var f;
      if ((f = r[u]) === yt) return Jt.NotAllowed;
      if (-1 === [At, gt].indexOf(f)) break;
      u -= 1;
    }
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (St === t && -1 !== [St, wt, Vt, Bt].indexOf(r) || -1 !== [wt, Vt].indexOf(t) && -1 !== [wt, Tt].indexOf(r) || -1 !== [Tt, Bt].indexOf(t) && r === Tt) return Jt.NotAllowed;
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (-1 !== Kt.indexOf(t) && -1 !== [Et, vt].indexOf(r) || -1 !== Kt.indexOf(r) && t === lt) return Jt.NotAllowed;
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (-1 !== qt.indexOf(t) && -1 !== qt.indexOf(r)) return Jt.NotAllowed;
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (t === gt && -1 !== qt.indexOf(r)) return Jt.NotAllowed;
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (-1 !== qt.concat(yt).indexOf(t) && r === pt || -1 !== qt.concat(yt).indexOf(r) && t === Ct) return Jt.NotAllowed;
  }, function (e) {
    var t = e.index,
      r = e.types,
      n = e.indicies,
      i = e.current,
      a = e.next;
    if (i === Zt && a === Zt) {
      for (var o = n[t], u = 1; o > 0 && r[o -= 1] === Zt;) u += 1;
      if (u % 2 != 0) return Jt.NotAllowed;
    }
  }, function (e) {
    var t = e.current,
      r = e.next;
    if (t === Rt && r === Ft) return Jt.NotAllowed;
  }],
  ar = ["Lu", "Ll", "Lt", "Lm", "Lo", "Nd", "Nl", "No"],
  or = E$1.createTrie(T.LineBreak);
function ur(e, t) {
  void 0 === t && (t = tr.Strict);
  var r = [],
    n = [],
    i = [];
  return e.forEach(function (e, a) {
    var o = or.get(e),
      u = Ue(e);
    if (i.push(ar.includes(u)), -1 !== [tr.Normal, tr.Auto, tr.Loose].indexOf(t) && -1 !== [8208, 8211, 12316, 12448].indexOf(e)) return n.push(a), r.push(Mt);
    if (o === ct) {
      if (8220 === e) return n.push(a), r.push(pt);
      if (8221 === e) return n.push(a), r.push(Pt);
    }
    if (o === it || o === zt) {
      if (0 === a) return o === zt ? (n.push(a), r.push(zt)) : (n.push(a), r.push(ht));
      var f = function (e, t) {
        var r = e;
        for (; r >= 0;) {
          var n = t[r];
          if (n !== zt && n !== it) return n;
          r -= 1;
        }
        return -1;
      }(a - 1, r);
      return -1 === f ? (n.push(a), r.push(ht)) : -1 === _t.indexOf(f) ? (n.push(n[a - 1]), r.push(f)) : (n.push(a), r.push(ht));
    }
    return n.push(a), o === Ut ? t === tr.Strict ? r.push(kt) : r.push(jt) : o === It || o === Lt ? r.push(ht) : o === nt ? e >= 131072 && e <= 196605 || e >= 196608 && e <= 262141 ? r.push(jt) : r.push(ht) : void r.push(o);
  }), [n, r, i];
}
function fr(e, t, r, n, i, a) {
  if (void 0 === i && (i = null), void 0 === a && (a = null), 0 === r[n]) return Jt.NotAllowed;
  var o = n - 1;
  if (Array.isArray(i) && !0 === i[o]) return Jt.NotAllowed;
  var u,
    f = o + 1,
    d = t[o],
    s = t[f];
  return ir.some(function (e) {
    return void 0 !== (u = e({
      index: o,
      types: t,
      indicies: r,
      current: d,
      next: s
    }));
  }), void 0 !== u ? u : Array.isArray(a) && -1 !== a.indexOf(d) ? Jt.NotAllowed : Jt.Allowed;
}
!function (e) {
  e[e.Auto = 0] = "Auto", e[e.Normal = 1] = "Normal", e[e.Loose = 2] = "Loose", e[e.Strict = 3] = "Strict";
}(tr || (tr = {})), function (e) {
  e[e.Normal = 0] = "Normal", e[e.BreakAll = 1] = "BreakAll", e[e.BreakWord = 2] = "BreakWord", e[e.KeepAll = 3] = "KeepAll";
}(rr || (rr = {})), function (e) {
  e[e.Ex = st] = "Ex", e[e.Sy = At] = "Sy";
}(nr || (nr = {}));
var sr = function () {
  function e(e, t) {
    var r;
    void 0 === t && (t = {
      lineBreak: tr.Normal,
      wordBreak: rr.Normal
    }), this.nextIndex = 0, this.ustr = new et(e), this.codePoints = this.ustr.codePoints(), this.codePointLen = this.codePoints.length, this.forbiddenBreakClasses = t.forbidClasses || [], r = function (e, t) {
      var r = ur(e, t.lineBreak),
        n = r[0],
        i = r[1],
        a = r[2],
        o = i;
      return t.wordBreak !== rr.BreakAll && t.wordBreak !== rr.BreakWord || (o = i.map(function (e) {
        return -1 !== [yt, ht, It].indexOf(e) ? jt : e;
      })), [n, o, t.wordBreak === rr.KeepAll ? a.map(function (t, r) {
        return t && e[r] >= 19968 && e[r] <= 40959;
      }) : null];
    }(this.codePoints, t), this.indicies = r[0], this.lineBreakClasses = r[1], this.forbiddenBreakpoints = r[2];
  }
  return e.prototype.getGraphemeInfoFromCodePointIndex = function (e) {
    var t = this.ustr.codePointIndex2CharCodeIndexRange(e),
      r = this.ustr.charCodeIndex2GraphemeIndex(t.start),
      n = this.ustr.graphemeIndex2CharCodeIndexRange(r),
      i = {
        start: this.ustr.charCodeIndex2CodePointIndex(n.start),
        end: this.ustr.charCodeIndex2CodePointIndex(n.end)
      };
    return {
      length: i.end - i.start + 1,
      range: i
    };
  }, e.prototype.next = function (e) {
    if (void 0 === e && (e = !1), this.nextIndex >= this.codePointLen) return null;
    for (var t = Jt.NotAllowed; this.nextIndex < this.codePointLen;) if ((t = fr(this.codePoints, this.lineBreakClasses, this.indicies, this.nextIndex += 1, this.forbiddenBreakpoints, this.forbiddenBreakClasses)) !== Jt.NotAllowed) {
      if (e) {
        var r = this.getGraphemeInfoFromCodePointIndex(this.nextIndex - 1),
          n = r.length,
          i = r.range;
        n > 1 && (this.nextIndex = i.start + n);
      }
      break;
    }
    return t !== Jt.NotAllowed || this.nextIndex === this.codePointLen ? {
      required: t === Jt.Mandatory,
      position: this.ustr.codePointIndex2CharCodeIndexRange(this.nextIndex - 1).end + 1
    } : null;
  }, e;
}();

/**
 * 对排版方式不同的字符类型进行区分
 */

function getTokenType(codePoint) {
  var tokenType;
  if (Ke(codePoint)) {
    tokenType = TokenType.Whitespace;
  } else if (isPageBreak(codePoint)) {
    tokenType = TokenType.PageBreak;
  } else if (isSectionBreak(codePoint)) {
    tokenType = TokenType.SectionBreak;
  } else if (isLineBreaker(codePoint)) {
    tokenType = TokenType.LineBreak;
  } else if (isTab(codePoint)) {
    tokenType = TokenType.Tabstop;
  } else if (isEast(codePoint)) {
    tokenType = TokenType.EAST;
  } else {
    tokenType = TokenType.Default;
  }
  return tokenType;
}
/**
 * 定义可以在后面断行的字符类型
 */

function canBreakAfter(tokeyType) {
  return tokeyType === TokenType.Tabstop;
}
/**
 * 定义可在其前面断行的字符类型
 * @param tokeyType
 */

function canBreakBefore(tokeyType) {
  return tokeyType === TokenType.Tabstop;
}
/**
 * 判断是否为Tab
 */

function isTabToken(node) {
  return node.kind === BaseNodeKind.Box && node.type === TokenType.Tabstop;
}
/**
 * east code point
 */

var EAST_SYMBOL_CODE = [12290, 65292, 65307, 65306, 65311, 65281, 12289 // 、
// 8220, // “
// 8221, // ”
// 8216, // ‘
// 8217, // ’
];
/**
 * 是否亚洲方形字，如CJK。中文标点也包含在内
 * @param codePoint
 */

function isEast(codePoint) {
  if (typeof codePoint !== 'number') {
    return false;
  }
  var script = Be(codePoint);
  return script === 'Han' || script === 'Hiragana' || script === 'Hangul' || isEastSymbol(codePoint);
}
function isEastSymbol(codePoint) {
  return EAST_SYMBOL_CODE.includes(codePoint);
} // 括号类标点的 codePoint

var BRACKETS_CODE = [91, 93, 12304, 12305, 123, 125, 12300, 12301, 60, 62, 12298, 12299, 40, 41, 65288, 65289 // ）
];
/**
 * 是否是括号类标点
 * @param codePoint
 * @returns
 */

function isBrackets(codePoint) {
  if (typeof codePoint !== 'number') {
    return false;
  }
  return BRACKETS_CODE.includes(codePoint);
}
/**
 * 判断是否为空白的token
 * @param node 待检查的TypesetNode
 */

function isGlueToken(node) {
  if (node.kind !== BaseNodeKind.Box) {
    return false;
  }
  switch (node.type) {
    case TokenType.Whitespace:
    case TokenType.PageBreak:
    case TokenType.SectionBreak:
    case TokenType.LineBreak:
      return true;
  }
  return false;
}
function isPageBreakToken(node) {
  return node.kind === BaseNodeKind.Box && node.type === TokenType.PageBreak;
}
/**
 * 判断是否被列为尾空白字符
 */

function isTailGlue(node) {
  return node.kind === BaseNodeKind.Glue ||
  // 空格
  node.kind === BaseNodeKind.Penalty || isGlueToken(node); // 其他空白字符
}
/**
 * 判断是否为penalty
 */

function isPenalty(node) {
  return node.kind === BaseNodeKind.Penalty;
}
/**
 * 判断是否为相同的Penalty
 */

function isSamePenalty(node1, node2) {
  return node1.kind === BaseNodeKind.Penalty && node2.kind === BaseNodeKind.Penalty && node1.penalty === node2.penalty;
}
var TypesetGlue = function (_super) {
  __extends(TypesetGlue, _super);
  function TypesetGlue() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.kind = BaseNodeKind.Glue;
    _this.width = 0;
    _this.isSeparate = false;
    /** width调整值，>0拉伸值, <0压缩值，=0保持原始值，空格可拉伸 */

    _this.widthAdj = 0;
    return _this;
  }
  TypesetGlue.obtain = function (width, range) {
    var obj = TypesetGlue.sPool.obtain();
    if (!obj) {
      obj = new TypesetGlue();
    }
    obj.range = range;
    obj.width = width;
    return obj;
  };
  TypesetGlue.prototype.recycle = function () {
    this.range = undefined;
    this.text = undefined;
    this.glyph = undefined;
    this.width = 0;
    TypesetGlue.sPool.recycle(this);
  };
  /**
   * 调整值会累加到width上，并记录widthAdj的值
   */

  TypesetGlue.prototype.adjustWidth = function (adj) {
    this.widthAdj = adj;
    this.width += adj;
  };
  TypesetGlue.sPool = new ObjectPool(100);
  return TypesetGlue;
}(PoolNode);
var TypesetPenalty = function (_super) {
  __extends(TypesetPenalty, _super);
  function TypesetPenalty() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.kind = BaseNodeKind.Penalty;
    _this.width = 0;
    _this.penalty = 0;
    return _this;
  }
  TypesetPenalty.obtain = function (width, penalty) {
    var obj = TypesetPenalty.sPool.obtain();
    if (!obj) {
      obj = new TypesetPenalty();
    }
    obj.width = width;
    obj.penalty = penalty;
    return obj;
  };
  TypesetPenalty.prototype.recycle = function () {
    TypesetPenalty.sPool.recycle(this);
  };
  TypesetPenalty.sPool = new ObjectPool(300);
  return TypesetPenalty;
}(PoolNode);

/**
 * Typeset Node Factory generates Contains a lot of helpers to create typeset nodes.
 *
 * @export
 * @class BaseTypesetNodeFactory
 */

var TypesetNodeFactory = function () {
  function TypesetNodeFactory() {}
  TypesetNodeFactory.makeBox = function (width, range) {
    return TypesetBox.obtain(width, range);
  };
  TypesetNodeFactory.makeGlue = function (width, range) {
    return TypesetGlue.obtain(width, range);
  };
  TypesetNodeFactory.makePenalty = function (forceBreak, width) {
    if (forceBreak === void 0) {
      forceBreak = false;
    }
    if (width === void 0) {
      width = 0;
    }
    return TypesetPenalty.obtain(width, forceBreak ? MIN_PENALTY : 0);
  };
  return TypesetNodeFactory;
}();
var BGPStore = function () {
  function BGPStore(BGPCreator) {
    // 当前已生成的所有BGP模型
    this.allBGPs = []; // 当前排版位置

    this.curIndex = 0;
    this.mBGPCreator = BGPCreator;
  }
  /**
   * 对未排版完的bgp模型进行回退
   * 1.如果列表中能找到对应的bgp模型，则仅仅对curIndex索引进行修改
   * 2.如果列表中找不到，暂存到lastOverBGPs
   * @param bgps
   */

  BGPStore.prototype.setLastBGPs = function (bgps) {
    if (bgps.length) {
      var _a = __read(bgps, 1),
        _b = __read(_a[0], 1),
        first = _b[0];
      var find = false;
      for (var i = 0; i < this.allBGPs.length; i++) {
        var bgp = this.allBGPs[i];
        if (first === bgp[0]) {
          // 找到对应的bgp数据，修改curIndex
          this.curIndex = i;
          find = true;
          break;
        }
      }
      if (!find) {
        // 未查找到，暂存到lastOverBGPs
        this.lastOverBGPs = bgps;
      }
    }
  };
  BGPStore.prototype.hasNext = function () {
    return !!this.lastOverBGPs || this.curIndex < this.allBGPs.length;
  };
  BGPStore.prototype.getNext = function () {
    // 有上次退回的BGP，直接返回
    if (this.lastOverBGPs) {
      var bgps = this.lastOverBGPs;
      this.lastOverBGPs = undefined;
      return bgps;
    } // 否则返回下一组连续的Box/Glue模型

    var first = this.nextBGP();
    if (!first) return [];
    var result = [first];
    var _a = __read(first, 1),
      node = _a[0];
    if (node.kind !== BaseNodeKind.Penalty) {
      var next = this.nextBGP();
      while (next) {
        if (next[0].kind !== node.kind || this.shouldShortCircuitOnAccumulateBoxes(next)) {
          this.curIndex -= 1;
          break;
        }
        result.push(next);
        next = this.nextBGP();
      }
    }
    return result;
  };
  BGPStore.prototype.recycle = function () {
    if (this.hasNext()) return;
    this.allBGPs.forEach(function (bgp) {
      var _a = __read(bgp, 1),
        node = _a[0];
      node.recycle();
    });
  }; // 返回下一个待排版的BGP模型

  BGPStore.prototype.nextBGP = function () {
    if (this.curIndex >= this.allBGPs.length) {
      var next = this.mBGPCreator.createNextBGP(); // eslint-disable-next-line @typescript-eslint/prefer-optional-chain

      var bgps = next || []; // eslint-disable-next-line @typescript-eslint/prefer-for-of

      for (var i = 0; i < bgps.length; i++) {
        this.allBGPs.push(bgps[i]);
      }
    }
    if (this.curIndex < this.allBGPs.length) {
      var curBGP = this.allBGPs[this.curIndex];
      this.curIndex += 1;
      return curBGP;
    }
    return undefined;
  };
  BGPStore.prototype.shouldShortCircuitOnAccumulateBoxes = function (next) {
    // tabstop 单独与其他 box 返回给上层便于判断
    var shouldSeparateTokenTypes = [TokenType.Tabstop];
    return next[0].kind === BaseNodeKind.Box && shouldSeparateTokenTypes.includes(next[0].type);
  };
  return BGPStore;
}();

/**
 * @class GCPRange
 * 用于表示区间Range的类
 */

var GCPRange = function () {
  function GCPRange(gcpBegin, len) {
    if (gcpBegin === void 0) {
      gcpBegin = 0;
    }
    if (len === void 0) {
      len = 0;
    }
    this.gcpBegin = gcpBegin;
    this.len = len;
  }
  /**
   * 创建一个空区间
   */

  GCPRange.emptyRange = function () {
    return new GCPRange(0, 0);
  };
  /**
   * 创建一个无效区间
   */

  GCPRange.invalidRange = function () {
    return new GCPRange(-1, -1);
  };
  /**
   * 对区间进行镜像缩放，整数为缩小区间，负数为增大区间
   * @param offset 偏移量
   */

  GCPRange.inset = function (range, offset) {
    return new GCPRange(range.begin() + offset, range.length() - 2 * offset);
  };
  GCPRange.insetBoth = function (range, startOffset, endOffset) {
    return new GCPRange(range.begin() + startOffset, range.length() - startOffset - endOffset);
  };
  /**
   * 区间开始
   */

  GCPRange.prototype.begin = function () {
    return this.gcpBegin;
  };
  /**
   * 区间结尾
   */

  GCPRange.prototype.end = function () {
    return this.gcpBegin + this.len;
  };
  /**
   * 区间长度
   */

  GCPRange.prototype.length = function () {
    return this.len;
  };
  /**
   * 区间是否为空
   */

  GCPRange.prototype.isEmpty = function () {
    return this.len <= 0;
  };
  /**
   * 区间是否为空
   */

  GCPRange.prototype.isNull = function () {
    return this.gcpBegin === 0 && this.len <= 0;
  };
  /**
   * 区间是否合法
   */

  GCPRange.prototype.isValid = function () {
    return this.gcpBegin >= 0 && this.len >= 0;
  };
  /**
   * 区间是否交叉
   * @param other
   */

  GCPRange.prototype.intersect = function (other, containIntersection) {
    var bResult = true;
    if (this.end() < other.begin() || this.end() === other.begin() && this.length() > 0 && !containIntersection || this.begin() > other.end() || this.begin() === other.end() && other.length() > 0 && !containIntersection) {
      bResult = false;
    }
    return bResult;
  };
  /**
   * 区间是否包含，刚好落在端点也算包含
   * @param other 传入区间判断是否被当前区间包含，也可以传入一个点
   */

  GCPRange.prototype.contains = function (other) {
    var otherBegin = other instanceof GCPRange ? other.begin() : other;
    var otherEnd = other instanceof GCPRange ? other.end() : other;
    var bResult = false;
    if (this.begin() <= otherBegin && (otherEnd < this.end() || otherEnd === this.end() && otherBegin !== otherEnd)) {
      bResult = true;
    }
    return bResult;
  };
  /**
   * 返回交集
   * @param other
   */

  GCPRange.prototype.intersectRange = function (other) {
    var start = Math.max(this.begin(), other.begin());
    var end = Math.min(this.end(), other.end());
    return new GCPRange(start, end - start);
  };
  /**
   * 返回并集
   * @param other
   */

  GCPRange.prototype.unionRange = function (other) {
    var start = Math.min(this.begin(), other.begin());
    var end = Math.max(this.end(), other.end());
    return new GCPRange(start, end - start);
  };
  /**
   * 判断当前区间是否小于传入的区间
   * @param other
   */

  GCPRange.prototype.lessThan = function (other) {
    return this.begin() < other.begin() || this.begin() === other.begin() && this.end() < other.end();
  };
  /**
   * 区间是否不等
   * @param other
   */

  GCPRange.prototype.notEqual = function (other) {
    return this.gcpBegin !== other.gcpBegin || this.len !== other.len;
  };
  /**
   * 区间是否相等
   * @param other
   */

  GCPRange.prototype.equal = function (other) {
    return !this.notEqual(other);
  };
  /**
   * 拷贝
   */

  GCPRange.prototype.clone = function () {
    return new GCPRange(this.gcpBegin, this.len);
  };
  /**
   * 从另一个Range复制
   * @param other
   */

  GCPRange.prototype.copyFrom = function (other) {
    this.gcpBegin = other.gcpBegin;
    this.len = other.len;
    return this;
  };
  /**
   * 返回本区间在父区间中的相对区间
   * @param parent 父区间
   */

  GCPRange.prototype.relativeInRange = function (parent) {
    return new GCPRange(this.begin() - parent.begin(), this.length());
  };
  return GCPRange;
}();

/**
 * 根据不同的文字方向处理测量出来的文字 glyph
 */

function processTextGlyphByTextDirection(text, spanPro, glyph, verticalType) {
  if (verticalType === VerticalType.WordArtVerticalRtl || verticalType === VerticalType.WordArtVerticalLtr) {
    return processTextGlyphInWordArtVertical(text, spanPro, glyph);
  }
  if (verticalType === VerticalType.Vertical) {
    return processTextGlyphInVerticalEast(text, spanPro, glyph);
  }
  return glyph;
}
/**
 * 处理竖排文字测量出来的 glyph
 * 竖排的中文不旋转，文字方向是左上，所在坐标系为右上，需要把测量出来的尺寸按照当前坐标系转换为逻辑尺寸
 */

function processTextGlyphInVerticalEast(text, spanPro, glyph) {
  if (isEast(text.codePointAt(0))) {
    var ascent = glyph.ascent,
      width = glyph.width,
      height = glyph.height,
      actualWidth = glyph.actualWidth,
      actualHeight = glyph.actualHeight; // east 字符，竖排时每个文字都拆分为单个节点，所以间距就等于 letterSpacing

    var spacing = spanPro.letterSpacing; // 根据 office ppt 表现，竖排中文的逻辑宽度（也就是最终的显示高度）为文字宽度
    // 默认测量出来的宽度已经包含了文字间距

    var noSpacingWidth = width - spacing;
    var radio = ascent ? ascent / height : ASCENT_RATIO;
    return _assign(_assign({}, glyph), {
      height: noSpacingWidth,
      // 最终绘制的中文高度是这里计算出来的逻辑宽度，所以需要用原始的逻辑宽度（不包含文字间距）重新计算 ascent 和 descent
      ascent: noSpacingWidth * radio,
      descent: noSpacingWidth * (1 - radio),
      actualWidth: actualHeight,
      actualHeight: actualWidth
    });
  }
  return glyph;
}
/**
 * 处理堆积文字测量出来的 glyph
 * 堆积除了括号类标点之外所有文字都不旋转，文字方向是左上，所在坐标系为右上，需要把测量出来的尺寸按照当前坐标系转换为逻辑尺寸
 */

function processTextGlyphInWordArtVertical(text, spanPro, glyph) {
  if (!isBrackets(text.codePointAt(0))) {
    var height = glyph.height,
      actualWidth = glyph.actualWidth,
      actualHeight = glyph.actualHeight; // 堆积中每个文字都拆分为单个节点，所以间距就等于 letterSpacing

    var spacing = spanPro.letterSpacing; // 根据 office ppt 表现，堆积文字的逻辑宽度（也就是最终的显示高度）为文字高度
    // 文字间距需要加在逻辑宽度上

    var measure = height + spacing; // 最终绘制的中文高度是这里计算出来的逻辑宽度，由于逻辑宽度（不包含文字间距）就是文字高度，所以不需要重新计算 ascent 和 descent

    return _assign(_assign({}, glyph), {
      width: measure,
      actualWidth: actualHeight,
      actualHeight: actualWidth
    });
  }
  return glyph;
}
var TypesetProcessorBase = function () {
  function TypesetProcessorBase(context) {
    this.mContext = context;
    this.mShaper = context.shaper;
  }
  TypesetProcessorBase.prototype.processAfterMeasure = function (text, spanPro, glyph) {
    if (this.mState.curTokenType === TokenType.Tabstop) {
      var spaceGlyph = this.mShaper.shapeToken(PlaceholderChar.Space);
      return _assign(_assign({}, glyph), {
        width: spaceGlyph.width * Defaults.tabSize
      });
    }
    return processTextGlyphByTextDirection(text, spanPro, glyph, this.mContext.verticalType);
  }; // 通过当前位置字符类型判断前一个token是否结束
  // 比如‘hi  jom’，在第一个空格处是前token”hi“的结束位置，'j'是前一个token‘  ’结束的位置

  TypesetProcessorBase.prototype.isTokenEnd = function (tokenType) {
    // 最新位置的token类型发生变化，前一个token必然结束了
    if (tokenType !== this.mState.curTokenType) return true; // 以下特殊字符需要独立为一个token

    switch (tokenType) {
      case TokenType.PageBreak:
      case TokenType.SectionBreak:
      case TokenType.LineBreak:
      case TokenType.Tabstop:
        return true;
      default:
        return false;
    }
  };
  TypesetProcessorBase.prototype.pushCurrentTokenAsGlue = function () {
    var mState = this.mState;
    var curTokenStart = mState.curTokenStartIndex;
    var curTokenEnd = mState.curTokenEndIndex;
    var textRunStr = mState.model.getText();
    var curTokenLen = curTokenEnd - curTokenStart + 1;
    var tokenText = textRunStr.substr(curTokenStart - mState.model.range.begin(), curTokenLen);
    var glyph = this.shapeCurrentToken(mState, tokenText);
    var glueNode = TypesetNodeFactory.makeGlue(glyph.width, new GCPRange(curTokenStart, curTokenLen));
    glueNode.glyph = glyph;
    glueNode.text = tokenText;
    glueNode.isSeparate = mState.isSeparate;
    mState.nodes.push(glueNode);
  };
  TypesetProcessorBase.prototype.pushCurrentTokenAsBox = function () {
    var mState = this.mState;
    var curTokenStart = mState.curTokenStartIndex;
    var curTokenEnd = mState.curTokenEndIndex;
    var textRunStr = mState.model.getText();
    var curTokenLen = curTokenEnd - curTokenStart + 1;
    var tokenText = textRunStr.substr(curTokenStart - mState.model.range.begin(), curTokenLen);
    var glyph = this.shapeCurrentToken(mState, tokenText);
    var box = TypesetNodeFactory.makeBox(glyph.width, new GCPRange(curTokenStart, curTokenLen));
    box.text = tokenText;
    box.glyph = glyph;
    box.type = mState.curTokenType;
    box.hanging = mState.hanging;
    box.isSeparate = mState.isSeparate;
    mState.nodes.push(box);
  };
  TypesetProcessorBase.prototype.shapeCurrentToken = function (state, srcTokenText) {
    var tokenText = this.processBeforeMeasure(srcTokenText);
    var style = state.model.getProperty() || undefined;
    var spanPro = style;
    var glyph = this.mShaper.shapeToken(tokenText.toString(), spanPro);
    glyph = this.processAfterMeasure(tokenText.toString(), spanPro, glyph);
    return glyph;
  };
  TypesetProcessorBase.prototype.processBeforeMeasure = function (token) {
    switch (this.mState.curTokenType) {
      default:
        return token;
    }
  };
  return TypesetProcessorBase;
}();

/**
 * 拆字方式
 */

var BreakType;
(function (BreakType) {
  BreakType[BreakType["NORMAL"] = 10] = "NORMAL";
  BreakType[BreakType["BREAK_EAST"] = 11] = "BREAK_EAST";
  BreakType[BreakType["BREAK_ALL"] = 12] = "BREAK_ALL";
})(BreakType || (BreakType = {}));
/**
 * 按照正常的BGP模型输出
 */

var UnicodeProcessor = function (_super) {
  __extends(UnicodeProcessor, _super);
  function UnicodeProcessor() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UnicodeProcessor.prototype.pushCurrentToken = function (canBreak, forceBreak) {
    if (this.mState.curTokenType === TokenType.Whitespace) {
      this.pushCurrentTokenAsGlue();
      if (forceBreak) {
        var penalty = TypesetNodeFactory.makePenalty(true);
        this.mState.nodes.push(penalty);
      }
    } else {
      this.pushCurrentTokenAsBox();
      if (canBreak || canBreakAfter(this.mState.curTokenType) || canBreakBefore(this.mState.curPosTokenType)) {
        var penalty = TypesetNodeFactory.makePenalty(forceBreak);
        this.mState.nodes.push(penalty);
      }
    }
    this.mState.curTokenStartIndex = this.mState.curPos;
    this.mState.curTokenType = this.mState.curPosTokenType;
  };
  UnicodeProcessor.prototype.getCurrentLineBreakIndex = function (lineBreaks, rangeStart) {
    for (var i = 0; i < lineBreaks.length; i++) {
      var lineBreakOpp = lineBreaks[i];
      if (lineBreakOpp.position >= rangeStart) {
        return i;
      }
    }
    return 0;
  }; // eslint-disable-next-line @typescript-eslint/member-ordering,complexity

  UnicodeProcessor.prototype.process = function (inputModel, lineBreaks) {
    var range = inputModel.range;
    var rangeStart = range.begin();
    var rangeEnd = rangeStart + range.length() - 1; // find first line break position in this text run.

    var currentLineBreakIndex = this.getCurrentLineBreakIndex(lineBreaks, rangeStart);
    var textRunStr = inputModel.getText();
    var breakType = this.getBreakType(inputModel);
    var results = [];
    var state = {
      model: inputModel,
      nodes: results,
      lineBreakPoints: lineBreaks,
      nextLineBreakPointIndex: currentLineBreakIndex,
      curTokenType: TokenType.Start,
      curTokenStartIndex: rangeStart,
      curTokenEndIndex: rangeStart,
      curPos: rangeStart,
      curPosTokenType: TokenType.Start,
      hanging: false,
      isSeparate: false
    };
    this.mState = state;
    var charOffset = 0; // 文字字符偏移

    for (var i$1$1 = rangeStart; i$1$1 <= rangeEnd; i$1$1++) {
      state.curPos = i$1$1;
      var charCode = textRunStr.charCodeAt(charOffset);
      if (n$1(charCode) && i$1$1 <= rangeEnd - 1) {
        var nextCharCode = textRunStr.charCodeAt(charOffset + 1);
        if (i$1(nextCharCode)) {
          i$1$1 += 1;
          charOffset += 1;
          charCode = ((charCode & 0x3ff) << 10) + (nextCharCode & 0x3ff) + 0x10000;
        }
      }
      charOffset += 1;
      var curPosTokenType = getTokenType(charCode);
      if (state.curTokenType === TokenType.Start) {
        state.curTokenType = curPosTokenType;
      }
      state.curPosTokenType = curPosTokenType;
      var nextBreakPointIndex = state.nextLineBreakPointIndex;
      var nextBreakPoint = state.lineBreakPoints[nextBreakPointIndex]; // 兼容处理空白字符强制换行问题

      if (nextBreakPoint.required && isWhiteBreakChar(charCode)) {
        nextBreakPoint.required = false;
      }
      var curPosCanBreak = state.curPos === nextBreakPoint.position;
      var curPosForceBreak = curPosCanBreak && nextBreakPoint.required;
      var isSeparate = this.isCurPosSeparate(breakType); // 遇到可断行处，或者当前 token 需要作为独立的 box，或者token的自然结束位置，生成并push前一个token

      if (state.curPos > rangeStart && (isSeparate || curPosCanBreak || this.isTokenEnd(curPosTokenType))) {
        this.pushCurrentToken(curPosCanBreak, curPosForceBreak);
      }
      if (curPosCanBreak && nextBreakPointIndex < state.lineBreakPoints.length - 1) {
        state.nextLineBreakPointIndex = nextBreakPointIndex + 1;
      }
      state.curTokenEndIndex = i$1$1; // 换行符可超出版心悬挂在行尾

      state.hanging = curPosTokenType === TokenType.LineBreak; // 记录当前 token 状态

      state.isSeparate = isSeparate;
    } // reach the end, see whether next pos can break and push current token

    var lastBreakPointIndex = state.nextLineBreakPointIndex;
    var lastBreakPoint = state.lineBreakPoints[lastBreakPointIndex];
    var nextPosCanBreak = rangeEnd + 1 === (lastBreakPoint === null || lastBreakPoint === void 0 ? void 0 : lastBreakPoint.position);
    var nextPosForceBreak = nextPosCanBreak && lastBreakPoint.required;
    this.pushCurrentToken(nextPosCanBreak, nextPosForceBreak);
    return state.nodes;
  };
  /**
   * 当前位置是否需要独立为一个 box
   */

  UnicodeProcessor.prototype.isCurPosSeparate = function (breakType) {
    if (breakType === BreakType.BREAK_ALL) {
      return true;
    }
    if (breakType === BreakType.BREAK_EAST && this.mState.curPosTokenType === TokenType.EAST) {
      return true;
    }
    return false;
  };
  UnicodeProcessor.prototype.getBreakType = function (model) {
    var _a, _b, _c;
    if ((_a = model.getProperty()) === null || _a === void 0 ? void 0 : _a.letterSpacing) {
      // 设置了letter spacing，需要拆分所有文字，每个文字都需要独立
      return BreakType.BREAK_ALL;
    }
    if (((_c = (_b = this.getParagraphNode(model)) === null || _b === void 0 ? void 0 : _b.getProperty()) === null || _c === void 0 ? void 0 : _c.textAlignment) === TextAlignmentType.Distribute) {
      // 分散对齐，拆分所有文字
      return BreakType.BREAK_ALL;
    }
    if (this.mContext.isVertEast()) {
      // 竖排的中文需要拆分
      return BreakType.BREAK_EAST;
    }
    if (this.mContext.isWordArtVertical()) {
      // 堆积需要拆分所有字符
      return BreakType.BREAK_ALL;
    }
    return BreakType.NORMAL;
  };
  UnicodeProcessor.prototype.getParagraphNode = function (model) {
    var parentNode = model;
    while (parentNode && !(parentNode instanceof ParagraphNode)) {
      parentNode = parentNode.getParentNode();
    }
    return parentNode;
  };
  return UnicodeProcessor;
}(TypesetProcessorBase);
var NOWRAP_TOKEN_END = [TokenType.PageBreak, TokenType.SectionBreak, TokenType.LineBreak, TokenType.Tabstop];
/**
 * 不换行场景输出BGP模型，不测量typesetGlue 和 typesetPenalty
 */

var NowrapUnicodeProcessor = function (_super) {
  __extends(NowrapUnicodeProcessor, _super);
  function NowrapUnicodeProcessor() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  NowrapUnicodeProcessor.prototype.process = function (inputModel) {
    var range = inputModel.range;
    var rangeStart = range.begin();
    var rangeEnd = rangeStart + range.length() - 1;
    var textRunStr = inputModel.getText() || "\uFEFF";
    var results = [];
    var state = {
      model: inputModel,
      nodes: results,
      lineBreakPoints: [],
      nextLineBreakPointIndex: -1,
      curTokenType: TokenType.Start,
      curTokenStartIndex: rangeStart,
      curTokenEndIndex: rangeStart,
      curPos: rangeStart,
      curPosTokenType: TokenType.Start,
      hanging: false,
      isSeparate: false
    };
    this.mState = state;
    for (var i$1$1 = rangeStart; i$1$1 <= rangeEnd; i$1$1++) {
      state.curPos = i$1$1;
      var charCode = textRunStr.charCodeAt(i$1$1);
      if (n$1(charCode) && i$1$1 <= rangeEnd - 1) {
        var nextCharCode = textRunStr.charCodeAt(i$1$1 + 1);
        if (i$1(nextCharCode)) {
          i$1$1 += 1;
          charCode = ((charCode & 0x3ff) << 10) + (nextCharCode & 0x3ff) + 0x10000;
        }
      }
      var curPosTokenType = getTokenType(charCode);
      if (state.curTokenType === TokenType.Start) {
        state.curTokenType = curPosTokenType;
      }
      state.curPosTokenType = curPosTokenType; // 遇到token的自然结束位置，生成并push前一个token

      if (state.curPos > rangeStart && this.isTokenEnd(curPosTokenType)) {
        this.pushCurrentToken();
      }
      state.curTokenEndIndex = i$1$1;
    }
    this.pushCurrentToken();
    return state.nodes;
  }; // nowraper场景下，大部分token是可以合并的，需要单独拆分的在下面指定出来

  NowrapUnicodeProcessor.prototype.isTokenEnd = function (tokenType) {
    // 只要前后位置存在一个特殊字符，就需要断开
    if (NOWRAP_TOKEN_END.includes(this.mState.curTokenType) || NOWRAP_TOKEN_END.includes(tokenType)) {
      return true;
    } // 如果是空格开头的通常字符串，也需要断开

    return !!(this.mState.curTokenType === TokenType.Whitespace && tokenType === TokenType.Default);
  };
  NowrapUnicodeProcessor.prototype.pushCurrentToken = function () {
    this.pushCurrentTokenAsBox();
    this.mState.curTokenStartIndex = this.mState.curPos;
    this.mState.curTokenType = this.mState.curPosTokenType;
  };
  return NowrapUnicodeProcessor;
}(TypesetProcessorBase);

/**
 * 计算嵌入式元素的BGP模型
 */

var ObjectProcessor = function () {
  function ObjectProcessor(shaper) {
    this.shaper = shaper;
  }
  ObjectProcessor.prototype.process = function (inputModel) {
    var results = []; // can break before embed node

    results.push(TypesetNodeFactory.makePenalty());
    var range = inputModel.range;
    var typesetBox = TypesetNodeFactory.makeBox(0, range);
    var tokenText = inputModel.getText();
    var style = inputModel.getProperty() || undefined;
    var spanPro = style;
    var glyph = this.shaper.shapeToken(tokenText, spanPro);
    var size = inputModel.getContainerSize();
    typesetBox.glyph = glyph;
    typesetBox.type = TokenType.PlaceHolder;
    typesetBox.text = tokenText;
    typesetBox.setSize({
      measure: size.width + glyph.width,
      extent: Math.max(size.height, glyph.height)
    });
    results.push(typesetBox); // can break after embed node

    results.push(TypesetNodeFactory.makePenalty());
    return results;
  };
  return ObjectProcessor;
}();
var TypesetProcessorWrapper = function () {
  function TypesetProcessorWrapper(context) {
    this.mContext = context;
  }
  Object.defineProperty(TypesetProcessorWrapper.prototype, "objectProcessor", {
    get: function get() {
      if (!this.mObjectProcessor) {
        this.mObjectProcessor = new ObjectProcessor(this.mContext.shaper);
      }
      return this.mObjectProcessor;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TypesetProcessorWrapper.prototype, "normalProcessor", {
    get: function get() {
      if (!this.mNormalProcessor) {
        this.mNormalProcessor = new UnicodeProcessor(this.mContext);
      }
      return this.mNormalProcessor;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TypesetProcessorWrapper.prototype, "nowrapProcessor", {
    get: function get() {
      if (!this.mNowrapProcessor) {
        this.mNowrapProcessor = new NowrapUnicodeProcessor(this.mContext);
      }
      return this.mNowrapProcessor;
    },
    enumerable: false,
    configurable: true
  });
  TypesetProcessorWrapper.prototype.process = function (model, lineBreaks) {
    if (model instanceof TextNode) {
      if (lineBreaks) {
        return this.normalProcessor.process(model, lineBreaks);
      }
      return this.nowrapProcessor.process(model);
    }
    if (model instanceof InlineNode) {
      return this.objectProcessor.process(model);
    }
    return [];
  };
  return TypesetProcessorWrapper;
}();

/**
 * @class Line Break Iterator
 *
 * use this to iterator the line break opportunities in a string of text
 *
 */

var LineBreakIterator = function () {
  function LineBreakIterator(text, options) {
    this._text = text;
    if (options === undefined) {
      this._options = {
        lineBreak: tr.Strict,
        wordBreak: rr.Normal
      };
    } else {
      this._options = options;
    }
    this._breaker = new sr(this._text, this._options);
  }
  Object.defineProperty(LineBreakIterator.prototype, "text", {
    get: function get() {
      return this._text;
    },
    enumerable: false,
    configurable: true
  });
  LineBreakIterator.prototype.next = function () {
    var brk = this._breaker.next(true);
    return brk;
  };
  return LineBreakIterator;
}();

/* 获取指定node的可断行点 */

var getBreakOpportunity = function getBreakOpportunity(node) {
  var lineBreaks = [];
  var textContent = node.getTextContent();
  var options = {
    lineBreak: tr.Normal,
    wordBreak: rr.Normal,
    forbidClasses: [nr.Ex, nr.Sy]
  };
  var lineBreakIter = new LineBreakIterator(textContent, options);
  var brk = lineBreakIter.next();
  while (brk !== null) {
    lineBreaks.push(brk);
    brk = lineBreakIter.next();
  }
  return lineBreaks;
};

/**
 * 空文本节点。文本为空, 样式依赖于前一个节点。
 */

var EmptyTextNode = function (_super) {
  __extends(EmptyTextNode, _super);
  function EmptyTextNode(parent) {
    return _super.call(this, parent) || this;
  }
  EmptyTextNode.prototype.getParentNode = function () {
    return this.getGroupNode();
  };
  EmptyTextNode.prototype.getNextSibling = function () {
    var parent = this.getParentNode();
    return parent.getChildNodeNextSibling(this);
  };
  EmptyTextNode.prototype.getPrevSibling = function () {
    var parent = this.getParentNode();
    return parent.getChildNodePrevSibling(this);
  };
  EmptyTextNode.prototype.getProperty = function () {
    var _a;
    return (_a = this.getPrevSibling()) === null || _a === void 0 ? void 0 : _a.getProperty();
  };
  EmptyTextNode.prototype.getText = function () {
    return '';
  };
  return EmptyTextNode;
}(TextNode);

/**
 * 遍历TextNode，返回对应的BGP模型
 */

var TextGenerator = function (_super) {
  __extends(TextGenerator, _super);
  function TextGenerator(context, node) {
    var _this = _super.call(this, context, node) || this;
    _this.mStore = new BGPStore(_this);
    _this.mProcessor = new TypesetProcessorWrapper(context);
    _this.mBreakOpportunity = _this.initBreakOpportunity();
    _this.seekBegin();
    return _this;
  }
  Object.defineProperty(TextGenerator.prototype, "store", {
    get: function get() {
      return this.mStore;
    },
    enumerable: false,
    configurable: true
  });
  TextGenerator.prototype.createNextBGP = function () {
    if (this.mNextNode) {
      var model_1 = this.mNextNode;
      var bgps = this.mProcessor.process(model_1, this.mBreakOpportunity);
      this.mNextNode = this.mNode.getChildNodeNextSibling(model_1) || undefined;
      return bgps.map(function (bgp) {
        return [bgp, model_1];
      });
    }
    return [];
  };
  TextGenerator.prototype.hasNext = function () {
    // 排版数据模型还没到结束位置
    if (this.mNextNode) {
      return true;
    } // 有没有已生成的BGP模型未排完

    return this.mStore.hasNext();
  };
  /**
   * 还有next，并且nextNode不是empty
   */

  TextGenerator.prototype.hasNextAndNotEmpty = function () {
    // 排版数据模型还没到结束位置
    if (this.mNextNode && !(this.mNextNode instanceof EmptyTextNode)) {
      return true;
    } // 有没有已生成的BGP模型未排完

    return this.mStore.hasNext();
  };
  /**
   * BGP模型生成器，一次处理一个TextRun
   */

  TextGenerator.prototype.createIterator = function () {
    var next;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!this.hasNext()) return [3
          /*break*/, 2];
          next = this.mStore.getNext();
          return [4
          /*yield*/, next];
        case 1:
          _a.sent();
          return [3
          /*break*/, 0];
        case 2:
          return [2
          /*return*/];
      }
    });
  };
  TextGenerator.prototype.seekBegin = function () {
    this.mNextNode = this.getBeginChild() || undefined;
  };
  TextGenerator.prototype.initBreakOpportunity = function () {
    if (!this.mContext.isNowrapState()) {
      return getBreakOpportunity(this.mNode);
    }
    return undefined;
  };
  return TextGenerator;
}(BaseLayoutGenerator);
var TypesetBoxSplitter = function () {
  function TypesetBoxSplitter(shaper) {
    this.mShaper = shaper;
  }
  /**
   * 断字，通过二分法测量内容，找一个合适的分割点位置将文本分成左右两份，
   * 其中左侧内容满足：至少一个字素，或者测量尺寸<=指定的measure
   * @param tokenBox BGP模型之Box模型
   * @param model 对应的数据模型
   * @param measure 排版指定限制尺寸
   */
  // eslint-disable-next-line complexity

  TypesetBoxSplitter.prototype.breakWord = function (tokenBox, model, measure) {
    if (!(tokenBox instanceof TypesetBox) || !(model instanceof TextNode) || !tokenBox.text) {
      // 只对normal类型的TypesetBox进行分割
      return [tokenBox];
    }
    var uStr = new et(tokenBox.text);
    var graphemeStart = 0;
    var graphemeEnd = uStr.graphemeCount() - 1; // only one grapheme

    if (graphemeEnd === 0) return [tokenBox]; // binary find the break grapheme index

    var textSpan = model.getProperty() || undefined;
    var breakIdx = graphemeEnd;
    for (;;) {
      var mid = Math.floor((graphemeEnd - graphemeStart) / 2 + graphemeStart);
      if (mid <= graphemeStart) {
        breakIdx = graphemeStart;
        break;
      }
      var sliceUStr = uStr.sliceByGrapheme(0, mid + 1);
      var glyph = this.mShaper.shapeToken(sliceUStr.toString(), textSpan);
      if (glyph.width > measure) {
        graphemeEnd = mid;
      } else if (glyph.width < measure) {
        graphemeStart = mid;
      } else {
        // perfect match (mostly impossible)
        breakIdx = mid;
        break;
      }
    }
    var breakIdxRange = uStr.graphemeIndex2CharCodeIndexRange(breakIdx);
    var breakLen = breakIdxRange.end + 1;
    var range = tokenBox.range; // break in the end (mostly impossible however)

    if (!range || breakLen === range.len) {
      return [tokenBox];
    } // measure break text [0,breakIdx+1)

    var breakText = uStr.sliceByGrapheme(0, breakIdx + 1).toString();
    var breakGlyph = this.mShaper.shapeToken(breakText, textSpan); // slice first box

    var newRange = new GCPRange(range.gcpBegin, breakLen);
    var firstBox = TypesetNodeFactory.makeBox(breakGlyph.width, newRange);
    firstBox.type = tokenBox.type;
    firstBox.glyph = breakGlyph;
    firstBox.text = breakText; // slice second box (the rest)

    newRange = new GCPRange(newRange.end(), range.len - breakLen);
    var restText = tokenBox.text.slice(breakLen);
    var restGlyph = this.mShaper.shapeToken(restText, textSpan);
    var secondBox = TypesetNodeFactory.makeBox(restGlyph.width, newRange);
    secondBox.type = tokenBox.type;
    secondBox.glyph = restGlyph;
    secondBox.text = restText;
    return [firstBox, secondBox];
  };
  /**
   * 将一个BGPTuple[]一分为二，使左边部分总width<=measure
   */

  TypesetBoxSplitter.prototype.split = function (bgps, measure) {
    if (measure <= 0) {
      return [bgps, []];
    }
    var left = [];
    var rest = [];
    var curWidth = 0;
    for (var i = 0; i < bgps.length; i++) {
      var bgp = bgps[i];
      if (curWidth + bgp[0].width <= measure) {
        left.push(bgp);
        curWidth += bgp[0].width;
      } else {
        var restMeasure = measure - curWidth;
        if (restMeasure <= 0) {
          rest = bgps.slice(i);
          break;
        }
        var result = this.breakWord(bgp[0], bgp[1], restMeasure);
        var _a = __read(result, 2),
          first = _a[0],
          second = _a[1];
        var restStart = void 0;
        if (curWidth === 0 || curWidth + first.width <= measure) {
          left.push([first, bgp[1]]);
          if (second) rest.push([second, bgp[1]]);
          restStart = i + 1;
        } else {
          restStart = i;
        }
        rest.push.apply(rest, __spreadArray([], __read(bgps.slice(restStart))));
        break;
      }
    }
    return [left, rest];
  };
  return TypesetBoxSplitter;
}();

/**
 * 制表符对齐服务
 */
var TabAlignmentService = function () {
  function TabAlignmentService(textLayout, getCurPos, setCurPos) {
    this.textLayout = textLayout;
    this.getCurPos = getCurPos;
    this.setCurPos = setCurPos;
  }
  /**
   * bgp 返回了制表符 box，预处理制表符宽度
   * 分两种情况：
   * 1. 段落属性中手动设置了制表符 tabList 数据，优先采用该数据
   * 2. 如果没有 tabList，或者 tabList 中没有合适的 tabstop，则使用默认宽度制表符
   * @param node 制表符 box
   */

  TabAlignmentService.prototype.computeTabstop = function (node) {
    this.textLayout.setPreviousTabstop(null);
    var _a = this.computeTabstopContext(),
      lineMeasure = _a.lineMeasure,
      restMeasure = _a.restMeasure;
    if (restMeasure > 0) {
      var tabListIndex = this.indexOfNextValidTabstopFromTabList(lineMeasure);
      if (tabListIndex !== -1) {
        // 找到了合适的 tabList 中制表符位置，优先使用
        this.computeTabstopWidthFromTabList(node, tabListIndex);
      } else {
        // 没有合适的 tabList 候选制表符，使用默认宽度制表符对齐
        this.computeTabstopWidthFromDefaultTabSize(node);
      }
    }
  };
  /**
   * 传入受制表符影响的 box 宽度，根据该宽度来动态调整制表符宽度
   * @param nodeWidth 受制表符影响的 box 宽度
   */

  TabAlignmentService.prototype.adjustTabstopAlignment = function (nodeWidth) {
    var previousTabstop = this.textLayout.getPreviousTabstop();
    if (!previousTabstop || previousTabstop.tabstopAlignment === 'left') {
      // 1. 没有前置的制表符，不需要动态调整宽度
      // 2. 前置位制表符为向左对齐制表符，这种情况下制表符宽度固定，不需要动态调整
      return;
    }
    if (previousTabstop.tabstopAlignment !== 'center' && previousTabstop.tabBox.width < nodeWidth || previousTabstop.tabBox.width < nodeWidth / 2) {
      // 1. 向右对齐制表符，判断剩余可排版空间是否放得下待排版 node 的整体宽度
      // 2. 居中对齐制表符，判断剩余可排版空间是否放得下待排版 node 的**一半**宽度
      // TODO 3. 小数点对齐制表符待支持
      this.onNotEnoughMeasureForTabstop(previousTabstop, nodeWidth);
      return;
    }
    if (previousTabstop.tabstopAlignment === 'right') {
      this.handleRightAlignmentTabstopAdjustment(nodeWidth, previousTabstop);
    } else if (previousTabstop.tabstopAlignment === 'center') {
      this.handleCenterAlignmentTabstopAdjustment(nodeWidth, previousTabstop);
    } else if (previousTabstop.tabstopAlignment === 'decimal') ;
  };
  /**
   * 排版空间不够将待排版受制表符影响的 box 对齐了
   */

  TabAlignmentService.prototype.onNotEnoughMeasureForTabstop = function (previousTabstop, nodeWidth) {
    if (previousTabstop.tabstopAlignment === 'right') {
      // 空间不够所造成的超出的空间
      var extraMeasure = nodeWidth - previousTabstop.tabBox.width;
      this.curPos = previousTabstop.tabstop - nodeWidth + extraMeasure;
    } else if (previousTabstop.tabstopAlignment === 'center') {
      var extraMeasure = nodeWidth - previousTabstop.tabBox.width;
      previousTabstop.tabBox.width -= extraMeasure;
    } else {
      this.curPos -= nodeWidth;
    }
    previousTabstop.tabBox.width = 0; // 清除前置制表符的上下文信息，后续本应受该制表符影响的 box 不再判断制表符逻辑，继续顺排

    this.textLayout.setPreviousTabstop(null);
  };
  /**
   * 给定当前行排版位置，返回对应 tabList 中 tabstop 的 index
   * 如果没有合适的则返回 -1
   * @param lineMeasure 当前排版位置
   * @returns tabList 中某个 index 或者 -1
   */

  TabAlignmentService.prototype.indexOfNextValidTabstopFromTabList = function (lineMeasure) {
    var _a, _b;
    var tabList = this.textLayout.tabList;
    var tabListIndex = 0;
    if (this.textLayout.hasPreviousTabstop()) {
      tabListIndex = this.textLayout.getPreviousTabstop().tabListIndex + 1;
    }
    while (((_b = (_a = tabList[tabListIndex]) === null || _a === void 0 ? void 0 : _a.position) !== null && _b !== void 0 ? _b : Number.POSITIVE_INFINITY) <= lineMeasure) {
      tabListIndex += 1;
    }
    var tabstop = tabList[tabListIndex];
    return tabstop ? tabListIndex : -1;
  };
  TabAlignmentService.prototype.computeTabstopWidthFromTabList = function (node, tabListIndex) {
    var lineMeasure = this.computeTabstopContext().lineMeasure;
    var tabstop = this.textLayout.tabList[tabListIndex];
    var previousTabstop = {
      tabBox: node,
      tabstop: tabstop.position,
      tabstopAlignment: tabstop.alignment,
      tabListIndex: tabListIndex
    };
    var rootContentMeasure = this.textLayout.getRootContentMeasure();
    if (tabstop.alignment !== 'left' && tabstop.position > rootContentMeasure) {
      // 制表符超出文本框末尾情况，且非向左对齐制表符
      // 默认对齐文本框末尾
      node.width = rootContentMeasure - lineMeasure;
      previousTabstop.tabstop = rootContentMeasure;
    } else {
      node.width = tabstop.position - lineMeasure;
    }
    this.textLayout.setPreviousTabstop(previousTabstop);
  };
  TabAlignmentService.prototype.computeTabstopWidthFromDefaultTabSize = function (node) {
    var _a;
    var _b = this.computeTabstopContext(),
      lineMeasure = _b.lineMeasure,
      restMeasure = _b.restMeasure;
    if (this.shouldAlignTabstopToMarginLeft(lineMeasure)) {
      node.width = this.textLayout.marginLeft - lineMeasure;
      return;
    }
    var tabstopPosition = (_a = this.textLayout.defaultTabSize) !== null && _a !== void 0 ? _a : node.width;
    var used = lineMeasure % tabstopPosition; // 计算当前tab的真实宽度

    var tabWidth;
    if (tabstopPosition - used < restMeasure) {
      // 空间够用，对齐到下一个tabstop
      var newWidth = tabstopPosition - used;
      if (lineMeasure + newWidth === lineMeasure) {
        // 兜底精度问题
        tabWidth = tabstopPosition;
      } else {
        tabWidth = newWidth;
      }
    } else {
      // 空间不够，两种情况：
      // 1. 如果有 tabList，则默认对齐 tabList 的第一个制表符位置
      // 2. 如果没有，则制表符宽度等于默认制表符宽度
      var tabListIndex = this.indexOfNextValidTabstopFromTabList(lineMeasure);
      if (tabListIndex !== -1) {
        // 找到了合适的 tabList 中制表符位置，优先使用
        return this.computeTabstopWidthFromTabList(node, tabListIndex);
      }
      tabWidth = tabstopPosition;
    }
    node.width = tabWidth; // 这里获取tab实时宽度
  };
  TabAlignmentService.prototype.computeTabstopContext = function () {
    var absoluteStart = this.textLayout.getRootAbsoluteStartExceptPadding();
    var lineMeasure = this.curPos + absoluteStart;
    var maxMeasure = Math.max(this.textLayout.maxMeasure, this.textLayout.getRootContentMeasure());
    var restMeasure = maxMeasure - lineMeasure;
    return {
      lineMeasure: lineMeasure,
      restMeasure: restMeasure
    };
  };
  /**
   * 第一行，有悬挂属性的场景，第一个 tabstop 应该对齐到缩进宽度
   */

  TabAlignmentService.prototype.shouldAlignTabstopToMarginLeft = function (lineMeasure) {
    return this.textLayout.isFirstLine() && this.textLayout.indent < 0 && lineMeasure < this.textLayout.marginLeft;
  };
  /**
   * 处理向右对齐制表符
   * @param nodeWidth 待排版 box 的宽度，受向右对齐制表符影响
   * @param previousTabstop 向右对齐制表符上下文信息
   */

  TabAlignmentService.prototype.handleRightAlignmentTabstopAdjustment = function (nodeWidth, previousTabstop) {
    if (previousTabstop.tabstop === this.curPos) {
      // 如果 curPos 等于向右对齐制表符的位置，则说明受该制表符影响的文本已经排了至少一个 box 了（且空间还没用完）
      previousTabstop.tabBox.width -= nodeWidth;
      this.curPos -= nodeWidth;
    } else if (previousTabstop.tabstop < this.curPos) {
      // 空间不够用了
      previousTabstop.tabBox.width = 0;
      this.textLayout.setPreviousTabstop(null);
    } else {
      // 此时是第一次使用 previousTabstop 排的第一个 box
      var tabstopWidth = previousTabstop.tabBox.width - nodeWidth;
      if (tabstopWidth < 0) {
        return;
      }
      previousTabstop.tabBox.width = tabstopWidth; // 减去 nodeWidth 是因为在 handleBox 中会调用 addBgps 给 curPos 加上 node.width
      // 这里做补偿要减去 nodeWidth。在 handleBox 之后，curPos 应该等于 tabstop.position

      this.curPos = previousTabstop.tabstop - nodeWidth;
    }
  };
  /**
   * 处理居中对齐制表符
   * @param nodeWidth 待排版 box 的宽度，受居中对齐制表符影响
   * @param previousTabstop 居中对齐制表符上下文信息
   */

  TabAlignmentService.prototype.handleCenterAlignmentTabstopAdjustment = function (nodeWidth, previousTabstop) {
    if (previousTabstop.tabBox.width === previousTabstop.tabstop - this.curPos) {
      // 第一个 box
      var tabEnd = previousTabstop.tabstop - nodeWidth / 2;
      if (this.curPos > tabEnd) {
        previousTabstop.tabBox.width = 0;
        return;
      }
      previousTabstop.tabBox.width = tabEnd - this.curPos;
      this.curPos = tabEnd;
    } else {
      // 后续 box
      if (nodeWidth / 2 > previousTabstop.tabBox.width) {
        previousTabstop.tabBox.width = 0;
        return;
      }
      previousTabstop.tabBox.width -= nodeWidth / 2;
      this.curPos -= nodeWidth / 2;
    }
    var rootContentMeasure = this.textLayout.getRootContentMeasure();
    if (this.curPos + nodeWidth > rootContentMeasure) {
      var toBeFixed = this.curPos + nodeWidth - rootContentMeasure;
      if (toBeFixed > previousTabstop.tabBox.width) {
        return;
      }
      previousTabstop.tabBox.width -= toBeFixed;
      this.curPos -= toBeFixed;
    }
  };
  Object.defineProperty(TabAlignmentService.prototype, "curPos", {
    get: function get() {
      return this.getCurPos();
    },
    set: function set(curPos) {
      this.setCurPos(curPos);
    },
    enumerable: false,
    configurable: true
  });
  return TabAlignmentService;
}();

/**
 * 处理行盒内容的空间管理
 */

var TextContainer = function () {
  function TextContainer(textLayout) {
    var _this = this; // 当前measure方向排版位置

    this.curPos = 0; // 预排版起始索引位置

    this.preStartIndex = -1;
    this.preMeasure = 0; // 预排版超出正常排版大小，计算行宽度时要减掉

    this.preBeyondMeasure = 0; // 标记这次已经进行无效预排版，下次不进入预排版

    this.hasPreLayoutInvalid = false;
    this.textLayout = textLayout;
    this.content = [];
    this.tabAlignmentService = new TabAlignmentService(textLayout, function () {
      return _this.curPos;
    }, function (curPos) {
      _this.curPos = curPos;
    });
  }
  TextContainer.prototype.isEmpty = function () {
    return this.content.length < 1;
  };
  /**
   * 清除已排版的内容
   */

  TextContainer.prototype.clearContent = function () {
    this.content = [];
    this.curPos = 0; // 重置预排版数据

    this.clearPreState();
  };
  Object.defineProperty(TextContainer.prototype, "lastNode", {
    get: function get() {
      var size = this.content.length;
      if (size > 0) {
        return this.content[size - 1][0];
      }
      return undefined;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextContainer.prototype, "restMeasure", {
    get: function get() {
      var maxMeasure = this.textLayout.maxMeasure || 0;
      return maxMeasure - this.curPos;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextContainer.prototype, "isLastLine", {
    get: function get() {
      return !this.textLayout.hasNext();
    },
    enumerable: false,
    configurable: true
  });
  TextContainer.prototype.isOver = function (measure) {
    return this.restMeasure < measure;
  };
  /**
   * 计算当前位置距离下一个Tabstop的距离，即为tab字符的measure
   */

  TextContainer.prototype.computeTabstop = function (node) {
    this.tabAlignmentService.computeTabstop(node);
  };
  TextContainer.prototype.adjustTabstopAlignment = function (nodeWidth) {
    this.tabAlignmentService.adjustTabstopAlignment(nodeWidth);
  };
  /**
   * 新增BGP模型
   * @param bgps
   * @param addMeasure 新增BGP模型总宽度
   */

  TextContainer.prototype.addBGPs = function (bgps, addMeasure) {
    var _a;
    (_a = this.content).push.apply(_a, __spreadArray([], __read(bgps)));
    this.curPos += addMeasure; // 记录预排版状态的measure

    if (this.isInPreState()) {
      this.preMeasure += addMeasure;
    }
    return false;
  };
  /**
   * 排版BGP模型（使用first-fit算法进行断行）
   * @param bgps BGP模型
   */

  TextContainer.prototype.typesetBGPs = function (bgps) {
    if (bgps.length <= 0) return false;
    var _a = __read(bgps, 1),
      _b = __read(_a[0], 1),
      curNode = _b[0];
    if (curNode.kind === BaseNodeKind.Box) {
      return this.handleBox(bgps);
    }
    if (curNode.kind === BaseNodeKind.Glue) {
      return this.handleGlue(bgps);
    }
    if (curNode.kind === BaseNodeKind.Penalty) {
      return this.handlePenalty(bgps);
    }
    return false;
  }; // 处理Box模型排版

  TextContainer.prototype.handleBox = function (boxes) {
    var _this = this;
    var curMeasure = 0;
    boxes.forEach(function (box) {
      var _a = __read(box, 2),
        node = _a[0],
        model = _a[1];
      if (node.type === TokenType.PlaceHolder) {
        _this.textLayout.measureObject(node, model);
      } else if (node.type === TokenType.Tabstop) {
        _this.computeTabstop(node);
      } else if (_this.textLayout.hasPreviousTabstop()) {
        _this.adjustTabstopAlignment(node.width);
      }
      curMeasure += node.width;
    });
    var _a = __read(boxes[boxes.length - 1], 1),
      last = _a[0];
    var hangWidth = last.hanging ? last.width : 0;
    if (!this.isOver(curMeasure - hangWidth)) {
      this.addBGPs(boxes, curMeasure);
      return false;
    } // 挤压handing space，使内容尽量显示在一行

    if (!this.hasPreLayoutInvalid && this.textLayout.shouldHandingChar4OneLine()) {
      var handingSpace = this.textLayout.handingSpace;
      if (!this.isOver(curMeasure - hangWidth - handingSpace)) {
        this.savePreState(boxes, curMeasure);
        return false;
      } // 如果不能显示再一行，则还原预排版之前的状态

      if (this.isInPreState()) {
        this.restorePreState(boxes);
        return false;
      }
    }
    if (this.isEmpty()) {
      // 超长文本强制断行
      var _b = __read(this.textLayout.splitBGPs(boxes), 2),
        result = _b[0],
        rest = _b[1];
      var totalWidth = result.reduce(function (width, bgp) {
        return width + bgp[0].width;
      }, 0);
      this.addBGPs(result, totalWidth);
      if (rest && rest.length > 0) {
        // 强制断行剩余有内容下次再排
        this.textLayout.backOverBGPs(rest);
      } else {
        // 无剩余内容需要看下有没有需要排版在行尾的（悬挂，尾空格，Penalty等）
        return false;
      }
    } else {
      // 整体下行再排
      this.textLayout.backOverBGPs(boxes);
    }
    return true;
  };
  /**
   * 还原到预排版之前的状态
   * @param boxes
   * @private
   */

  TextContainer.prototype.restorePreState = function (boxes) {
    var start = this.preStartIndex;
    var result = [this.content.slice(0, start), this.content.slice(start)]; // 1.状态回退

    this.content = result[0];
    this.curPos -= this.preMeasure;
    this.clearPreState(); // 2.bgp回退

    this.textLayout.backOverBGPs(result[1].concat(boxes)); // 3.标记当前行已经进行预排版,且进行了回退

    this.hasPreLayoutInvalid = true;
  };
  /**
   * 保存预排版的状态
   * @param boxes
   * @param curMeasure
   * @private
   */

  TextContainer.prototype.savePreState = function (boxes, curMeasure) {
    if (!this.isInPreState()) {
      // 记录预测量的起始索引位置
      this.preStartIndex = this.content.length;
    } // 记录预排版超出区域

    var resetSpace = this.restMeasure;
    if (resetSpace <= 0) {
      this.preBeyondMeasure += curMeasure;
    } else {
      this.preBeyondMeasure += curMeasure - resetSpace;
    }
    this.addBGPs(boxes, curMeasure);
  };
  TextContainer.prototype.isInPreState = function () {
    return this.preStartIndex !== -1;
  };
  TextContainer.prototype.clearPreState = function () {
    // 重置预排版数据
    this.preStartIndex = -1;
    this.preMeasure = 0;
    this.preBeyondMeasure = 0;
    this.hasPreLayoutInvalid = false;
  }; // 处理Glue模型排版

  TextContainer.prototype.handleGlue = function (glues) {
    var measure = glues.reduce(function (acc, glue) {
      return acc + glue[0].width;
    }, 0);
    this.adjustTabstopAlignment(measure);
    this.addBGPs(glues, measure);
    return false;
  }; // 处理Penalty模型排版

  TextContainer.prototype.handlePenalty = function (penalty) {
    if (this.isEmpty()) {
      // 过滤行首Penalty
      return false;
    }
    var _a = __read(penalty, 1),
      _b = __read(_a[0], 1),
      curNode = _b[0];
    var preNode = this.lastNode;
    if (preNode && isSamePenalty(preNode, curNode)) {
      // 过滤重复Penalty
      return false;
    }
    var isForceBreak = curNode.penalty <= MIN_PENALTY; // 预排版过程中，发现有强制换行，并且换行后还有后续内容，则回退预排版逻辑，重新排。

    if (this.isInPreState() && isForceBreak && this.textLayout.hasNextAndNotEmpty()) {
      this.restorePreState(penalty);
      return false;
    }
    this.addBGPs(penalty, 0);
    return isForceBreak;
  };
  /**
   * 两端对齐规则：
   * - 只处理首尾空白字符之间的内容
   * - 只处理最后一个Tab字符之后的内容
   * - 对满足以上条件范围内的Glue和Penalty之前的Box进行拉伸
   */

  TextContainer.prototype.justifyAlign = function () {
    var firstBoxIndex = this.getHeadBoxInfo().firstBoxIndex;
    var _a = this.getTailBoxInfo(),
      lastBoxIndex = _a.lastBoxIndex,
      tailGlueWidth = _a.tailGlueWidth;
    var nodes = this.getJustifyAlignStretchNodes(firstBoxIndex, lastBoxIndex);
    this.stretchContent(tailGlueWidth, nodes);
    var maxMeasure = this.textLayout.maxMeasure || 0; // 宽度直接置为最大宽度即可（这是原始逻辑，加上 tailGlueWidth 应该是因为在 text-layout transToLineBoxes 时会统一减去 tailGlueWidth，加上之后保证两端对齐和正常文本处理逻辑一致）

    this.curPos = maxMeasure + tailGlueWidth;
  };
  /**
   * 获取两端对齐时需要拉伸的节点
   * @param lastBoxIndex
   * @returns
   */

  TextContainer.prototype.getJustifyAlignStretchNodes = function (firstBoxIndex, lastBoxIndex) {
    var stretchNodes = [];
    for (var i = firstBoxIndex + 1; i < lastBoxIndex; i += 1) {
      var _a = __read(this.content[i], 1),
        node = _a[0];
      if (node.kind === BaseNodeKind.Glue) {
        stretchNodes.push(node);
      } else if (node.kind === BaseNodeKind.Penalty) {
        // 断行位置，取前一个Box做拉伸，如中文
        var _b = __read(this.content[i - 1], 1),
          prev = _b[0]; // 两端对齐不拉伸Tab字符

        if (!isTabToken(prev)) {
          stretchNodes.push(prev);
        }
      } else if (isTabToken(node)) {
        // Tabstop之前的BGP模型不能拉伸
        stretchNodes = [];
      }
    }
    return stretchNodes;
  };
  /**
   * 分散对齐规则：
   * - 只处理首尾空白字符之间的内容
   * - 只处理最后一个Tab字符之后的内容
   * - 对满足以上条件范围内的 Box 和 Glue 进行拉伸
   * - 当前段落最后一行如果没有任何文字需要拉伸的话，当前行主内容居中
   */

  TextContainer.prototype.distributeAlign = function () {
    var firstBoxIndex = this.getHeadBoxInfo().firstBoxIndex;
    var _a = this.getTailBoxInfo(),
      lastBoxIndex = _a.lastBoxIndex,
      tailGlueWidth = _a.tailGlueWidth;
    var nodes = this.getDistributeAlignStretchNodes(firstBoxIndex, lastBoxIndex);
    this.stretchContent(tailGlueWidth, nodes);
    var maxMeasure = this.textLayout.maxMeasure || 0; // 最后一行如果需要没有需要拉伸的文字的话，需要把主内容居中，所以不需要改动 curPos，保证最终计算出来的宽度为内容宽度
    // 其他行的宽度直接置为最大宽度即可（这是原始逻辑，加上 tailGlueWidth 应该是因为在 text-layout transToLineBoxes 时会统一减去 tailGlueWidth，加上之后保证分散对齐和正常文本处理逻辑一致）

    if (!(this.isLastLine && nodes.length === 0)) {
      this.curPos = maxMeasure + tailGlueWidth;
    }
  };
  /**
   * 获取分散对齐时需要拉伸的节点
   * @returns
   */

  TextContainer.prototype.getDistributeAlignStretchNodes = function (firstBoxIndex, lastBoxIndex) {
    var stretchNodes = [];
    for (var i = firstBoxIndex; i <= lastBoxIndex; i += 1) {
      var _a = __read(this.content[i], 1),
        node = _a[0];
      if (isTabToken(node)) {
        // Tabstop之前的BGP模型不能拉伸
        stretchNodes = [];
      } else if (i < lastBoxIndex && (node.kind === BaseNodeKind.Glue || node.kind === BaseNodeKind.Box)) {
        // 最后一个文字不参与拉伸
        stretchNodes.push(node);
      }
    }
    return stretchNodes;
  };
  /**
   * 拉伸节点空间
   */

  TextContainer.prototype.stretchContent = function (tailGlueWidth, stretchNodes) {
    var maxMeasure = this.textLayout.maxMeasure || 0; // 计算可拉伸的空间
    // 可拉伸空间 = 最大空间 - 已经被占用的空间
    // 已经被占用的空间 = 目前排版到的位置 - 需要被忽略的空间
    // 尾部空格不需要挤压剩余可拉伸空间，所以需要被忽略掉
    // 开头的空格需要挤压剩余可拉伸空间，所以不能忽略掉

    var stretchLength = maxMeasure - (this.curPos - tailGlueWidth);
    if (stretchLength <= 0) {
      // 不需要拉伸
      return;
    } // 目前是对于所有可拉伸的BGP模型进行等比拉伸

    var delta = stretchLength / stretchNodes.length;
    stretchNodes.forEach(function (bgp) {
      if (bgp instanceof TypesetBox || bgp instanceof TypesetGlue) {
        bgp.adjustWidth(delta);
      }
    });
  };
  /**
   * 获取尾部空白字符宽度和最后一个 box 索引
   * @returns
   */

  TextContainer.prototype.getTailBoxInfo = function () {
    var lastBoxIndex = 0;
    var tailGlueWidth = 0;
    for (var i = this.content.length - 1; i > 0; i -= 1) {
      var _a = __read(this.content[i], 1),
        node = _a[0];
      if (node.kind === BaseNodeKind.Box) {
        lastBoxIndex = i;
        break;
      }
      tailGlueWidth += node.width;
    }
    return {
      tailGlueWidth: tailGlueWidth,
      lastBoxIndex: lastBoxIndex
    };
  };
  /**
   * 获取头部第一个 box 索引
   * @returns
   */

  TextContainer.prototype.getHeadBoxInfo = function () {
    var firstBoxIndex = 0;
    for (var i = 0; i < this.content.length; i++) {
      var _a = __read(this.content[i], 1),
        node = _a[0];
      if (node.kind === BaseNodeKind.Box) {
        firstBoxIndex = i;
        break;
      }
    }
    return {
      firstBoxIndex: firstBoxIndex
    };
  };
  /**
   * 将BGP按layoutInputNode分组成textRun，过滤掉Penalty
   * @returns [textRun[], 总typesetNode数]
   * @param content
   */

  TextContainer.prototype.createTextRuns = function (content) {
    var textRuns = [];
    var bgps = [];
    var model;
    for (var i = 0; i < content.length; i += 1) {
      var _a = __read(content[i], 2),
        node = _a[0],
        curModel = _a[1];
      if (curModel !== model) {
        model = curModel;
        bgps = [];
        textRuns.push({
          model: model,
          bgps: bgps
        });
      }
      bgps.push(node);
    }
    return textRuns;
  };
  TextContainer.prototype.getTailGlueInfo = function (content) {
    var tailInfo = {
      tailGlueCount: 0,
      tailGlueWidth: 0
    };
    for (var i = content.length - 1; i >= 0; i -= 1) {
      var _a = __read(content[i], 1),
        node = _a[0];
      if (!isTailGlue(node)) {
        return tailInfo;
      }
      tailInfo.tailGlueCount += 1;
      tailInfo.tailGlueWidth += node.width;
    }
    return tailInfo;
  };
  /**
   * 将当前已排版的BGPs生成breakLine
   * - 两端对齐，对Box/Glue进行拉伸
   * - 分散对齐，对Box/Glue进行拉伸
   * - 过滤Penalty
   * - 生成textRun->model映射数据
   * @param 是否两端对齐
   */

  TextContainer.prototype.createBreakLine = function () {
    var _a = this.textLayout,
      isJustify = _a.isJustify,
      isNowrap = _a.isNowrap,
      isDistribute = _a.isDistribute;
    if (isJustify && !isNowrap && !this.isLastLine) {
      this.justifyAlign();
    } // 只有自动换行的文本分散对齐才会生效

    if (isDistribute && !isNowrap) {
      this.distributeAlign();
    }
    var content = this.content.filter(function (bgp) {
      return !isPenalty(bgp[0]);
    });
    var length = content.length;
    var _b = this.getTailGlueInfo(content),
      tailGlueCount = _b.tailGlueCount,
      tailGlueWidth = _b.tailGlueWidth;
    var textRuns = this.createTextRuns(content);
    var tailGlueStart = length - tailGlueCount;
    var last = length > 0 && content[length - 1][0];
    var isPageBreak = last && isPageBreakToken(last);
    var result = {
      content: content,
      textRuns: textRuns,
      measure: this.curPos,
      beyondMeasure: this.isInPreState() ? this.preBeyondMeasure : 0,
      tailGlueStart: tailGlueStart,
      tailGlueWidth: tailGlueWidth,
      isPageBreak: isPageBreak
    };
    return result;
  };
  return TextContainer;
}();

/**
 * @class LeafBox
 * 排版最小元素
 */

var BaseLeafBox = function (_super) {
  __extends(BaseLeafBox, _super);
  function BaseLeafBox(size) {
    var _this = _super.call(this, size) || this;
    /** 旋转角度 */

    _this.rotate = 0;
    /** 文字偏移，根据文字的基线对齐方式，调整文字的偏移 */

    _this.fontOffsetX = 0;
    _this.fontOffsetY = 0;
    _this.imgOffsetY = 0;
    _this.imgOffsetX = 0; // 文字偏移逻辑尺寸

    _this._offsetMeasure = 0;
    _this._offsetExtent = 0;
    _this._display = LayoutDisplay.Inline;
    return _this;
  }
  Object.defineProperty(BaseLeafBox.prototype, "textStyle", {
    get: function get() {
      return this._textStyle || new SpanProperty();
    },
    set: function set(style) {
      this._textStyle = style;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLeafBox.prototype, "display", {
    get: function get() {
      return this._display;
    },
    set: function set(boxType) {
      this._display = boxType;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLeafBox.prototype, "offsetMeasure", {
    get: function get() {
      return this._offsetMeasure;
    },
    set: function set(offset) {
      this._offsetMeasure = offset;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseLeafBox.prototype, "offsetExtent", {
    get: function get() {
      return this._offsetExtent;
    },
    set: function set(offset) {
      this._offsetExtent = offset;
    },
    enumerable: false,
    configurable: true
  });
  return BaseLeafBox;
}(BaseLayoutBox);

/**
 * @class TextBox
 * 文字排版元素，例如一个英文单词、中文字、空格、标点、非嵌入式对象占位符等
 */

var TextBox = function (_super) {
  __extends(TextBox, _super);
  function TextBox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.kind = BoxKind.Text;
    _this.text = '';
    return _this;
  }
  TextBox.prototype.textString = function () {
    return this.text;
  };
  Object.defineProperty(TextBox.prototype, "ascent", {
    get: function get() {
      return this.glyph ? this.glyph.ascent : 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextBox.prototype, "descent", {
    get: function get() {
      return this.glyph ? this.glyph.descent : 0;
    },
    enumerable: false,
    configurable: true
  });
  return TextBox;
}(BaseLeafBox);
var ListMarkTextBox = function (_super) {
  __extends(ListMarkTextBox, _super);
  function ListMarkTextBox(size) {
    var _this = _super.call(this, size) || this;
    _this.isListMark = true;
    _this.offsetLeft = 0;
    return _this;
  }
  Object.defineProperty(ListMarkTextBox.prototype, "fontFamilyPrefix", {
    /** 表示项目编号在渲染时实际应该使用的字体 */
    get: function get() {
      var _a, _b, _c;
      var list = (_b = (_a = this.lineBox) === null || _a === void 0 ? void 0 : _a.parentBox) === null || _b === void 0 ? void 0 : _b.paraProps;
      if (list) {
        if (list.isTask || list.isBullet && !((_c = list.listMarkerSpanProp) === null || _c === void 0 ? void 0 : _c.fontFamily)) {
          return 'txdocfont,';
        }
      }
      return '';
    },
    enumerable: false,
    configurable: true
  });
  return ListMarkTextBox;
}(TextBox);
/**
 * 空白字符Box，宽度允许拉伸/压缩
 * whitespace: unicode category is Zs、Zl or Zp
 */

var TextWhitespaceBox = function (_super) {
  __extends(TextWhitespaceBox, _super);
  function TextWhitespaceBox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return TextWhitespaceBox;
}(TextBox);
var TextBreakerBox = function (_super) {
  __extends(TextBreakerBox, _super);
  function TextBreakerBox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TextBreakerBox.prototype.textString = function () {
    return PlaceholderChar.NonBreakSpace;
  };
  return TextBreakerBox;
}(TextBox);
var TextSeparatorBox = function (_super) {
  __extends(TextSeparatorBox, _super);
  function TextSeparatorBox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TextSeparatorBox.prototype.textString = function () {
    return PlaceholderChar.NoWidthOptionalBreak;
  };
  return TextSeparatorBox;
}(TextBox);
var TabstopTextBox = function (_super) {
  __extends(TabstopTextBox, _super);
  function TabstopTextBox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TabstopTextBox.prototype.textString = function () {
    return PlaceholderChar.NoWidthOptionalBreak;
  };
  return TabstopTextBox;
}(TextBox);
/**
 * 根据文本内容创建不同类型TextBox
 * @param size box大小
 * @param text 文本内容
 */

var createTextBox = function createTextBox(text, size) {
  var box;
  if (text.length === 1) {
    var charCode = text.charCodeAt(0);
    if (isLineBreaker(charCode)) {
      box = new TextBreakerBox(size);
    } else if (isSeparator(charCode)) {
      box = new TextSeparatorBox(size);
    } else if (isTab(charCode)) {
      box = new TabstopTextBox(size);
    }
  }
  if (!box) {
    box = new TextBox(size);
  }
  box.text = text;
  return box;
};

/**
 * @class EmbedBox
 * 嵌入式的对象，例如嵌入式图片、嵌入式形状、嵌入式公式等
 */

var InlineBox = function (_super) {
  __extends(InlineBox, _super);
  function InlineBox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.kind = BoxKind.Inline;
    return _this;
  }
  InlineBox.prototype.textString = function () {
    return '*';
  };
  Object.defineProperty(InlineBox.prototype, "property", {
    get: function get() {
      return this._property;
    },
    set: function set(prop) {
      this._property = prop;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(InlineBox.prototype, "ascent", {
    get: function get() {
      return this.glyph ? this.glyph.ascent : 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(InlineBox.prototype, "descent", {
    get: function get() {
      return this.glyph ? this.glyph.descent : 0;
    },
    enumerable: false,
    configurable: true
  });
  return InlineBox;
}(BaseLeafBox);

/**
 * 对返回的bgp模型，进行 行拆分和排版
 */

var TextLayout = function (_super) {
  __extends(TextLayout, _super);
  function TextLayout(context, node) {
    var _this = _super.call(this, context, node) || this; // 已排版的行数

    _this.mCurLineCount = 0;
    _this.mStartOffset = 0;
    /**
     * 制表符的复杂对齐方式需要的上下文信息
     * 排某一个 box 时，如果前一个 box 是制表符，则需要动态根据当前 box 的宽度来调整制表符和自己的宽度
     */

    _this.previousTabstop = null;
    _this.getInlineBoxRunRange = function (bgpRange, modelRange) {
      return new GCPRange(((bgpRange === null || bgpRange === void 0 ? void 0 : bgpRange.begin()) || 0) - modelRange.begin(), (bgpRange === null || bgpRange === void 0 ? void 0 : bgpRange.length()) || 0);
    };
    var paraStyle = node.getProperty();
    _this.mParaStyle = paraStyle ? paraStyle : new ParaProperty();
    _this.mSplitter = new TypesetBoxSplitter(context.shaper);
    _this.mContainer = new TextContainer(_this);
    return _this;
  }
  Object.defineProperty(TextLayout.prototype, "isJustify", {
    get: function get() {
      var textAlignment = this.mParaStyle.textAlignment;
      return textAlignment === TextAlignmentType.Justify;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextLayout.prototype, "isDistribute", {
    get: function get() {
      var textAlignment = this.mParaStyle.textAlignment;
      return textAlignment === TextAlignmentType.Distribute;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextLayout.prototype, "isNowrap", {
    get: function get() {
      return this.mContext.isNowrap();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextLayout.prototype, "defaultTabSize", {
    get: function get() {
      return this.mParaStyle.defaultTabSize;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextLayout.prototype, "tabList", {
    get: function get() {
      return this.mParaStyle.tabList;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextLayout.prototype, "indent", {
    get: function get() {
      return this.mParaStyle.indent;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextLayout.prototype, "marginLeft", {
    get: function get() {
      return this.mParaStyle.marginLeft;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextLayout.prototype, "docPaddingMeasure", {
    /**
     * 获取document padding measure
     */
    get: function get() {
      var _a, _b;
      return (_b = (_a = this.getRootLayout()) === null || _a === void 0 ? void 0 : _a.paddingMeasure) !== null && _b !== void 0 ? _b : 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextLayout.prototype, "handingSpace", {
    /**
     * 设置handingChar4OneLine之后的最大挤压空间
     */
    get: function get() {
      var maxHandingSpace = this.mContext.getMaxHandingSpace();
      return Math.min(maxHandingSpace, this.docPaddingMeasure);
    },
    enumerable: false,
    configurable: true
  });
  TextLayout.prototype.shouldHandingChar4OneLine = function () {
    // 不支持该设置，返回false
    if (!this.mContext.isHandingChar4OneLine()) {
      return false;
    } // 不自动换行情况

    if (this.isNowrap) {
      return false;
    } // 分栏情况不处理handing

    if (this.mContext.columnNumber > 1) {
      return false;
    } // 不是第一行，返回false

    return this.mCurLineCount <= 0;
  };
  /**
   * 相对根节点的绝对offset start，除去root节点的padding start
   */

  TextLayout.prototype.getRootAbsoluteStartExceptPadding = function () {
    var _a;
    var offsetStart = 0;
    var parent = this.getParent();
    while (parent) {
      offsetStart += ((_a = parent.getParentOffset()) === null || _a === void 0 ? void 0 : _a.start) || 0;
      var parentNode = parent.getParent();
      if (!parentNode) {
        // parent是root节点
        offsetStart -= (parent === null || parent === void 0 ? void 0 : parent.getPadding().start) || 0;
      }
      parent = parentNode;
    }
    return offsetStart;
  };
  /**
   * 获取根节点内容大小。不包括padding
   */

  TextLayout.prototype.getRootContentMeasure = function () {
    var root = this.getRootLayout();
    if (!root) return 0;
    var inlineSpec = root.getSizeSpec().inlineSpec;
    var rootMeasure = MeasureSpec.getSize(inlineSpec);
    return rootMeasure - root.getPadding().measure;
  };
  /**
   * 获取根节点内容大小。不包括padding
   */

  TextLayout.prototype.getRootLayout = function () {
    var parent = this.getParent();
    var root;
    while (parent) {
      var parentNode = parent.getParent();
      if (!parentNode) {
        root = parent;
      }
      parent = parentNode;
    }
    return root;
  };
  Object.defineProperty(TextLayout.prototype, "maxMeasure", {
    get: function get() {
      return this.mMaxMeasure;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 测量(排版)嵌入式对象
   * @param node 嵌入式对象对应的Box模型
   * @param model 对应的数据模型
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  TextLayout.prototype.measureObject = function (node, model) {};
  /**
   * 回退未排版完的BGP模型
   * @param bgps 待排版的BGP模型
   */

  TextLayout.prototype.backOverBGPs = function (bgps) {
    this.mGenerator.store.setLastBGPs(bgps);
  };
  TextLayout.prototype.hasNextAndNotEmpty = function () {
    return this.mGenerator.hasNextAndNotEmpty();
  };
  TextLayout.prototype.setPreviousTabstop = function (previousTabstop) {
    this.previousTabstop = previousTabstop;
  };
  TextLayout.prototype.hasPreviousTabstop = function () {
    return !!this.previousTabstop;
  };
  TextLayout.prototype.getPreviousTabstop = function () {
    return this.previousTabstop;
  };
  TextLayout.prototype.isFirstLine = function () {
    return this.mParentLayout instanceof LineLayout$1 && this.mParentLayout.isFirstLine();
  };
  /**
   * 超长文本按当前行measure对bgps进行分割，前半部分用于当前排版，后半部分下次再排
   */

  TextLayout.prototype.splitBGPs = function (bgps, maxMeasure) {
    var measure = maxMeasure || this.mMaxMeasure || 1; // 最小不能为0，否则不会split

    return this.mSplitter.split(bgps, measure);
  };
  TextLayout.prototype.createGenerator = function (context, node) {
    return new TextGenerator(context, node);
  };
  TextLayout.prototype.onLayout = function () {
    var expectSize = MeasureSpec.getSize(this.mInlineMeasureSpec);
    this.mMaxMeasure = resolveSize(expectSize, this.mInlineMeasureSpec);
    var value = [];
    while (true) {
      var next = this.mGenerator.getNext();
      if (next.done || next.value.length < 1) {
        break;
      }
      if (this.pushBGPs(next.value)) {
        value = this.reduceBreakLine();
        break;
      }
    }
    if (value.length < 1) {
      value = this.reduceBreakLine();
    }
    if (value.length > 0) {
      // 转换value为BaseLayoutBox数组
      return this.transToLineBoxes(value);
    }
    return {
      layoutBoxes: []
    };
  };
  TextLayout.prototype.generateDefaultLayoutParams = function () {
    var measureSize = this.isNowrap ? MAX_MEASURE : LayoutSizeSpec.WRAP_CONTENT;
    return new LayoutParams(measureSize, LayoutSizeSpec.WRAP_CONTENT);
  };
  /**
   * 排版BGP模型，根据first-fit算法进行断行
   */

  TextLayout.prototype.pushBGPs = function (bgps) {
    return this.mContainer.typesetBGPs(bgps);
  };
  /**
   * 生成排版行
   */

  TextLayout.prototype.reduceBreakLine = function () {
    if (this.mContainer.isEmpty()) return [];
    var line = this.mContainer.createBreakLine();
    this.mContainer.clearContent();
    this.mCurLineCount += 1;
    return [line];
  };
  /**
   * 转换BGP模型为输出的text box模型
   * @param value
   */

  TextLayout.prototype.transToLineBoxes = function (value) {
    var _this = this;
    var _a = __read(value, 1),
      line = _a[0];
    var nodeIndex = 0;
    this.mStartOffset = this.mOffset.start + this.paddingStart;
    var contentWidth = this.mContext.includeTailWhitespaceWidth() ? line.measure : line.measure - line.tailGlueWidth; // BGP模型转排版输出box，并添加到container

    var content = [];
    line.textRuns.forEach(function (textRun) {
      var model = textRun.model,
        bgps = textRun.bgps;
      var tailStart = Math.max(line.tailGlueStart - nodeIndex, 0);
      var boxes = _this.createLineChild(model, bgps, tailStart);
      content.push.apply(content, __spreadArray([], __read(boxes)));
      nodeIndex += bgps.length;
    });
    return {
      layoutBoxes: content,
      contentWidth: contentWidth,
      tailGlueWidth: line.tailGlueWidth,
      beyondMeasure: line.beyondMeasure
    };
  }; // 处理TextRun的BGP模型转LineChildBox

  TextLayout.prototype.createLineChild = function (model, bgps, tailStart) {
    if (bgps.length <= 0) return [];
    if (model instanceof TextNode) {
      return this.createTextBoxes(model, bgps, tailStart);
    }
    if (model instanceof InlineNode) {
      return [this.createInlineBox(model, bgps[0])];
    }
    return [];
  };
  /**
   * 处理文本类型BGP模型转LeafBox，为减少Box节点数，需做合并优化，具体规则：
   * - 空格：两端对齐时除尾空格之外的空格都独立成box，否则合并
   * - Tab：Tab字符本身独立成box，其前面的内容不能拉伸，因此可合并
   * - 宽度有调整的BGP模型独立成box
   */

  TextLayout.prototype.createTextBoxes = function (model, bgps, tailStart) {
    var _this = this;
    var result = []; // 合并的内容

    var textInfo; // eslint-disable-next-line complexity

    var pushTextBox = function pushTextBox(bg) {
      var _a, _b, _c;
      var node = bg || textInfo;
      if (!node || !node.range) return;
      var measure = node.width;
      var extent = ((_a = node.glyph) === null || _a === void 0 ? void 0 : _a.height) || 0;
      var box;
      if (node instanceof TypesetGlue) {
        // 独立成Box的空格
        box = new TextWhitespaceBox({
          measure: measure,
          extent: extent
        });
        box.text = node.text || '';
      } else if (node instanceof TypesetBox) {
        // 其他独立成Box的字符
        box = createTextBox(node.text || '', {
          measure: measure,
          extent: extent
        });
      } else {
        // 多BGP合并的Box
        box = createTextBox(node.text, {
          measure: measure,
          extent: extent
        });
        box.hangingGlue = node.hangineGlue;
        textInfo = undefined;
      }
      box.glyph = node.glyph;
      if (bg) {
        box.glyphs = bg.glyph ? [bg.glyph] : [];
      } else {
        box.glyphs = (_b = node) === null || _b === void 0 ? void 0 : _b.glyphs;
      }
      box.textStyle = model.getProperty();
      if (model instanceof EmptyTextNode) {
        // EmptyTextNode从属于上一个node节点
        var preModel = model.getPrevSibling();
        var len = ((_c = preModel === null || preModel === void 0 ? void 0 : preModel.getText()) === null || _c === void 0 ? void 0 : _c.length) || 0;
        box.runRange = new GCPRange(len, 0);
      } else {
        box.runRange = new GCPRange(node.range.begin() - model.range.begin(), node.range.length());
      }
      var baselineOffset = _this.getBaselineOffset(box); // 设置相对坐标

      box.logicPoint = new LogicalPoint(_this.mStartOffset, _this.mOffset.before - baselineOffset);
      _this.mStartOffset += box.totalMeasure;
      _this.setRotate(node, box);
      result.push(box);
    };
    var unionTextInfo = function unionTextInfo(bg, tailGlue) {
      var _a;
      if (!bg.range) {
        return;
      }
      if (!textInfo) {
        textInfo = {
          hangineGlue: tailGlue,
          text: bg.text || '',
          width: bg.width,
          range: bg.range,
          glyph: bg.glyph,
          glyphs: bg.glyph ? [bg.glyph] : []
        };
      } else {
        textInfo.text += bg.text || '';
        textInfo.width += bg.width;
        textInfo.range = textInfo.range.unionRange(bg.range);
        var curHeight = textInfo.glyph ? textInfo.glyph.height : 0;
        var nodeHeight = bg.glyph ? bg.glyph.height : 0;
        if (nodeHeight > curHeight) {
          textInfo.glyph = bg.glyph;
        }
        bg.glyph && ((_a = textInfo.glyphs) === null || _a === void 0 ? void 0 : _a.push(bg.glyph));
      }
    };
    for (var i = 0; i < bgps.length; i++) {
      var node = bgps[i];
      if (node.kind === BaseNodeKind.Box) {
        if (this.isNoMergeNodeType(node.type) || node.isSeparate || node.widthAdj !== 0) {
          // Tab字符，或宽度有调整，不合并
          pushTextBox();
          pushTextBox(node);
        } else {
          unionTextInfo(node);
        }
      } else if (node.kind === BaseNodeKind.Glue) {
        if (i < tailStart && node.widthAdj !== 0) {
          // 在尾空格之前且宽度有调整的空格，不合并
          pushTextBox();
          pushTextBox(node);
        } else {
          var tailGlue = i >= tailStart;
          unionTextInfo(node, tailGlue);
        }
      }
    }
    pushTextBox();
    return result;
  };
  /**
   * 获取当前文字节点的 baseline 偏移量
   * @param box
   * @returns
   */

  TextLayout.prototype.getBaselineOffset = function (box) {
    var _a = box.textStyle,
      baselineOffset = _a.baselineOffset,
      originFontSize = _a.originFontSize;
    if (baselineOffset) {
      return originFontSize * baselineOffset;
    }
    return 0;
  };
  TextLayout.prototype.isNoMergeNodeType = function (type) {
    return type === TokenType.Tabstop || type === TokenType.LineBreak;
  };
  TextLayout.prototype.createInlineBox = function (model, bgp) {
    if (model.isRotateInVertLayout()) {
      return this.createInlineBoxRotateOnVert(model, bgp);
    }
    return this.createInlineBoxNotRotateOnVert(model, bgp);
  };
  /**
   * 竖排时，内联进行旋转的情况，创建内联inlineBox
   */

  TextLayout.prototype.createInlineBoxRotateOnVert = function (model, bgp) {
    var box;
    if (bgp.box) {
      box = bgp.box;
    } else {
      var boxSize = {
        measure: bgp.width,
        extent: bgp.height
      };
      box = new InlineBox(boxSize);
    }
    box.glyph = bgp.glyph;
    box.textStyle = model.getProperty() || new SpanProperty();
    box.text = bgp.text || ''; // 设置 margin

    var margin = model.getContainerMargin();
    box.logicEdge = LogicalBoxEdge.obtain();
    box.logicEdge.margin = new LogicalEdgeSize(margin);
    box.runRange = this.getInlineBoxRunRange(bgp.range, model.range); // 计算垂直方向的偏移量

    var beforeOffset = 0;
    if (box.textStyle.baselineOffset) {
      beforeOffset = box.glyph.height * box.textStyle.baselineOffset;
    } // 设置相对坐标

    box.logicPoint = new LogicalPoint(this.mStartOffset + margin.start, this.mOffset.before + margin.before - beforeOffset);
    this.mStartOffset += box.totalMeasure;
    if (model.getInlineType() === InlineNodeType.InlinePictrue && box.glyph) {
      box.glyph.picSrc = model.getDrawingSrc().picSrc;
      var size = model.getContainerSize();
      box.glyph.width = size.width;
      box.glyph.height = size.height;
      box.glyph.ascent = box.glyph.ascent || box.glyph.height;
    }
    this.setRotate(bgp, box);
    return box;
  };
  /**
   * 竖排时，内联不旋转的情况，创建内联inlineBox
   */

  TextLayout.prototype.createInlineBoxNotRotateOnVert = function (model, bgp) {
    var box;
    if (bgp.box) {
      box = bgp.box;
    } else {
      var boxSize = {
        measure: bgp.width,
        extent: bgp.height
      };
      if (this.mContext.isVert()) {
        boxSize.measure = bgp.height;
        boxSize.extent = bgp.width;
      }
      box = new InlineBox(boxSize);
    }
    box.glyph = bgp.glyph;
    box.textStyle = model.getProperty() || new SpanProperty();
    box.text = bgp.text || ''; // 设置 margin

    var margin = model.getContainerMargin();
    box.logicEdge = LogicalBoxEdge.obtain();
    box.logicEdge.margin = new LogicalEdgeSize(margin);
    box.runRange = this.getInlineBoxRunRange(bgp.range, model.range); // 计算垂直方向的偏移量

    var beforeOffset = 0;
    if (box.textStyle.baselineOffset) {
      beforeOffset = box.glyph.height * box.textStyle.baselineOffset;
    } // 设置相对坐标

    box.logicPoint = new LogicalPoint(this.mStartOffset + margin.start, this.mOffset.before + margin.before - beforeOffset);
    this.mStartOffset += box.totalMeasure;
    if (model.getInlineType() === InlineNodeType.InlinePictrue && box.glyph) {
      box.glyph.picSrc = model.getDrawingSrc().picSrc;
      var size = model.getContainerSize();
      box.glyph.width = size.width;
      box.glyph.height = size.height;
      box.glyph.ascent = box.glyph.ascent || box.glyph.height;
      if (this.mContext.isVert()) {
        box.glyph.ascent = box.glyph.width;
      }
    }
    return box;
  };
  /**
   * 设置box模型旋转的中心和角度
   * @param node
   * @param box
   */

  TextLayout.prototype.setRotate = function (node, box) {
    var _a, _b;
    var leafBox = box;
    var rotate = 0;
    var rotateOrigin;
    var imgDescent = ((_a = box.glyph) === null || _a === void 0 ? void 0 : _a.descent) || 0;
    var imgOffsetY = 0;
    var imgOffsetX = 0;
    var isEast = node instanceof TypesetBox && node.type === TokenType.EAST;
    /**
     * 旋转 90
     * - 竖排方式为 isVert90
     * - 竖排方式为 isVertEast 时所有非亚洲方形字
     * - 堆积排版中的(括号类字符 或 inlineNode)
     */

    if (this.mContext.isVert90() || this.mContext.isVertEast() && !isEast || this.mContext.isWordArtVertical() && (isBrackets((_b = node.text) === null || _b === void 0 ? void 0 : _b.codePointAt(0)) || leafBox instanceof InlineBox)) {
      rotate = 90;
      rotateOrigin = new Point$1({
        x: box.extent / 2,
        y: box.extent / 2
      });
      imgOffsetX -= imgDescent / 2;
    } else if (this.mContext.isVert270()) {
      rotate = 270;
      rotateOrigin = new Point$1({
        x: box.measure / 2,
        y: box.measure / 2
      });
      imgOffsetX += imgDescent / 2;
    } else {
      imgOffsetY += imgDescent / 2;
    }
    leafBox.rotate = rotate;
    leafBox.rotateOrigin = rotateOrigin;
    leafBox.imgOffsetY = imgOffsetY;
    leafBox.imgOffsetX = imgOffsetX;
  };
  return TextLayout;
}(BaseLayout);

/**
 * LineGenerator遍历TextLayout切割成的多组text box，每一组是一行。
 */

var LineGenerator = function (_super) {
  __extends(LineGenerator, _super);
  function LineGenerator(context, node, layoutParent) {
    return _super.call(this, context, node, layoutParent) || this;
  }
  LineGenerator.prototype.createChildLayout = function (context, node) {
    return new TextLayout(context, node);
  };
  /**
   * first节点返回自身
   */

  LineGenerator.prototype.getBeginChild = function () {
    return this.mNode;
  };
  return LineGenerator;
}(LayoutParentGenerator);

/**
 * @class TextLineBox
 * 文本行
 */

var TextLineBox = function (_super) {
  __extends(TextLineBox, _super);
  function TextLineBox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.kind = BoxKind.TextLine;
    /**
     * 未计算行距前的原始行高
     */

    _this.sourceExtent = 0;
    /**
     * 去除尾空格的行宽
     */

    _this.contentWidth = 0;
    _this._ascent = 0;
    _this._descent = 0;
    return _this;
  }
  Object.defineProperty(TextLineBox.prototype, "ascent", {
    get: function get() {
      return this._ascent ? this._ascent : 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextLineBox.prototype, "descent", {
    get: function get() {
      return this._descent;
    },
    enumerable: false,
    configurable: true
  });
  TextLineBox.prototype.setBaseline = function (ascent, descent) {
    this._ascent = ascent;
    this._descent = descent;
  };
  return TextLineBox;
}(BaseParentBox);
var LineLayout = function (_super) {
  __extends(LineLayout, _super);
  function LineLayout(context, node) {
    var _this = _super.call(this, context, node) || this;
    _this.isSubLine = false; // 已排版的行数

    _this.mCurLineCount = 0;
    var paraStyle = node.getProperty();
    if (paraStyle) {
      var isList = paraStyle.isList;
      if (isList) {
        _this.mParaStyle = paraStyle;
      } else {
        _this.mParaStyle = paraStyle;
      }
    } else {
      _this.mParaStyle = new ParaProperty();
    }
    _this.updateForNewLine(_this.isFirstLine());
    return _this;
  }
  /**
   * 当前是否排版首行
   */

  LineLayout.prototype.isFirstLine = function () {
    return this.mCurLineCount === 0;
  };
  /**
   * 更新新行排版数据
   */

  LineLayout.prototype.updateForNewLine = function (isFirstLine) {
    this.updateIndent(isFirstLine); // 更新下一行的缩进
  };
  LineLayout.prototype.addBox = function (box) {
    this.mContent.pushInline(box);
  };
  LineLayout.prototype.createGenerator = function (context, node) {
    return new LineGenerator(context, node, this);
  };
  /**
   * mGenerator返回一组LineChildBox，直接就是一行了。不需要继续循环。
   */

  LineLayout.prototype.onLayout = function () {
    var _this = this;
    var next = this.mGenerator.getNext();
    if (next.done || next.value.layoutBoxes.length < 1) {
      return {
        layoutBoxes: []
      };
    }
    next.value.layoutBoxes.forEach(function (value) {
      _this.addBox(value);
    });
    return this.reduceLayout(next.value);
  };
  LineLayout.prototype.reduceLayout = function (childLayoutValue) {
    var textLineBox = this.createLineBox(childLayoutValue);
    this.mCurLineCount += 1;
    this.updateForNewLine(this.isFirstLine());
    this.mContent.clearInlines();
    return {
      layoutBoxes: [textLineBox]
    };
  };
  LineLayout.prototype.computeMetric = function (initial) {
    var initialValue = initial || {
      fontAscent: 0,
      fontDescent: 0,
      lineAscent: 0,
      lineDescent: 0,
      maxFontSize: 0
    };
    return this.mContent.getInlines().reduce(function (acc, box) {
      var _a;
      if (box instanceof ListMarkTextBox) {
        // 行高计算需要过滤项目符号
        return acc;
      }
      acc.fontAscent = Math.max(acc.fontAscent, box.ascent);
      acc.fontDescent = Math.max(acc.fontDescent, box.descent);
      if (box instanceof InlineBox) {
        acc.maxFontSize = Math.max(acc.maxFontSize || 0, box.ascent);
      } else {
        acc.maxFontSize = Math.max(acc.maxFontSize || 0, (_a = box.textStyle) === null || _a === void 0 ? void 0 : _a.fontSize);
      }
      acc.lineAscent = Math.max(acc.lineAscent, box.ascent + logicEdge(box).before);
      acc.lineDescent = Math.max(acc.lineDescent, box.descent + logicEdge(box).after);
      return acc;
    }, initialValue);
  };
  /**
   * 创建LineBox实例
   */

  LineLayout.prototype.newLineBox = function (size) {
    return new TextLineBox(size);
  };
  /**
   * 设置行缩进，以下为ppt规则
   */

  LineLayout.prototype.updateIndent = function (isFirstLine) {
    var lp = this.getLayoutParams(); // 首行，且悬挂或者首行缩进不为0

    if (isFirstLine && Math.abs(this.mParaStyle.indent) !== 0) {
      // 悬挂缩进减小start值，首行缩进增加start值
      // indent为负 是悬挂缩进， indent为正是：首行缩进；
      lp.margin.start = this.mParaStyle.marginLeft + this.mParaStyle.indent;
      if (lp.margin.start < 0) {
        lp.margin.start = 0;
      }
      return;
    } // 非首行

    lp.margin.start = this.mParaStyle.marginLeft;
  };
  LineLayout.prototype.updateBoxContentLogicFrame = function (box, contentWidth) {
    if (contentWidth === void 0) {
      contentWidth = 0;
    }
    var layoutBox = box; // 文字内容区域起始位置，根据 office 的表现，文字区域需要包含缩进

    var margin = this.getLayoutParams().margin;
    var contentStart = layoutBox.logicPoint.start - margin.start;
    var contentEnd = layoutBox.logicPoint.start + contentWidth;
    var contentBefore = layoutBox.logicPoint.before - margin.before;
    layoutBox.contentPoint = new LogicalPoint(contentStart, contentBefore);
    layoutBox.contentMeasure = contentEnd - contentStart; // 需要加上缩进
  };
  LineLayout.prototype.createLineBox = function (childLayoutValue) {
    var _this = this;
    var _a = childLayoutValue || {},
      _b = _a.tailGlueWidth,
      tailGlueWidth = _b === void 0 ? 0 : _b,
      _c = _a.beyondMeasure,
      beyondMeasure = _c === void 0 ? 0 : _c;
    var totalMeasure = this.mContext.includeTailWhitespaceWidth() ? this.mContent.inlinePos : this.mContent.inlinePos - tailGlueWidth;
    var contentWidth = (childLayoutValue === null || childLayoutValue === void 0 ? void 0 : childLayoutValue.contentWidth) || totalMeasure;
    var metric = this.computeMetric();
    var maxExtent = metric.lineAscent + metric.lineDescent; // 1. 计算行高

    var multipleLineSpacingBaseValue = this.getMultipleLineSpacingBaseValue(metric);
    var extentWithLineHeight = this.computeLineExtent(multipleLineSpacingBaseValue);
    var listMarkMeasure = 0;
    var childBaseBefore = (extentWithLineHeight - maxExtent) / 2; // line中文字居中
    // eslint-disable-next-line complexity

    this.mContent.getInlines().forEach(function (inline) {
      var _a, _b, _c, _d, _e;
      var inlineBox = inline;
      if (inlineBox instanceof ListMarkTextBox) {
        // 获取项目符号宽度
        listMarkMeasure = inlineBox.totalMeasure;
      } // 2. 调整child位置

      inlineBox.logicPoint.before += childBaseBefore; // line中文字居中

      var isBaseLineAlpha = _this.mContext.textBaseLine === TextBaselineType.Alphabetic;
      if (isBaseLineAlpha) {
        if (_this.mContext.isVertEast() || _this.mContext.isWordArtVertical()) {
          // 文字需要在当前行居中
          inlineBox.logicPoint.before += (maxExtent - inlineBox.extent) / 2; // 竖排单个文字左右居中

          if (inline.rotate) {
            inlineBox.offsetExtent += inlineBox.ascent;
          } else {
            inlineBox.offsetMeasure += inlineBox.ascent + inlineBox.ascent / 10; // 部分文字顶部会超出box，这里额外加一点偏移

            var isSymbol = _this.isEastSymbol(inlineBox);
            if (isSymbol && _this.mContext.isVertEast()) {
              // 调整竖排中文字符的位置
              var offsetMeasure = (inlineBox.measure - (((_a = inlineBox.glyph) === null || _a === void 0 ? void 0 : _a.actualWidth) || 0)) / 2;
              var offsetExtent = inlineBox.extent - (((_b = inlineBox.glyph) === null || _b === void 0 ? void 0 : _b.actualHeight) || 0);
              inlineBox.offsetMeasure -= offsetMeasure;
              inlineBox.offsetExtent -= offsetExtent;
            } else {
              // 文字在当前文字块左右居中
              inlineBox.offsetExtent -= ((_c = inlineBox.glyph) === null || _c === void 0 ? void 0 : _c.actualHeight) ? (inlineBox.extent - ((_d = inlineBox.glyph) === null || _d === void 0 ? void 0 : _d.actualHeight)) / 2 : 0;
            }
          }
        } else {
          var offsetBefore = metric.lineAscent - inlineBox.ascent;
          inlineBox.logicPoint.before += offsetBefore; // box偏移到文字位置

          inlineBox.offsetExtent = metric.lineAscent - offsetBefore;
        }
      }
      var imgWidth = ((_e = inline.glyph) === null || _e === void 0 ? void 0 : _e.picSrc) ? inline.glyph.width : 0;
      inlineBox.offsetMeasure += imgWidth;
    }); // 3. 计算左中右对齐

    var measure = resolveSize(
    // 行宽不能包含超出边界的区域（office也是这样），因为如果文本框宽度会扩张，这种情况会无限往后输入。
    totalMeasure - beyondMeasure + this.paddingMeasure, this.mInlineMeasureSpec);
    var expectMeasure = MeasureSpec.getSize(this.mInlineMeasureSpec);
    var left = this.computeLinePadding(contentWidth + listMarkMeasure + this.paddingMeasure, expectMeasure);
    var extent = resolveSize(extentWithLineHeight + this.paddingExtent, this.mBlockMeasureSpec); // 4. 创建lineBox

    var lineBox = new TextLineBox({
      measure: measure,
      extent: extent
    });
    lineBox.logicPoint = new LogicalPoint(this.mOffset.start + left, this.mOffset.before);
    lineBox.logicEdge = LogicalBoxEdge.obtain();
    lineBox.setBaseline(metric.lineAscent, metric.lineDescent);
    lineBox.logicEdge.margin = new LogicalEdgeSize(this.getLayoutParams().margin);
    lineBox.logicEdge.padding = new LogicalEdgeSize(this.mPadding); // 文字内容区域起始位置，根据 office 的表现，文字区域需要包含缩进

    this.updateBoxContentLogicFrame(lineBox, contentWidth + listMarkMeasure); // 更新children的真实相对坐标

    this.transRealCoordinate(measure, extent, maxExtent, childBaseBefore);
    lineBox.append.apply(lineBox, __spreadArray([], __read(this.mContent.getInlines())));
    return lineBox;
  };
  LineLayout.prototype.isEastSymbol = function (inlineBox) {
    var isSymbol = false;
    if (inlineBox instanceof TextBox) {
      var text = inlineBox.textString();
      if ((text === null || text === void 0 ? void 0 : text.length) === 1) {
        isSymbol = isEastSymbol(text.charCodeAt(0));
      }
    }
    return isSymbol;
  };
  /**
   * 转换相关逻辑尺寸为物理尺寸
   * @param measure
   * @param extent
   * @param maxExtent
   * @param childBaseBefore child top基线位置
   */

  LineLayout.prototype.transRealCoordinate = function (measure, extent, maxExtent, childBaseBefore) {
    var _this = this;
    this.mContent.getInlines().forEach(function (inline) {
      var inlineBox = inline; // 转换box rect区域

      inlineBox.rect = transChildRectToPhysical(_this.mContext.coordinateZero, _this.mContext.lineExpandDirection, inlineBox.logicPoint, {
        measure: inlineBox.measure,
        extent: inlineBox.extent
      }, {
        measure: measure,
        extent: extent
      });
      inlineBox.bgRect = transChildRectToPhysical(_this.mContext.coordinateZero, _this.mContext.lineExpandDirection, {
        start: inlineBox.logicPoint.start,
        before: childBaseBefore
      }, {
        measure: inlineBox.measure,
        extent: maxExtent
      }, {
        measure: measure,
        extent: extent
      }); // 转换offset偏移

      var _a = transOffsetToPhysical(_this.mContext.coordinateZero, _this.mContext.lineExpandDirection, inlineBox.offsetMeasure, inlineBox.offsetExtent),
        offsetX = _a.offsetX,
        offsetY = _a.offsetY;
      inlineBox.fontOffsetX = offsetX;
      inlineBox.fontOffsetY = offsetY;
    });
  };
  LineLayout.prototype.computeLinePadding = function (measure, maxMeasure) {
    var paddingLeft;
    var align = this.mParaStyle.textAlignment;
    switch (align) {
      case TextAlignmentType.Right:
        paddingLeft = maxMeasure - measure;
        break;
      case TextAlignmentType.Center:
        paddingLeft = (maxMeasure - measure) / 2;
        break;
      case TextAlignmentType.Distribute:
        // 分散对齐段落最后一行如果没有文字需要拉伸的话，那么这一行主内容需要居中对齐
        // 保证其他行 contentWidth 和最大宽度一致，需要居中的行 contentWidth 为实际内容宽度，然后每一行都居中即可
        if (this.mContext.isNowrap()) {
          paddingLeft = 0;
        } else {
          // 只有自动换行的文本分散对齐才会生效
          paddingLeft = (maxMeasure - measure) / 2;
        }
        break;
      default:
        paddingLeft = 0;
        break;
    }
    return paddingLeft;
  };
  /**
   * 获取计算多倍行距的基准值
   * @param lineMetric
   * @returns
   */

  LineLayout.prototype.getMultipleLineSpacingBaseValue = function (lineMetric) {
    var fontExtent = lineMetric.fontDescent + lineMetric.fontAscent; // 之前的逻辑是 lineMetric.maxFontSize || fontExtent
    // 这样在其他方向和 office ppt 的表现类似，但是在堆积中相差比较大
    // 堆积改用 fontExtent 计算后和 office ppt 表现类似

    if (this.mContext.isWordArtVertical()) {
      return fontExtent;
    }
    return lineMetric.maxFontSize || fontExtent;
  };
  LineLayout.prototype.computeLineExtent = function (textExtentVal) {
    // 行内文本的高度，用于计算倍数行间距
    var textExtent = textExtentVal;
    var lineExtent = 0;
    var lineSpacingConfig = this.mParaStyle.lineSpacingConfig;
    switch (lineSpacingConfig.rule) {
      case LineSpacingType.Multiple:
        {
          textExtent *= lineSpacingConfig.value;
          lineExtent += textExtent;
          break;
        }
      case LineSpacingType.Exactly:
        textExtent = lineSpacingConfig.value;
        lineExtent += textExtent;
        break;
      case LineSpacingType.AtLeast:
        textExtent = textExtent > lineSpacingConfig.value ? textExtent : lineSpacingConfig.value;
        lineExtent += textExtent;
        break;
    }
    return lineExtent || textExtent;
  };
  return LineLayout;
}(FlowLayout);
var LineLayout$1 = LineLayout;

/**
 * 列表段落首行
 */

var ListTextLineBox = function (_super) {
  __extends(ListTextLineBox, _super);
  function ListTextLineBox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(ListTextLineBox.prototype, "listMarkOffsetLeft", {
    /** 表示项目编号在渲染时应该相对于行偏移多少位置 */
    get: function get() {
      var _a, _b, _c;
      var paddingLeft = (_b = (_a = this.logicEdge) === null || _a === void 0 ? void 0 : _a.padding) === null || _b === void 0 ? void 0 : _b.start;
      if (paddingLeft !== undefined) {
        return paddingLeft - (((_c = this.listMark) === null || _c === void 0 ? void 0 : _c.totalWidth) || 0);
      }
      return 0;
    },
    enumerable: false,
    configurable: true
  });
  return ListTextLineBox;
}(TextLineBox);
var ListLineLayout = function (_super) {
  __extends(ListLineLayout, _super);
  function ListLineLayout() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.maxContentMeasure = 0;
    return _this;
  }
  ListLineLayout.prototype.updateForNewLine = function (isFirstLine) {
    if (!this.listMarkInfo) {
      this.listMarkInfo = this.getListMarkInfo();
    }
    this.updateIndent(isFirstLine);
    if (isFirstLine) {
      this.addMarkBox();
      return;
    }
  };
  ListLineLayout.prototype.addMarkBox = function () {
    if (this.listMarkTextGlyph.length === 1) {
      this.listMarkBox = this.createListMark(this.listMarkInfo);
      this.addBox(this.listMarkBox);
      return;
    }
    /**
     * 有多个 textGlyph，这种情况出现在：
     *  垂直排版，中文有序编号，且字数大于一个
     *  堆积排版
     *  最后一个 textGlyph 承载剩下的measure距离
     */

    var offsetMeasure = 0;
    var restMeasure = this.listMarkInfo.measure;
    for (var index = 0; index < this.listMarkTextGlyph.length; index++) {
      var measure = this.listMarkTextGlyph[index].width;
      if (index === this.listMarkTextGlyph.length - 1) {
        measure = restMeasure;
      } else {
        restMeasure -= measure;
      }
      var markInfo = {
        measure: measure,
        text: this.listMarkInfo.text[index],
        textSpan: this.listMarkInfo.textSpan,
        textGlyph: this.listMarkTextGlyph[index]
      };
      var markBox = this.createListMark(markInfo, offsetMeasure);
      this.addBox(markBox);
      offsetMeasure += measure;
    }
  };
  ListLineLayout.prototype.newLineBox = function (size) {
    if (this.listMarkBox) {
      var listLineBox = new ListTextLineBox(size);
      listLineBox.listMark = this.listMarkBox;
      this.listMarkBox.lineBox = listLineBox;
      return listLineBox;
    }
    return _super.prototype.newLineBox.call(this, size);
  };
  /**
   * 列表计算行前间距，这里word和ppt不同
   * 其中word的左缩进和ppt的“文本前距离”含义不一样
   * 其行前间距计算规则也不一致
   */

  ListLineLayout.prototype.updateIndent = function (isFirstLine) {
    if (this.mContext.isPPT()) {
      this.updateIndentInPPT(isFirstLine);
      return;
    }
    this.updateIndentInWORD(isFirstLine);
  };
  /**
   * word的行前间距计算：
   * 首行，左缩进值
   * 非首行，左缩进值 + 项目编号及其右侧空间的宽度
   * @param isFirstLine 是否首行
   */

  ListLineLayout.prototype.updateIndentInWORD = function (isFirstLine) {
    var lp = this.getLayoutParams();
    var marginLeft = this.mParaStyle.marginLeft;
    if (isFirstLine) {
      lp.margin.start = marginLeft;
      return;
    }
    lp.margin.start = marginLeft + this.listMarkInfo.measure;
  };
  /**
   * ppt的行前间距：
   * 首行，行前间距等于 “文本前左缩进” 减去 “项目编号及其右边的距离”
   * 非首行，行前间距等于“文本前左缩进”
   * @param isFirstLine 是否首行
   */

  ListLineLayout.prototype.updateIndentInPPT = function (isFirstLine) {
    var lp = this.getLayoutParams();
    var listMarkWidth = this.listMarkInfo.measure;
    var hangingWidth = Math.abs(this.mParaStyle.indent);
    var marginLeft = this.mParaStyle.marginLeft; // listItemWidth 是 项目编号及其右侧的空白空间

    var listItemWidth = hangingWidth;
    if (listMarkWidth > hangingWidth) {
      listItemWidth = listMarkWidth;
    } // 列表首行

    if (isFirstLine) {
      lp.margin.start = 0;
      if (this.mParaStyle.indent > 0) {
        // 正值为首行缩进
        lp.margin.start = marginLeft;
        return;
      } // 负值为悬挂缩进

      if (marginLeft > listItemWidth) {
        if (hangingWidth < listMarkWidth) {
          // 当悬挂距离小与编号自身宽度
          lp.margin.start = marginLeft - hangingWidth;
          return;
        }
        lp.margin.start = marginLeft - listItemWidth;
      }
      return;
    } // 非首行

    lp.margin.start = marginLeft;
  };
  ListLineLayout.prototype.getListMarkInfo = function () {
    var listProperty = this.mParaStyle; // 存在测量专用字符，使用测量专用字符来计算编号宽度

    var markText = listProperty.measureText || listProperty.actualText;
    var textSpan = this.getListMarkSpanProp();
    var textGlyph = this.getMarkGlyph(markText, textSpan); // 无序列表的图片类型

    if (listProperty.isBullet && listProperty.listPicMarkProp) {
      var _a = listProperty.listPicMarkProp,
        width = _a.width,
        height = _a.height,
        picSrc = _a.picSrc;
      var picRatio = width / height;
      textGlyph.width = textGlyph.ascent * picRatio;
      textGlyph.height = textGlyph.ascent; // word的：三种竖排（竖排、旋转 90、旋转270），根据图片尺寸更新信息

      if (!this.mContext.isPPT() && this.mContext.isVert()) {
        textGlyph.ascent = textGlyph.width - textGlyph.descent;
        textSpan.fontSize = textGlyph.width;
      }
      textGlyph.picSrc = picSrc;
    }
    var indentWidth = Math.abs(listProperty.indent); // 编号及其左侧空间的宽度计算

    var layoutInfo = this.getMarkLayoutInfo(textGlyph);
    var markMeasure = this.getListMarkWidth(layoutInfo.measure, indentWidth);
    return {
      measure: markMeasure,
      text: listProperty.actualText,
      textSpan: textSpan,
      textGlyph: textGlyph
    };
  };
  /**
   * 获取项目编号符号的图形尺寸
   */

  ListLineLayout.prototype.getMarkGlyph = function (markText, textSpan) {
    this.listMarkTextGlyph = [];
    if (this.isNeedSplitMarkText(markText)) {
      var totalTextGlyph = this.getTextGlyph(markText[0], textSpan);
      this.listMarkTextGlyph.push(_assign({}, totalTextGlyph));
      for (var i = 1; i < markText.length; i++) {
        var glyph = this.getTextGlyph(markText[i], textSpan);
        this.listMarkTextGlyph.push(glyph); // 测量出来的 glyph 已经是逻辑尺寸了，glyph.width 是逻辑宽度

        totalTextGlyph.width += glyph.width;
      }
      return totalTextGlyph;
    }
    var textGlyph = this.getTextGlyph(markText, textSpan);
    this.listMarkTextGlyph.push(textGlyph);
    return textGlyph;
  };
  ListLineLayout.prototype.getTextGlyph = function (text, spanPro) {
    var glyph = this.mContext.shaper.shapeToken(text, spanPro);
    return processTextGlyphByTextDirection(text, spanPro, glyph, this.mContext.verticalType);
  };
  /**
   * 是否需要拆分项目符号文字
   * 目前有两种情况：
   * - 竖排文字 && 项目符号第一个字符是 east 字符
   * - 堆积排版
   * @param markText
   */

  ListLineLayout.prototype.isNeedSplitMarkText = function (markText) {
    return markText.length > 1 && (this.mContext.isVertEast() && isEast(markText.codePointAt(0)) || this.mContext.isWordArtVertical());
  };
  /**
   * 计算项目编号本身宽度及其右边空白的总距离
   * 由悬挂缩进和 编号字符测量宽度决定，ppt 和 word的决定逻辑不一样
   */

  ListLineLayout.prototype.getListMarkWidth = function (textWidth, indentWidth) {
    if (this.mContext.isPPT()) {
      return this.getListMarkWidthInPPT(textWidth, indentWidth);
    }
    return this.getListMarkWidthInWORD(textWidth, indentWidth);
  };
  /**
   * 目标是：求解编号自身及其右边空白宽度的距离和。
   * word中：
   *  悬挂缩进：既有字符宽度，又有距离宽度，两个并存，先用距离宽度。
   *  默认是距离宽度。
   *  悬挂缩进的字符宽度，默认为2个字符宽
   *  当悬挂缩进的距离宽度小于编号自身宽度时，改为使用悬挂缩进的字符宽度，目标距离是2个字符宽；
   *  当使用悬挂缩进的字符宽度时，目标宽度也可以为1个字符宽
   * @param textWidth 编号自身的宽度
   * @param indentWidth 悬挂缩进
   */

  ListLineLayout.prototype.getListMarkWidthInWORD = function (textWidth, indentWidth) {
    var _a;
    var listProperty = this.mParaStyle;
    var textSpan = (_a = this.mNode.getBeginChild()) === null || _a === void 0 ? void 0 : _a.getProperty(); // 存在以字符形式的悬挂缩进

    if (listProperty.hangingChars > 0) {
      var hangingWidth = textSpan.fontSize * listProperty.hangingChars;
      if (hangingWidth < textWidth) {
        return textSpan.fontSize * 2;
      }
      return hangingWidth;
    }
    if (textWidth <= indentWidth) {
      return indentWidth;
    }
    return textSpan.fontSize * 2;
  };
  /**
   * 求解ppt中 编号自身及其右边空白宽度的距离和。
   * @param textWidth 编号自身的宽度
   * @param indentWidth 悬挂缩进的值
   */

  ListLineLayout.prototype.getListMarkWidthInPPT = function (textWidth, indentWidth) {
    return Math.max(textWidth, indentWidth);
  };
  /**
   * 计算项目编号的测量和渲染所需的文字属性
   * 该属性在ppt中，取决于编号自身是否有属性，若无则跟随首个字符的属性
   * 该属性在word中，取决于编号自身以及段落的文字属性，编号自身优先级更高
   */

  ListLineLayout.prototype.getListMarkSpanProp = function () {
    if (this.mContext.isPPT()) {
      return this.getListMarkSpanPropInPPT();
    }
    return this.getListMarkSpanPropInWORD();
  };
  /**
   * ppt的项目编号有属性：大小、颜色、删除线
   */

  ListLineLayout.prototype.getListMarkSpanPropInPPT = function () {
    var _a;
    var listProperty = this.mParaStyle;
    var textSpan = (_a = this.mNode.getBeginChild()) === null || _a === void 0 ? void 0 : _a.getProperty(); // 没有项目编号自身属性，则跟随首字符属性

    var resultSpanProp = listProperty.listMarkerSpanProp || textSpan;
    resultSpanProp.strike = textSpan.strike;
    return resultSpanProp;
  };
  /**
   * word的项目编号有属性：大小、颜色、外边框、倾斜、加粗、下划线、删除线
   */

  ListLineLayout.prototype.getListMarkSpanPropInWORD = function () {
    var _a;
    var listProperty = this.mParaStyle; // 项目编号自身的属性优于段的文字属性

    return (_a = listProperty.listMarkerSpanProp) !== null && _a !== void 0 ? _a : listProperty.spanProperty;
  };
  ListLineLayout.prototype.createListMark = function (info, offsetMeasure) {
    if (offsetMeasure === void 0) {
      offsetMeasure = 0;
    }
    var _a = this.getMarkLayoutInfo(info.textGlyph),
      measure = _a.measure,
      extent = _a.extent;
    var padding = new LogicalEdgeSize({
      before: 0,
      after: 0,
      start: 0,
      end: info.measure - measure
    });
    measure += padding.measure;
    extent += padding.extent;
    var listMarkBox = new ListMarkTextBox({
      measure: measure,
      extent: extent
    });
    listMarkBox.text = info.text;
    listMarkBox.glyph = info.textGlyph;
    listMarkBox.textStyle = info.textSpan;
    listMarkBox.logicEdge = LogicalBoxEdge.obtain();
    listMarkBox.logicEdge.padding = padding;
    listMarkBox.logicPoint = new LogicalPoint(offsetMeasure, 0);
    this.setRotate(listMarkBox);
    return listMarkBox;
  };
  ListLineLayout.prototype.getMarkLayoutInfo = function (textGlyph) {
    if (this.mContext.isPPT()) {
      return this.getMarkLayoutInfoInPPT(textGlyph);
    }
    return this.getMarkLayoutInfoInWORD(textGlyph);
  };
  /**
   * ppt 竖排的图片编号需要旋转
   * 测量的项目符号相关尺寸已经是逻辑尺寸了，不需要做额外的旋转
   */

  ListLineLayout.prototype.getMarkLayoutInfoInPPT = function (textGlyph) {
    return {
      measure: textGlyph.width,
      extent: textGlyph.height
    };
  };
  /**
   * word 两种情况需要颠倒 extent和measure：
   *  1 三种非横排的图片
   *  2 竖排的无序编号
   */

  ListLineLayout.prototype.getMarkLayoutInfoInWORD = function (textGlyph) {
    var listProperty = this.mParaStyle;
    if (this.mContext.isVert() && textGlyph.picSrc || this.mContext.isVertEast() && listProperty.isBullet) {
      // 图片的项目编号
      return {
        measure: textGlyph.height,
        extent: textGlyph.width
      };
    }
    return {
      measure: textGlyph.width,
      extent: textGlyph.height
    };
  };
  ListLineLayout.prototype.setRotate = function (box) {
    var leafBox = box; // 0 表示 listMarkBox.text 的第 0 个字符；

    var isEastChar = isEast(this.listMarkInfo.text.charCodeAt(0));
    var rotateInfoVal;
    if (this.mContext.isPPT()) {
      rotateInfoVal = this.getRotateInfoInPPT(box);
    } else {
      rotateInfoVal = this.getRotateInfoInWORD(box, isEastChar);
    }
    leafBox.rotate = rotateInfoVal.rotate;
    leafBox.rotateOrigin = rotateInfoVal.rotateOrigin;
  };
  ListLineLayout.prototype.getRotateInfoInPPT = function (box) {
    var resultVal = {
      rotate: 0,
      rotateOrigin: undefined
    };
    var isEastChar = isEast(box.text.charCodeAt(0)); // 竖排非中文字符需要旋转
    // 堆积括号类字符需要旋转

    if (this.mContext.isVertEast() && !isEastChar || this.mContext.isWordArtVertical() && isBrackets(box.text.codePointAt(0))) {
      resultVal.rotate = 90;
      resultVal.rotateOrigin = new Point$1({
        x: box.extent / 2,
        y: box.extent / 2
      });
      return resultVal;
    }
    return this.getCommonRotateInfo(box);
  };
  ListLineLayout.prototype.getRotateInfoInWORD = function (box, isEastChar) {
    var _a;
    var resultVal = {
      rotate: 0,
      rotateOrigin: undefined
    }; // word的图片编号都不旋转

    if ((_a = box.glyph) === null || _a === void 0 ? void 0 : _a.picSrc) {
      return resultVal;
    }
    var listProperty = this.mParaStyle; // isVertEast 非中文字符、非无序编号 会旋转

    if (this.mContext.isVertEast() && !isEastChar && !listProperty.isBullet) {
      resultVal.rotate = 90;
      resultVal.rotateOrigin = new Point$1({
        x: box.extent / 2,
        y: box.extent / 2
      });
      return resultVal;
    }
    return this.getCommonRotateInfo(box);
  };
  /**
   * 获取ppt和word的共有部分的旋转信息
   * @param box 标签盒信息
   */

  ListLineLayout.prototype.getCommonRotateInfo = function (box) {
    var resultVal = {
      rotate: 0,
      rotateOrigin: undefined
    };
    if (this.mContext.isVert90()) {
      resultVal.rotate = 90;
      resultVal.rotateOrigin = new Point$1({
        x: box.extent / 2,
        y: box.extent / 2
      });
    }
    if (this.mContext.isVert270()) {
      resultVal.rotate = 270;
      resultVal.rotateOrigin = new Point$1({
        x: box.measure / 2,
        y: box.measure / 2
      });
    }
    return resultVal;
  };
  return ListLineLayout;
}(LineLayout$1);
var ParagraphGenerator = function (_super) {
  __extends(ParagraphGenerator, _super);
  function ParagraphGenerator(context, node, layoutParent) {
    return _super.call(this, context, node, layoutParent) || this;
  }
  ParagraphGenerator.prototype.createChildLayout = function (context, node) {
    var textGroup = this.createTextGroupNode(node);
    var paraProperty = textGroup.getProperty();
    if (paraProperty instanceof ListProperty) {
      return new ListLineLayout(context, textGroup);
    }
    return new LineLayout$1(context, textGroup);
  };
  /**
   * 创建TextGroupNode。并计算出每个textRun在该段落中对应的range。
   * @param node
   */

  ParagraphGenerator.prototype.createTextGroupNode = function (node) {
    var childNode = node;
    var offset = 0;
    childNode.range = new GCPRange(offset, node.getText().length);
    offset += childNode.range.length();
    var children = [childNode];
    do {
      childNode = childNode.getNextSibling();
      if (!childNode) break;
      childNode.range = new GCPRange(offset, childNode.getText().length);
      offset += childNode.range.length();
      children.push(childNode);
    } while (childNode); // 判断是否最后一个字符是换行

    if (this.isLastCharNextLine(children[children.length - 1])) {
      childNode = new EmptyTextNode();
      childNode.range = new GCPRange(offset, childNode.getText().length);
      children.push(childNode);
    }
    return new TextGroupNode(children, node.getParentNode());
  };
  /**
   * 段落最后一个节点，最后一个字符是换行
   * @param lasNode
   */

  ParagraphGenerator.prototype.isLastCharNextLine = function (lasNode) {
    var text = lasNode === null || lasNode === void 0 ? void 0 : lasNode.getText();
    if (text) text = text.replace(/\r/g, '\n'); // 所有\r要换成\n，否则不能正常换行

    var lastChar = text === null || text === void 0 ? void 0 : text.charAt(text.length - 1);
    return lastChar === '\n';
  };
  return ParagraphGenerator;
}(BlockGenerator);
var ParagraphLayout = function (_super) {
  __extends(ParagraphLayout, _super);
  function ParagraphLayout() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.pendingTextLineBoxes = null;
    /**
     * 计算当前段落最大 extent 空间
     */

    _this.initMaxExtent = function () {
      var expectSize = MeasureSpec.getSize(_this.mBlockMeasureSpec);
      _this.maxExtent = resolveSize(expectSize, _this.mBlockMeasureSpec);
    };
    return _this;
  }
  Object.defineProperty(ParagraphLayout.prototype, "isCurrentParagraphUnfinished", {
    get: function get() {
      var _a;
      return !!((_a = this.pendingTextLineBoxes) === null || _a === void 0 ? void 0 : _a.length);
    },
    enumerable: false,
    configurable: true
  });
  ParagraphLayout.prototype.onLayout = function () {
    var e_1, _a;
    this.resolveLastColumnRemainingContent();
    this.initMaxExtent();
    while (true) {
      var next = this.mGenerator.getNext();
      var _b = (next.value || {}).layoutBoxes,
        layoutBoxes = _b === void 0 ? [] : _b;
      if (next.done || layoutBoxes.length < 1) {
        break;
      }
      var remainingLines = [];
      try {
        for (var _c = (e_1 = void 0, __values(layoutBoxes)), _d = _c.next(); !_d.done; _d = _c.next()) {
          var box = _d.value;
          if (this.hasEnoughSpace(box)) {
            this.addBox(box);
          } else {
            // 如果当前段落放不下，放到下一栏去排
            remainingLines.push(box);
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c["return"])) _a.call(_c);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      if (remainingLines.length) {
        // 已经没有足够的空间，需要换栏，把排版中断的数据暂存起来
        this.pendingTextLineBoxes = remainingLines;
        break;
      }
    }
    var layoutValue = this.reduceLayout(); // 清除当前 layout 已排的内容，因为换栏后还会复用当前 layout 排当前段落剩余的部分

    this.mContent.clearBlocks();
    return layoutValue;
  };
  ParagraphLayout.prototype.createGenerator = function (context, node) {
    return new ParagraphGenerator(context, node, this);
  };
  /**
   * 获取当前生成的 paragraphBox 的 margin
   * 现在一个 paragraphLayout 可能会生成多个 box，所以不能在所有 box 上都应用相同的段前段后间距
   * 栏的第一段落忽略段前间距
   * 只有当前 paragraphLayout 的最后一个 paragraphBox 才需要加
   * @returns
   */

  ParagraphLayout.prototype.getParagraphBoxMargin = function () {
    var margin = _assign({}, this.getLayoutParams().margin);
    if (this.mParentLayout instanceof ColumnLayout) {
      // 当前 box 是栏的第一段，忽略段前间距
      if (this.mParentLayout.isEmpty()) {
        margin.before = 0;
      } // 如果有未排完的段落，说明当前 box 不是最后一个，所以不需要加段后间距

      if (this.isCurrentParagraphUnfinished) {
        margin.after = 0;
      }
    }
    return new LogicalEdgeSize(margin);
  };
  ParagraphLayout.prototype.hasEnoughSpace = function (box) {
    return box.totalExtent <= this.restExtent;
  };
  Object.defineProperty(ParagraphLayout.prototype, "restExtent", {
    /**
     * extent 方向当前剩余的空间
     */
    get: function get() {
      // 最后一栏空间没有限制
      if (this.currentColumnIndex === this.mContext.columnNumber - 1) {
        return Number.POSITIVE_INFINITY;
      }
      return this.maxExtent - this.mContent.blockPos;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParagraphLayout.prototype, "currentColumnIndex", {
    get: function get() {
      if (this.mParentLayout instanceof ColumnLayout) {
        return this.mParentLayout.currentColumnIndex;
      }
      return 0;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 处理上一栏排版剩余的内容
   */

  ParagraphLayout.prototype.resolveLastColumnRemainingContent = function () {
    var _this = this;
    if (this.pendingTextLineBoxes) {
      this.pendingTextLineBoxes.forEach(function (box) {
        var _a, _b; // 更新这些 lineBoxes 的起始坐标
        // 因为这些行数据上还是属于当前段落，它相对于段落的 start 坐标和它在第一行还是最后一行无关，所以 start 坐标不用修改
        // 只需要调整 before 坐标

        var marginBefore = ((_b = (_a = box.logicEdge) === null || _a === void 0 ? void 0 : _a.margin) === null || _b === void 0 ? void 0 : _b.before) || 0;
        var contentBefore = _this.paddingBefore + _this.mContent.blockPos;
        box.logicPoint.before = contentBefore + marginBefore;
        box.contentPoint.before = contentBefore;
        _this.addBox(box);
      });
      this.pendingTextLineBoxes = null;
    }
  };
  return ParagraphLayout;
}(BaseParagraphLayout);
var ParagraphLayout$1 = ParagraphLayout;

/**
 * 重新组合每一栏放置的行，使多栏高度尽可能平衡
 * - 目前还没考虑段前段后间距，段落在栏开始位置时，段前间距可能会被忽略，所以还不太好算
 * - 重新组合后整个文字宽度和高度会变化，这个有可能会修改形状的尺寸，从而再次触发排版
 * 由于无法保证重新组合的结果是最优的，也就是无法保证「重新组合后的排版结果」和「再次排版的结果」一致，为了避免排版出现跳动
 * 需要先进行预组合确定最大的栏高度，再根据这个高度流式组合所有
 * @param textLineExtents
 * @param columnNumber
 */
function reassembleColumn(textLineExtents, columnNumber) {
  var maxColumnHeight = preReassemble(textLineExtents, columnNumber);
  var columns = [];
  var currentColumnExtent = 0;
  var currentColumnLines = [];
  textLineExtents.forEach(function (currentLineExtent) {
    if (currentColumnExtent + currentLineExtent <= maxColumnHeight) {
      // 栏内未超过最大栏高度，当前行放入当前栏
      currentColumnExtent += currentLineExtent;
      currentColumnLines.push(currentLineExtent);
    } else {
      columns.push(currentColumnLines.length);
      currentColumnExtent = currentLineExtent;
      currentColumnLines = [currentLineExtent];
    }
  });
  if (currentColumnLines.length) {
    columns.push(currentColumnLines.length);
  }
  return columns;
}
/**
 * 预组合，目的是确定最大的栏高度
 */

function preReassemble(textLineExtents, columnNumber) {
  var totalExtent = textLineExtents.reduce(function (a, b) {
    return a + b;
  }, 0); // 栏高度基准值

  var averageExtent = totalExtent / columnNumber;
  var columnHeights = [];
  var maxColumnHeight = 0;
  var currentColumnExtent = 0;
  var currentColumnLines = [];
  textLineExtents.forEach(function (currentLineExtent) {
    currentColumnExtent += currentLineExtent;
    currentColumnLines.push(currentLineExtent);
    if (currentColumnExtent >= averageExtent) {
      // 超出当前栏平均值，当前栏结束
      maxColumnHeight = Math.max(maxColumnHeight, currentColumnExtent);
      columnHeights.push(currentColumnExtent); // 重新计算 columnHeights 平均值作为 averageExtent

      averageExtent = columnHeights.reduce(function (a, b) {
        return a + b;
      }, 0) / columnHeights.length; // 重置

      currentColumnExtent = 0;
      currentColumnLines = [];
    }
  });
  return maxColumnHeight;
}
var ColumnContainerBox = function (_super) {
  __extends(ColumnContainerBox, _super);
  function ColumnContainerBox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.kind = BoxKind.InlineContainer;
    return _this;
  }
  return ColumnContainerBox;
}(BaseParentBox);
var ColumnContainerGenerator = function (_super) {
  __extends(ColumnContainerGenerator, _super);
  function ColumnContainerGenerator(context, node, layoutParent) {
    return _super.call(this, context, node, layoutParent) || this;
  }
  ColumnContainerGenerator.prototype.createChildLayout = function (context, node) {
    return new ColumnLayout(context, node);
  };
  ColumnContainerGenerator.prototype.getBeginChild = function () {
    return this.mNode;
  };
  return ColumnContainerGenerator;
}(LayoutParentGenerator);

/**
 * 重新组装所有的行
 */
var ReassembleManager = function () {
  function ReassembleManager(textLineBoxes, paragraphLineCounts, columnLineCounts) {
    // 当前行在整个文档中的索引
    this.currentLineIndex = 0; // 当前段落索引，这个段落是指原始数据的段落

    this.currentParagraphIndex = -1; // 当前行在段落中的索引，用于辅助判断当前段落是否结束

    this.currentLineIndexInParagraph = 0; // 当前栏索引

    this.currentColumnIndex = 0; // 当前行在栏中的索引，用于辅助判断当前栏是否结束

    this.currentLineIndexInColumn = 0;
    this.textLineBoxes = textLineBoxes;
    this.paragraphLineCounts = paragraphLineCounts;
    this.columnLineCounts = columnLineCounts;
  }
  ReassembleManager.prototype.getNextLine = function () {
    if (this.hasNextLine()) {
      var _a = this,
        textLineBoxes = _a.textLineBoxes,
        currentLineIndex = _a.currentLineIndex;
      this.moveToNextLine();
      return textLineBoxes[currentLineIndex];
    }
    return null;
  };
  ReassembleManager.prototype.hasNextLine = function () {
    return this.currentLineIndex < this.textLineBoxes.length;
  };
  /**
   * 当前段落是否已经结束
   * @returns
   */

  ReassembleManager.prototype.isParagraphEnd = function () {
    var _a = this,
      currentParagraphIndex = _a.currentParagraphIndex,
      paragraphLineCounts = _a.paragraphLineCounts,
      currentLineIndexInParagraph = _a.currentLineIndexInParagraph; // 已经遍历完所有段落

    if (currentParagraphIndex > paragraphLineCounts.length - 1) {
      return true;
    }
    var currentParagraphLineCount = paragraphLineCounts[currentParagraphIndex];
    return currentLineIndexInParagraph >= currentParagraphLineCount;
  };
  /**
   * 当前栏是否已经结束
   * @returns
   */

  ReassembleManager.prototype.isColumnEnd = function () {
    var _a = this,
      currentColumnIndex = _a.currentColumnIndex,
      columnLineCounts = _a.columnLineCounts,
      currentLineIndexInColumn = _a.currentLineIndexInColumn; // 已经遍历完所有列

    if (currentColumnIndex > columnLineCounts.length - 1) {
      return true;
    }
    var currentColumnLineCount = columnLineCounts[currentColumnIndex];
    return currentLineIndexInColumn >= currentColumnLineCount;
  };
  /**
   * 切换到下一段
   */

  ReassembleManager.prototype.moveToNextParagraph = function () {
    this.currentParagraphIndex += 1;
    this.currentLineIndexInParagraph = 0;
  };
  /**
   * 切换到下一栏
   */

  ReassembleManager.prototype.moveToNextColumn = function () {
    this.currentColumnIndex += 1;
    this.currentLineIndexInColumn = 0;
  };
  /**
   * 切换到下一行
   */

  ReassembleManager.prototype.moveToNextLine = function () {
    this.currentLineIndex += 1;
    this.currentLineIndexInParagraph += 1;
    this.currentLineIndexInColumn += 1;
  };
  return ReassembleManager;
}();
var ReassembleLayoutContext = function (_super) {
  __extends(ReassembleLayoutContext, _super);
  function ReassembleLayoutContext(adapter, reassembleManager) {
    var _this = _super.call(this, adapter) || this;
    _this.reassembleManager = reassembleManager;
    return _this;
  }
  return ReassembleLayoutContext;
}(LayoutContext);
var BaseColumnContainerLayout = function (_super) {
  __extends(BaseColumnContainerLayout, _super);
  function BaseColumnContainerLayout(context, node, columnProperty) {
    var _this = _super.call(this, context, node) || this;
    _this.currentColumnIndex = 0;
    /**
     * 计算实际栏间距
     * Math.min(栏间距值，当前文档可排版measure / (columnNumber - 1))
     * @returns
     */

    _this.getColumnSpace = function () {
      var _a = _this.mColumnProperty,
        columnNumber = _a.columnNumber,
        columnSpace = _a.columnSpace;
      var availableLayoutSpace = _this.getAvailableLayoutSpace();
      return Math.min(columnSpace, availableLayoutSpace / (columnNumber - 1));
    };
    /**
     * 计算每一栏排版空间
     * 除去栏间距之外的所有空间根据栏数平分
     * @returns
     */

    _this.getColumnInlineSize = function () {
      var columnNumber = _this.mColumnProperty.columnNumber;
      var realColumnSpace = _this.getColumnSpace();
      var allColumnSpace = realColumnSpace * (columnNumber - 1);
      var availableLayoutSpace = _this.getAvailableLayoutSpace();
      return (availableLayoutSpace - allColumnSpace) / columnNumber;
    };
    /**
     * 获取当前可排版空间
     * @returns
     */

    _this.getAvailableLayoutSpace = function () {
      var measure = MeasureSpec.getSize(_this.mInlineMeasureSpec);
      return measure - _this.paddingMeasure;
    };
    _this.mColumnProperty = columnProperty;
    return _this;
  }
  /**
   * 对child layout进行布局通用逻辑。
   * 注意：对齐等需要排版完child才能计算box位置
   * @param childLayout
   */

  BaseColumnContainerLayout.prototype.layoutChild = function (childLayout) {
    // 执行栏排版前，先根据栏间距更新当前栏的 margin
    childLayout.updateMargin(this.getColumnSpace());
    var childLp = childLayout.getLayoutParams();
    var childInlineMeasureSpec = getChildMeasureSpec(this.mInlineMeasureSpec, this.paddingMeasure + childLp.marginMeasure + this.mContent.inlinePos, this.getColumnInlineSize());
    var childBlockMeasureSpec = getChildMeasureSpec(this.mBlockMeasureSpec, this.paddingExtent + childLp.marginExtent + this.mContent.blockPos, childLp.extent);
    var start = this.paddingStart + childLp.margin.start + this.mContent.inlinePos;
    var before = this.paddingBefore + childLp.margin.before + this.mContent.blockPos;
    return childLayout.layout(start, before, childInlineMeasureSpec, childBlockMeasureSpec);
  };
  return BaseColumnContainerLayout;
}(BlockLayout);
var ReassembleLineGenerator = function (_super) {
  __extends(ReassembleLineGenerator, _super);
  function ReassembleLineGenerator(context, node) {
    return _super.call(this, context, node) || this;
  }
  ReassembleLineGenerator.prototype.hasNext = function () {
    return this.mContext.reassembleManager.hasNextLine();
  };
  ReassembleLineGenerator.prototype.getNext = function () {
    var reassembleManager = this.mContext.reassembleManager;
    if (reassembleManager.isParagraphEnd()) {
      return {
        done: true,
        value: null
      };
    }
    if (reassembleManager.isColumnEnd()) {
      return {
        done: true,
        value: null
      };
    }
    var lineBox = this.mContext.reassembleManager.getNextLine();
    if (lineBox) {
      return {
        done: false,
        value: lineBox
      };
    }
    return {
      done: true,
      value: null
    };
  };
  return ReassembleLineGenerator;
}(BaseLayoutGenerator);
var ReassembleLineLayout = function (_super) {
  __extends(ReassembleLineLayout, _super);
  function ReassembleLineLayout(context, node) {
    return _super.call(this, context, node) || this;
  }
  ReassembleLineLayout.prototype.onLayout = function () {
    var _a = this.mGenerator.getNext(),
      done = _a.done,
      value = _a.value;
    if (done || !value) {
      return {
        layoutBoxes: []
      };
    } // 重新组装时，原有 lineBox 的 before 坐标失效，需要重新计算

    value.logicPoint.before = this.mOffset.before;
    return {
      layoutBoxes: [value]
    };
  };
  ReassembleLineLayout.prototype.createGenerator = function (context, node) {
    return new ReassembleLineGenerator(context, node);
  };
  return ReassembleLineLayout;
}(BaseLayout);
var ReassembleParagraphGenerator = function (_super) {
  __extends(ReassembleParagraphGenerator, _super);
  function ReassembleParagraphGenerator(context, node, layoutParent) {
    return _super.call(this, context, node, layoutParent) || this;
  }
  ReassembleParagraphGenerator.prototype.hasNext = function () {
    if (this.mContext.reassembleManager.isParagraphEnd()) {
      return false;
    }
    return _super.prototype.hasNext.call(this);
  };
  ReassembleParagraphGenerator.prototype.createChildLayout = function (context, node) {
    return new ReassembleLineLayout(context, node);
  };
  return ReassembleParagraphGenerator;
}(BlockGenerator);
var ReassembleParagraphLayout = function (_super) {
  __extends(ReassembleParagraphLayout, _super);
  function ReassembleParagraphLayout(context, node) {
    var _this = _super.call(this, context, node) || this;
    _this.mContext.reassembleManager.moveToNextParagraph();
    return _this;
  }
  ReassembleParagraphLayout.prototype.onLayout = function () {
    var _this = this;
    while (true) {
      var next = this.mGenerator.getNext();
      if (next.done || next.value.layoutBoxes.length < 1) {
        break;
      }
      next.value.layoutBoxes.forEach(function (value) {
        _this.addBox(value);
      });
    }
    var layoutValue = this.reduceLayout();
    this.mContent.clearBlocks();
    return layoutValue;
  };
  ReassembleParagraphLayout.prototype.createGenerator = function (context, node) {
    return new ReassembleParagraphGenerator(context, node, this);
  };
  ReassembleParagraphLayout.prototype.getParagraphBoxMargin = function () {
    var margin = _assign({}, this.getLayoutParams().margin);
    if (this.mParentLayout instanceof ReassembleColumnLayout) {
      // 当前 box 是栏的第一段，忽略段前间距
      if (this.mParentLayout.isEmpty()) {
        margin.before = 0;
      } // 如果有未排完的段落，说明当前 box 不是最后一个，所以不需要加段后间距

      if (!this.mContext.reassembleManager.isParagraphEnd()) {
        margin.after = 0;
      }
    }
    return new LogicalEdgeSize(margin);
  };
  return ReassembleParagraphLayout;
}(BaseParagraphLayout);
var ReassembleColumnGenerator = function (_super) {
  __extends(ReassembleColumnGenerator, _super);
  function ReassembleColumnGenerator(context, node, layoutParent) {
    return _super.call(this, context, node, layoutParent) || this;
  }
  ReassembleColumnGenerator.prototype.createChildLayout = function (context, node) {
    return new ReassembleParagraphLayout(context, node);
  };
  return ReassembleColumnGenerator;
}(LayoutParentGenerator);
var ReassembleColumnLayout = function (_super) {
  __extends(ReassembleColumnLayout, _super);
  function ReassembleColumnLayout() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ReassembleColumnLayout.prototype.onLayout = function () {
    var _this = this;
    while (true) {
      var next = this.mGenerator.getNext();
      if (next.done || next.value.layoutBoxes.length < 1) {
        break;
      }
      next.value.layoutBoxes.forEach(function (value) {
        _this.addBox(value);
      }); // 如果当前栏排完了，退出循环生成 columnBox

      var reassembleManager = this.mContext.reassembleManager;
      if (reassembleManager.isColumnEnd()) {
        reassembleManager.moveToNextColumn();
        break;
      }
    }
    var columnLayoutValue = this.reduceLayout(); // 清除目前保存的内容，下一栏就是新的内容了

    this.mContent.clearBlocks();
    return columnLayoutValue;
  };
  ReassembleColumnLayout.prototype.createGenerator = function (context, node) {
    return new ReassembleColumnGenerator(context, node, this);
  };
  return ReassembleColumnLayout;
}(BaseColumnLayout);
var ReassembleColumnContainerGenerator = function (_super) {
  __extends(ReassembleColumnContainerGenerator, _super);
  function ReassembleColumnContainerGenerator(context, node, layoutParent) {
    return _super.call(this, context, node, layoutParent) || this;
  }
  ReassembleColumnContainerGenerator.prototype.createChildLayout = function (context) {
    return new ReassembleColumnLayout(context, this.mNode);
  };
  return ReassembleColumnContainerGenerator;
}(LayoutParentGenerator);
var ReassembleColumnContainerLayout = function (_super) {
  __extends(ReassembleColumnContainerLayout, _super);
  function ReassembleColumnContainerLayout(context, node, columnProperty) {
    var _this = _super.call(this, context, node, columnProperty) || this;
    _this.mGenerator = _this.createGenerator(context, node);
    return _this;
  }
  ReassembleColumnContainerLayout.prototype.createGenerator = function (context, node) {
    return new ReassembleColumnContainerGenerator(context, node, this);
  };
  ReassembleColumnContainerLayout.prototype.addBox = function (box) {
    // 层层遍历添加box
    this.mContent.pushInline(box);
    this.currentColumnIndex += 1;
  };
  ReassembleColumnContainerLayout.prototype.reduceLayout = function () {
    return {
      layoutBoxes: this.mContent.getInlines()
    };
  };
  return ReassembleColumnContainerLayout;
}(BaseColumnContainerLayout);

/**
 * 由于栏 ColumnBox 之间是水平排列的，为了保证排版结果和流程与正常块结构排版一致
 * 使用 ColumnContainerLayout 管理多栏的水平排版（计算栏空间和间距），排版返回值是 ColumnContainerBox
 * ColumnContainerBox 可以当做正常的块看待
 */

var ColumnContainerLayout = function (_super) {
  __extends(ColumnContainerLayout, _super);
  function ColumnContainerLayout() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ColumnContainerLayout.prototype.addBox = function (box) {
    this.mContent.pushInline(box);
    if (this.currentColumnIndex === this.mContext.columnNumber - 1) {
      // 所有栏排版完成之后处理平衡分栏
      if (this.isNeedReassemble()) {
        this.reassemble();
      }
    }
    this.currentColumnIndex += 1;
  };
  ColumnContainerLayout.prototype.reduceLayout = function () {
    var _this = this;
    var measure = resolveSize(this.mContent.inlinePos + this.paddingMeasure, this.mInlineMeasureSpec); // 根据所有栏的最大高度计算 ColumnContainerBox 的高度

    var extent = resolveSize(this.mContent.getLineExtent() + this.paddingExtent, this.mBlockMeasureSpec);
    var box = new ColumnContainerBox({
      measure: measure,
      extent: extent
    });
    box.logicPoint = this.mOffset; // 设置相对位置

    box.logicEdge = LogicalBoxEdge.obtain();
    box.logicEdge.margin = this.getLayoutParams().margin;
    box.logicEdge.padding = new LogicalEdgeSize(this.mPadding);
    this.mContent.getInlines().forEach(function (columnBox) {
      columnBox.rect = transChildRectToPhysical(_this.mContext.coordinateZero, _this.mContext.lineExpandDirection, columnBox.logicPoint, {
        measure: columnBox.measure,
        extent: columnBox.extent
      }, {
        measure: measure,
        extent: extent
      });
    }); // 更新content logic rect

    this.updateBoxContentLogicFrame(box);
    box.append.apply(box, __spreadArray([], __read(this.mContent.getInlines())));
    return {
      layoutBoxes: [box]
    };
  };
  ColumnContainerLayout.prototype.createGenerator = function (context, node) {
    return new ColumnContainerGenerator(context, node, this);
  };
  /**
   * 判断是否需要重新组合生成栏，来保证每栏高度平衡
   * @returns
   */

  ColumnContainerLayout.prototype.isNeedReassemble = function () {
    var columns = this.mContent.getInlines();
    if (columns.length <= 1) {
      return false;
    }
    var expectExtent = MeasureSpec.getSize(this.mBlockMeasureSpec);
    return columns[columns.length - 1].extent > expectExtent;
  };
  /**
   * 为了保证每一栏高度平衡，重新组装行
   */

  ColumnContainerLayout.prototype.reassemble = function () {
    var _this = this;
    var _a = this.getLinesData(),
      textLineExtents = _a.textLineExtents,
      textLineBoxes = _a.textLineBoxes,
      paragraphLineCounts = _a.paragraphLineCounts;
    var columnLineCounts = reassembleColumn(textLineExtents, this.mContext.columnNumber);
    var reassembleManager = new ReassembleManager(textLineBoxes, paragraphLineCounts, columnLineCounts);
    var reassembleLayoutContext = new ReassembleLayoutContext(this.mContext.mAdapter, reassembleManager);
    var reassembleDocumentLayout = new ReassembleColumnContainerLayout(reassembleLayoutContext, this.mNode, this.mColumnProperty);
    var layoutBoxes = reassembleDocumentLayout.layout(this.mOffset.start, this.mOffset.before, this.mInlineMeasureSpec, this.mBlockMeasureSpec).layoutBoxes; // 清除原有栏 box, 替换为新的栏 box

    this.mContent.clearInlines();
    layoutBoxes.forEach(function (box) {
      _this.mContent.pushInline(box);
    });
  };
  /**
   * 获取目前所有行信息
   * @returns
   */

  ColumnContainerLayout.prototype.getLinesData = function () {
    var _a;
    var columns = this.mContent.getInlines(); // 所有行的高度

    var textLineExtents = []; // 所有 textLineBox

    var textLineBoxes = []; // 每个段落中的行数

    var paragraphLineCounts = []; // 上一个 paragraphBox 对应的段落 id

    var prevParagraphBoxId = null;
    traverseLayoutBoxesWithHandlers(columns, (_a = {}, _a[BoxKind.TextLine] = function (lineBox) {
      textLineExtents.push(lineBox.extent);
      textLineBoxes.push(lineBox);
    }, _a[BoxKind.Paragraph] = function (paragraphBox) {
      // 是否和上一个 paragraphBox 属于同一段落数据
      var isSameParagraph = paragraphBox.paragraphId === prevParagraphBoxId;
      if (isSameParagraph) {
        paragraphLineCounts[paragraphLineCounts.length - 1] += paragraphBox.children.length;
      } else {
        paragraphLineCounts.push(paragraphBox.children.length);
      }
      prevParagraphBoxId = paragraphBox.paragraphId;
    }, _a));
    return {
      textLineExtents: textLineExtents,
      textLineBoxes: textLineBoxes,
      paragraphLineCounts: paragraphLineCounts
    };
  };
  return ColumnContainerLayout;
}(BaseColumnContainerLayout);

/**
 * 文档遍历器，负责遍历文档中的所有段落
 */

var DocumentGenerator = function (_super) {
  __extends(DocumentGenerator, _super);
  function DocumentGenerator(context, node, layoutParent) {
    return _super.call(this, context, node, layoutParent) || this;
  }
  DocumentGenerator.prototype.createChildLayout = function (context, node) {
    if (this.mContext.columnNumber > 1) {
      return new ColumnContainerLayout(context, this.mNode, this.mNode.getProperty());
    }
    return new ParagraphLayout$1(context, node);
  };
  return DocumentGenerator;
}(LayoutParentGenerator);

/**
 * @class DocumentBox
 * 整个文档Box模型，排版总输出
 */

var DocumentBox = function (_super) {
  __extends(DocumentBox, _super);
  function DocumentBox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.kind = BoxKind.Document;
    return _this;
  }
  DocumentBox.prototype.append = function () {
    var boxes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      boxes[_i] = arguments[_i];
    }
    _super.prototype.append.apply(this, __spreadArray([], __read(boxes)));
    this.refreshUUID();
  };
  DocumentBox.prototype.clearChildren = function () {
    _super.prototype.clearChildren.call(this);
    this.setMeasure(0);
    this.setExtent(0);
  };
  DocumentBox.prototype.onAppendChild = function (box, index) {
    _super.prototype.onAppendChild.call(this, box, index); // this.setMeasure(Math.max(this.measure, box.totalMeasure));
    // this.setExtent(this.extent + box.totalExtent);
  };
  Object.defineProperty(DocumentBox.prototype, "parentBox", {
    get: function get() {
      return undefined;
    },
    enumerable: false,
    configurable: true
  });
  return DocumentBox;
}(BaseParentBox);
var DocumentLayout = function (_super) {
  __extends(DocumentLayout, _super);
  function DocumentLayout(context, node) {
    var _this = _super.call(this, context, node) || this;
    var docProps = node.getProperty();
    _this.mDocProps = docProps ? docProps : new DocumentProperty();
    _this.initDocPadding();
    _this.minStart = Number.POSITIVE_INFINITY;
    _this.maxEnd = Number.NEGATIVE_INFINITY;
    return _this;
  }
  /**
   * 获取外界传入的期望尺寸
   */

  DocumentLayout.prototype.getExpectSize = function () {
    var expectMeasure = MeasureSpec.getSize(this.mInlineMeasureSpec);
    var expectExtent = MeasureSpec.getSize(this.mBlockMeasureSpec);
    return {
      measure: expectMeasure,
      extent: expectExtent
    };
  };
  DocumentLayout.prototype.addBox = function (box) {
    // 层层遍历添加box
    this.mContent.pushBlock(box);
    if (box instanceof ParagraphBox) {
      this.compareAndUpdateParaStartEnd(box);
    } else {
      this.compareAndUpdateBlockStartEnd(box);
    }
  };
  DocumentLayout.prototype.reduceLayout = function () {
    var _this = this;
    var expectMeasure = MeasureSpec.getSize(this.mInlineMeasureSpec);
    var expectExtent = MeasureSpec.getSize(this.mBlockMeasureSpec);
    var totalMeasure = this.maxParaMeasure + this.paddingMeasure;
    var measure = this.getDocBoxMeasure(totalMeasure, expectMeasure);
    var totalExtent = this.mContent.blockPos + this.paddingExtent;
    var extent = resolveSize(totalExtent, this.mBlockMeasureSpec); // 垂直对齐

    var before = this.computeBlockOffset(totalExtent, expectExtent); // 左右居中

    var start = this.computeInlineOffset(totalMeasure, expectMeasure); // 计算padding对冲的情况

    var _a = this.computePaddingOffset(expectMeasure, expectExtent),
      paddingMeasure = _a.paddingMeasure,
      paddingExtent = _a.paddingExtent;
    var box = new DocumentBox({
      measure: measure,
      extent: extent
    });
    box.logicPoint = new LogicalPoint(start + paddingMeasure, before + paddingExtent); // 设置相对位置
    // 更新children的真实相对坐标

    this.mContent.getBlocks().forEach(function (block) {
      var blockBox = block;
      blockBox.rect = transChildRectToPhysical(_this.mContext.coordinateZero, _this.mContext.lineExpandDirection, block.logicPoint, {
        measure: block.measure,
        extent: block.extent
      }, {
        measure: measure,
        extent: extent
      });
    }); // 更新content logic rect

    this.updateBoxContentLogicFrame(box); // 更新内容区域 rect

    var contentPoint = box.contentPoint;
    var contentLogicSize = {
      measure: box.contentMeasure,
      extent: this.mContent.blockPos
    };
    var expectLogicSize = {
      measure: expectMeasure,
      extent: expectExtent
    };
    box.contentRect = transChildRectToPhysical(this.mContext.coordinateZero, this.mContext.lineExpandDirection, contentPoint, contentLogicSize, expectLogicSize); // 更新document box的真实rect

    box.rect = transChildRectToPhysical(this.mContext.coordinateZero, this.mContext.lineExpandDirection, box.logicPoint, {
      measure: box.measure,
      extent: box.extent
    }, {
      measure: measure,
      extent: expectExtent
    });
    box.rect.x += this.mOffset.start;
    box.rect.y += this.mOffset.before;
    box.append.apply(box, __spreadArray([], __read(this.mContent.getBlocks())));
    return {
      layoutBoxes: [box]
    };
  };
  DocumentLayout.prototype.createGenerator = function (context, node) {
    return new DocumentGenerator(context, node, this);
  };
  DocumentLayout.prototype.generateDefaultLayoutParams = function () {
    // document布局默认inline方向充满父级，block方向自适应
    var measureSize = this.mContext.isNowrap() ? LayoutSizeSpec.WRAP_CONTENT : LayoutSizeSpec.MATCH_PARENT;
    return new LayoutParams(measureSize, LayoutSizeSpec.WRAP_CONTENT);
  };
  /**
   * 根据排版方式，初始化对应padding值
   */

  DocumentLayout.prototype.initDocPadding = function () {
    var _a = this.mDocProps,
      leftPadding = _a.leftPadding,
      topPadding = _a.topPadding,
      rightPadding = _a.rightPadding,
      bottomPadding = _a.bottomPadding; // 默认left top

    var start = leftPadding;
    var end = rightPadding;
    var before = topPadding;
    var after = bottomPadding;
    var coordinate = this.mContext.coordinateZero;
    if (coordinate === CoordinateZero.RIGHT_TOP) {
      start = topPadding;
      end = bottomPadding;
      before = rightPadding;
      after = leftPadding;
    } else if (coordinate === CoordinateZero.RIGHT_BOTTOM) {
      start = rightPadding;
      end = leftPadding;
      before = bottomPadding;
      after = topPadding;
    } else if (coordinate === CoordinateZero.LEFT_BOTTOM) {
      start = bottomPadding;
      end = topPadding;
      before = leftPadding;
      after = rightPadding;
    } else if (coordinate === CoordinateZero.LEFT_TOP) {
      if (this.mContext.lineExpandDirection === LineExpandDirection.HORIZONTAL) {
        start = topPadding;
        end = bottomPadding;
        before = leftPadding;
        after = rightPadding;
      }
    }
    this.setPadding(start, end, before, after);
  };
  DocumentLayout.prototype.getDocBoxMeasure = function (contentMeasure, expectMeasure) {
    var docSizeType = this.mDocProps.docSizeType;
    if (docSizeType === DocSizeType.WrapContent) {
      return contentMeasure;
    }
    if (docSizeType === DocSizeType.AtLeast) {
      // 至少为传入值
      return Math.max(contentMeasure, expectMeasure);
    }
    return expectMeasure;
  };
  /**
   * 计算垂直对齐偏移
   * @param contentExtent
   * @param expectExtent
   */

  DocumentLayout.prototype.computeBlockOffset = function (contentExtent, expectExtent) {
    var anchor = this.mDocProps.anchor;
    var before = 0;
    switch (anchor) {
      case AnchorType.Bottom:
        before = expectExtent - contentExtent;
        break;
      case AnchorType.Center:
        before = (expectExtent - contentExtent) / 2;
        break;
      default:
        before = 0;
    }
    return before;
  };
  /**
   * 计算textBody左右居中offset
   */

  DocumentLayout.prototype.computeInlineOffset = function (contentMeasure, expectMeasure) {
    var anchorCenter = this.mDocProps.anchorCenter;
    var startOffset = 0;
    if (anchorCenter) {
      startOffset = (expectMeasure - contentMeasure) / 2 - (this.minStart === Number.POSITIVE_INFINITY ? 0 : this.minStart - this.paddingStart);
    }
    return startOffset;
  };
  DocumentLayout.prototype.compareAndUpdateBlockStartEnd = function (block) {
    var _a;
    var totalMeasure = block.totalMeasure,
      logicPoint = block.logicPoint,
      logicEdge = block.logicEdge;
    var blockMarginStart = ((_a = logicEdge === null || logicEdge === void 0 ? void 0 : logicEdge.margin) === null || _a === void 0 ? void 0 : _a.start) || 0; // block start包含document的padding start和block的margin start

    var blockStart = logicPoint.start - blockMarginStart;
    if (blockStart < this.minStart) {
      this.minStart = blockStart;
    }
    var blockEnd = blockStart + totalMeasure;
    if (blockEnd > this.maxEnd) {
      this.maxEnd = blockEnd;
    }
  };
  /**
   * 计算para相对于document的start和end
   * @param paraBox
   * @param lineBox
   */

  DocumentLayout.prototype.compareAndUpdateParaStartEnd = function (paraBox) {
    var _a, _b, _c;
    var pLogicPoint = paraBox.logicPoint,
      pTotalMeasure = paraBox.totalMeasure,
      pLogicEdge = paraBox.logicEdge;
    var minStartLineBox = this.getMinStartLineBox(paraBox);
    if (!minStartLineBox) return;
    var logicPoint = minStartLineBox.logicPoint,
      logicEdge = minStartLineBox.logicEdge;
    var paraMarginStart = ((_a = pLogicEdge === null || pLogicEdge === void 0 ? void 0 : pLogicEdge.margin) === null || _a === void 0 ? void 0 : _a.start) || 0;
    var paraPaddingStart = ((_b = pLogicEdge === null || pLogicEdge === void 0 ? void 0 : pLogicEdge.padding) === null || _b === void 0 ? void 0 : _b.start) || 0;
    var lineMarginStart = ((_c = logicEdge === null || logicEdge === void 0 ? void 0 : logicEdge.margin) === null || _c === void 0 ? void 0 : _c.start) || 0;
    var lineAbsoluteStart = logicPoint.start + pLogicPoint.start; // 段落包裹line时的起始位置

    var paraStart = lineAbsoluteStart - lineMarginStart - paraPaddingStart - paraMarginStart;
    if (paraStart < this.minStart) {
      this.minStart = paraStart;
    }
    var paraEnd = paraStart + pTotalMeasure;
    if (paraEnd > this.maxEnd) {
      this.maxEnd = paraEnd;
    }
  };
  DocumentLayout.prototype.getMinStartLineBox = function (paraBox) {
    var minStartLineBox = null;
    var pLogicPoint = paraBox.logicPoint;
    var minLineAbsoluteStart = Number.POSITIVE_INFINITY;
    paraBox.children.forEach(function (lineBox) {
      var logicPoint = lineBox.logicPoint;
      var lineAbsoluteStart = logicPoint.start + pLogicPoint.start;
      if (lineAbsoluteStart < minLineAbsoluteStart) {
        minLineAbsoluteStart = lineAbsoluteStart;
        minStartLineBox = lineBox;
      }
    });
    return minStartLineBox;
  };
  Object.defineProperty(DocumentLayout.prototype, "maxParaMeasure", {
    get: function get() {
      var maxMeasure = 0;
      if (this.minStart !== Number.POSITIVE_INFINITY) {
        maxMeasure = Math.max(this.maxEnd - this.minStart, 0);
      }
      return maxMeasure;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 计算padding偏移，左右或上下padding会进行对冲
   * @param expectMeasure
   * @param expectExtent
   */

  DocumentLayout.prototype.computePaddingOffset = function (expectMeasure, expectExtent) {
    var paddingMeasure = 0;
    var paddingExtent = 0;
    var anchorCenter = this.mDocProps.anchorCenter; // 超出后，anchorCenter和paddingMeasure冲突

    if (!anchorCenter && this.paddingStart + this.paddingEnd > expectMeasure) {
      var offsetLR = (this.paddingStart - this.paddingEnd) / 2;
      paddingMeasure = -(this.paddingStart - expectMeasure / 2) + offsetLR;
    }
    if (this.paddingBefore + this.paddingAfter > expectExtent) {
      var offsetTB = (this.paddingBefore - this.paddingAfter) / 2;
      paddingExtent = -(this.paddingBefore - expectExtent / 2) + offsetTB;
    }
    return {
      paddingMeasure: paddingMeasure,
      paddingExtent: paddingExtent
    };
  };
  return DocumentLayout;
}(FlowLayout);
function isLeafBox(box) {
  return !!box && [BoxKind.Text, BoxKind.Inline].includes(box.kind);
}
function isParentBox(box) {
  return !!box && [BoxKind.Document, BoxKind.InlineContainer, BoxKind.Column, BoxKind.Paragraph, BoxKind.TextLine].includes(box.kind);
}
function isTextLineBox(box) {
  return !!box && box.kind === BoxKind.TextLine;
}
function isTextBox(box) {
  return !!box && box.kind === BoxKind.Text;
}
function isInlineBox(box) {
  return !!box && box.kind === BoxKind.Inline;
}

/**
 * melo方法：
 * 根据leafBox内位置获取相应的文字分割点偏移值
 * @param textBox
 * @param position 节点内查找位置偏移 PX
 * @returns offset: 字符偏移值；offsetUString: unicode字符偏移值(core range 偏移)；offsetPx: 位置偏移量
 */

function getOffsetByPosition(textBox, position) {
  var text = textBox.textString();
  if (text) {
    var uStr = new et(text);
    return binarySearchPosition(uStr, textBox, position, 0, uStr.graphemeCount(), text.length);
  }
  return {
    offset: 0,
    offsetUString: 0,
    offsetPx: 0
  };
}
function searchSinglePosition(textBox, position) {
  var width = twipsToPx(textBox.measure);
  if (position <= width / 2) {
    return {
      offset: 0,
      offsetUString: 0,
      offsetPx: 0
    };
  }
  return {
    offset: 1,
    offsetUString: textBox.text.length,
    offsetPx: width
  };
}
/**
 * 二分法根据节点内位置获取相应的文字分割点偏移值
 */

function binarySearchPosition(uStr, textBox, position, start, end, length) {
  if (textBox instanceof TabstopTextBox) {
    return searchSinglePosition(textBox, position);
  }
  if (uStr.graphemeCount() === 1) {
    /**
     * 整个 box 只有一个不可分割的字位（最小的有意义的书写字符单元，比如'😊'的字符长度是 2，字位长度是 1）时，把整个 box 作为一个整体来计算文字分割点
     * 比如：在两端对齐或分散对齐时，文字会拆分为单独的 box 用于承载每一行排版完成之后额外的长度，
     * 这个长度无法通过 measureChar 计算出来，所以就需要把整个 box 作为一个整体来计算文字分割点
     */
    return searchSinglePosition(textBox, position);
  }
  if (end - start > 1) {
    var mid = Math.floor((start + end) / 2);
    var _a = TextRunMeasureEngine.getDefaultEngine().measureChar(textBox.textString(), textBox.textStyle, uStr.graphemeIndex2CharCodeIndexRange(start).start, uStr.graphemeIndex2CharCodeIndexRange(mid).end > length ? length : uStr.graphemeIndex2CharCodeIndexRange(mid).end),
      width_1 = _a.width,
      offsetLeft_1 = _a.offsetLeft;
    if (position <= twipsToPx(offsetLeft_1 + width_1)) {
      return binarySearchPosition(uStr, textBox, position, start, mid, length);
    }
    return binarySearchPosition(uStr, textBox, position, mid, end, length);
  }
  var _b = TextRunMeasureEngine.getDefaultEngine().measureChar(textBox.textString(), textBox.textStyle, uStr.graphemeIndex2CharCodeIndexRange(start).start, uStr.graphemeIndex2CharCodeIndexRange(start).end + 1 > length ? length : uStr.graphemeIndex2CharCodeIndexRange(start).end + 1),
    width = _b.width,
    offsetLeft = _b.offsetLeft;
  if (position <= twipsToPx(offsetLeft + width / 2)) {
    return {
      offset: start,
      offsetUString: uStr.graphemeIndex2CharCodeIndexRange(start).start,
      offsetPx: twipsToPx(offsetLeft)
    };
  }
  return {
    offset: end,
    offsetUString: uStr.graphemeIndex2CharCodeIndexRange(start).end + 1,
    offsetPx: twipsToPx(offsetLeft + width)
  };
}

/**
 * 逻辑尺寸Rect
 */
var LogicalRect = function () {
  function LogicalRect(start, before, measure, extent) {
    this.start = start;
    this.before = before;
    this.measure = measure;
    this.extent = extent;
  }
  Object.defineProperty(LogicalRect, "zero", {
    get: function get() {
      return new LogicalRect(0, 0, 0, 0);
    },
    enumerable: false,
    configurable: true
  });
  LogicalRect.prototype.isZero = function () {
    return this.measure === 0 && this.extent === 0;
  };
  LogicalRect.prototype.getStartBefore = function () {
    return {
      start: this.start,
      before: this.before
    };
  };
  LogicalRect.prototype.getSize = function () {
    return {
      measure: this.measure,
      extent: this.extent
    };
  };
  LogicalRect.prototype.getEnd = function () {
    return this.start + this.measure;
  };
  LogicalRect.prototype.getAfter = function () {
    return this.before + this.extent;
  };
  LogicalRect.prototype.offset = function (offsetStart, offsetBefore) {
    this.start += offsetStart;
    this.before += offsetBefore;
  };
  /**
   * 判断是否包含
   * @param point 坐标点
   */

  LogicalRect.prototype.contains = function (point) {
    return point.start >= this.start && point.start <= this.getEnd() && point.before >= this.before && point.before <= this.getAfter();
  };
  /**
   * 判断是否与指定区域有交集
   * @param rect 区域
   */

  LogicalRect.prototype.intersect = function (rect) {
    return rect.getEnd() >= this.start && this.getEnd() >= rect.start && rect.getAfter() >= this.before && this.getAfter() >= rect.before;
  }; // eslint-disable-next-line @typescript-eslint/member-ordering

  LogicalRect.sZero = LogicalRect.zero;
  return LogicalRect;
}();

/**
 * 通过坐标位置，查找range，并返回对应box和rect。
 * 查找函数都是基于逻辑尺寸进行计算。
 */

var RangeFinder = function () {
  function RangeFinder(layoutContext) {
    this.layoutContext = layoutContext;
  }
  /**
   * 通过点击位置，返回排版数据、区域等相关信息。
   * @param docBox
   * @param docExpectSize 文档期望尺寸大小
   * @param hitPoint 相对文档左上角的点击位置
   */

  RangeFinder.prototype.findHitViewPoint = function (docBox, docExpectSize, hitPoint) {
    var filterListMark = true;
    var hitLeafBox = this.findHitLeafBoxInParentBox(docBox, docBox.logicPoint, hitPoint, filterListMark);
    if (!hitLeafBox) {
      return null;
    }
    return this.findHitViewPointInLeaf(hitLeafBox, docExpectSize, hitPoint, filterListMark);
  };
  /**
   * 在 ParentBox 中查找点击的 LeafBox
   * @param srcParentBox srcParentBox
   * @param srcParentOffset srcParentOffset
   * @param hitPoint 点击的坐标
   * @param filterListMark
   */

  RangeFinder.prototype.findHitLeafBoxInParentBox = function (srcParentBox, srcParentOffset, hitPoint, filterListMark) {
    var hitLineBox = this.findHitLineBoxInParentBox(srcParentBox, srcParentOffset, hitPoint);
    if (hitLineBox) {
      var hitLeafBox = this.findHitLeafBoxInLine(hitLineBox.targetBox, hitLineBox.targetRect, hitPoint, filterListMark);
      if (hitLeafBox && isLeafBox(hitLeafBox.targetBox)) {
        return {
          targetBox: hitLeafBox.targetBox,
          targetRect: hitLeafBox.targetRect
        };
      }
    }
    return null;
  };
  RangeFinder.prototype.findHitLineBoxInParentBox = function (srcParentBox, srcParentOffset, hitPoint) {
    var target = null;
    var boxQueue = [{
      layoutBox: srcParentBox,
      offset: srcParentOffset
    }];
    var appendBox = function appendBox(param) {
      boxQueue.push(param);
    };
    while (boxQueue.length) {
      var currentNode = boxQueue.shift();
      if (!currentNode) {
        break;
      }
      var layoutBox = currentNode.layoutBox,
        offset = currentNode.offset;
      if (!isParentBox(layoutBox)) {
        continue;
      }
      if (isTextLineBox(layoutBox)) {
        var measure = layoutBox.measure,
          extent = layoutBox.extent;
        var logicalRect = new LogicalRect(offset.start, offset.before, measure, extent);
        target = {
          targetBox: layoutBox,
          targetRect: logicalRect
        };
        break;
      }
      var _a = this.findNearestChildBox(layoutBox, offset, hitPoint),
        nearestDistance = _a.nearestDistance,
        nearestChildBox = _a.nearestChildBox,
        nearestChildRect = _a.nearestChildRect;
      if (!nearestChildBox || !nearestChildRect) {
        continue;
      }
      if (nearestDistance <= 0 && isTextLineBox(nearestChildBox)) {
        target = {
          targetBox: nearestChildBox,
          targetRect: nearestChildRect
        };
        break;
      }
      appendBox({
        layoutBox: nearestChildBox,
        offset: nearestChildRect.getStartBefore()
      });
    }
    return target;
  };
  /**
   * 在 TextLine 中查找点击的 LeafBox
   * @param textLineBox textLineBox
   * @param textLineRect textLineRect
   * @param hitPoint 点击的坐标
   * @param filterListMark 是否过滤项目符号
   */

  RangeFinder.prototype.findHitLeafBoxInLine = function (textLineBox, textLineRect, hitPoint, filterListMark) {
    var e_1, _a;
    var _b, _c;
    if (textLineBox.children.length > 0) {
      try {
        for (var _d = __values(textLineBox.children), _e = _d.next(); !_e.done; _e = _d.next()) {
          var childBox = _e.value;
          if (filterListMark && childBox instanceof ListMarkTextBox) {
            // 过滤项目符号
            continue;
          }
          var logicPoint = childBox.logicPoint,
            measure = childBox.measure,
            extent = childBox.extent;
          var childRect = new LogicalRect(textLineRect.start + logicPoint.start, textLineRect.before + logicPoint.before, measure, extent);
          var firstChild = (_b = childBox.parentBox) === null || _b === void 0 ? void 0 : _b.firstVisibleChild;
          if (filterListMark && firstChild instanceof ListMarkTextBox) {
            firstChild = firstChild.nextSibling;
          }
          var lastChild = (_c = childBox.parentBox) === null || _c === void 0 ? void 0 : _c.lastVisibleChild;
          if (firstChild === childBox && hitPoint.start < childRect.start || hitPoint.start >= childRect.start && hitPoint.start < childRect.getEnd() || lastChild === childBox && hitPoint.start >= childRect.getEnd()) {
            return {
              targetBox: childBox,
              targetRect: childRect
            };
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_e && !_e.done && (_a = _d["return"])) _a.call(_d);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return null;
    }
    return null;
  };
  /**
   * 查找点击距离最近的 LayoutBox
   * @param srcParentBox srcParentBox
   * @param srcParentOffset srcParentOffset
   * @param hitPoint 点击的坐标
   */

  RangeFinder.prototype.findNearestChildBox = function (srcParentBox, srcParentOffset, hitPoint) {
    var e_2, _a;
    var nearestChildInfo = {
      nearestDistance: Number.MAX_SAFE_INTEGER,
      nearestChildBox: undefined,
      nearestChildRect: undefined
    };
    try {
      for (var _b = __values(srcParentBox.children), _c = _b.next(); !_c.done; _c = _b.next()) {
        var childBox = _c.value;
        var logicPoint = childBox.logicPoint,
          measure = childBox.measure,
          extent = childBox.extent,
          display = childBox.display;
        var childRect = new LogicalRect(srcParentOffset.start + logicPoint.start, srcParentOffset.before + logicPoint.before, measure, extent);
        var distance = 0; // 1. 完全命中，直接退出循环

        if (childRect.contains(hitPoint)) {
          nearestChildInfo.nearestDistance = 0;
          nearestChildInfo.nearestChildBox = childBox;
          nearestChildInfo.nearestChildRect = childRect;
          break;
        } // 2.水平方向布局，计算x轴上 hitPoint 与 childBox 的距离

        if (display === LayoutDisplay.Inline || display === LayoutDisplay.InlineBlock) {
          if (hitPoint.start < childRect.start) {
            distance += Math.abs(childRect.start - hitPoint.start);
          } else if (hitPoint.start > childRect.getEnd()) {
            distance += Math.abs(hitPoint.start - childRect.getEnd());
          }
        }
        if (display === LayoutDisplay.Block) {
          // 3.垂直方向布局，计算y轴上 hitPoint 与 childBox 的距离
          if (hitPoint.before < childRect.before) {
            distance += Math.abs(childRect.before - hitPoint.before);
          } else if (hitPoint.before > childRect.getAfter()) {
            distance += Math.abs(hitPoint.before - childRect.getAfter());
          }
        } // 只保留最短距离的 childBox

        if (distance < nearestChildInfo.nearestDistance) {
          nearestChildInfo.nearestDistance = distance;
          nearestChildInfo.nearestChildBox = childBox;
          nearestChildInfo.nearestChildRect = childRect;
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return nearestChildInfo;
  };
  /**
   * 在 LeafBox 中获取 ViewPoint
   * @param hitBox 点击的 LeafBox
   * @param hitPoint 点击的坐标
   * @param findBreakNode 是否允许查找 BreakNode
   */

  /* eslint complexity: ["error", 15] */

  RangeFinder.prototype.findHitViewPointInLeaf = function (hitBox, docExpectSize, hitPoint, filterListMark) {
    var _a, _b;
    if (isTextBox(hitBox.targetBox)) {
      var range = hitBox.targetBox.runRange;
      var searchResult = this.getSearchResult(hitBox, hitPoint);
      var offsetUString = searchResult.offsetUString,
        offsetPx = searchResult.offsetPx;
      var boxOffset = offsetUString;
      var runOffset = range.begin() + boxOffset;
      var targetRect = hitBox.targetRect,
        targetBox = hitBox.targetBox;
      var leafBox = targetBox; // 调整光标位置

      targetRect.offset(pxToTwips(offsetPx), 0);
      targetRect.measure = pxToTwips(1);
      if (offsetUString === 0) {
        // 如果在首位，使用上一个box的height
        var preBox = targetBox.prevSibling;
        if (!(filterListMark && preBox instanceof ListMarkTextBox) && isTextBox(preBox)) {
          leafBox = preBox;
          boxOffset = ((_a = preBox.text) === null || _a === void 0 ? void 0 : _a.length) || 0;
          runOffset = preBox.runRange.begin() + boxOffset;
          targetRect.extent = preBox.extent;
          targetRect.before += preBox.logicPoint.before - targetBox.logicPoint.before;
        }
      }
      var caretRect = transChildRectToPhysical(this.layoutContext.coordinateZero, this.layoutContext.lineExpandDirection, {
        start: targetRect.start,
        before: targetRect.before
      }, {
        measure: targetRect.measure,
        extent: targetRect.extent
      }, docExpectSize);
      return {
        leafBox: leafBox,
        runOffset: runOffset,
        caretRect: caretRect,
        boxOffset: boxOffset
      };
    }
    if (isInlineBox(hitBox.targetBox)) {
      var inlineNodeRunOffset = this.isPointLeft(hitBox, hitPoint) ? 0 : ((_b = hitBox.targetBox.runRange) === null || _b === void 0 ? void 0 : _b.len) || 0;
      hitBox.targetRect.start = this.isPointLeft(hitBox, hitPoint) ? hitBox.targetRect.start : hitBox.targetRect.measure + hitBox.targetRect.start;
      hitBox.targetRect.measure = pxToTwips(1);
      var caretRect = transChildRectToPhysical(this.layoutContext.coordinateZero, this.layoutContext.lineExpandDirection, {
        start: hitBox.targetRect.start,
        before: hitBox.targetRect.before
      }, {
        measure: hitBox.targetRect.measure,
        extent: hitBox.targetRect.extent
      }, docExpectSize);
      return {
        leafBox: hitBox.targetBox,
        runOffset: inlineNodeRunOffset,
        caretRect: caretRect,
        boxOffset: 0
      };
    }
    return null;
  };
  RangeFinder.prototype.isPointLeft = function (hitBox, hitPoint) {
    var _a;
    var middleWidth = (((_a = hitBox.targetRect) === null || _a === void 0 ? void 0 : _a.measure) || 0) / 2;
    var hitPointStart = hitPoint.start - hitBox.targetRect.start;
    return hitPointStart < middleWidth;
  };
  RangeFinder.prototype.getSearchResult = function (hitBox, hitPoint) {
    var targetBox = hitBox.targetBox;
    var searchResult;
    if (targetBox instanceof TextBreakerBox) {
      searchResult = {
        offset: 0,
        offsetUString: 0,
        offsetPx: 0
      };
    } else {
      searchResult = getOffsetByPosition(targetBox, twipsToPx(hitPoint.start - hitBox.targetRect.start));
    }
    return searchResult;
  };
  return RangeFinder;
}();
var LayoutController = function () {
  function LayoutController(adapter) {
    this.layoutAdapter = adapter;
    this.layoutContext = new LayoutContext(adapter);
    this.rangeFinder = new RangeFinder(this.layoutContext);
  }
  /**
   * 通过点击位置，返回排版数据、区域等相关信息
   * @param hitPoint 相对文档左上角的点击位置
   */

  LayoutController.prototype.findHitViewPoint = function (hitPoint) {
    if (!this.layoutBox) return null;
    var docExpectSize = this.docLayout.getExpectSize();
    var isVert = this.layoutContext.isVert();
    var docPhysicalSize = {
      width: isVert ? docExpectSize.extent : docExpectSize.measure,
      height: isVert ? docExpectSize.measure : docExpectSize.extent
    }; // 转换为逻辑尺寸进行计算

    var hitLogicPoint = transPointToLogic(this.layoutContext.coordinateZero, this.layoutContext.lineExpandDirection, docPhysicalSize, hitPoint);
    return this.rangeFinder.findHitViewPoint(this.layoutBox, docExpectSize, hitLogicPoint);
  };
  /**
   * 给定排版区域px值，触发排版
   * @param left
   * @param top
   * @param width
   * @param height
   * @param unit
   */

  LayoutController.prototype.doLayout = function (left, top, width, height, unit) {
    var docLayout = new DocumentLayout(this.layoutContext, this.layoutAdapter.getRootNode());
    this.docLayout = docLayout;
    this.layoutAdapter.onLayoutStart();
    var leftTwips = left;
    var topTwips = top;
    var widthTwips = width;
    var heightTwips = height;
    if (!unit || unit === LayoutUnit.PX) {
      leftTwips = pxToTwips(left);
      topTwips = pxToTwips(top);
      widthTwips = pxToTwips(width);
      heightTwips = pxToTwips(height);
    }
    var lp = docLayout.getLayoutParams();
    var isVert = this.layoutContext.isVert();
    var inlineMeasureSpec = getRootMeasureSpec(isVert ? heightTwips : widthTwips, lp.measure);
    var blockMeasureSpec = getRootMeasureSpec(isVert ? widthTwips : heightTwips, lp.extent);
    var layoutValue = docLayout.layout(leftTwips, topTwips, inlineMeasureSpec, blockMeasureSpec);
    var _a = __read(layoutValue.layoutBoxes, 1),
      layoutBox = _a[0];
    this.layoutBox = layoutBox;
    this.layoutAdapter.onLayoutChanged();
    this.layoutAdapter.onLayoutFinished();
  };
  LayoutController.prototype.getLayoutBox = function () {
    return this.layoutBox;
  };
  /* ---------------debug接口start---------------------*/

  LayoutController.prototype.debug = function (isDebug) {
    LayoutController.debug = isDebug;
    if (!isDebug) {
      LayoutController.allMeasureCount = 0;
      LayoutController.allMeasureTime = 0;
    }
  };
  LayoutController.debug = false;
  LayoutController.allMeasureTime = 0;
  LayoutController.allMeasureCount = 0;
  return LayoutController;
}();
var MEASURE_CANVAS_ID = 'alloy-text-layout-measure-canvas';
var OffScreenRenderMeasureCanvas = function () {
  function OffScreenRenderMeasureCanvas() {
    this._ctx = null;
    this.checkMeasureCanvas();
  }
  OffScreenRenderMeasureCanvas.prototype.getMeasureContext = function () {
    return this._ctx;
  }; // measure node 延迟到使用的时候再初始化

  OffScreenRenderMeasureCanvas.prototype.checkMeasureCanvas = function () {
    if (this._ctx) return true;
    var canvas = document.getElementById(MEASURE_CANVAS_ID);
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.id = MEASURE_CANVAS_ID;
      canvas.style.cssText = 'position:absolute;width:10px;height:10px;top:-50000px;letter-spacing:0'; // 创建容器，为了保证测量的 canvas 不会撑开外界的滚动宽度导致预期之外的滚动

      var container = document.createElement('div');
      container.style.cssText = 'position: absolute; top: -50000px; overflow: hidden;';
      container.appendChild(canvas);
      document.body.append(container);
    }
    this._ctx = canvas === null || canvas === void 0 ? void 0 : canvas.getContext('2d');
    if (this._ctx) {
      return true;
    }
    return false;
  };
  /**
   * measure token with text style
   * @param word
   * @param textDir
   * @param style
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering

  OffScreenRenderMeasureCanvas.prototype.measureSize = function (word, textAttr, style) {
    if (!this.checkMeasureCanvas()) {
      return [0, 0, 0, 0, 0];
    }
    this._ctx.font = textAttr.fontWeight + " " + twipsToPt(textAttr.fontSize) + "pt ''"; // 先设置一个默认值，防止设置非法属性。随便写，不是非法字体即可

    this._ctx.font = style.style;
    var textMetrics = this._ctx.measureText(word); // 处理字间距

    var spacing = 0;
    var letterSpacing = textAttr.letterSpacing;
    if (letterSpacing !== 0) {
      letterSpacing = twipsToPx(letterSpacing);
      if (word.length === 1) {
        spacing = letterSpacing;
      } else {
        spacing = letterSpacing * new et(word).graphemeCount();
      }
    }
    var actualHeight = (textMetrics.actualBoundingBoxAscent || 0) + (textMetrics.actualBoundingBoxDescent || 0);
    var actualWidth = Math.abs(textMetrics.actualBoundingBoxLeft || 0) + Math.abs(textMetrics.actualBoundingBoxRight || 0);
    return [
    // 测量的宽度不能小于 0
    Math.max(textMetrics.width + spacing, 0), textMetrics.fontBoundingBoxAscent, textMetrics.fontBoundingBoxDescent, actualWidth, actualHeight, textMetrics];
  };
  return OffScreenRenderMeasureCanvas;
}();
/**
 * 文字测量
 */

var TextMeasure = function () {
  function TextMeasure(measureImp) {
    this._cacheL1 = {};
    this._measureImp = measureImp;
  }
  TextMeasure.prototype.getMeasureContext = function () {
    return this._measureImp.getMeasureContext();
  };
  /**
   * 字符串测量
   * @param {string} word         待测量的字符串
   * @param {string} textDir      文字方向
   * @param {string} style        文字样式
   * @returns {number, number}    测量之后的长宽
   */

  TextMeasure.prototype.measure = function (word, textAttr, style) {
    if (!Object.prototype.hasOwnProperty.call(this._cacheL1, style.key)) {
      this._cacheL1[style.key] = new Map();
    }
    var cacheL2 = this._cacheL1[style.key];
    var size = cacheL2.get(word);
    if (size) return size;
    size = this._measureImp.measureSize(word, textAttr, style);
    cacheL2.set(word, size);
    return size;
  };
  /**
   * 清除测量缓存
   */

  TextMeasure.prototype.clearCache = function () {
    this._cacheL1 = {};
  };
  TextMeasure.prototype.invalidateCacheL1 = function (key) {
    var _this = this;
    var keys = Object.keys(this._cacheL1);
    keys.forEach(function (cacheKey) {
      if (cacheKey.includes(key)) {
        delete _this._cacheL1[cacheKey];
      }
    });
  };
  return TextMeasure;
}();
var GlobalPropKey;
(function (GlobalPropKey) {
  GlobalPropKey["DefaultFontFamily"] = "default_font_family";
})(GlobalPropKey || (GlobalPropKey = {})); // 指定特定脚本类型对应的属性 key

var unicodeScriptPropKey = {
  Han: 'han_default_font_family'
};
/**
 * 全局属性存储器。
 * 所有排版用到的相关属性会继承全局属性，如fontFamily
 */

var GlobalPropStore = function () {
  function GlobalPropStore() {}
  /**
   * 设置全局默认文字
   * 可拼接多种字体，字体名称非字母开头或中间有空格的，都必须加上引号
   * @param value
   */

  GlobalPropStore.setDefaultFontFamily = function (value, specificFontFamilies) {
    var _this = this;
    this.propMap.set(GlobalPropKey.DefaultFontFamily, value);
    if (!specificFontFamilies) {
      return;
    }
    Object.entries(specificFontFamilies).forEach(function (_a) {
      var _b = __read(_a, 2),
        scriptType = _b[0],
        fontFamilies = _b[1];
      if (unicodeScriptPropKey[scriptType] && fontFamilies) {
        _this.propMap.set(unicodeScriptPropKey[scriptType], fontFamilies);
      }
    });
  };
  /**
   * 根据脚本类型获取默认字体
   * @param scriptType
   * @returns
   */

  GlobalPropStore.getDefaultFontFamily = function (scriptType) {
    if (scriptType) {
      var defaultFontFamily = this.propMap.get(unicodeScriptPropKey[scriptType]);
      if (defaultFontFamily) {
        return defaultFontFamily;
      }
    }
    return this.propMap.get(GlobalPropKey.DefaultFontFamily) || '';
  };
  GlobalPropStore.propMap = new Map();
  return GlobalPropStore;
}();

// eslint-disable-next-line prettier/prettier

var TestCharacters = ['一', '国', '字', '中', '文', '你', '好', '我', '了', '的', '天', '小', '山', '水', '龙', '鱼', '马', '鸟', '花', '目', '木', '金', '石', '火', '风'];
/**
 * 用于检测中文字体是否为等宽字体
 */

var MonospaceFontDetector = function () {
  // 私有构造函数，确保只能通过getInstance方法创建实例
  function MonospaceFontDetector() {
    this.cache = new Map();
  } // 获取MonospaceFontDetector类的单例

  MonospaceFontDetector.getInstance = function () {
    if (!this.instance) {
      this.instance = new MonospaceFontDetector();
    }
    return this.instance;
  }; // 判断字体是否为等宽字体，如果已经在缓存中，则直接返回结果，否则进行测量并将结果存入缓存

  MonospaceFontDetector.prototype.isChineseMonospace = function (context, fontFamilyInCacheKey, fontFamilyInStyle) {
    if (!context || !fontFamilyInCacheKey || !fontFamilyInStyle) {
      return true;
    }
    var cachedResult = this.getCache(fontFamilyInCacheKey);
    if (cachedResult !== null) {
      return cachedResult;
    }
    context.font = "16px " + fontFamilyInStyle;
    var firstCharWidth = context.measureText(TestCharacters[0]).width;
    var testString = TestCharacters.join('');
    var totalWidth = context.measureText(testString).width; // 最终宽度相差小于容差值，视为等宽字体

    var tolerance = 0.1;
    var isMonospace = Math.abs(totalWidth - firstCharWidth * TestCharacters.length) <= tolerance;
    this.setCache(fontFamilyInCacheKey, isMonospace);
    return isMonospace;
  }; // 清除指定字体的缓存信息

  MonospaceFontDetector.prototype.invalidateCache = function (fontFamily) {
    var e_1, _a;
    if (fontFamily) {
      try {
        for (var _b = __values(this.cache.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          if (key.includes(fontFamily)) {
            this.cache["delete"](key);
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
  }; // 清除所有缓存

  MonospaceFontDetector.prototype.clearCache = function () {
    this.cache.clear();
  }; // 将字体等宽信息存入缓存

  MonospaceFontDetector.prototype.setCache = function (fontFamily, isMonospace) {
    this.cache.set(fontFamily, isMonospace);
  }; // 从缓存中获取字体等宽信息，如果不存在则返回null

  MonospaceFontDetector.prototype.getCache = function (fontFamily) {
    return this.cache.has(fontFamily) ? this.cache.get(fontFamily) : null;
  };
  return MonospaceFontDetector;
}();
var TextRunMeasureImp = function () {
  function TextRunMeasureImp(preciseMeasurement) {
    if (preciseMeasurement === void 0) {
      preciseMeasurement = false;
    }
    this.measureImpl = new TextMeasure(new OffScreenRenderMeasureCanvas());
    this.CJKCache = {};
    this.preciseMeasurement = preciseMeasurement;
  }
  /**
   * 修改文字精确测量状态
   * @param preciseMeasurement
   */

  TextRunMeasureImp.prototype.setPreciseMeasurement = function (preciseMeasurement) {
    this.preciseMeasurement = preciseMeasurement;
  }; // 目前影响测量的只有字体、字号、字重和字间距这4种字属性

  TextRunMeasureImp.prototype.computeCSSStyleForTextRunAttr = function (attr, fontFamilyInCacheKey, fontFamilyInStyle) {
    var fontSize = twipsToPt(attr.fontSize);
    var letterSpacing = twipsToPt(attr.letterSpacing);
    var fontWeight = attr.fontWeight;
    var italic = attr.italic ? 'italic' : '';
    var style = fontWeight + " " + italic + " " + fontSize + "pt " + fontFamilyInStyle;
    return {
      key: fontWeight + " " + italic + " " + fontSize + " " + fontFamilyInCacheKey + " " + letterSpacing,
      style: style
    };
  }; // eslint-disable-next-line complexity

  TextRunMeasureImp.prototype.measureAttributedText = function (text, textAttr) {
    if (text.length === 0) {
      return {
        width: 0,
        height: 0
      };
    }
    var isHan = text.length === 1 && Be(text.codePointAt(0) || 0) === 'Han'; // 取中文默认字体时中文标点也包含在内，同时也要考虑中文和标点一起测字的情况，到这一步测量时 text 中所有字符都是同一种 TokenType，所以判断第一个字符是 east 就可以
    // 否则可能还会命中 chrome 中测字的 bug，也就是某些字体（比如 calibri）虽然不支持中文字符渲染，但是会影响测量结果的 ascent 和 descent，导致排版和渲染不一致

    var defaultFontFamily = GlobalPropStore.getDefaultFontFamily(isEast(text.codePointAt(0)) ? 'Han' : undefined);
    var _a = this.getFontFamily(text, textAttr, defaultFontFamily),
      fontFamilyInCacheKey = _a.fontFamilyInCacheKey,
      fontFamilyInStyle = _a.fontFamilyInStyle;
    var style = this.computeCSSStyleForTextRunAttr(textAttr, fontFamilyInCacheKey, fontFamilyInStyle); // 中文且非精确测量且是等宽字体，则使用 CJKCache 缓存

    var enableCJKCache = isHan && !this.preciseMeasurement && MonospaceFontDetector.getInstance().isChineseMonospace(this.measureImpl.getMeasureContext(), fontFamilyInCacheKey, fontFamilyInStyle);
    var size;
    var cachedSize = enableCJKCache ? this.CJKCache[style.key] : undefined;
    if (cachedSize) {
      size = cachedSize;
    } else {
      size = this.measureImpl.measure(text.toString(), textAttr, style);
      if (enableCJKCache) {
        this.CJKCache[style.key] = size;
      }
    }
    var ascent = size[1] ? pxToTwips(size[1]) : undefined;
    var descent = size[2] ? pxToTwips(size[2]) : undefined;
    return {
      width: pxToTwips(size[0] || 0),
      height: this.getTextHeight(textAttr, ascent, descent),
      ascent: ascent,
      descent: descent,
      actualWidth: pxToTwips(size[3]),
      actualHeight: pxToTwips(size[4]),
      textMetrics: size[5]
    };
  };
  TextRunMeasureImp.prototype.measureChar = function (text, textAttr, startPos, endPos) {
    return _assign(_assign({}, this.measureAttributedText(text.substring(startPos, endPos), textAttr)), {
      offsetLeft: this.measureAttributedText(text.substring(0, startPos), textAttr).width
    });
  };
  TextRunMeasureImp.prototype.clearCache = function () {
    this.CJKCache = {};
    this.measureImpl.clearCache();
    MonospaceFontDetector.getInstance().clearCache();
  };
  TextRunMeasureImp.prototype.invalidateMeasureCache = function (fontFamily) {
    var _this = this;
    var cJKKeys = Object.keys(this.CJKCache);
    cJKKeys.forEach(function (cacheKey) {
      if (cacheKey.includes(fontFamily)) {
        delete _this.CJKCache[cacheKey];
      }
    });
    this.measureImpl.invalidateCacheL1(fontFamily);
    MonospaceFontDetector.getInstance().invalidateCache(fontFamily);
  };
  TextRunMeasureImp.prototype.getTextHeight = function (textAttr, ascent, descent) {
    if (ascent === void 0) {
      ascent = 0;
    }
    if (descent === void 0) {
      descent = 0;
    }
    if (ascent || descent) {
      return ascent + descent;
    }
    var fontSize = Defaults.fontSize;
    if ((textAttr === null || textAttr === void 0 ? void 0 : textAttr.fontSize) && !Number.isNaN(textAttr.fontSize)) {
      fontSize = textAttr.fontSize;
    }
    return fontSize * FONT_SIZE_PERCENT;
  };
  TextRunMeasureImp.prototype.getFontFamily = function (text, attr, defaultFontFamily) {
    var globalFontFamily = defaultFontFamily;
    var fontFamily = attr.has(SpanPropKey.fontFamily) ? attr.fontFamily : '';
    if (text === TaskStateChar.Done || text === TaskStateChar.Todo) {
      var fontFamilyPrefix = 'txdocfont';
      fontFamily = "" + fontFamilyPrefix + (fontFamily ? "," + fontFamily : '');
    }
    if (globalFontFamily) {
      globalFontFamily = fontFamily ? "," + globalFontFamily : globalFontFamily; // 这个不作为key
    }
    return {
      fontFamilyInCacheKey: fontFamily,
      fontFamilyInStyle: "" + fontFamily + (globalFontFamily !== null && globalFontFamily !== void 0 ? globalFontFamily : '')
    };
  };
  return TextRunMeasureImp;
}();
var TextLayoutEngine = function () {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function TextLayoutEngine(measureContext) {// 后面需要设置给测量引擎
  }
  TextLayoutEngine.getInstance = function () {
    return TextLayoutEngine.instance;
  };
  TextLayoutEngine.initLayoutEngine = function (measureContext) {
    TextLayoutEngine.instance = new TextLayoutEngine();
  };
  TextLayoutEngine.initWithDefaultMeasureContext = function (preciseMeasurement) {
    if (preciseMeasurement === void 0) {
      preciseMeasurement = false;
    }
    TextRunMeasureEngine.getDefaultEngine().setTextRunMeasureImp(new TextRunMeasureImp(preciseMeasurement));
    TextLayoutEngine.instance = new TextLayoutEngine();
    return TextLayoutEngine.instance;
  };
  /**
   * 创建排版管理器，可以同时创建多个
   * @param adapter
   */

  TextLayoutEngine.prototype.createTextLayout = function (adapter) {
    return new LayoutController(adapter);
  };
  /**
   * 设置全局默认文字
   * 可拼接多种字体，字体名称非字母开头或中间有空格的，都必须加上引号
   * @param value
   */

  TextLayoutEngine.prototype.setDefaultFontFamily = function (value, specificFontFamilies) {
    GlobalPropStore.setDefaultFontFamily(value, specificFontFamilies);
  };
  TextLayoutEngine.prototype.getDefaultFontFamily = function (scriptType) {
    return GlobalPropStore.getDefaultFontFamily(scriptType);
  };
  /**
   * 清除某个字体的测量缓存
   * @param fontFamily 需要被清除测量缓存的字体名称
   */

  TextLayoutEngine.prototype.invalidateMeasureCache = function (fontFamily) {
    TextRunMeasureEngine.getDefaultEngine().invalidateMeasureCache(fontFamily);
  };
  /**
   * 修改文字精确测量状态
   * @param preciseMeasurement
   */

  TextLayoutEngine.prototype.setPreciseMeasurement = function (preciseMeasurement) {
    TextRunMeasureEngine.getDefaultEngine().setPreciseMeasurement(preciseMeasurement);
  };
  return TextLayoutEngine;
}();
var AbstractLayoutAdapter = function () {
  function AbstractLayoutAdapter() {} // eslint-disable-next-line @typescript-eslint/no-unused-vars

  AbstractLayoutAdapter.prototype.onLayoutBlockStart = function (block) {// 子类选择性继承
  };
  AbstractLayoutAdapter.prototype.onLayoutChanged = function () {// 子类选择性继承
  };
  AbstractLayoutAdapter.prototype.onLayoutFinished = function () {// 子类选择性继承
  };
  AbstractLayoutAdapter.prototype.onLayoutStart = function () {// 子类选择性继承
  };
  AbstractLayoutAdapter.prototype.getDocType = function () {
    return DocType.PPT;
  };
  return AbstractLayoutAdapter;
}();
(function (_super) {
  __extends(BlockContainerBox, _super);
  function BlockContainerBox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.kind = BoxKind.BlockContainer;
    return _this;
  }
  return BlockContainerBox;
})(BaseLayoutBox);

/**
 * @class TextPageBox
 * 文本页
 * 子节点可能是ParagraphBox或者TableBox
 */

(function (_super) {
  __extends(TextPageBox, _super);
  function TextPageBox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.kind = BoxKind.TextPage;
    return _this;
  }
  return TextPageBox;
})(BaseParentBox);

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray$1(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$1(r, e) || _nonIterableRest();
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _defineProperty$1(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$1(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$1(r) || _nonIterableSpread();
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof(o) {
    "@babel/helpers - typeof";

    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
  }
  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(_typeof_1);

var regeneratorRuntime$1 = createCommonjsModule(function (module) {
  var _typeof = _typeof_1["default"];
  function _regeneratorRuntime() {

    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
    module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
      return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = Object.defineProperty || function (t, e, r) {
        t[e] = r.value;
      },
      i = "function" == typeof Symbol ? Symbol : {},
      a = i.iterator || "@@iterator",
      c = i.asyncIterator || "@@asyncIterator",
      u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
      return Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[e];
    }
    try {
      define({}, "");
    } catch (t) {
      define = function define(t, e, r) {
        return t[e] = r;
      };
    }
    function wrap(t, e, r, n) {
      var i = e && e.prototype instanceof Generator ? e : Generator,
        a = Object.create(i.prototype),
        c = new Context(n || []);
      return o(a, "_invoke", {
        value: makeInvokeMethod(t, r, c)
      }), a;
    }
    function tryCatch(t, e, r) {
      try {
        return {
          type: "normal",
          arg: t.call(e, r)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }
    e.wrap = wrap;
    var h = "suspendedStart",
      l = "suspendedYield",
      f = "executing",
      s = "completed",
      y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function () {
      return this;
    });
    var d = Object.getPrototypeOf,
      v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
      ["next", "throw", "return"].forEach(function (e) {
        define(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function AsyncIterator(t, e) {
      function invoke(r, o, i, a) {
        var c = tryCatch(t[r], t, o);
        if ("throw" !== c.type) {
          var u = c.arg,
            h = u.value;
          return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
            invoke("next", t, i, a);
          }, function (t) {
            invoke("throw", t, i, a);
          }) : e.resolve(h).then(function (t) {
            u.value = t, i(u);
          }, function (t) {
            return invoke("throw", t, i, a);
          });
        }
        a(c.arg);
      }
      var r;
      o(this, "_invoke", {
        value: function value(t, n) {
          function callInvokeWithMethodAndArg() {
            return new e(function (e, r) {
              invoke(t, n, e, r);
            });
          }
          return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(e, r, n) {
      var o = h;
      return function (i, a) {
        if (o === f) throw Error("Generator is already running");
        if (o === s) {
          if ("throw" === i) throw a;
          return {
            value: t,
            done: !0
          };
        }
        for (n.method = i, n.arg = a;;) {
          var c = n.delegate;
          if (c) {
            var u = maybeInvokeDelegate(c, n);
            if (u) {
              if (u === y) continue;
              return u;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
            if (o === h) throw o = s, n.arg;
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          o = f;
          var p = tryCatch(e, r, n);
          if ("normal" === p.type) {
            if (o = n.done ? s : l, p.arg === y) continue;
            return {
              value: p.arg,
              done: n.done
            };
          }
          "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
        }
      };
    }
    function maybeInvokeDelegate(e, r) {
      var n = r.method,
        o = e.iterator[n];
      if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
      var i = tryCatch(o, e.iterator, r.arg);
      if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
      var a = i.arg;
      return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
      if (e || "" === e) {
        var r = e[a];
        if (r) return r.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            i = function next() {
              for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
              return next.value = t, next.done = !0, next;
            };
          return i.next = i;
        }
      }
      throw new TypeError(_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function (t) {
      return {
        __await: t
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
      return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new AsyncIterator(wrap(t, r, n, o), i);
      return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
      return this;
    }), define(g, "toString", function () {
      return "[object Generator]";
    }), e.keys = function (t) {
      var e = Object(t),
        r = [];
      for (var n in e) r.push(n);
      return r.reverse(), function next() {
        for (; r.length;) {
          var t = r.pop();
          if (t in e) return next.value = t, next.done = !1, next;
        }
        return next.done = !0, next;
      };
    }, e.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var r = this;
        function handle(n, o) {
          return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
        }
        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var i = this.tryEntries[o],
            a = i.completion;
          if ("root" === i.tryLoc) return handle("end");
          if (i.tryLoc <= this.prev) {
            var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");
            if (c && u) {
              if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
              if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
            } else if (c) {
              if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            } else {
              if (!u) throw Error("try statement without catch or finally");
              if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, e) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];
          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }
        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
      },
      complete: function complete(t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
      },
      finish: function finish(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
        }
      },
      "catch": function _catch(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.tryLoc === t) {
            var n = r.completion;
            if ("throw" === n.type) {
              var o = n.arg;
              resetTryEntry(r);
            }
            return o;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, r, n) {
        return this.delegate = {
          iterator: values(e),
          resultName: r,
          nextLoc: n
        }, "next" === this.method && (this.arg = t), y;
      }
    }, e;
  }
  module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(regeneratorRuntime$1);

// TODO(Babel 8): Remove this file.

var runtime = regeneratorRuntime$1();
var regenerator = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject$1(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject(o) {
  var ctor,prot;

  if (isObject$1(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (ctor === undefined) return true;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObject$1(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}

function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if("production"!==process.env.NODE_ENV){var i=Y[n],o=i?"function"==typeof i?i.apply(null,t):i:"unknown error nr: "+n;throw Error("[Immer] "+o)}throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return "'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return !!n&&!!n[Q]}function t(n){var r;return !!n&&(function(n){if(!n||"object"!=typeof n)return !1;var r=Object.getPrototypeOf(n);if(null===r)return !0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n);})):n.forEach((function(t,e){return r(e,t,n)}));}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t;}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]});}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2);}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function _(){return "production"===process.env.NODE_ENV||U||n(0),U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r);}function g(n){O(n),n.p.forEach(S),n.p=null;}function O(n){n===U&&(U=n.l);}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0;}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s);}return e.o}function A(e,i,o,a,c,s,v){if("production"!==process.env.NODE_ENV&&c===o&&n(5),r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1;}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c);}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t);}function z(n,r){var t=n[Q];return (t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t);}}function k(n){n.P||(n.P=!0,n.l&&k(n.l));}function E(n){n.o||(n.o=l(n.t));}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return (t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1;}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t));})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return "Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return "Unsupported patch operation: "+n},18:function(n){return "The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return "'current' expects a draft, got: "+n},23:function(n){return "'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t);})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return !0;E(n),k(n);}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11);},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12);}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)};})),on.deleteProperty=function(r,t){return "production"!==process.env.NODE_ENV&&isNaN(parseInt(t))&&n(13),on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return "production"!==process.env.NODE_ENV&&"length"!==t&&isNaN(parseInt(t))&&n(14),en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return (t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1;}finally{v?g(c):O(c);}return "undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l);}return f}n(21,r);},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r;}));return "undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return [n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze);}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q];"production"!==process.env.NODE_ENV&&(e&&e.C||n(9),e.I&&n(10));var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n;},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r;},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce;an.produceWithPatches.bind(an);an.setAutoFreeze.bind(an);an.setUseProxies.bind(an);an.applyPatches.bind(an);var ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);

var _marked = /*#__PURE__*/regenerator.mark(levels),
  _marked2 = /*#__PURE__*/regenerator.mark(nodes),
  _marked3 = /*#__PURE__*/regenerator.mark(positions);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var PathRef = {
  transform: function transform(ref, op) {
    var current = ref.current,
      affinity = ref.affinity;
    if (current == null) {
      return;
    }
    var path = Path.transform(current, op, {
      affinity: affinity
    });
    ref.current = path;
    if (path == null) {
      ref.unref();
    }
  }
};
var PointRef = {
  transform: function transform(ref, op) {
    var current = ref.current,
      affinity = ref.affinity;
    if (current == null) {
      return;
    }
    var point = Point.transform(current, op, {
      affinity: affinity
    });
    ref.current = point;
    if (point == null) {
      ref.unref();
    }
  }
};
var RangeRef = {
  transform: function transform(ref, op) {
    var current = ref.current,
      affinity = ref.affinity;
    if (current == null) {
      return;
    }
    var path = Range.transform(current, op, {
      affinity: affinity
    });
    ref.current = path;
    if (path == null) {
      ref.unref();
    }
  }
};
var DIRTY_PATHS = new WeakMap();
var DIRTY_PATH_KEYS = new WeakMap();
var FLUSHING = new WeakMap();
var NORMALIZING = new WeakMap();
var PATH_REFS = new WeakMap();
var POINT_REFS = new WeakMap();
var RANGE_REFS = new WeakMap();

// eslint-disable-next-line no-redeclare
var Path = {
  ancestors: function ancestors(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$reverse = options.reverse,
      reverse = _options$reverse === void 0 ? false : _options$reverse;
    var paths = Path.levels(path, options);
    if (reverse) {
      paths = paths.slice(1);
    } else {
      paths = paths.slice(0, -1);
    }
    return paths;
  },
  common: function common(path, another) {
    var common = [];
    for (var i = 0; i < path.length && i < another.length; i++) {
      var av = path[i];
      var bv = another[i];
      if (av !== bv) {
        break;
      }
      common.push(av);
    }
    return common;
  },
  compare: function compare(path, another) {
    var min = Math.min(path.length, another.length);
    for (var i = 0; i < min; i++) {
      if (path[i] < another[i]) return -1;
      if (path[i] > another[i]) return 1;
    }
    return 0;
  },
  endsAfter: function endsAfter(path, another) {
    var i = path.length - 1;
    var as = path.slice(0, i);
    var bs = another.slice(0, i);
    var av = path[i];
    var bv = another[i];
    return Path.equals(as, bs) && av > bv;
  },
  endsAt: function endsAt(path, another) {
    var i = path.length;
    var as = path.slice(0, i);
    var bs = another.slice(0, i);
    return Path.equals(as, bs);
  },
  endsBefore: function endsBefore(path, another) {
    var i = path.length - 1;
    var as = path.slice(0, i);
    var bs = another.slice(0, i);
    var av = path[i];
    var bv = another[i];
    return Path.equals(as, bs) && av < bv;
  },
  equals: function equals(path, another) {
    return path.length === another.length && path.every(function (n, i) {
      return n === another[i];
    });
  },
  hasPrevious: function hasPrevious(path) {
    return path[path.length - 1] > 0;
  },
  isAfter: function isAfter(path, another) {
    return Path.compare(path, another) === 1;
  },
  isAncestor: function isAncestor(path, another) {
    return path.length < another.length && Path.compare(path, another) === 0;
  },
  isBefore: function isBefore(path, another) {
    return Path.compare(path, another) === -1;
  },
  isChild: function isChild(path, another) {
    return path.length === another.length + 1 && Path.compare(path, another) === 0;
  },
  isCommon: function isCommon(path, another) {
    return path.length <= another.length && Path.compare(path, another) === 0;
  },
  isDescendant: function isDescendant(path, another) {
    return path.length > another.length && Path.compare(path, another) === 0;
  },
  isParent: function isParent(path, another) {
    return path.length + 1 === another.length && Path.compare(path, another) === 0;
  },
  isPath: function isPath(value) {
    return Array.isArray(value) && (value.length === 0 || typeof value[0] === 'number');
  },
  isSibling: function isSibling(path, another) {
    if (path.length !== another.length) {
      return false;
    }
    var as = path.slice(0, -1);
    var bs = another.slice(0, -1);
    var al = path[path.length - 1];
    var bl = another[another.length - 1];
    return al !== bl && Path.equals(as, bs);
  },
  levels: function levels(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$reverse2 = options.reverse,
      reverse = _options$reverse2 === void 0 ? false : _options$reverse2;
    var list = [];
    for (var i = 0; i <= path.length; i++) {
      list.push(path.slice(0, i));
    }
    if (reverse) {
      list.reverse();
    }
    return list;
  },
  next: function next(path) {
    if (path.length === 0) {
      throw new Error("Cannot get the next path of a root path [".concat(path, "], because it has no next index."));
    }
    var last = path[path.length - 1];
    return path.slice(0, -1).concat(last + 1);
  },
  operationCanTransformPath: function operationCanTransformPath(operation) {
    switch (operation.type) {
      case 'insert_node':
      case 'remove_node':
      case 'merge_node':
      case 'split_node':
      case 'move_node':
        return true;
      default:
        return false;
    }
  },
  parent: function parent(path) {
    if (path.length === 0) {
      throw new Error("Cannot get the parent path of the root path [".concat(path, "]."));
    }
    return path.slice(0, -1);
  },
  previous: function previous(path) {
    if (path.length === 0) {
      throw new Error("Cannot get the previous path of a root path [".concat(path, "], because it has no previous index."));
    }
    var last = path[path.length - 1];
    if (last <= 0) {
      throw new Error("Cannot get the previous path of a first child path [".concat(path, "] because it would result in a negative index."));
    }
    return path.slice(0, -1).concat(last - 1);
  },
  relative: function relative(path, ancestor) {
    if (!Path.isAncestor(ancestor, path) && !Path.equals(path, ancestor)) {
      throw new Error("Cannot get the relative path of [".concat(path, "] inside ancestor [").concat(ancestor, "], because it is not above or equal to the path."));
    }
    return path.slice(ancestor.length);
  },
  transform: function transform(path, operation) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!path) return null; // PERF: use destructing instead of immer

    var p = _toConsumableArray(path);
    var _options$affinity = options.affinity,
      affinity = _options$affinity === void 0 ? 'forward' : _options$affinity; // PERF: Exit early if the operation is guaranteed not to have an effect.

    if (path.length === 0) {
      return p;
    }
    switch (operation.type) {
      case 'insert_node':
        {
          var op = operation.path;
          if (Path.equals(op, p) || Path.endsBefore(op, p) || Path.isAncestor(op, p)) {
            p[op.length - 1] += 1;
          }
          break;
        }
      case 'remove_node':
        {
          var _op = operation.path;
          if (Path.equals(_op, p) || Path.isAncestor(_op, p)) {
            return null;
          } else if (Path.endsBefore(_op, p)) {
            p[_op.length - 1] -= 1;
          }
          break;
        }
      case 'merge_node':
        {
          var _op2 = operation.path,
            position = operation.position;
          if (Path.equals(_op2, p) || Path.endsBefore(_op2, p)) {
            p[_op2.length - 1] -= 1;
          } else if (Path.isAncestor(_op2, p)) {
            p[_op2.length - 1] -= 1;
            p[_op2.length] += position;
          }
          break;
        }
      case 'split_node':
        {
          var _op3 = operation.path,
            _position = operation.position;
          if (Path.equals(_op3, p)) {
            if (affinity === 'forward') {
              p[p.length - 1] += 1;
            } else if (affinity === 'backward') ;else {
              return null;
            }
          } else if (Path.endsBefore(_op3, p)) {
            p[_op3.length - 1] += 1;
          } else if (Path.isAncestor(_op3, p) && path[_op3.length] >= _position) {
            p[_op3.length - 1] += 1;
            p[_op3.length] -= _position;
          }
          break;
        }
      case 'move_node':
        {
          var _op4 = operation.path,
            onp = operation.newPath; // If the old and new path are the same, it's a no-op.

          if (Path.equals(_op4, onp)) {
            return p;
          }
          if (Path.isAncestor(_op4, p) || Path.equals(_op4, p)) {
            var copy = onp.slice();
            if (Path.endsBefore(_op4, onp) && _op4.length < onp.length) {
              copy[_op4.length - 1] -= 1;
            }
            return copy.concat(p.slice(_op4.length));
          } else if (Path.isSibling(_op4, onp) && (Path.isAncestor(onp, p) || Path.equals(onp, p))) {
            if (Path.endsBefore(_op4, p)) {
              p[_op4.length - 1] -= 1;
            } else {
              p[_op4.length - 1] += 1;
            }
          } else if (Path.endsBefore(onp, p) || Path.equals(onp, p) || Path.isAncestor(onp, p)) {
            if (Path.endsBefore(_op4, p)) {
              p[_op4.length - 1] -= 1;
            }
            p[onp.length - 1] += 1;
          } else if (Path.endsBefore(_op4, p)) {
            if (Path.equals(onp, p)) {
              p[onp.length - 1] += 1;
            }
            p[_op4.length - 1] -= 1;
          }
          break;
        }
    }
    return p;
  }
};
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys$e(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$e(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$e(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$e(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var applyToDraft = function applyToDraft(editor, selection, op) {
  switch (op.type) {
    case 'insert_node':
      {
        var path = op.path,
          node = op.node;
        var parent = Node.parent(editor, path);
        var index = path[path.length - 1];
        if (index > parent.children.length) {
          throw new Error("Cannot apply an \"insert_node\" operation at path [".concat(path, "] because the destination is past the end of the node."));
        }
        parent.children.splice(index, 0, node);
        if (selection) {
          var _iterator = _createForOfIteratorHelper(Range.points(selection)),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _step$value = _slicedToArray(_step.value, 2),
                point = _step$value[0],
                key = _step$value[1];
              selection[key] = Point.transform(point, op);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        break;
      }
    case 'insert_text':
      {
        var _path = op.path,
          offset = op.offset,
          text = op.text;
        if (text.length === 0) break;
        var _node = Node.leaf(editor, _path);
        var before = _node.text.slice(0, offset);
        var after = _node.text.slice(offset);
        _node.text = before + text + after;
        if (selection) {
          var _iterator2 = _createForOfIteratorHelper(Range.points(selection)),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _step2$value = _slicedToArray(_step2.value, 2),
                _point = _step2$value[0],
                _key = _step2$value[1];
              selection[_key] = Point.transform(_point, op);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        break;
      }
    case 'merge_node':
      {
        var _path2 = op.path;
        var _node2 = Node.get(editor, _path2);
        var prevPath = Path.previous(_path2);
        var prev = Node.get(editor, prevPath);
        var _parent = Node.parent(editor, _path2);
        var _index = _path2[_path2.length - 1];
        if (Text.isText(_node2) && Text.isText(prev)) {
          prev.text += _node2.text;
        } else if (!Text.isText(_node2) && !Text.isText(prev)) {
          var _prev$children;
          (_prev$children = prev.children).push.apply(_prev$children, _toConsumableArray(_node2.children));
        } else {
          throw new Error("Cannot apply a \"merge_node\" operation at path [".concat(_path2, "] to nodes of different interfaces: ").concat(Scrubber.stringify(_node2), " ").concat(Scrubber.stringify(prev)));
        }
        _parent.children.splice(_index, 1);
        if (selection) {
          var _iterator3 = _createForOfIteratorHelper(Range.points(selection)),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _step3$value = _slicedToArray(_step3.value, 2),
                _point2 = _step3$value[0],
                _key2 = _step3$value[1];
              selection[_key2] = Point.transform(_point2, op);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
        break;
      }
    case 'move_node':
      {
        var _path3 = op.path,
          newPath = op.newPath;
        if (Path.isAncestor(_path3, newPath)) {
          throw new Error("Cannot move a path [".concat(_path3, "] to new path [").concat(newPath, "] because the destination is inside itself."));
        }
        var _node3 = Node.get(editor, _path3);
        var _parent2 = Node.parent(editor, _path3);
        var _index2 = _path3[_path3.length - 1]; // This is tricky, but since the `path` and `newPath` both refer to
        // the same snapshot in time, there's a mismatch. After either
        // removing the original position, the second step's path can be out
        // of date. So instead of using the `op.newPath` directly, we
        // transform `op.path` to ascertain what the `newPath` would be after
        // the operation was applied.

        _parent2.children.splice(_index2, 1);
        var truePath = Path.transform(_path3, op);
        var newParent = Node.get(editor, Path.parent(truePath));
        var newIndex = truePath[truePath.length - 1];
        newParent.children.splice(newIndex, 0, _node3);
        if (selection) {
          var _iterator4 = _createForOfIteratorHelper(Range.points(selection)),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _step4$value = _slicedToArray(_step4.value, 2),
                _point3 = _step4$value[0],
                _key3 = _step4$value[1];
              selection[_key3] = Point.transform(_point3, op);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
        break;
      }
    case 'remove_node':
      {
        var _path4 = op.path;
        var _index3 = _path4[_path4.length - 1];
        var _parent3 = Node.parent(editor, _path4);
        _parent3.children.splice(_index3, 1); // Transform all of the points in the value, but if the point was in the
        // node that was removed we need to update the range or remove it.

        if (selection) {
          var _iterator5 = _createForOfIteratorHelper(Range.points(selection)),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _step5$value = _slicedToArray(_step5.value, 2),
                _point4 = _step5$value[0],
                _key4 = _step5$value[1];
              var result = Point.transform(_point4, op);
              if (selection != null && result != null) {
                selection[_key4] = result;
              } else {
                var _prev = void 0;
                var next = void 0;
                var _iterator6 = _createForOfIteratorHelper(Node.texts(editor)),
                  _step6;
                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    var _step6$value = _slicedToArray(_step6.value, 2),
                      n = _step6$value[0],
                      p = _step6$value[1];
                    if (Path.compare(p, _path4) === -1) {
                      _prev = [n, p];
                    } else {
                      next = [n, p];
                      break;
                    }
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }
                var preferNext = false;
                if (_prev && next) {
                  if (Path.equals(next[1], _path4)) {
                    preferNext = !Path.hasPrevious(next[1]);
                  } else {
                    preferNext = Path.common(_prev[1], _path4).length < Path.common(next[1], _path4).length;
                  }
                }
                if (_prev && !preferNext) {
                  _point4.path = _prev[1];
                  _point4.offset = _prev[0].text.length;
                } else if (next) {
                  _point4.path = next[1];
                  _point4.offset = 0;
                } else {
                  selection = null;
                }
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
        break;
      }
    case 'remove_text':
      {
        var _path5 = op.path,
          _offset = op.offset,
          _text = op.text;
        if (_text.length === 0) break;
        var _node4 = Node.leaf(editor, _path5);
        var _before = _node4.text.slice(0, _offset);
        var _after = _node4.text.slice(_offset + _text.length);
        _node4.text = _before + _after;
        if (selection) {
          var _iterator7 = _createForOfIteratorHelper(Range.points(selection)),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _step7$value = _slicedToArray(_step7.value, 2),
                _point5 = _step7$value[0],
                _key5 = _step7$value[1];
              selection[_key5] = Point.transform(_point5, op);
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
        break;
      }
    case 'set_node':
      {
        var _path6 = op.path,
          properties = op.properties,
          newProperties = op.newProperties;
        if (_path6.length === 0) {
          throw new Error("Cannot set properties on the root node!");
        }
        var _node5 = Node.get(editor, _path6);
        for (var _key6 in newProperties) {
          if (_key6 === 'children' || _key6 === 'text') {
            throw new Error("Cannot set the \"".concat(_key6, "\" property of nodes!"));
          }
          var value = newProperties[_key6];
          if (value == null) {
            delete _node5[_key6];
          } else {
            _node5[_key6] = value;
          }
        } // properties that were previously defined, but are now missing, must be deleted

        for (var _key7 in properties) {
          if (!newProperties.hasOwnProperty(_key7)) {
            delete _node5[_key7];
          }
        }
        break;
      }
    case 'set_selection':
      {
        var _newProperties = op.newProperties;
        if (_newProperties == null) {
          selection = _newProperties;
        } else {
          if (selection == null) {
            if (!Range.isRange(_newProperties)) {
              throw new Error("Cannot apply an incomplete \"set_selection\" operation properties ".concat(Scrubber.stringify(_newProperties), " when there is no current selection."));
            }
            selection = _objectSpread$e({}, _newProperties);
          }
          for (var _key8 in _newProperties) {
            var _value = _newProperties[_key8];
            if (_value == null) {
              if (_key8 === 'anchor' || _key8 === 'focus') {
                throw new Error("Cannot remove the \"".concat(_key8, "\" selection property"));
              }
              delete selection[_key8];
            } else {
              selection[_key8] = _value;
            }
          }
        }
        break;
      }
    case 'split_node':
      {
        var _path7 = op.path,
          position = op.position,
          _properties = op.properties;
        if (_path7.length === 0) {
          throw new Error("Cannot apply a \"split_node\" operation at path [".concat(_path7, "] because the root node cannot be split."));
        }
        var _node6 = Node.get(editor, _path7);
        var _parent4 = Node.parent(editor, _path7);
        var _index4 = _path7[_path7.length - 1];
        var newNode;
        if (Text.isText(_node6)) {
          var _before2 = _node6.text.slice(0, position);
          var _after2 = _node6.text.slice(position);
          _node6.text = _before2;
          newNode = _objectSpread$e(_objectSpread$e({}, _properties), {}, {
            text: _after2
          });
        } else {
          var _before3 = _node6.children.slice(0, position);
          var _after3 = _node6.children.slice(position);
          _node6.children = _before3;
          newNode = _objectSpread$e(_objectSpread$e({}, _properties), {}, {
            children: _after3
          });
        }
        _parent4.children.splice(_index4 + 1, 0, newNode);
        if (selection) {
          var _iterator8 = _createForOfIteratorHelper(Range.points(selection)),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _step8$value = _slicedToArray(_step8.value, 2),
                _point6 = _step8$value[0],
                _key9 = _step8$value[1];
              selection[_key9] = Point.transform(_point6, op);
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        }
        break;
      }
  }
  return selection;
}; // eslint-disable-next-line no-redeclare

var GeneralTransforms = {
  transform: function transform(editor, op) {
    editor.children = ln(editor.children);
    var selection = editor.selection && ln(editor.selection);
    try {
      selection = applyToDraft(editor, selection, op);
    } finally {
      editor.children = dn(editor.children);
      if (selection) {
        editor.selection = r(selection) ? dn(selection) : selection;
      } else {
        editor.selection = null;
      }
    }
  }
};

// eslint-disable-next-line no-redeclare
var NodeTransforms = {
  insertNodes: function insertNodes(editor, nodes, options) {
    editor.insertNodes(nodes, options);
  },
  liftNodes: function liftNodes(editor, options) {
    editor.liftNodes(options);
  },
  mergeNodes: function mergeNodes(editor, options) {
    editor.mergeNodes(options);
  },
  moveNodes: function moveNodes(editor, options) {
    editor.moveNodes(options);
  },
  removeNodes: function removeNodes(editor, options) {
    editor.removeNodes(options);
  },
  setNodes: function setNodes(editor, props, options) {
    editor.setNodes(props, options);
  },
  splitNodes: function splitNodes(editor, options) {
    editor.splitNodes(options);
  },
  unsetNodes: function unsetNodes(editor, props, options) {
    editor.unsetNodes(props, options);
  },
  unwrapNodes: function unwrapNodes(editor, options) {
    editor.unwrapNodes(options);
  },
  wrapNodes: function wrapNodes(editor, element, options) {
    editor.wrapNodes(element, options);
  }
};

// eslint-disable-next-line no-redeclare
var SelectionTransforms = {
  collapse: function collapse(editor, options) {
    editor.collapse(options);
  },
  deselect: function deselect(editor) {
    editor.deselect();
  },
  move: function move(editor, options) {
    editor.move(options);
  },
  select: function select(editor, target) {
    editor.select(target);
  },
  setPoint: function setPoint(editor, props, options) {
    editor.setPoint(props, options);
  },
  setSelection: function setSelection(editor, props) {
    editor.setSelection(props);
  }
};

/*
  Custom deep equal comparison for Slate nodes.

  We don't need general purpose deep equality;
  Slate only supports plain values, Arrays, and nested objects.
  Complex values nested inside Arrays are not supported.

  Slate objects are designed to be serialised, so
  missing keys are deliberately normalised to undefined.
 */

var _isDeepEqual = function isDeepEqual(node, another) {
  for (var key in node) {
    var a = node[key];
    var b = another[key];
    if (isPlainObject(a) && isPlainObject(b)) {
      if (!_isDeepEqual(a, b)) return false;
    } else if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }
    } else if (a !== b) {
      return false;
    }
  }
  /*
    Deep object equality is only necessary in one direction; in the reverse direction
    we are only looking for keys that are missing.
    As above, undefined keys are normalised to missing.
  */

  for (var _key in another) {
    if (node[_key] === undefined && another[_key] !== undefined) {
      return false;
    }
  }
  return true;
};
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var _excluded$4 = ["anchor", "focus"];
function ownKeys$d(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$d(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$d(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$d(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Range = {
  edges: function edges(range) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$reverse3 = options.reverse,
      reverse = _options$reverse3 === void 0 ? false : _options$reverse3;
    var anchor = range.anchor,
      focus = range.focus;
    return Range.isBackward(range) === reverse ? [anchor, focus] : [focus, anchor];
  },
  end: function end(range) {
    var _Range$edges = Range.edges(range),
      _Range$edges2 = _slicedToArray(_Range$edges, 2),
      end = _Range$edges2[1];
    return end;
  },
  equals: function equals(range, another) {
    return Point.equals(range.anchor, another.anchor) && Point.equals(range.focus, another.focus);
  },
  includes: function includes(range, target) {
    if (Range.isRange(target)) {
      if (Range.includes(range, target.anchor) || Range.includes(range, target.focus)) {
        return true;
      }
      var _Range$edges3 = Range.edges(range),
        _Range$edges4 = _slicedToArray(_Range$edges3, 2),
        rs = _Range$edges4[0],
        re = _Range$edges4[1];
      var _Range$edges5 = Range.edges(target),
        _Range$edges6 = _slicedToArray(_Range$edges5, 2),
        ts = _Range$edges6[0],
        te = _Range$edges6[1];
      return Point.isBefore(rs, ts) && Point.isAfter(re, te);
    }
    var _Range$edges7 = Range.edges(range),
      _Range$edges8 = _slicedToArray(_Range$edges7, 2),
      start = _Range$edges8[0],
      end = _Range$edges8[1];
    var isAfterStart = false;
    var isBeforeEnd = false;
    if (Point.isPoint(target)) {
      isAfterStart = Point.compare(target, start) >= 0;
      isBeforeEnd = Point.compare(target, end) <= 0;
    } else {
      isAfterStart = Path.compare(target, start.path) >= 0;
      isBeforeEnd = Path.compare(target, end.path) <= 0;
    }
    return isAfterStart && isBeforeEnd;
  },
  intersection: function intersection(range, another) {
    var rest = _objectWithoutProperties(range, _excluded$4);
    var _Range$edges9 = Range.edges(range),
      _Range$edges10 = _slicedToArray(_Range$edges9, 2),
      s1 = _Range$edges10[0],
      e1 = _Range$edges10[1];
    var _Range$edges11 = Range.edges(another),
      _Range$edges12 = _slicedToArray(_Range$edges11, 2),
      s2 = _Range$edges12[0],
      e2 = _Range$edges12[1];
    var start = Point.isBefore(s1, s2) ? s2 : s1;
    var end = Point.isBefore(e1, e2) ? e1 : e2;
    if (Point.isBefore(end, start)) {
      return null;
    } else {
      return _objectSpread$d({
        anchor: start,
        focus: end
      }, rest);
    }
  },
  isBackward: function isBackward(range) {
    var anchor = range.anchor,
      focus = range.focus;
    return Point.isAfter(anchor, focus);
  },
  isCollapsed: function isCollapsed(range) {
    var anchor = range.anchor,
      focus = range.focus;
    return Point.equals(anchor, focus);
  },
  isExpanded: function isExpanded(range) {
    return !Range.isCollapsed(range);
  },
  isForward: function isForward(range) {
    return !Range.isBackward(range);
  },
  isRange: function isRange(value) {
    return isPlainObject(value) && Point.isPoint(value.anchor) && Point.isPoint(value.focus);
  },
  points: /*#__PURE__*/regenerator.mark(function points(range) {
    return regenerator.wrap(function points$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return [range.anchor, 'anchor'];
        case 2:
          _context.next = 4;
          return [range.focus, 'focus'];
        case 4:
        case "end":
          return _context.stop();
      }
    }, points);
  }),
  start: function start(range) {
    var _Range$edges13 = Range.edges(range),
      _Range$edges14 = _slicedToArray(_Range$edges13, 1),
      start = _Range$edges14[0];
    return start;
  },
  transform: function transform(range, op) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return fn(range, function (r) {
      if (r === null) {
        return null;
      }
      var _options$affinity2 = options.affinity,
        affinity = _options$affinity2 === void 0 ? 'inward' : _options$affinity2;
      var affinityAnchor;
      var affinityFocus;
      if (affinity === 'inward') {
        // If the range is collapsed, make sure to use the same affinity to
        // avoid the two points passing each other and expanding in the opposite
        // direction
        var isCollapsed = Range.isCollapsed(r);
        if (Range.isForward(r)) {
          affinityAnchor = 'forward';
          affinityFocus = isCollapsed ? affinityAnchor : 'backward';
        } else {
          affinityAnchor = 'backward';
          affinityFocus = isCollapsed ? affinityAnchor : 'forward';
        }
      } else if (affinity === 'outward') {
        if (Range.isForward(r)) {
          affinityAnchor = 'backward';
          affinityFocus = 'forward';
        } else {
          affinityAnchor = 'forward';
          affinityFocus = 'backward';
        }
      } else {
        affinityAnchor = affinity;
        affinityFocus = affinity;
      }
      var anchor = Point.transform(r.anchor, op, {
        affinity: affinityAnchor
      });
      var focus = Point.transform(r.focus, op, {
        affinity: affinityFocus
      });
      if (!anchor || !focus) {
        return null;
      }
      r.anchor = anchor;
      r.focus = focus;
    });
  }
};

/**
 * Shared the function with isElementType utility
 */

var isElement = function isElement(value) {
  return isPlainObject(value) && Node.isNodeList(value.children) && !Editor.isEditor(value);
}; // eslint-disable-next-line no-redeclare

var Element = {
  isAncestor: function isAncestor(value) {
    return isPlainObject(value) && Node.isNodeList(value.children);
  },
  isElement: isElement,
  isElementList: function isElementList(value) {
    return Array.isArray(value) && value.every(function (val) {
      return Element.isElement(val);
    });
  },
  isElementProps: function isElementProps(props) {
    return props.children !== undefined;
  },
  isElementType: function isElementType(value, elementVal) {
    var elementKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'type';
    return isElement(value) && value[elementKey] === elementVal;
  },
  matches: function matches(element, props) {
    for (var key in props) {
      if (key === 'children') {
        continue;
      }
      if (element[key] !== props[key]) {
        return false;
      }
    }
    return true;
  }
};
var _excluded$3 = ["children"],
  _excluded2$3 = ["text"];
var IS_NODE_LIST_CACHE = new WeakMap(); // eslint-disable-next-line no-redeclare

var Node = {
  ancestor: function ancestor(root, path) {
    var node = Node.get(root, path);
    if (Text.isText(node)) {
      throw new Error("Cannot get the ancestor node at path [".concat(path, "] because it refers to a text node instead: ").concat(Scrubber.stringify(node)));
    }
    return node;
  },
  ancestors: /*#__PURE__*/regenerator.mark(function ancestors(root, path) {
    var options,
      _iterator9,
      _step9,
      p,
      n,
      entry,
      _args2 = arguments;
    return regenerator.wrap(function ancestors$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          _iterator9 = _createForOfIteratorHelper(Path.ancestors(path, options));
          _context2.prev = 2;
          _iterator9.s();
        case 4:
          if ((_step9 = _iterator9.n()).done) {
            _context2.next = 12;
            break;
          }
          p = _step9.value;
          n = Node.ancestor(root, p);
          entry = [n, p];
          _context2.next = 10;
          return entry;
        case 10:
          _context2.next = 4;
          break;
        case 12:
          _context2.next = 17;
          break;
        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2["catch"](2);
          _iterator9.e(_context2.t0);
        case 17:
          _context2.prev = 17;
          _iterator9.f();
          return _context2.finish(17);
        case 20:
        case "end":
          return _context2.stop();
      }
    }, ancestors, null, [[2, 14, 17, 20]]);
  }),
  child: function child(root, index) {
    if (Text.isText(root)) {
      throw new Error("Cannot get the child of a text node: ".concat(Scrubber.stringify(root)));
    }
    var c = root.children[index];
    if (c == null) {
      throw new Error("Cannot get child at index `".concat(index, "` in node: ").concat(Scrubber.stringify(root)));
    }
    return c;
  },
  children: /*#__PURE__*/regenerator.mark(function children(root, path) {
    var options,
      _options$reverse4,
      reverse,
      ancestor,
      children,
      index,
      child,
      childPath,
      _args3 = arguments;
    return regenerator.wrap(function children$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          options = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
          _options$reverse4 = options.reverse, reverse = _options$reverse4 === void 0 ? false : _options$reverse4;
          ancestor = Node.ancestor(root, path);
          children = ancestor.children;
          index = reverse ? children.length - 1 : 0;
        case 5:
          if (!(reverse ? index >= 0 : index < children.length)) {
            _context3.next = 13;
            break;
          }
          child = Node.child(ancestor, index);
          childPath = path.concat(index);
          _context3.next = 10;
          return [child, childPath];
        case 10:
          index = reverse ? index - 1 : index + 1;
          _context3.next = 5;
          break;
        case 13:
        case "end":
          return _context3.stop();
      }
    }, children);
  }),
  common: function common(root, path, another) {
    var p = Path.common(path, another);
    var n = Node.get(root, p);
    return [n, p];
  },
  descendant: function descendant(root, path) {
    var node = Node.get(root, path);
    if (Editor.isEditor(node)) {
      throw new Error("Cannot get the descendant node at path [".concat(path, "] because it refers to the root editor node instead: ").concat(Scrubber.stringify(node)));
    }
    return node;
  },
  descendants: /*#__PURE__*/regenerator.mark(function descendants(root) {
    var options,
      _iterator10,
      _step10,
      _step10$value,
      node,
      path,
      _args4 = arguments;
    return regenerator.wrap(function descendants$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
          _iterator10 = _createForOfIteratorHelper(Node.nodes(root, options));
          _context4.prev = 2;
          _iterator10.s();
        case 4:
          if ((_step10 = _iterator10.n()).done) {
            _context4.next = 11;
            break;
          }
          _step10$value = _slicedToArray(_step10.value, 2), node = _step10$value[0], path = _step10$value[1];
          if (!(path.length !== 0)) {
            _context4.next = 9;
            break;
          }
          _context4.next = 9;
          return [node, path];
        case 9:
          _context4.next = 4;
          break;
        case 11:
          _context4.next = 16;
          break;
        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](2);
          _iterator10.e(_context4.t0);
        case 16:
          _context4.prev = 16;
          _iterator10.f();
          return _context4.finish(16);
        case 19:
        case "end":
          return _context4.stop();
      }
    }, descendants, null, [[2, 13, 16, 19]]);
  }),
  elements: /*#__PURE__*/regenerator.mark(function elements(root) {
    var options,
      _iterator11,
      _step11,
      _step11$value,
      node,
      path,
      _args5 = arguments;
    return regenerator.wrap(function elements$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
          _iterator11 = _createForOfIteratorHelper(Node.nodes(root, options));
          _context5.prev = 2;
          _iterator11.s();
        case 4:
          if ((_step11 = _iterator11.n()).done) {
            _context5.next = 11;
            break;
          }
          _step11$value = _slicedToArray(_step11.value, 2), node = _step11$value[0], path = _step11$value[1];
          if (!Element.isElement(node)) {
            _context5.next = 9;
            break;
          }
          _context5.next = 9;
          return [node, path];
        case 9:
          _context5.next = 4;
          break;
        case 11:
          _context5.next = 16;
          break;
        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](2);
          _iterator11.e(_context5.t0);
        case 16:
          _context5.prev = 16;
          _iterator11.f();
          return _context5.finish(16);
        case 19:
        case "end":
          return _context5.stop();
      }
    }, elements, null, [[2, 13, 16, 19]]);
  }),
  extractProps: function extractProps(node) {
    if (Element.isAncestor(node)) {
      var properties = _objectWithoutProperties(node, _excluded$3);
      return properties;
    } else {
      var properties = _objectWithoutProperties(node, _excluded2$3);
      return properties;
    }
  },
  first: function first(root, path) {
    var p = path.slice();
    var n = Node.get(root, p);
    while (n) {
      if (Text.isText(n) || n.children.length === 0) {
        break;
      } else {
        n = n.children[0];
        p.push(0);
      }
    }
    return [n, p];
  },
  fragment: function fragment(root, range) {
    if (Text.isText(root)) {
      throw new Error("Cannot get a fragment starting from a root text node: ".concat(Scrubber.stringify(root)));
    }
    var newRoot = fn({
      children: root.children
    }, function (r) {
      var _Range$edges15 = Range.edges(range),
        _Range$edges16 = _slicedToArray(_Range$edges15, 2),
        start = _Range$edges16[0],
        end = _Range$edges16[1];
      var nodeEntries = Node.nodes(r, {
        reverse: true,
        pass: function pass(_ref) {
          var _ref3 = _slicedToArray(_ref, 2),
            path = _ref3[1];
          return !Range.includes(range, path);
        }
      });
      var _iterator12 = _createForOfIteratorHelper(nodeEntries),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _step12$value = _slicedToArray(_step12.value, 2),
            path = _step12$value[1];
          if (!Range.includes(range, path)) {
            var parent = Node.parent(r, path);
            var index = path[path.length - 1];
            parent.children.splice(index, 1);
          }
          if (Path.equals(path, end.path)) {
            var leaf = Node.leaf(r, path);
            leaf.text = leaf.text.slice(0, end.offset);
          }
          if (Path.equals(path, start.path)) {
            var _leaf = Node.leaf(r, path);
            _leaf.text = _leaf.text.slice(start.offset);
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      if (Editor.isEditor(r)) {
        r.selection = null;
      }
    });
    return newRoot.children;
  },
  get: function get(root, path) {
    var node = root;
    for (var i = 0; i < path.length; i++) {
      var p = path[i];
      if (Text.isText(node) || !node.children[p]) {
        throw new Error("Cannot find a descendant at path [".concat(path, "] in node: ").concat(Scrubber.stringify(root)));
      }
      node = node.children[p];
    }
    return node;
  },
  has: function has(root, path) {
    var node = root;
    for (var i = 0; i < path.length; i++) {
      var p = path[i];
      if (Text.isText(node) || !node.children[p]) {
        return false;
      }
      node = node.children[p];
    }
    return true;
  },
  isNode: function isNode(value) {
    return Text.isText(value) || Element.isElement(value) || Editor.isEditor(value);
  },
  isNodeList: function isNodeList(value) {
    if (!Array.isArray(value)) {
      return false;
    }
    var cachedResult = IS_NODE_LIST_CACHE.get(value);
    if (cachedResult !== undefined) {
      return cachedResult;
    }
    var isNodeList = value.every(function (val) {
      return Node.isNode(val);
    });
    IS_NODE_LIST_CACHE.set(value, isNodeList);
    return isNodeList;
  },
  last: function last(root, path) {
    var p = path.slice();
    var n = Node.get(root, p);
    while (n) {
      if (Text.isText(n) || n.children.length === 0) {
        break;
      } else {
        var i = n.children.length - 1;
        n = n.children[i];
        p.push(i);
      }
    }
    return [n, p];
  },
  leaf: function leaf(root, path) {
    var node = Node.get(root, path);
    if (!Text.isText(node)) {
      throw new Error("Cannot get the leaf node at path [".concat(path, "] because it refers to a non-leaf node: ").concat(Scrubber.stringify(node)));
    }
    return node;
  },
  levels: /*#__PURE__*/regenerator.mark(function levels(root, path) {
    var options,
      _iterator13,
      _step13,
      p,
      n,
      _args6 = arguments;
    return regenerator.wrap(function levels$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          options = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
          _iterator13 = _createForOfIteratorHelper(Path.levels(path, options));
          _context6.prev = 2;
          _iterator13.s();
        case 4:
          if ((_step13 = _iterator13.n()).done) {
            _context6.next = 11;
            break;
          }
          p = _step13.value;
          n = Node.get(root, p);
          _context6.next = 9;
          return [n, p];
        case 9:
          _context6.next = 4;
          break;
        case 11:
          _context6.next = 16;
          break;
        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](2);
          _iterator13.e(_context6.t0);
        case 16:
          _context6.prev = 16;
          _iterator13.f();
          return _context6.finish(16);
        case 19:
        case "end":
          return _context6.stop();
      }
    }, levels, null, [[2, 13, 16, 19]]);
  }),
  matches: function matches(node, props) {
    return Element.isElement(node) && Element.isElementProps(props) && Element.matches(node, props) || Text.isText(node) && Text.isTextProps(props) && Text.matches(node, props);
  },
  nodes: /*#__PURE__*/regenerator.mark(function nodes(root) {
    var options,
      pass,
      _options$reverse5,
      reverse,
      _options$from,
      from,
      to,
      visited,
      p,
      n,
      nextIndex,
      newPath,
      _newPath,
      _args7 = arguments;
    return regenerator.wrap(function nodes$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          options = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
          pass = options.pass, _options$reverse5 = options.reverse, reverse = _options$reverse5 === void 0 ? false : _options$reverse5;
          _options$from = options.from, from = _options$from === void 0 ? [] : _options$from, to = options.to;
          visited = new Set();
          p = [];
          n = root;
        case 6:
          if (!(to && (reverse ? Path.isBefore(p, to) : Path.isAfter(p, to)))) {
            _context7.next = 9;
            break;
          }
          return _context7.abrupt("break", 37);
        case 9:
          if (visited.has(n)) {
            _context7.next = 12;
            break;
          }
          _context7.next = 12;
          return [n, p];
        case 12:
          if (!(!visited.has(n) && !Text.isText(n) && n.children.length !== 0 && (pass == null || pass([n, p]) === false))) {
            _context7.next = 19;
            break;
          }
          visited.add(n);
          nextIndex = reverse ? n.children.length - 1 : 0;
          if (Path.isAncestor(p, from)) {
            nextIndex = from[p.length];
          }
          p = p.concat(nextIndex);
          n = Node.get(root, p);
          return _context7.abrupt("continue", 6);
        case 19:
          if (!(p.length === 0)) {
            _context7.next = 21;
            break;
          }
          return _context7.abrupt("break", 37);
        case 21:
          if (reverse) {
            _context7.next = 27;
            break;
          }
          newPath = Path.next(p);
          if (!Node.has(root, newPath)) {
            _context7.next = 27;
            break;
          }
          p = newPath;
          n = Node.get(root, p);
          return _context7.abrupt("continue", 6);
        case 27:
          if (!(reverse && p[p.length - 1] !== 0)) {
            _context7.next = 32;
            break;
          }
          _newPath = Path.previous(p);
          p = _newPath;
          n = Node.get(root, p);
          return _context7.abrupt("continue", 6);
        case 32:
          // Otherwise we're going upward...

          p = Path.parent(p);
          n = Node.get(root, p);
          visited.add(n);
          _context7.next = 6;
          break;
        case 37:
        case "end":
          return _context7.stop();
      }
    }, nodes);
  }),
  parent: function parent(root, path) {
    var parentPath = Path.parent(path);
    var p = Node.get(root, parentPath);
    if (Text.isText(p)) {
      throw new Error("Cannot get the parent of path [".concat(path, "] because it does not exist in the root."));
    }
    return p;
  },
  string: function string(node) {
    if (Text.isText(node)) {
      return node.text;
    } else {
      return node.children.map(Node.string).join('');
    }
  },
  texts: /*#__PURE__*/regenerator.mark(function texts(root) {
    var options,
      _iterator14,
      _step14,
      _step14$value,
      node,
      path,
      _args8 = arguments;
    return regenerator.wrap(function texts$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          options = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
          _iterator14 = _createForOfIteratorHelper(Node.nodes(root, options));
          _context8.prev = 2;
          _iterator14.s();
        case 4:
          if ((_step14 = _iterator14.n()).done) {
            _context8.next = 11;
            break;
          }
          _step14$value = _slicedToArray(_step14.value, 2), node = _step14$value[0], path = _step14$value[1];
          if (!Text.isText(node)) {
            _context8.next = 9;
            break;
          }
          _context8.next = 9;
          return [node, path];
        case 9:
          _context8.next = 4;
          break;
        case 11:
          _context8.next = 16;
          break;
        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8["catch"](2);
          _iterator14.e(_context8.t0);
        case 16:
          _context8.prev = 16;
          _iterator14.f();
          return _context8.finish(16);
        case 19:
        case "end":
          return _context8.stop();
      }
    }, texts, null, [[2, 13, 16, 19]]);
  })
};
function ownKeys$c(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$c(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$c(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$c(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Operation = {
  isNodeOperation: function isNodeOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith('_node');
  },
  isOperation: function isOperation(value) {
    if (!isPlainObject(value)) {
      return false;
    }
    switch (value.type) {
      case 'insert_node':
        return Path.isPath(value.path) && Node.isNode(value.node);
      case 'insert_text':
        return typeof value.offset === 'number' && typeof value.text === 'string' && Path.isPath(value.path);
      case 'merge_node':
        return typeof value.position === 'number' && Path.isPath(value.path) && isPlainObject(value.properties);
      case 'move_node':
        return Path.isPath(value.path) && Path.isPath(value.newPath);
      case 'remove_node':
        return Path.isPath(value.path) && Node.isNode(value.node);
      case 'remove_text':
        return typeof value.offset === 'number' && typeof value.text === 'string' && Path.isPath(value.path);
      case 'set_node':
        return Path.isPath(value.path) && isPlainObject(value.properties) && isPlainObject(value.newProperties);
      case 'set_selection':
        return value.properties === null && Range.isRange(value.newProperties) || value.newProperties === null && Range.isRange(value.properties) || isPlainObject(value.properties) && isPlainObject(value.newProperties);
      case 'split_node':
        return Path.isPath(value.path) && typeof value.position === 'number' && isPlainObject(value.properties);
      default:
        return false;
    }
  },
  isOperationList: function isOperationList(value) {
    return Array.isArray(value) && value.every(function (val) {
      return Operation.isOperation(val);
    });
  },
  isSelectionOperation: function isSelectionOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith('_selection');
  },
  isTextOperation: function isTextOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith('_text');
  },
  inverse: function inverse(op) {
    switch (op.type) {
      case 'insert_node':
        {
          return _objectSpread$c(_objectSpread$c({}, op), {}, {
            type: 'remove_node'
          });
        }
      case 'insert_text':
        {
          return _objectSpread$c(_objectSpread$c({}, op), {}, {
            type: 'remove_text'
          });
        }
      case 'merge_node':
        {
          return _objectSpread$c(_objectSpread$c({}, op), {}, {
            type: 'split_node',
            path: Path.previous(op.path)
          });
        }
      case 'move_node':
        {
          var newPath = op.newPath,
            path = op.path; // PERF: in this case the move operation is a no-op anyways.

          if (Path.equals(newPath, path)) {
            return op;
          } // If the move happens completely within a single parent the path and
          // newPath are stable with respect to each other.

          if (Path.isSibling(path, newPath)) {
            return _objectSpread$c(_objectSpread$c({}, op), {}, {
              path: newPath,
              newPath: path
            });
          } // If the move does not happen within a single parent it is possible
          // for the move to impact the true path to the location where the node
          // was removed from and where it was inserted. We have to adjust for this
          // and find the original path. We can accomplish this (only in non-sibling)
          // moves by looking at the impact of the move operation on the node
          // after the original move path.

          var inversePath = Path.transform(path, op);
          var inverseNewPath = Path.transform(Path.next(path), op);
          return _objectSpread$c(_objectSpread$c({}, op), {}, {
            path: inversePath,
            newPath: inverseNewPath
          });
        }
      case 'remove_node':
        {
          return _objectSpread$c(_objectSpread$c({}, op), {}, {
            type: 'insert_node'
          });
        }
      case 'remove_text':
        {
          return _objectSpread$c(_objectSpread$c({}, op), {}, {
            type: 'insert_text'
          });
        }
      case 'set_node':
        {
          var properties = op.properties,
            newProperties = op.newProperties;
          return _objectSpread$c(_objectSpread$c({}, op), {}, {
            properties: newProperties,
            newProperties: properties
          });
        }
      case 'set_selection':
        {
          var _properties = op.properties,
            _newProperties = op.newProperties;
          if (_properties == null) {
            return _objectSpread$c(_objectSpread$c({}, op), {}, {
              properties: _newProperties,
              newProperties: null
            });
          } else if (_newProperties == null) {
            return _objectSpread$c(_objectSpread$c({}, op), {}, {
              properties: null,
              newProperties: _properties
            });
          } else {
            return _objectSpread$c(_objectSpread$c({}, op), {}, {
              properties: _newProperties,
              newProperties: _properties
            });
          }
        }
      case 'split_node':
        {
          return _objectSpread$c(_objectSpread$c({}, op), {}, {
            type: 'merge_node',
            path: Path.next(op.path)
          });
        }
    }
  }
};
var IS_EDITOR_CACHE = new WeakMap();
var _isEditor = function isEditor(value) {
  var cachedIsEditor = IS_EDITOR_CACHE.get(value);
  if (cachedIsEditor !== undefined) {
    return cachedIsEditor;
  }
  if (!isPlainObject(value)) {
    return false;
  }
  var isEditor = typeof value.addMark === 'function' && typeof value.apply === 'function' && typeof value.deleteFragment === 'function' && typeof value.insertBreak === 'function' && typeof value.insertSoftBreak === 'function' && typeof value.insertFragment === 'function' && typeof value.insertNode === 'function' && typeof value.insertText === 'function' && typeof value.isElementReadOnly === 'function' && typeof value.isInline === 'function' && typeof value.isSelectable === 'function' && typeof value.isVoid === 'function' && typeof value.normalizeNode === 'function' && typeof value.onChange === 'function' && typeof value.removeMark === 'function' && typeof value.getDirtyPaths === 'function' && (value.marks === null || isPlainObject(value.marks)) && (value.selection === null || Range.isRange(value.selection)) && Node.isNodeList(value.children) && Operation.isOperationList(value.operations);
  IS_EDITOR_CACHE.set(value, isEditor);
  return isEditor;
};
var Editor = {
  above: function above(editor, options) {
    return editor.above(options);
  },
  addMark: function addMark(editor, key, value) {
    editor.addMark(key, value);
  },
  after: function after(editor, at, options) {
    return editor.after(at, options);
  },
  before: function before(editor, at, options) {
    return editor.before(at, options);
  },
  deleteBackward: function deleteBackward(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$unit = options.unit,
      unit = _options$unit === void 0 ? 'character' : _options$unit;
    editor.deleteBackward(unit);
  },
  deleteForward: function deleteForward(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$unit2 = options.unit,
      unit = _options$unit2 === void 0 ? 'character' : _options$unit2;
    editor.deleteForward(unit);
  },
  deleteFragment: function deleteFragment(editor, options) {
    editor.deleteFragment(options);
  },
  edges: function edges(editor, at) {
    return editor.edges(at);
  },
  elementReadOnly: function elementReadOnly(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return editor.elementReadOnly(options);
  },
  end: function end(editor, at) {
    return editor.end(at);
  },
  first: function first(editor, at) {
    return editor.first(at);
  },
  fragment: function fragment(editor, at) {
    return editor.fragment(at);
  },
  hasBlocks: function hasBlocks(editor, element) {
    return editor.hasBlocks(element);
  },
  hasInlines: function hasInlines(editor, element) {
    return editor.hasInlines(element);
  },
  hasPath: function hasPath(editor, path) {
    return editor.hasPath(path);
  },
  hasTexts: function hasTexts(editor, element) {
    return editor.hasTexts(element);
  },
  insertBreak: function insertBreak(editor) {
    editor.insertBreak();
  },
  insertFragment: function insertFragment(editor, fragment, options) {
    editor.insertFragment(fragment, options);
  },
  insertNode: function insertNode(editor, node) {
    editor.insertNode(node);
  },
  insertSoftBreak: function insertSoftBreak(editor) {
    editor.insertSoftBreak();
  },
  insertText: function insertText(editor, text) {
    editor.insertText(text);
  },
  isBlock: function isBlock(editor, value) {
    return editor.isBlock(value);
  },
  isEdge: function isEdge(editor, point, at) {
    return editor.isEdge(point, at);
  },
  isEditor: function isEditor(value) {
    return _isEditor(value);
  },
  isElementReadOnly: function isElementReadOnly(editor, element) {
    return editor.isElementReadOnly(element);
  },
  isEmpty: function isEmpty(editor, element) {
    return editor.isEmpty(element);
  },
  isEnd: function isEnd(editor, point, at) {
    return editor.isEnd(point, at);
  },
  isInline: function isInline(editor, value) {
    return editor.isInline(value);
  },
  isNormalizing: function isNormalizing(editor) {
    return editor.isNormalizing();
  },
  isSelectable: function isSelectable(editor, value) {
    return editor.isSelectable(value);
  },
  isStart: function isStart(editor, point, at) {
    return editor.isStart(point, at);
  },
  isVoid: function isVoid(editor, value) {
    return editor.isVoid(value);
  },
  last: function last(editor, at) {
    return editor.last(at);
  },
  leaf: function leaf(editor, at, options) {
    return editor.leaf(at, options);
  },
  levels: function levels(editor, options) {
    return editor.levels(options);
  },
  marks: function marks(editor) {
    return editor.getMarks();
  },
  next: function next(editor, options) {
    return editor.next(options);
  },
  node: function node(editor, at, options) {
    return editor.node(at, options);
  },
  nodes: function nodes(editor, options) {
    return editor.nodes(options);
  },
  normalize: function normalize(editor, options) {
    editor.normalize(options);
  },
  parent: function parent(editor, at, options) {
    return editor.parent(at, options);
  },
  path: function path(editor, at, options) {
    return editor.path(at, options);
  },
  pathRef: function pathRef(editor, path, options) {
    return editor.pathRef(path, options);
  },
  pathRefs: function pathRefs(editor) {
    return editor.pathRefs();
  },
  point: function point(editor, at, options) {
    return editor.point(at, options);
  },
  pointRef: function pointRef(editor, point, options) {
    return editor.pointRef(point, options);
  },
  pointRefs: function pointRefs(editor) {
    return editor.pointRefs();
  },
  positions: function positions(editor, options) {
    return editor.positions(options);
  },
  previous: function previous(editor, options) {
    return editor.previous(options);
  },
  range: function range(editor, at, to) {
    return editor.range(at, to);
  },
  rangeRef: function rangeRef(editor, range, options) {
    return editor.rangeRef(range, options);
  },
  rangeRefs: function rangeRefs(editor) {
    return editor.rangeRefs();
  },
  removeMark: function removeMark(editor, key) {
    editor.removeMark(key);
  },
  setNormalizing: function setNormalizing(editor, isNormalizing) {
    editor.setNormalizing(isNormalizing);
  },
  start: function start(editor, at) {
    return editor.start(at);
  },
  string: function string(editor, at, options) {
    return editor.string(at, options);
  },
  unhangRange: function unhangRange(editor, range, options) {
    return editor.unhangRange(range, options);
  },
  "void": function _void(editor, options) {
    return editor["void"](options);
  },
  withoutNormalizing: function withoutNormalizing(editor, fn) {
    editor.withoutNormalizing(fn);
  }
};

var Span = {
  isSpan: function isSpan(value) {
    return Array.isArray(value) && value.length === 2 && value.every(Path.isPath);
  }
};
function ownKeys$b(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$b(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$b(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$b(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Point = {
  compare: function compare(point, another) {
    var result = Path.compare(point.path, another.path);
    if (result === 0) {
      if (point.offset < another.offset) return -1;
      if (point.offset > another.offset) return 1;
      return 0;
    }
    return result;
  },
  isAfter: function isAfter(point, another) {
    return Point.compare(point, another) === 1;
  },
  isBefore: function isBefore(point, another) {
    return Point.compare(point, another) === -1;
  },
  equals: function equals(point, another) {
    // PERF: ensure the offsets are equal first since they are cheaper to check.
    return point.offset === another.offset && Path.equals(point.path, another.path);
  },
  isPoint: function isPoint(value) {
    return isPlainObject(value) && typeof value.offset === 'number' && Path.isPath(value.path);
  },
  transform: function transform(point, op) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return fn(point, function (p) {
      if (p === null) {
        return null;
      }
      var _options$affinity3 = options.affinity,
        affinity = _options$affinity3 === void 0 ? 'forward' : _options$affinity3;
      var path = p.path,
        offset = p.offset;
      switch (op.type) {
        case 'insert_node':
        case 'move_node':
          {
            p.path = Path.transform(path, op, options);
            break;
          }
        case 'insert_text':
          {
            if (Path.equals(op.path, path) && (op.offset < offset || op.offset === offset && affinity === 'forward')) {
              p.offset += op.text.length;
            }
            break;
          }
        case 'merge_node':
          {
            if (Path.equals(op.path, path)) {
              p.offset += op.position;
            }
            p.path = Path.transform(path, op, options);
            break;
          }
        case 'remove_text':
          {
            if (Path.equals(op.path, path) && op.offset <= offset) {
              p.offset -= Math.min(offset - op.offset, op.text.length);
            }
            break;
          }
        case 'remove_node':
          {
            if (Path.equals(op.path, path) || Path.isAncestor(op.path, path)) {
              return null;
            }
            p.path = Path.transform(path, op, options);
            break;
          }
        case 'split_node':
          {
            if (Path.equals(op.path, path)) {
              if (op.position === offset && affinity == null) {
                return null;
              } else if (op.position < offset || op.position === offset && affinity === 'forward') {
                p.offset -= op.position;
                p.path = Path.transform(path, op, _objectSpread$b(_objectSpread$b({}, options), {}, {
                  affinity: 'forward'
                }));
              }
            } else {
              p.path = Path.transform(path, op, options);
            }
            break;
          }
      }
    });
  }
};
var _scrubber = undefined;
/**
 * This interface implements a stringify() function, which is used by Slate
 * internally when generating exceptions containing end user data. Developers
 * using Slate may call Scrubber.setScrubber() to alter the behavior of this
 * stringify() function.
 *
 * For example, to prevent the cleartext logging of 'text' fields within Nodes:
 *
 *    import { Scrubber } from 'slate';
 *    Scrubber.setScrubber((key, val) => {
 *      if (key === 'text') return '...scrubbed...'
 *      return val
 *    });
 *
 */
// eslint-disable-next-line no-redeclare

var Scrubber = {
  setScrubber: function setScrubber(scrubber) {
    _scrubber = scrubber;
  },
  stringify: function stringify(value) {
    return JSON.stringify(value, _scrubber);
  }
};
var _excluded$2 = ["text"],
  _excluded2$2 = ["anchor", "focus"];
function ownKeys$a(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$a(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$a(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$a(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Text = {
  equals: function equals(text, another) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$loose = options.loose,
      loose = _options$loose === void 0 ? false : _options$loose;
    function omitText(obj) {
      var rest = _objectWithoutProperties(obj, _excluded$2);
      return rest;
    }
    return _isDeepEqual(loose ? omitText(text) : text, loose ? omitText(another) : another);
  },
  isText: function isText(value) {
    return isPlainObject(value) && typeof value.text === 'string';
  },
  isTextList: function isTextList(value) {
    return Array.isArray(value) && value.every(function (val) {
      return Text.isText(val);
    });
  },
  isTextProps: function isTextProps(props) {
    return props.text !== undefined;
  },
  matches: function matches(text, props) {
    for (var key in props) {
      if (key === 'text') {
        continue;
      }
      if (!text.hasOwnProperty(key) || text[key] !== props[key]) {
        return false;
      }
    }
    return true;
  },
  decorations: function decorations(node, _decorations) {
    var leaves = [_objectSpread$a({}, node)];
    var _iterator15 = _createForOfIteratorHelper(_decorations),
      _step15;
    try {
      for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
        var dec = _step15.value;
        var rest = _objectWithoutProperties(dec, _excluded2$2);
        var _Range$edges17 = Range.edges(dec),
          _Range$edges18 = _slicedToArray(_Range$edges17, 2),
          start = _Range$edges18[0],
          end = _Range$edges18[1];
        var next = [];
        var leafEnd = 0;
        var decorationStart = start.offset;
        var decorationEnd = end.offset;
        var _iterator16 = _createForOfIteratorHelper(leaves),
          _step16;
        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var leaf = _step16.value;
            var length = leaf.text.length;
            var leafStart = leafEnd;
            leafEnd += length; // If the range encompasses the entire leaf, add the range.

            if (decorationStart <= leafStart && leafEnd <= decorationEnd) {
              Object.assign(leaf, rest);
              next.push(leaf);
              continue;
            } // If the range expanded and match the leaf, or starts after, or ends before it, continue.

            if (decorationStart !== decorationEnd && (decorationStart === leafEnd || decorationEnd === leafStart) || decorationStart > leafEnd || decorationEnd < leafStart || decorationEnd === leafStart && leafStart !== 0) {
              next.push(leaf);
              continue;
            } // Otherwise we need to split the leaf, at the start, end, or both,
            // and add the range to the middle intersecting section. Do the end
            // split first since we don't need to update the offset that way.

            var middle = leaf;
            var before = void 0;
            var after = void 0;
            if (decorationEnd < leafEnd) {
              var off = decorationEnd - leafStart;
              after = _objectSpread$a(_objectSpread$a({}, middle), {}, {
                text: middle.text.slice(off)
              });
              middle = _objectSpread$a(_objectSpread$a({}, middle), {}, {
                text: middle.text.slice(0, off)
              });
            }
            if (decorationStart > leafStart) {
              var _off = decorationStart - leafStart;
              before = _objectSpread$a(_objectSpread$a({}, middle), {}, {
                text: middle.text.slice(0, _off)
              });
              middle = _objectSpread$a(_objectSpread$a({}, middle), {}, {
                text: middle.text.slice(_off)
              });
            }
            Object.assign(middle, rest);
            if (before) {
              next.push(before);
            }
            next.push(middle);
            if (after) {
              next.push(after);
            }
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
        leaves = next;
      }
    } catch (err) {
      _iterator15.e(err);
    } finally {
      _iterator15.f();
    }
    return leaves;
  }
};

/**
 * Get the default location to insert content into the editor.
 * By default, use the selection as the target location. But if there is
 * no selection, insert at the end of the document since that is such a
 * common use case when inserting from a non-selected state.
 */

var getDefaultInsertLocation = function getDefaultInsertLocation(editor) {
  if (editor.selection) {
    return editor.selection;
  } else if (editor.children.length > 0) {
    return Editor.end(editor, []);
  } else {
    return [0];
  }
};
var matchPath = function matchPath(editor, path) {
  var _Editor$node = Editor.node(editor, path),
    _Editor$node2 = _slicedToArray(_Editor$node, 1),
    node = _Editor$node2[0];
  return function (n) {
    return n === node;
  };
};

// Character (grapheme cluster) boundaries are determined according to
// the default grapheme cluster boundary specification, extended grapheme clusters variant[1].
//
// References:
//
// [1] https://www.unicode.org/reports/tr29/#Default_Grapheme_Cluster_Table
// [2] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakProperty.txt
// [3] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.html
// [4] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.txt

/**
 * Get the distance to the end of the first character in a string of text.
 */
var getCharacterDistance = function getCharacterDistance(str) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isLTR = !isRTL;
  var codepoints = isRTL ? codepointsIteratorRTL(str) : str;
  var left = CodepointType.None;
  var right = CodepointType.None;
  var distance = 0; // Evaluation of these conditions are deferred.

  var gb11 = null; // Is GB11 applicable?

  var gb12Or13 = null; // Is GB12 or GB13 applicable?
  var _iterator17 = _createForOfIteratorHelper(codepoints),
    _step17;
  try {
    for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
      var _char = _step17.value;
      var code = _char.codePointAt(0);
      if (!code) break;
      var type = getCodepointType(_char, code);
      var _ref4 = isLTR ? [right, type] : [type, left];
      var _ref5 = _slicedToArray(_ref4, 2);
      left = _ref5[0];
      right = _ref5[1];
      if (intersects(left, CodepointType.ZWJ) && intersects(right, CodepointType.ExtPict)) {
        if (isLTR) {
          gb11 = endsWithEmojiZWJ(str.substring(0, distance));
        } else {
          gb11 = endsWithEmojiZWJ(str.substring(0, str.length - distance));
        }
        if (!gb11) break;
      }
      if (intersects(left, CodepointType.RI) && intersects(right, CodepointType.RI)) {
        if (gb12Or13 !== null) {
          gb12Or13 = !gb12Or13;
        } else {
          if (isLTR) {
            gb12Or13 = true;
          } else {
            gb12Or13 = endsWithOddNumberOfRIs(str.substring(0, str.length - distance));
          }
        }
        if (!gb12Or13) break;
      }
      if (left !== CodepointType.None && right !== CodepointType.None && isBoundaryPair(left, right)) {
        break;
      }
      distance += _char.length;
    }
  } catch (err) {
    _iterator17.e(err);
  } finally {
    _iterator17.f();
  }
  return distance || 1;
};
var SPACE = /\s/;
var PUNCTUATION = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
var CHAMELEON = /['\u2018\u2019]/;
/**
 * Get the distance to the end of the first word in a string of text.
 */

var getWordDistance = function getWordDistance(text) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var dist = 0;
  var started = false;
  while (text.length > 0) {
    var charDist = getCharacterDistance(text, isRTL);
    var _splitByCharacterDist = splitByCharacterDistance(text, charDist, isRTL),
      _splitByCharacterDist2 = _slicedToArray(_splitByCharacterDist, 2),
      _char2 = _splitByCharacterDist2[0],
      remaining = _splitByCharacterDist2[1];
    if (isWordCharacter(_char2, remaining, isRTL)) {
      started = true;
      dist += charDist;
    } else if (!started) {
      dist += charDist;
    } else {
      break;
    }
    text = remaining;
  }
  return dist;
};
/**
 * Split a string in two parts at a given distance starting from the end when
 * `isRTL` is set to `true`.
 */

var splitByCharacterDistance = function splitByCharacterDistance(str, dist, isRTL) {
  if (isRTL) {
    var at = str.length - dist;
    return [str.slice(at, str.length), str.slice(0, at)];
  }
  return [str.slice(0, dist), str.slice(dist)];
};
/**
 * Check if a character is a word character. The `remaining` argument is used
 * because sometimes you must read subsequent characters to truly determine it.
 */

var isWordCharacter = function isWordCharacter(_char3, remaining) {
  var isRTL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (SPACE.test(_char3)) {
    return false;
  } // Chameleons count as word characters as long as they're in a word, so
  // recurse to see if the next one is a word character or not.

  if (CHAMELEON.test(_char3)) {
    var charDist = getCharacterDistance(remaining, isRTL);
    var _splitByCharacterDist3 = splitByCharacterDistance(remaining, charDist, isRTL),
      _splitByCharacterDist4 = _slicedToArray(_splitByCharacterDist3, 2),
      nextChar = _splitByCharacterDist4[0],
      nextRemaining = _splitByCharacterDist4[1];
    if (isWordCharacter(nextChar, nextRemaining, isRTL)) {
      return true;
    }
  }
  if (PUNCTUATION.test(_char3)) {
    return false;
  }
  return true;
};
/**
 * Iterate on codepoints from right to left.
 */

var codepointsIteratorRTL = /*#__PURE__*/regenerator.mark(function codepointsIteratorRTL(str) {
  var end, i, char1, char2;
  return regenerator.wrap(function codepointsIteratorRTL$(_context9) {
    while (1) switch (_context9.prev = _context9.next) {
      case 0:
        end = str.length - 1;
        i = 0;
      case 2:
        if (!(i < str.length)) {
          _context9.next = 16;
          break;
        }
        char1 = str.charAt(end - i);
        if (!isLowSurrogate(char1.charCodeAt(0))) {
          _context9.next = 11;
          break;
        }
        char2 = str.charAt(end - i - 1);
        if (!isHighSurrogate(char2.charCodeAt(0))) {
          _context9.next = 11;
          break;
        }
        _context9.next = 9;
        return char2 + char1;
      case 9:
        i++;
        return _context9.abrupt("continue", 13);
      case 11:
        _context9.next = 13;
        return char1;
      case 13:
        i++;
        _context9.next = 2;
        break;
      case 16:
      case "end":
        return _context9.stop();
    }
  }, codepointsIteratorRTL);
});
/**
 * Is `charCode` a high surrogate.
 *
 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
 */

var isHighSurrogate = function isHighSurrogate(charCode) {
  return charCode >= 0xd800 && charCode <= 0xdbff;
};
/**
 * Is `charCode` a low surrogate.
 *
 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
 */

var isLowSurrogate = function isLowSurrogate(charCode) {
  return charCode >= 0xdc00 && charCode <= 0xdfff;
};
var CodepointType;
(function (CodepointType) {
  CodepointType[CodepointType["None"] = 0] = "None";
  CodepointType[CodepointType["Extend"] = 1] = "Extend";
  CodepointType[CodepointType["ZWJ"] = 2] = "ZWJ";
  CodepointType[CodepointType["RI"] = 4] = "RI";
  CodepointType[CodepointType["Prepend"] = 8] = "Prepend";
  CodepointType[CodepointType["SpacingMark"] = 16] = "SpacingMark";
  CodepointType[CodepointType["L"] = 32] = "L";
  CodepointType[CodepointType["V"] = 64] = "V";
  CodepointType[CodepointType["T"] = 128] = "T";
  CodepointType[CodepointType["LV"] = 256] = "LV";
  CodepointType[CodepointType["LVT"] = 512] = "LVT";
  CodepointType[CodepointType["ExtPict"] = 1024] = "ExtPict";
  CodepointType[CodepointType["Any"] = 2048] = "Any";
})(CodepointType || (CodepointType = {}));
var reExtend = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/;
var rePrepend = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/;
var reSpacingMark = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/;
var reL = /^[\u1100-\u115F\uA960-\uA97C]$/;
var reV = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/;
var reT = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/;
var reLV = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/;
var reLVT = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/;
var reExtPict = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/;
var getCodepointType = function getCodepointType(_char4, code) {
  var type = CodepointType.Any;
  if (_char4.search(reExtend) !== -1) {
    type |= CodepointType.Extend;
  }
  if (code === 0x200d) {
    type |= CodepointType.ZWJ;
  }
  if (code >= 0x1f1e6 && code <= 0x1f1ff) {
    type |= CodepointType.RI;
  }
  if (_char4.search(rePrepend) !== -1) {
    type |= CodepointType.Prepend;
  }
  if (_char4.search(reSpacingMark) !== -1) {
    type |= CodepointType.SpacingMark;
  }
  if (_char4.search(reL) !== -1) {
    type |= CodepointType.L;
  }
  if (_char4.search(reV) !== -1) {
    type |= CodepointType.V;
  }
  if (_char4.search(reT) !== -1) {
    type |= CodepointType.T;
  }
  if (_char4.search(reLV) !== -1) {
    type |= CodepointType.LV;
  }
  if (_char4.search(reLVT) !== -1) {
    type |= CodepointType.LVT;
  }
  if (_char4.search(reExtPict) !== -1) {
    type |= CodepointType.ExtPict;
  }
  return type;
};
function intersects(x, y) {
  return (x & y) !== 0;
}
var NonBoundaryPairs = [
// GB6
[CodepointType.L, CodepointType.L | CodepointType.V | CodepointType.LV | CodepointType.LVT],
// GB7
[CodepointType.LV | CodepointType.V, CodepointType.V | CodepointType.T],
// GB8
[CodepointType.LVT | CodepointType.T, CodepointType.T],
// GB9
[CodepointType.Any, CodepointType.Extend | CodepointType.ZWJ],
// GB9a
[CodepointType.Any, CodepointType.SpacingMark],
// GB9b
[CodepointType.Prepend, CodepointType.Any],
// GB11
[CodepointType.ZWJ, CodepointType.ExtPict],
// GB12 and GB13
[CodepointType.RI, CodepointType.RI]];
function isBoundaryPair(left, right) {
  return NonBoundaryPairs.findIndex(function (r) {
    return intersects(left, r[0]) && intersects(right, r[1]);
  }) === -1;
}
var endingEmojiZWJ = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/;
var endsWithEmojiZWJ = function endsWithEmojiZWJ(str) {
  return str.search(endingEmojiZWJ) !== -1;
};
var endingRIs = /(?:\uD83C[\uDDE6-\uDDFF])+$/g;
var endsWithOddNumberOfRIs = function endsWithOddNumberOfRIs(str) {
  var match = str.match(endingRIs);
  if (match === null) {
    return false;
  } else {
    // A RI is represented by a surrogate pair.
    var numRIs = match[0].length / 2;
    return numRIs % 2 === 1;
  }
};
var TextTransforms = {
  "delete": function _delete(editor, options) {
    editor["delete"](options);
  },
  insertFragment: function insertFragment(editor, fragment, options) {
    editor.insertFragment(fragment, options);
  },
  insertText: function insertText(editor, text) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor.withoutNormalizing(editor, function () {
      var _options$voids = options.voids,
        voids = _options$voids === void 0 ? false : _options$voids;
      var _options$at = options.at,
        at = _options$at === void 0 ? getDefaultInsertLocation(editor) : _options$at;
      if (Path.isPath(at)) {
        at = Editor.range(editor, at);
      }
      if (Range.isRange(at)) {
        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var end = Range.end(at);
          if (!voids && Editor["void"](editor, {
            at: end
          })) {
            return;
          }
          var start = Range.start(at);
          var startRef = Editor.pointRef(editor, start);
          var endRef = Editor.pointRef(editor, end);
          Transforms["delete"](editor, {
            at: at,
            voids: voids
          });
          var startPoint = startRef.unref();
          var endPoint = endRef.unref();
          at = startPoint || endPoint;
          Transforms.setSelection(editor, {
            anchor: at,
            focus: at
          });
        }
      }
      if (!voids && Editor["void"](editor, {
        at: at
      }) || Editor.elementReadOnly(editor, {
        at: at
      })) {
        return;
      }
      var _at = at,
        path = _at.path,
        offset = _at.offset;
      if (text.length > 0) editor.apply({
        type: 'insert_text',
        path: path,
        offset: offset,
        text: text
      });
    });
  }
};
function ownKeys$9(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$9(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$9(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Transforms = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, GeneralTransforms), NodeTransforms), SelectionTransforms), TextTransforms);
var apply = function apply(editor, op) {
  var _iterator18 = _createForOfIteratorHelper(Editor.pathRefs(editor)),
    _step18;
  try {
    for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
      var ref = _step18.value;
      PathRef.transform(ref, op);
    }
  } catch (err) {
    _iterator18.e(err);
  } finally {
    _iterator18.f();
  }
  var _iterator19 = _createForOfIteratorHelper(Editor.pointRefs(editor)),
    _step19;
  try {
    for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
      var _ref = _step19.value;
      PointRef.transform(_ref, op);
    }
  } catch (err) {
    _iterator19.e(err);
  } finally {
    _iterator19.f();
  }
  var _iterator20 = _createForOfIteratorHelper(Editor.rangeRefs(editor)),
    _step20;
  try {
    for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
      var _ref2 = _step20.value;
      RangeRef.transform(_ref2, op);
    }
  } catch (err) {
    _iterator20.e(err);
  } finally {
    _iterator20.f();
  }
  var oldDirtyPaths = DIRTY_PATHS.get(editor) || [];
  var oldDirtyPathKeys = DIRTY_PATH_KEYS.get(editor) || new Set();
  var dirtyPaths;
  var dirtyPathKeys;
  var add = function add(path) {
    if (path) {
      var key = path.join(',');
      if (!dirtyPathKeys.has(key)) {
        dirtyPathKeys.add(key);
        dirtyPaths.push(path);
      }
    }
  };
  if (Path.operationCanTransformPath(op)) {
    dirtyPaths = [];
    dirtyPathKeys = new Set();
    var _iterator21 = _createForOfIteratorHelper(oldDirtyPaths),
      _step21;
    try {
      for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
        var path = _step21.value;
        var newPath = Path.transform(path, op);
        add(newPath);
      }
    } catch (err) {
      _iterator21.e(err);
    } finally {
      _iterator21.f();
    }
  } else {
    dirtyPaths = oldDirtyPaths;
    dirtyPathKeys = oldDirtyPathKeys;
  }
  var newDirtyPaths = editor.getDirtyPaths(op);
  var _iterator22 = _createForOfIteratorHelper(newDirtyPaths),
    _step22;
  try {
    for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
      var _path = _step22.value;
      add(_path);
    }
  } catch (err) {
    _iterator22.e(err);
  } finally {
    _iterator22.f();
  }
  DIRTY_PATHS.set(editor, dirtyPaths);
  DIRTY_PATH_KEYS.set(editor, dirtyPathKeys);
  Transforms.transform(editor, op);
  editor.operations.push(op);
  Editor.normalize(editor, {
    operation: op
  }); // Clear any formats applied to the cursor if the selection changes.

  if (op.type === 'set_selection') {
    editor.marks = null;
  }
  if (!FLUSHING.get(editor)) {
    FLUSHING.set(editor, true);
    Promise.resolve().then(function () {
      FLUSHING.set(editor, false);
      editor.onChange({
        operation: op
      });
      editor.operations = [];
    });
  }
};

/**
 * Get the "dirty" paths generated from an operation.
 */

var getDirtyPaths = function getDirtyPaths(editor, op) {
  switch (op.type) {
    case 'insert_text':
    case 'remove_text':
    case 'set_node':
      {
        var path = op.path;
        return Path.levels(path);
      }
    case 'insert_node':
      {
        var node = op.node,
          _path = op.path;
        var levels = Path.levels(_path);
        var descendants = Text.isText(node) ? [] : Array.from(Node.nodes(node), function (_ref) {
          var _ref6 = _slicedToArray(_ref, 2),
            p = _ref6[1];
          return _path.concat(p);
        });
        return [].concat(_toConsumableArray(levels), _toConsumableArray(descendants));
      }
    case 'merge_node':
      {
        var _path2 = op.path;
        var ancestors = Path.ancestors(_path2);
        var previousPath = Path.previous(_path2);
        return [].concat(_toConsumableArray(ancestors), [previousPath]);
      }
    case 'move_node':
      {
        var _path3 = op.path,
          newPath = op.newPath;
        if (Path.equals(_path3, newPath)) {
          return [];
        }
        var oldAncestors = [];
        var newAncestors = [];
        var _iterator23 = _createForOfIteratorHelper(Path.ancestors(_path3)),
          _step23;
        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var ancestor = _step23.value;
            var p = Path.transform(ancestor, op);
            oldAncestors.push(p);
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
        var _iterator24 = _createForOfIteratorHelper(Path.ancestors(newPath)),
          _step24;
        try {
          for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
            var _ancestor = _step24.value;
            var _p = Path.transform(_ancestor, op);
            newAncestors.push(_p);
          }
        } catch (err) {
          _iterator24.e(err);
        } finally {
          _iterator24.f();
        }
        var newParent = newAncestors[newAncestors.length - 1];
        var newIndex = newPath[newPath.length - 1];
        var resultPath = newParent.concat(newIndex);
        return [].concat(oldAncestors, newAncestors, [resultPath]);
      }
    case 'remove_node':
      {
        var _path4 = op.path;
        var _ancestors = Path.ancestors(_path4);
        return _toConsumableArray(_ancestors);
      }
    case 'split_node':
      {
        var _path5 = op.path;
        var _levels = Path.levels(_path5);
        var nextPath = Path.next(_path5);
        return [].concat(_toConsumableArray(_levels), [nextPath]);
      }
    default:
      {
        return [];
      }
  }
};
var getFragment = function getFragment(editor) {
  var selection = editor.selection;
  if (selection) {
    return Node.fragment(editor, selection);
  }
  return [];
};
var normalizeNode = function normalizeNode(editor, entry) {
  var _entry2 = _slicedToArray(entry, 2),
    node = _entry2[0],
    path = _entry2[1]; // There are no core normalizations for text nodes.

  if (Text.isText(node)) {
    return;
  } // Ensure that block and inline nodes have at least one text child.

  if (Element.isElement(node) && node.children.length === 0) {
    var child = {
      text: ''
    };
    Transforms.insertNodes(editor, child, {
      at: path.concat(0),
      voids: true
    });
    return;
  } // Determine whether the node should have block or inline children.

  var shouldHaveInlines = Editor.isEditor(node) ? false : Element.isElement(node) && (editor.isInline(node) || node.children.length === 0 || Text.isText(node.children[0]) || editor.isInline(node.children[0])); // Since we'll be applying operations while iterating, keep track of an
  // index that accounts for any added/removed nodes.

  var n = 0;
  for (var i = 0; i < node.children.length; i++, n++) {
    var currentNode = Node.get(editor, path);
    if (Text.isText(currentNode)) continue;
    var _child = currentNode.children[n];
    var prev = currentNode.children[n - 1];
    var isLast = i === node.children.length - 1;
    var isInlineOrText = Text.isText(_child) || Element.isElement(_child) && editor.isInline(_child); // Only allow block nodes in the top-level children and parent blocks
    // that only contain block nodes. Similarly, only allow inline nodes in
    // other inline nodes, or parent blocks that only contain inlines and
    // text.

    if (isInlineOrText !== shouldHaveInlines) {
      Transforms.removeNodes(editor, {
        at: path.concat(n),
        voids: true
      });
      n--;
    } else if (Element.isElement(_child)) {
      // Ensure that inline nodes are surrounded by text nodes.
      if (editor.isInline(_child)) {
        if (prev == null || !Text.isText(prev)) {
          var newChild = {
            text: ''
          };
          Transforms.insertNodes(editor, newChild, {
            at: path.concat(n),
            voids: true
          });
          n++;
        } else if (isLast) {
          var _newChild = {
            text: ''
          };
          Transforms.insertNodes(editor, _newChild, {
            at: path.concat(n + 1),
            voids: true
          });
          n++;
        }
      }
    } else {
      // Merge adjacent text nodes that are empty or match.
      if (prev != null && Text.isText(prev)) {
        if (Text.equals(_child, prev, {
          loose: true
        })) {
          Transforms.mergeNodes(editor, {
            at: path.concat(n),
            voids: true
          });
          n--;
        } else if (prev.text === '') {
          Transforms.removeNodes(editor, {
            at: path.concat(n - 1),
            voids: true
          });
          n--;
        } else if (_child.text === '') {
          Transforms.removeNodes(editor, {
            at: path.concat(n),
            voids: true
          });
          n--;
        }
      }
    }
  }
};
var shouldNormalize = function shouldNormalize(editor, _ref) {
  var iteration = _ref.iteration,
    initialDirtyPathsLength = _ref.initialDirtyPathsLength;
  var maxIterations = initialDirtyPathsLength * 42; // HACK: better way?

  if (iteration > maxIterations) {
    throw new Error("Could not completely normalize the editor after ".concat(maxIterations, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state."));
  }
  return true;
};
var above = function above(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$voids2 = options.voids,
    voids = _options$voids2 === void 0 ? false : _options$voids2,
    _options$mode = options.mode,
    mode = _options$mode === void 0 ? 'lowest' : _options$mode,
    _options$at2 = options.at,
    at = _options$at2 === void 0 ? editor.selection : _options$at2,
    match = options.match;
  if (!at) {
    return;
  }
  var path = Editor.path(editor, at);
  var reverse = mode === 'lowest';
  var _iterator25 = _createForOfIteratorHelper(Editor.levels(editor, {
      at: path,
      voids: voids,
      match: match,
      reverse: reverse
    })),
    _step25;
  try {
    for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
      var _step25$value = _slicedToArray(_step25.value, 2),
        n = _step25$value[0],
        p = _step25$value[1];
      if (Text.isText(n)) continue;
      if (Range.isRange(at)) {
        if (Path.isAncestor(p, at.anchor.path) && Path.isAncestor(p, at.focus.path)) {
          return [n, p];
        }
      } else {
        if (!Path.equals(path, p)) {
          return [n, p];
        }
      }
    }
  } catch (err) {
    _iterator25.e(err);
  } finally {
    _iterator25.f();
  }
};
function ownKeys$8(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$8(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$8(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var addMark = function addMark(editor, key, value) {
  var selection = editor.selection;
  if (selection) {
    var match = function match(node, path) {
      if (!Text.isText(node)) {
        return false; // marks can only be applied to text
      }
      var _Editor$parent = Editor.parent(editor, path),
        _Editor$parent2 = _slicedToArray(_Editor$parent, 2),
        parentNode = _Editor$parent2[0];
        _Editor$parent2[1];
      return !editor.isVoid(parentNode) || editor.markableVoid(parentNode);
    };
    var expandedSelection = Range.isExpanded(selection);
    var markAcceptingVoidSelected = false;
    if (!expandedSelection) {
      var _Editor$node3 = Editor.node(editor, selection),
        _Editor$node4 = _slicedToArray(_Editor$node3, 2),
        selectedNode = _Editor$node4[0],
        selectedPath = _Editor$node4[1];
      if (selectedNode && match(selectedNode, selectedPath)) {
        var _Editor$parent3 = Editor.parent(editor, selectedPath),
          _Editor$parent4 = _slicedToArray(_Editor$parent3, 1),
          parentNode = _Editor$parent4[0];
        markAcceptingVoidSelected = parentNode && editor.markableVoid(parentNode);
      }
    }
    if (expandedSelection || markAcceptingVoidSelected) {
      Transforms.setNodes(editor, _defineProperty$1({}, key, value), {
        match: match,
        split: true,
        voids: true
      });
    } else {
      var marks = _objectSpread$8(_objectSpread$8({}, Editor.marks(editor) || {}), {}, _defineProperty$1({}, key, value));
      editor.marks = marks;
      if (!FLUSHING.get(editor)) {
        editor.onChange();
      }
    }
  }
};
function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$7(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$7(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var after = function after(editor, at) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var anchor = Editor.point(editor, at, {
    edge: 'end'
  });
  var focus = Editor.end(editor, []);
  var range = {
    anchor: anchor,
    focus: focus
  };
  var _options$distance = options.distance,
    distance = _options$distance === void 0 ? 1 : _options$distance;
  var d = 0;
  var target;
  var _iterator26 = _createForOfIteratorHelper(Editor.positions(editor, _objectSpread$7(_objectSpread$7({}, options), {}, {
      at: range
    }))),
    _step26;
  try {
    for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
      var p = _step26.value;
      if (d > distance) {
        break;
      }
      if (d !== 0) {
        target = p;
      }
      d++;
    }
  } catch (err) {
    _iterator26.e(err);
  } finally {
    _iterator26.f();
  }
  return target;
};
function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$6(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$6(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var before = function before(editor, at) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var anchor = Editor.start(editor, []);
  var focus = Editor.point(editor, at, {
    edge: 'start'
  });
  var range = {
    anchor: anchor,
    focus: focus
  };
  var _options$distance2 = options.distance,
    distance = _options$distance2 === void 0 ? 1 : _options$distance2;
  var d = 0;
  var target;
  var _iterator27 = _createForOfIteratorHelper(Editor.positions(editor, _objectSpread$6(_objectSpread$6({}, options), {}, {
      at: range,
      reverse: true
    }))),
    _step27;
  try {
    for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
      var p = _step27.value;
      if (d > distance) {
        break;
      }
      if (d !== 0) {
        target = p;
      }
      d++;
    }
  } catch (err) {
    _iterator27.e(err);
  } finally {
    _iterator27.f();
  }
  return target;
};
var deleteBackward = function deleteBackward(editor, unit) {
  var selection = editor.selection;
  if (selection && Range.isCollapsed(selection)) {
    Transforms["delete"](editor, {
      unit: unit,
      reverse: true
    });
  }
};
var deleteForward = function deleteForward(editor, unit) {
  var selection = editor.selection;
  if (selection && Range.isCollapsed(selection)) {
    Transforms["delete"](editor, {
      unit: unit
    });
  }
};
var deleteFragment = function deleteFragment(editor) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref7$direction = _ref7.direction,
    direction = _ref7$direction === void 0 ? 'forward' : _ref7$direction;
  var selection = editor.selection;
  if (selection && Range.isExpanded(selection)) {
    Transforms["delete"](editor, {
      reverse: direction === 'backward'
    });
  }
};
var edges = function edges(editor, at) {
  return [Editor.start(editor, at), Editor.end(editor, at)];
};
function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var elementReadOnly = function elementReadOnly(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Editor.above(editor, _objectSpread$5(_objectSpread$5({}, options), {}, {
    match: function match(n) {
      return Element.isElement(n) && Editor.isElementReadOnly(editor, n);
    }
  }));
};
var end = function end(editor, at) {
  return Editor.point(editor, at, {
    edge: 'end'
  });
};
var first = function first(editor, at) {
  var path = Editor.path(editor, at, {
    edge: 'start'
  });
  return Editor.node(editor, path);
};
var fragment = function fragment(editor, at) {
  var range = Editor.range(editor, at);
  return Node.fragment(editor, range);
};
function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var getVoid = function getVoid(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Editor.above(editor, _objectSpread$4(_objectSpread$4({}, options), {}, {
    match: function match(n) {
      return Element.isElement(n) && Editor.isVoid(editor, n);
    }
  }));
};
var hasBlocks = function hasBlocks(editor, element) {
  return element.children.some(function (n) {
    return Element.isElement(n) && Editor.isBlock(editor, n);
  });
};
var hasInlines = function hasInlines(editor, element) {
  return element.children.some(function (n) {
    return Text.isText(n) || Editor.isInline(editor, n);
  });
};
var hasPath = function hasPath(editor, path) {
  return Node.has(editor, path);
};
var hasTexts = function hasTexts(editor, element) {
  return element.children.every(function (n) {
    return Text.isText(n);
  });
};
var insertBreak = function insertBreak(editor) {
  Transforms.splitNodes(editor, {
    always: true
  });
};
var insertNode = function insertNode(editor, node, options) {
  Transforms.insertNodes(editor, node, options);
};
var insertSoftBreak = function insertSoftBreak(editor) {
  Transforms.splitNodes(editor, {
    always: true
  });
};
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var insertText = function insertText(editor, text) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var selection = editor.selection,
    marks = editor.marks;
  if (selection) {
    if (marks) {
      var node = _objectSpread$3({
        text: text
      }, marks);
      Transforms.insertNodes(editor, node, {
        at: options.at,
        voids: options.voids
      });
    } else {
      Transforms.insertText(editor, text, options);
    }
    editor.marks = null;
  }
};
var isBlock = function isBlock(editor, value) {
  return !editor.isInline(value);
};
var isEdge = function isEdge(editor, point, at) {
  return Editor.isStart(editor, point, at) || Editor.isEnd(editor, point, at);
};
var isEmpty = function isEmpty(editor, element) {
  var children = element.children;
  var _children = _slicedToArray(children, 1),
    first = _children[0];
  return children.length === 0 || children.length === 1 && Text.isText(first) && first.text === '' && !editor.isVoid(element);
};
var isEnd = function isEnd(editor, point, at) {
  var end = Editor.end(editor, at);
  return Point.equals(point, end);
};
var isNormalizing = function isNormalizing(editor) {
  var isNormalizing = NORMALIZING.get(editor);
  return isNormalizing === undefined ? true : isNormalizing;
};
var isStart = function isStart(editor, point, at) {
  // PERF: If the offset isn't `0` we know it's not the start.
  if (point.offset !== 0) {
    return false;
  }
  var start = Editor.start(editor, at);
  return Point.equals(point, start);
};
var last = function last(editor, at) {
  var path = Editor.path(editor, at, {
    edge: 'end'
  });
  return Editor.node(editor, path);
};
var leaf = function leaf(editor, at) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var path = Editor.path(editor, at, options);
  var node = Node.leaf(editor, path);
  return [node, path];
};
function levels(editor) {
  var options,
    _options$at3,
    at,
    _options$reverse6,
    reverse,
    _options$voids3,
    voids,
    match,
    levels,
    path,
    _iterator28,
    _step28,
    _step28$value,
    n,
    p,
    _args10 = arguments;
  return regenerator.wrap(function levels$(_context10) {
    while (1) switch (_context10.prev = _context10.next) {
      case 0:
        options = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
        _options$at3 = options.at, at = _options$at3 === void 0 ? editor.selection : _options$at3, _options$reverse6 = options.reverse, reverse = _options$reverse6 === void 0 ? false : _options$reverse6, _options$voids3 = options.voids, voids = _options$voids3 === void 0 ? false : _options$voids3;
        match = options.match;
        if (match == null) {
          match = function match() {
            return true;
          };
        }
        if (at) {
          _context10.next = 6;
          break;
        }
        return _context10.abrupt("return");
      case 6:
        levels = [];
        path = Editor.path(editor, at);
        _iterator28 = _createForOfIteratorHelper(Node.levels(editor, path));
        _context10.prev = 9;
        _iterator28.s();
      case 11:
        if ((_step28 = _iterator28.n()).done) {
          _context10.next = 20;
          break;
        }
        _step28$value = _slicedToArray(_step28.value, 2), n = _step28$value[0], p = _step28$value[1];
        if (match(n, p)) {
          _context10.next = 15;
          break;
        }
        return _context10.abrupt("continue", 18);
      case 15:
        levels.push([n, p]);
        if (!(!voids && Element.isElement(n) && Editor.isVoid(editor, n))) {
          _context10.next = 18;
          break;
        }
        return _context10.abrupt("break", 20);
      case 18:
        _context10.next = 11;
        break;
      case 20:
        _context10.next = 25;
        break;
      case 22:
        _context10.prev = 22;
        _context10.t0 = _context10["catch"](9);
        _iterator28.e(_context10.t0);
      case 25:
        _context10.prev = 25;
        _iterator28.f();
        return _context10.finish(25);
      case 28:
        if (reverse) {
          levels.reverse();
        }
        return _context10.delegateYield(levels, "t1", 30);
      case 30:
      case "end":
        return _context10.stop();
    }
  }, _marked, null, [[9, 22, 25, 28]]);
}
var _excluded$1 = ["text"],
  _excluded2$1 = ["text"];
var marks = function marks(editor) {
  var marks = editor.marks,
    selection = editor.selection;
  if (!selection) {
    return null;
  }
  if (marks) {
    return marks;
  }
  if (Range.isExpanded(selection)) {
    var _Editor$nodes = Editor.nodes(editor, {
        match: Text.isText
      }),
      _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
      match = _Editor$nodes2[0];
    if (match) {
      var _match = _slicedToArray(match, 1),
        _node = _match[0];
      var _rest = _objectWithoutProperties(_node, _excluded$1);
      return _rest;
    } else {
      return {};
    }
  }
  var anchor = selection.anchor;
  var path = anchor.path;
  var _Editor$leaf = Editor.leaf(editor, path),
    _Editor$leaf2 = _slicedToArray(_Editor$leaf, 1),
    node = _Editor$leaf2[0];
  if (anchor.offset === 0) {
    var prev = Editor.previous(editor, {
      at: path,
      match: Text.isText
    });
    var markedVoid = Editor.above(editor, {
      match: function match(n) {
        return Element.isElement(n) && Editor.isVoid(editor, n) && editor.markableVoid(n);
      }
    });
    if (!markedVoid) {
      var block = Editor.above(editor, {
        match: function match(n) {
          return Element.isElement(n) && Editor.isBlock(editor, n);
        }
      });
      if (prev && block) {
        var _prev2 = _slicedToArray(prev, 2),
          prevNode = _prev2[0],
          prevPath = _prev2[1];
        var _block = _slicedToArray(block, 2),
          blockPath = _block[1];
        if (Path.isAncestor(blockPath, prevPath)) {
          node = prevNode;
        }
      }
    }
  }
  var rest = _objectWithoutProperties(node, _excluded2$1);
  return rest;
};
var next = function next(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$mode2 = options.mode,
    mode = _options$mode2 === void 0 ? 'lowest' : _options$mode2,
    _options$voids4 = options.voids,
    voids = _options$voids4 === void 0 ? false : _options$voids4;
  var match = options.match,
    _options$at4 = options.at,
    at = _options$at4 === void 0 ? editor.selection : _options$at4;
  if (!at) {
    return;
  }
  var pointAfterLocation = Editor.after(editor, at, {
    voids: voids
  });
  if (!pointAfterLocation) return;
  var _Editor$last = Editor.last(editor, []),
    _Editor$last2 = _slicedToArray(_Editor$last, 2),
    to = _Editor$last2[1];
  var span = [pointAfterLocation.path, to];
  if (Path.isPath(at) && at.length === 0) {
    throw new Error("Cannot get the next node from the root node!");
  }
  if (match == null) {
    if (Path.isPath(at)) {
      var _Editor$parent5 = Editor.parent(editor, at),
        _Editor$parent6 = _slicedToArray(_Editor$parent5, 1),
        parent = _Editor$parent6[0];
      match = function match(n) {
        return parent.children.includes(n);
      };
    } else {
      match = function match() {
        return true;
      };
    }
  }
  var _Editor$nodes3 = Editor.nodes(editor, {
      at: span,
      match: match,
      mode: mode,
      voids: voids
    }),
    _Editor$nodes4 = _slicedToArray(_Editor$nodes3, 1),
    next = _Editor$nodes4[0];
  return next;
};
var node = function node(editor, at) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var path = Editor.path(editor, at, options);
  var node = Node.get(editor, path);
  return [node, path];
};
function nodes(editor) {
  var options,
    _options$at5,
    at,
    _options$mode3,
    mode,
    _options$universal,
    universal,
    _options$reverse7,
    reverse,
    _options$voids5,
    voids,
    _options$ignoreNonSel,
    ignoreNonSelectable,
    match,
    from,
    to,
    first,
    last,
    nodeEntries,
    matches,
    hit,
    _iterator29,
    _step29,
    _step29$value,
    node,
    path,
    isLower,
    emit,
    _args11 = arguments;
  return regenerator.wrap(function nodes$(_context11) {
    while (1) switch (_context11.prev = _context11.next) {
      case 0:
        options = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : {};
        _options$at5 = options.at, at = _options$at5 === void 0 ? editor.selection : _options$at5, _options$mode3 = options.mode, mode = _options$mode3 === void 0 ? 'all' : _options$mode3, _options$universal = options.universal, universal = _options$universal === void 0 ? false : _options$universal, _options$reverse7 = options.reverse, reverse = _options$reverse7 === void 0 ? false : _options$reverse7, _options$voids5 = options.voids, voids = _options$voids5 === void 0 ? false : _options$voids5, _options$ignoreNonSel = options.ignoreNonSelectable, ignoreNonSelectable = _options$ignoreNonSel === void 0 ? false : _options$ignoreNonSel;
        match = options.match;
        if (!match) {
          match = function match() {
            return true;
          };
        }
        if (at) {
          _context11.next = 6;
          break;
        }
        return _context11.abrupt("return");
      case 6:
        if (Span.isSpan(at)) {
          from = at[0];
          to = at[1];
        } else {
          first = Editor.path(editor, at, {
            edge: 'start'
          });
          last = Editor.path(editor, at, {
            edge: 'end'
          });
          from = reverse ? last : first;
          to = reverse ? first : last;
        }
        nodeEntries = Node.nodes(editor, {
          reverse: reverse,
          from: from,
          to: to,
          pass: function pass(_ref) {
            var _ref8 = _slicedToArray(_ref, 1),
              node = _ref8[0];
            if (!Element.isElement(node)) return false;
            if (!voids && (Editor.isVoid(editor, node) || Editor.isElementReadOnly(editor, node))) return true;
            if (ignoreNonSelectable && !Editor.isSelectable(editor, node)) return true;
            return false;
          }
        });
        matches = [];
        _iterator29 = _createForOfIteratorHelper(nodeEntries);
        _context11.prev = 10;
        _iterator29.s();
      case 12:
        if ((_step29 = _iterator29.n()).done) {
          _context11.next = 39;
          break;
        }
        _step29$value = _slicedToArray(_step29.value, 2), node = _step29$value[0], path = _step29$value[1];
        if (!(ignoreNonSelectable && Element.isElement(node) && !Editor.isSelectable(editor, node))) {
          _context11.next = 16;
          break;
        }
        return _context11.abrupt("continue", 37);
      case 16:
        isLower = hit && Path.compare(path, hit[1]) === 0; // In highest mode any node lower than the last hit is not a match.
        if (!(mode === 'highest' && isLower)) {
          _context11.next = 19;
          break;
        }
        return _context11.abrupt("continue", 37);
      case 19:
        if (match(node, path)) {
          _context11.next = 25;
          break;
        }
        if (!(universal && !isLower && Text.isText(node))) {
          _context11.next = 24;
          break;
        }
        return _context11.abrupt("return");
      case 24:
        return _context11.abrupt("continue", 37);
      case 25:
        if (!(mode === 'lowest' && isLower)) {
          _context11.next = 28;
          break;
        }
        hit = [node, path];
        return _context11.abrupt("continue", 37);
      case 28:
        // In lowest mode we emit the last hit, once it's guaranteed lowest.
        emit = mode === 'lowest' ? hit : [node, path];
        if (!emit) {
          _context11.next = 36;
          break;
        }
        if (!universal) {
          _context11.next = 34;
          break;
        }
        matches.push(emit);
        _context11.next = 36;
        break;
      case 34:
        _context11.next = 36;
        return emit;
      case 36:
        hit = [node, path];
      case 37:
        _context11.next = 12;
        break;
      case 39:
        _context11.next = 44;
        break;
      case 41:
        _context11.prev = 41;
        _context11.t0 = _context11["catch"](10);
        _iterator29.e(_context11.t0);
      case 44:
        _context11.prev = 44;
        _iterator29.f();
        return _context11.finish(44);
      case 47:
        if (!(mode === 'lowest' && hit)) {
          _context11.next = 54;
          break;
        }
        if (!universal) {
          _context11.next = 52;
          break;
        }
        matches.push(hit);
        _context11.next = 54;
        break;
      case 52:
        _context11.next = 54;
        return hit;
      case 54:
        if (!universal) {
          _context11.next = 56;
          break;
        }
        return _context11.delegateYield(matches, "t1", 56);
      case 56:
      case "end":
        return _context11.stop();
    }
  }, _marked2, null, [[10, 41, 44, 47]]);
}
var normalize = function normalize(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$force = options.force,
    force = _options$force === void 0 ? false : _options$force,
    operation = options.operation;
  var getDirtyPaths = function getDirtyPaths(editor) {
    return DIRTY_PATHS.get(editor) || [];
  };
  var getDirtyPathKeys = function getDirtyPathKeys(editor) {
    return DIRTY_PATH_KEYS.get(editor) || new Set();
  };
  var popDirtyPath = function popDirtyPath(editor) {
    var path = getDirtyPaths(editor).pop();
    var key = path.join(',');
    getDirtyPathKeys(editor)["delete"](key);
    return path;
  };
  if (!Editor.isNormalizing(editor)) {
    return;
  }
  if (force) {
    var allPaths = Array.from(Node.nodes(editor), function (_ref) {
      var _ref9 = _slicedToArray(_ref, 2),
        p = _ref9[1];
      return p;
    });
    var allPathKeys = new Set(allPaths.map(function (p) {
      return p.join(',');
    }));
    DIRTY_PATHS.set(editor, allPaths);
    DIRTY_PATH_KEYS.set(editor, allPathKeys);
  }
  if (getDirtyPaths(editor).length === 0) {
    return;
  }
  Editor.withoutNormalizing(editor, function () {
    /*
      Fix dirty elements with no children.
      editor.normalizeNode() does fix this, but some normalization fixes also require it to work.
      Running an initial pass avoids the catch-22 race condition.
    */
    var _iterator30 = _createForOfIteratorHelper(getDirtyPaths(editor)),
      _step30;
    try {
      for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
        var dirtyPath = _step30.value;
        if (Node.has(editor, dirtyPath)) {
          var entry = Editor.node(editor, dirtyPath);
          var _entry3 = entry,
            _entry4 = _slicedToArray(_entry3, 2),
            node = _entry4[0],
            _ = _entry4[1];
          /*
            The default normalizer inserts an empty text node in this scenario, but it can be customised.
            So there is some risk here.
                     As long as the normalizer only inserts child nodes for this case it is safe to do in any order;
            by definition adding children to an empty node can't cause other paths to change.
          */

          if (Element.isElement(node) && node.children.length === 0) {
            editor.normalizeNode(entry, {
              operation: operation
            });
          }
        }
      }
    } catch (err) {
      _iterator30.e(err);
    } finally {
      _iterator30.f();
    }
    var dirtyPaths = getDirtyPaths(editor);
    var initialDirtyPathsLength = dirtyPaths.length;
    var iteration = 0;
    while (dirtyPaths.length !== 0) {
      if (!editor.shouldNormalize({
        dirtyPaths: dirtyPaths,
        iteration: iteration,
        initialDirtyPathsLength: initialDirtyPathsLength,
        operation: operation
      })) {
        return;
      }
      var _dirtyPath = popDirtyPath(editor); // If the node doesn't exist in the tree, it does not need to be normalized.

      if (Node.has(editor, _dirtyPath)) {
        var _entry = Editor.node(editor, _dirtyPath);
        editor.normalizeNode(_entry, {
          operation: operation
        });
      }
      iteration++;
      dirtyPaths = getDirtyPaths(editor);
    }
  });
};
var parent = function parent(editor, at) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var path = Editor.path(editor, at, options);
  var parentPath = Path.parent(path);
  var entry = Editor.node(editor, parentPath);
  return entry;
};
var pathRef = function pathRef(editor, path) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$affinity4 = options.affinity,
    affinity = _options$affinity4 === void 0 ? 'forward' : _options$affinity4;
  var ref = {
    current: path,
    affinity: affinity,
    unref: function unref() {
      var current = ref.current;
      var pathRefs = Editor.pathRefs(editor);
      pathRefs["delete"](ref);
      ref.current = null;
      return current;
    }
  };
  var refs = Editor.pathRefs(editor);
  refs.add(ref);
  return ref;
};
var pathRefs = function pathRefs(editor) {
  var refs = PATH_REFS.get(editor);
  if (!refs) {
    refs = new Set();
    PATH_REFS.set(editor, refs);
  }
  return refs;
};
var path = function path(editor, at) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var depth = options.depth,
    edge = options.edge;
  if (Path.isPath(at)) {
    if (edge === 'start') {
      var _Node$first = Node.first(editor, at),
        _Node$first2 = _slicedToArray(_Node$first, 2),
        firstPath = _Node$first2[1];
      at = firstPath;
    } else if (edge === 'end') {
      var _Node$last = Node.last(editor, at),
        _Node$last2 = _slicedToArray(_Node$last, 2),
        lastPath = _Node$last2[1];
      at = lastPath;
    }
  }
  if (Range.isRange(at)) {
    if (edge === 'start') {
      at = Range.start(at);
    } else if (edge === 'end') {
      at = Range.end(at);
    } else {
      at = Path.common(at.anchor.path, at.focus.path);
    }
  }
  if (Point.isPoint(at)) {
    at = at.path;
  }
  if (depth != null) {
    at = at.slice(0, depth);
  }
  return at;
};
var pointRef = function pointRef(editor, point) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$affinity5 = options.affinity,
    affinity = _options$affinity5 === void 0 ? 'forward' : _options$affinity5;
  var ref = {
    current: point,
    affinity: affinity,
    unref: function unref() {
      var current = ref.current;
      var pointRefs = Editor.pointRefs(editor);
      pointRefs["delete"](ref);
      ref.current = null;
      return current;
    }
  };
  var refs = Editor.pointRefs(editor);
  refs.add(ref);
  return ref;
};
var pointRefs = function pointRefs(editor) {
  var refs = POINT_REFS.get(editor);
  if (!refs) {
    refs = new Set();
    POINT_REFS.set(editor, refs);
  }
  return refs;
};
var point = function point(editor, at) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$edge = options.edge,
    edge = _options$edge === void 0 ? 'start' : _options$edge;
  if (Path.isPath(at)) {
    var path;
    if (edge === 'end') {
      var _Node$last3 = Node.last(editor, at),
        _Node$last4 = _slicedToArray(_Node$last3, 2),
        lastPath = _Node$last4[1];
      path = lastPath;
    } else {
      var _Node$first3 = Node.first(editor, at),
        _Node$first4 = _slicedToArray(_Node$first3, 2),
        firstPath = _Node$first4[1];
      path = firstPath;
    }
    var node = Node.get(editor, path);
    if (!Text.isText(node)) {
      throw new Error("Cannot get the ".concat(edge, " point in the node at path [").concat(at, "] because it has no ").concat(edge, " text node."));
    }
    return {
      path: path,
      offset: edge === 'end' ? node.text.length : 0
    };
  }
  if (Range.isRange(at)) {
    var _Range$edges19 = Range.edges(at),
      _Range$edges20 = _slicedToArray(_Range$edges19, 2),
      start = _Range$edges20[0],
      end = _Range$edges20[1];
    return edge === 'start' ? start : end;
  }
  return at;
};
function positions(editor) {
  var options,
    _options$at6,
    at,
    _options$unit3,
    unit,
    _options$reverse8,
    reverse,
    _options$voids6,
    voids,
    _options$ignoreNonSel2,
    ignoreNonSelectable,
    range,
    _Range$edges21,
    _Range$edges22,
    start,
    end,
    first,
    isNewBlock,
    blockText,
    distance,
    leafTextRemaining,
    leafTextOffset,
    _iterator31,
    _step31,
    _step31$value,
    node,
    path,
    e,
    s,
    isFirst,
    calcDistance,
    _args12 = arguments;
  return regenerator.wrap(function positions$(_context12) {
    while (1) switch (_context12.prev = _context12.next) {
      case 0:
        calcDistance = function _calcDistance(text, unit, reverse) {
          if (unit === 'character') {
            return getCharacterDistance(text, reverse);
          } else if (unit === 'word') {
            return getWordDistance(text, reverse);
          } else if (unit === 'line' || unit === 'block') {
            return text.length;
          }
          return 1;
        };
        options = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : {};
        _options$at6 = options.at, at = _options$at6 === void 0 ? editor.selection : _options$at6, _options$unit3 = options.unit, unit = _options$unit3 === void 0 ? 'offset' : _options$unit3, _options$reverse8 = options.reverse, reverse = _options$reverse8 === void 0 ? false : _options$reverse8, _options$voids6 = options.voids, voids = _options$voids6 === void 0 ? false : _options$voids6, _options$ignoreNonSel2 = options.ignoreNonSelectable, ignoreNonSelectable = _options$ignoreNonSel2 === void 0 ? false : _options$ignoreNonSel2;
        if (at) {
          _context12.next = 5;
          break;
        }
        return _context12.abrupt("return");
      case 5:
        /**
         * Algorithm notes:
         *
         * Each step `distance` is dynamic depending on the underlying text
         * and the `unit` specified.  Each step, e.g., a line or word, may
         * span multiple text nodes, so we iterate through the text both on
         * two levels in step-sync:
         *
         * `leafText` stores the text on a text leaf level, and is advanced
         * through using the counters `leafTextOffset` and `leafTextRemaining`.
         *
         * `blockText` stores the text on a block level, and is shortened
         * by `distance` every time it is advanced.
         *
         * We only maintain a window of one blockText and one leafText because
         * a block node always appears before all of its leaf nodes.
         */
        range = Editor.range(editor, at);
        _Range$edges21 = Range.edges(range), _Range$edges22 = _slicedToArray(_Range$edges21, 2), start = _Range$edges22[0], end = _Range$edges22[1];
        first = reverse ? end : start;
        isNewBlock = false;
        blockText = '';
        distance = 0; // Distance for leafText to catch up to blockText.
        leafTextRemaining = 0;
        leafTextOffset = 0; // Iterate through all nodes in range, grabbing entire textual content
        // of block nodes in blockText, and text nodes in leafText.
        // Exploits the fact that nodes are sequenced in such a way that we first
        // encounter the block node, then all of its text nodes, so when iterating
        // through the blockText and leafText we just need to remember a window of
        // one block node and leaf node, respectively.
        _iterator31 = _createForOfIteratorHelper(Editor.nodes(editor, {
          at: at,
          reverse: reverse,
          voids: voids,
          ignoreNonSelectable: ignoreNonSelectable
        }));
        _context12.prev = 14;
        _iterator31.s();
      case 16:
        if ((_step31 = _iterator31.n()).done) {
          _context12.next = 51;
          break;
        }
        _step31$value = _slicedToArray(_step31.value, 2), node = _step31$value[0], path = _step31$value[1];
        if (!Element.isElement(node)) {
          _context12.next = 26;
          break;
        }
        if (!(!voids && (editor.isVoid(node) || editor.isElementReadOnly(node)))) {
          _context12.next = 23;
          break;
        }
        _context12.next = 22;
        return Editor.start(editor, path);
      case 22:
        return _context12.abrupt("continue", 49);
      case 23:
        if (!editor.isInline(node)) {
          _context12.next = 25;
          break;
        }
        return _context12.abrupt("continue", 49);
      case 25:
        // Block element node - set `blockText` to its text content.

        if (Editor.hasInlines(editor, node)) {
          // We always exhaust block nodes before encountering a new one:
          //   console.assert(blockText === '',
          //     `blockText='${blockText}' - `+
          //     `not exhausted before new block node`, path)
          // Ensure range considered is capped to `range`, in the
          // start/end edge cases where block extends beyond range.
          // Equivalent to this, but presumably more performant:
          //   blockRange = Editor.range(editor, ...Editor.edges(editor, path))
          //   blockRange = Range.intersection(range, blockRange) // intersect
          //   blockText = Editor.string(editor, blockRange, { voids })
          e = Path.isAncestor(path, end.path) ? end : Editor.end(editor, path);
          s = Path.isAncestor(path, start.path) ? start : Editor.start(editor, path);
          blockText = Editor.string(editor, {
            anchor: s,
            focus: e
          }, {
            voids: voids
          });
          isNewBlock = true;
        }
      case 26:
        if (!Text.isText(node)) {
          _context12.next = 49;
          break;
        }
        isFirst = Path.equals(path, first.path); // Proof that we always exhaust text nodes before encountering a new one:
        //   console.assert(leafTextRemaining <= 0,
        //     `leafTextRemaining=${leafTextRemaining} - `+
        //     `not exhausted before new leaf text node`, path)
        // Reset `leafText` counters for new text node.
        if (isFirst) {
          leafTextRemaining = reverse ? first.offset : node.text.length - first.offset;
          leafTextOffset = first.offset; // Works for reverse too.
        } else {
          leafTextRemaining = node.text.length;
          leafTextOffset = reverse ? leafTextRemaining : 0;
        } // Yield position at the start of node (potentially).
        if (!(isFirst || isNewBlock || unit === 'offset')) {
          _context12.next = 33;
          break;
        }
        _context12.next = 32;
        return {
          path: path,
          offset: leafTextOffset
        };
      case 32:
        isNewBlock = false;
      case 33:
        if (!(distance === 0)) {
          _context12.next = 39;
          break;
        }
        if (!(blockText === '')) {
          _context12.next = 37;
          break;
        }
        return _context12.abrupt("break", 49);
      case 37:
        distance = calcDistance(blockText, unit, reverse); // Split the string at the previously found distance and use the
        // remaining string for the next iteration.

        blockText = splitByCharacterDistance(blockText, distance, reverse)[1];
      case 39:
        // Advance `leafText` by the current `distance`.

        leafTextOffset = reverse ? leafTextOffset - distance : leafTextOffset + distance;
        leafTextRemaining = leafTextRemaining - distance; // If `leafText` is exhausted, break to get a new leaf node
        // and set distance to the overflow amount, so we'll (maybe)
        // catch up to blockText in the next leaf text node.
        if (!(leafTextRemaining < 0)) {
          _context12.next = 44;
          break;
        }
        distance = -leafTextRemaining;
        return _context12.abrupt("break", 49);
      case 44:
        // Successfully walked `distance` offsets through `leafText`
        // to catch up with `blockText`, so we can reset `distance`
        // and yield this position in this node.

        distance = 0;
        _context12.next = 47;
        return {
          path: path,
          offset: leafTextOffset
        };
      case 47:
        _context12.next = 33;
        break;
      case 49:
        _context12.next = 16;
        break;
      case 51:
        _context12.next = 56;
        break;
      case 53:
        _context12.prev = 53;
        _context12.t0 = _context12["catch"](14);
        _iterator31.e(_context12.t0);
      case 56:
        _context12.prev = 56;
        _iterator31.f();
        return _context12.finish(56);
      case 59:
      case "end":
        return _context12.stop();
    }
  }, _marked3, null, [[14, 53, 56, 59]]);
}
var previous = function previous(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$mode4 = options.mode,
    mode = _options$mode4 === void 0 ? 'lowest' : _options$mode4,
    _options$voids7 = options.voids,
    voids = _options$voids7 === void 0 ? false : _options$voids7;
  var match = options.match,
    _options$at7 = options.at,
    at = _options$at7 === void 0 ? editor.selection : _options$at7;
  if (!at) {
    return;
  }
  var pointBeforeLocation = Editor.before(editor, at, {
    voids: voids
  });
  if (!pointBeforeLocation) {
    return;
  }
  var _Editor$first = Editor.first(editor, []),
    _Editor$first2 = _slicedToArray(_Editor$first, 2),
    to = _Editor$first2[1]; // The search location is from the start of the document to the path of
  // the point before the location passed in

  var span = [pointBeforeLocation.path, to];
  if (Path.isPath(at) && at.length === 0) {
    throw new Error("Cannot get the previous node from the root node!");
  }
  if (match == null) {
    if (Path.isPath(at)) {
      var _Editor$parent7 = Editor.parent(editor, at),
        _Editor$parent8 = _slicedToArray(_Editor$parent7, 1),
        parent = _Editor$parent8[0];
      match = function match(n) {
        return parent.children.includes(n);
      };
    } else {
      match = function match() {
        return true;
      };
    }
  }
  var _Editor$nodes5 = Editor.nodes(editor, {
      reverse: true,
      at: span,
      match: match,
      mode: mode,
      voids: voids
    }),
    _Editor$nodes6 = _slicedToArray(_Editor$nodes5, 1),
    previous = _Editor$nodes6[0];
  return previous;
};
var rangeRef = function rangeRef(editor, range) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$affinity6 = options.affinity,
    affinity = _options$affinity6 === void 0 ? 'forward' : _options$affinity6;
  var ref = {
    current: range,
    affinity: affinity,
    unref: function unref() {
      var current = ref.current;
      var rangeRefs = Editor.rangeRefs(editor);
      rangeRefs["delete"](ref);
      ref.current = null;
      return current;
    }
  };
  var refs = Editor.rangeRefs(editor);
  refs.add(ref);
  return ref;
};
var rangeRefs = function rangeRefs(editor) {
  var refs = RANGE_REFS.get(editor);
  if (!refs) {
    refs = new Set();
    RANGE_REFS.set(editor, refs);
  }
  return refs;
};
var range = function range(editor, at, to) {
  if (Range.isRange(at) && !to) {
    return at;
  }
  var start = Editor.start(editor, at);
  var end = Editor.end(editor, to || at);
  return {
    anchor: start,
    focus: end
  };
};
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var removeMark = function removeMark(editor, key) {
  var selection = editor.selection;
  if (selection) {
    var match = function match(node, path) {
      if (!Text.isText(node)) {
        return false; // marks can only be applied to text
      }
      var _Editor$parent9 = Editor.parent(editor, path),
        _Editor$parent10 = _slicedToArray(_Editor$parent9, 2),
        parentNode = _Editor$parent10[0];
        _Editor$parent10[1];
      return !editor.isVoid(parentNode) || editor.markableVoid(parentNode);
    };
    var expandedSelection = Range.isExpanded(selection);
    var markAcceptingVoidSelected = false;
    if (!expandedSelection) {
      var _Editor$node5 = Editor.node(editor, selection),
        _Editor$node6 = _slicedToArray(_Editor$node5, 2),
        selectedNode = _Editor$node6[0],
        selectedPath = _Editor$node6[1];
      if (selectedNode && match(selectedNode, selectedPath)) {
        var _Editor$parent11 = Editor.parent(editor, selectedPath),
          _Editor$parent12 = _slicedToArray(_Editor$parent11, 1),
          parentNode = _Editor$parent12[0];
        markAcceptingVoidSelected = parentNode && editor.markableVoid(parentNode);
      }
    }
    if (expandedSelection || markAcceptingVoidSelected) {
      Transforms.unsetNodes(editor, key, {
        match: match,
        split: true,
        voids: true
      });
    } else {
      var marks = _objectSpread$2({}, Editor.marks(editor) || {});
      delete marks[key];
      editor.marks = marks;
      if (!FLUSHING.get(editor)) {
        editor.onChange();
      }
    }
  }
};
var setNormalizing = function setNormalizing(editor, isNormalizing) {
  NORMALIZING.set(editor, isNormalizing);
};
var start = function start(editor, at) {
  return Editor.point(editor, at, {
    edge: 'start'
  });
};
var string = function string(editor, at) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$voids8 = options.voids,
    voids = _options$voids8 === void 0 ? false : _options$voids8;
  var range = Editor.range(editor, at);
  var _Range$edges23 = Range.edges(range),
    _Range$edges24 = _slicedToArray(_Range$edges23, 2),
    start = _Range$edges24[0],
    end = _Range$edges24[1];
  var text = '';
  var _iterator32 = _createForOfIteratorHelper(Editor.nodes(editor, {
      at: range,
      match: Text.isText,
      voids: voids
    })),
    _step32;
  try {
    for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
      var _step32$value = _slicedToArray(_step32.value, 2),
        node = _step32$value[0],
        path = _step32$value[1];
      var t = node.text;
      if (Path.equals(path, end.path)) {
        t = t.slice(0, end.offset);
      }
      if (Path.equals(path, start.path)) {
        t = t.slice(start.offset);
      }
      text += t;
    }
  } catch (err) {
    _iterator32.e(err);
  } finally {
    _iterator32.f();
  }
  return text;
};
var unhangRange = function unhangRange(editor, range) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$voids9 = options.voids,
    voids = _options$voids9 === void 0 ? false : _options$voids9;
  var _Range$edges25 = Range.edges(range),
    _Range$edges26 = _slicedToArray(_Range$edges25, 2),
    start = _Range$edges26[0],
    end = _Range$edges26[1]; // PERF: exit early if we can guarantee that the range isn't hanging.

  if (start.offset !== 0 || end.offset !== 0 || Range.isCollapsed(range) || Path.hasPrevious(end.path)) {
    return range;
  }
  var endBlock = Editor.above(editor, {
    at: end,
    match: function match(n) {
      return Element.isElement(n) && Editor.isBlock(editor, n);
    },
    voids: voids
  });
  var blockPath = endBlock ? endBlock[1] : [];
  var first = Editor.start(editor, start);
  var before = {
    anchor: first,
    focus: end
  };
  var skip = true;
  var _iterator33 = _createForOfIteratorHelper(Editor.nodes(editor, {
      at: before,
      match: Text.isText,
      reverse: true,
      voids: voids
    })),
    _step33;
  try {
    for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
      var _step33$value = _slicedToArray(_step33.value, 2),
        node = _step33$value[0],
        path = _step33$value[1];
      if (skip) {
        skip = false;
        continue;
      }
      if (node.text !== '' || Path.isBefore(path, blockPath)) {
        end = {
          path: path,
          offset: node.text.length
        };
        break;
      }
    }
  } catch (err) {
    _iterator33.e(err);
  } finally {
    _iterator33.f();
  }
  return {
    anchor: start,
    focus: end
  };
};
var withoutNormalizing = function withoutNormalizing(editor, fn) {
  var value = Editor.isNormalizing(editor);
  Editor.setNormalizing(editor, false);
  try {
    fn();
  } finally {
    Editor.setNormalizing(editor, value);
  }
  Editor.normalize(editor);
};
var deleteText = function deleteText(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Editor.withoutNormalizing(editor, function () {
    var _Editor$void, _Editor$void2;
    var _options$reverse9 = options.reverse,
      reverse = _options$reverse9 === void 0 ? false : _options$reverse9,
      _options$unit4 = options.unit,
      unit = _options$unit4 === void 0 ? 'character' : _options$unit4,
      _options$distance3 = options.distance,
      distance = _options$distance3 === void 0 ? 1 : _options$distance3,
      _options$voids10 = options.voids,
      voids = _options$voids10 === void 0 ? false : _options$voids10;
    var _options$at8 = options.at,
      at = _options$at8 === void 0 ? editor.selection : _options$at8,
      _options$hanging = options.hanging,
      hanging = _options$hanging === void 0 ? false : _options$hanging;
    if (!at) {
      return;
    }
    var isCollapsed = false;
    if (Range.isRange(at) && Range.isCollapsed(at)) {
      isCollapsed = true;
      at = at.anchor;
    }
    if (Point.isPoint(at)) {
      var furthestVoid = Editor["void"](editor, {
        at: at,
        mode: 'highest'
      });
      if (!voids && furthestVoid) {
        var _furthestVoid = _slicedToArray(furthestVoid, 2),
          voidPath = _furthestVoid[1];
        at = voidPath;
      } else {
        var opts = {
          unit: unit,
          distance: distance
        };
        var target = reverse ? Editor.before(editor, at, opts) || Editor.start(editor, []) : Editor.after(editor, at, opts) || Editor.end(editor, []);
        at = {
          anchor: at,
          focus: target
        };
        hanging = true;
      }
    }
    if (Path.isPath(at)) {
      Transforms.removeNodes(editor, {
        at: at,
        voids: voids
      });
      return;
    }
    if (Range.isCollapsed(at)) {
      return;
    }
    if (!hanging) {
      var _Range$edges27 = Range.edges(at),
        _Range$edges28 = _slicedToArray(_Range$edges27, 2),
        _end = _Range$edges28[1];
      var endOfDoc = Editor.end(editor, []);
      if (!Point.equals(_end, endOfDoc)) {
        at = Editor.unhangRange(editor, at, {
          voids: voids
        });
      }
    }
    var _Range$edges29 = Range.edges(at),
      _Range$edges30 = _slicedToArray(_Range$edges29, 2),
      start = _Range$edges30[0],
      end = _Range$edges30[1];
    var startBlock = Editor.above(editor, {
      match: function match(n) {
        return Element.isElement(n) && Editor.isBlock(editor, n);
      },
      at: start,
      voids: voids
    });
    var endBlock = Editor.above(editor, {
      match: function match(n) {
        return Element.isElement(n) && Editor.isBlock(editor, n);
      },
      at: end,
      voids: voids
    });
    var isAcrossBlocks = startBlock && endBlock && !Path.equals(startBlock[1], endBlock[1]);
    var isSingleText = Path.equals(start.path, end.path);
    var startNonEditable = voids ? null : (_Editor$void = Editor["void"](editor, {
      at: start,
      mode: 'highest'
    })) !== null && _Editor$void !== void 0 ? _Editor$void : Editor.elementReadOnly(editor, {
      at: start,
      mode: 'highest'
    });
    var endNonEditable = voids ? null : (_Editor$void2 = Editor["void"](editor, {
      at: end,
      mode: 'highest'
    })) !== null && _Editor$void2 !== void 0 ? _Editor$void2 : Editor.elementReadOnly(editor, {
      at: end,
      mode: 'highest'
    }); // If the start or end points are inside an inline void, nudge them out.

    if (startNonEditable) {
      var before = Editor.before(editor, start);
      if (before && startBlock && Path.isAncestor(startBlock[1], before.path)) {
        start = before;
      }
    }
    if (endNonEditable) {
      var after = Editor.after(editor, end);
      if (after && endBlock && Path.isAncestor(endBlock[1], after.path)) {
        end = after;
      }
    } // Get the highest nodes that are completely inside the range, as well as
    // the start and end nodes.

    var matches = [];
    var lastPath;
    var _iterator34 = _createForOfIteratorHelper(Editor.nodes(editor, {
        at: at,
        voids: voids
      })),
      _step34;
    try {
      for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
        var entry = _step34.value;
        var _entry5 = entry,
          _entry6 = _slicedToArray(_entry5, 2),
          node = _entry6[0],
          path = _entry6[1];
        if (lastPath && Path.compare(path, lastPath) === 0) {
          continue;
        }
        if (!voids && Element.isElement(node) && (Editor.isVoid(editor, node) || Editor.isElementReadOnly(editor, node)) || !Path.isCommon(path, start.path) && !Path.isCommon(path, end.path)) {
          matches.push(entry);
          lastPath = path;
        }
      }
    } catch (err) {
      _iterator34.e(err);
    } finally {
      _iterator34.f();
    }
    var pathRefs = Array.from(matches, function (_ref) {
      var _ref10 = _slicedToArray(_ref, 2),
        p = _ref10[1];
      return Editor.pathRef(editor, p);
    });
    var startRef = Editor.pointRef(editor, start);
    var endRef = Editor.pointRef(editor, end);
    var removedText = '';
    if (!isSingleText && !startNonEditable) {
      var _point = startRef.current;
      var _Editor$leaf3 = Editor.leaf(editor, _point),
        _Editor$leaf4 = _slicedToArray(_Editor$leaf3, 1),
        _node = _Editor$leaf4[0];
      var _path = _point.path;
      var _start = start,
        offset = _start.offset;
      var text = _node.text.slice(offset);
      if (text.length > 0) {
        editor.apply({
          type: 'remove_text',
          path: _path,
          offset: offset,
          text: text
        });
        removedText = text;
      }
    }
    pathRefs.reverse().map(function (r) {
      return r.unref();
    }).filter(function (r) {
      return r !== null;
    }).forEach(function (p) {
      return Transforms.removeNodes(editor, {
        at: p,
        voids: voids
      });
    });
    if (!endNonEditable) {
      var _point2 = endRef.current;
      var _Editor$leaf5 = Editor.leaf(editor, _point2),
        _Editor$leaf6 = _slicedToArray(_Editor$leaf5, 1),
        _node2 = _Editor$leaf6[0];
      var _path2 = _point2.path;
      var _offset = isSingleText ? start.offset : 0;
      var _text = _node2.text.slice(_offset, end.offset);
      if (_text.length > 0) {
        editor.apply({
          type: 'remove_text',
          path: _path2,
          offset: _offset,
          text: _text
        });
        removedText = _text;
      }
    }
    if (!isSingleText && isAcrossBlocks && endRef.current && startRef.current) {
      Transforms.mergeNodes(editor, {
        at: endRef.current,
        hanging: true,
        voids: voids
      });
    } // For Thai script, deleting N character(s) backward should delete
    // N code point(s) instead of an entire grapheme cluster.
    // Therefore, the remaining code points should be inserted back.

    if (isCollapsed && reverse && unit === 'character' && removedText.length > 1 && removedText.match(/[\u0E00-\u0E7F]+/)) {
      Transforms.insertText(editor, removedText.slice(0, removedText.length - distance));
    }
    var startUnref = startRef.unref();
    var endUnref = endRef.unref();
    var point = reverse ? startUnref || endUnref : endUnref || startUnref;
    if (options.at == null && point) {
      Transforms.select(editor, point);
    }
  });
};
var insertFragment = function insertFragment(editor, fragment) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Editor.withoutNormalizing(editor, function () {
    var _options$hanging2 = options.hanging,
      hanging = _options$hanging2 === void 0 ? false : _options$hanging2,
      _options$voids11 = options.voids,
      voids = _options$voids11 === void 0 ? false : _options$voids11;
    var _options$at9 = options.at,
      at = _options$at9 === void 0 ? getDefaultInsertLocation(editor) : _options$at9;
    if (!fragment.length) {
      return;
    }
    if (Range.isRange(at)) {
      if (!hanging) {
        at = Editor.unhangRange(editor, at, {
          voids: voids
        });
      }
      if (Range.isCollapsed(at)) {
        at = at.anchor;
      } else {
        var _Range$edges31 = Range.edges(at),
          _Range$edges32 = _slicedToArray(_Range$edges31, 2),
          end = _Range$edges32[1];
        if (!voids && Editor["void"](editor, {
          at: end
        })) {
          return;
        }
        var pointRef = Editor.pointRef(editor, end);
        Transforms["delete"](editor, {
          at: at
        });
        at = pointRef.unref();
      }
    } else if (Path.isPath(at)) {
      at = Editor.start(editor, at);
    }
    if (!voids && Editor["void"](editor, {
      at: at
    })) {
      return;
    } // If the insert point is at the edge of an inline node, move it outside
    // instead since it will need to be split otherwise.

    var inlineElementMatch = Editor.above(editor, {
      at: at,
      match: function match(n) {
        return Element.isElement(n) && Editor.isInline(editor, n);
      },
      mode: 'highest',
      voids: voids
    });
    if (inlineElementMatch) {
      var _inlineElementMatch = _slicedToArray(inlineElementMatch, 2),
        _inlinePath = _inlineElementMatch[1];
      if (Editor.isEnd(editor, at, _inlinePath)) {
        var after = Editor.after(editor, _inlinePath);
        at = after;
      } else if (Editor.isStart(editor, at, _inlinePath)) {
        var before = Editor.before(editor, _inlinePath);
        at = before;
      }
    }
    var blockMatch = Editor.above(editor, {
      match: function match(n) {
        return Element.isElement(n) && Editor.isBlock(editor, n);
      },
      at: at,
      voids: voids
    });
    var _blockMatch = _slicedToArray(blockMatch, 2),
      blockPath = _blockMatch[1];
    var isBlockStart = Editor.isStart(editor, at, blockPath);
    var isBlockEnd = Editor.isEnd(editor, at, blockPath);
    var isBlockEmpty = isBlockStart && isBlockEnd;
    var mergeStart = !isBlockStart || isBlockStart && isBlockEnd;
    var mergeEnd = !isBlockEnd;
    var _Node$first5 = Node.first({
        children: fragment
      }, []),
      _Node$first6 = _slicedToArray(_Node$first5, 2),
      firstPath = _Node$first6[1];
    var _Node$last5 = Node.last({
        children: fragment
      }, []),
      _Node$last6 = _slicedToArray(_Node$last5, 2),
      lastPath = _Node$last6[1];
    var matches = [];
    var matcher = function matcher(_ref) {
      var _ref11 = _slicedToArray(_ref, 2),
        n = _ref11[0],
        p = _ref11[1];
      var isRoot = p.length === 0;
      if (isRoot) {
        return false;
      }
      if (isBlockEmpty) {
        return true;
      }
      if (mergeStart && Path.isAncestor(p, firstPath) && Element.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) {
        return false;
      }
      if (mergeEnd && Path.isAncestor(p, lastPath) && Element.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) {
        return false;
      }
      return true;
    };
    var _iterator35 = _createForOfIteratorHelper(Node.nodes({
        children: fragment
      }, {
        pass: matcher
      })),
      _step35;
    try {
      for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
        var entry = _step35.value;
        if (matcher(entry)) {
          matches.push(entry);
        }
      }
    } catch (err) {
      _iterator35.e(err);
    } finally {
      _iterator35.f();
    }
    var starts = [];
    var middles = [];
    var ends = [];
    var starting = true;
    var hasBlocks = false;
    for (var _i = 0, _matches = matches; _i < _matches.length; _i++) {
      var _matches$_i = _slicedToArray(_matches[_i], 1),
        node = _matches$_i[0];
      if (Element.isElement(node) && !editor.isInline(node)) {
        starting = false;
        hasBlocks = true;
        middles.push(node);
      } else if (starting) {
        starts.push(node);
      } else {
        ends.push(node);
      }
    }
    var _Editor$nodes7 = Editor.nodes(editor, {
        at: at,
        match: function match(n) {
          return Text.isText(n) || Editor.isInline(editor, n);
        },
        mode: 'highest',
        voids: voids
      }),
      _Editor$nodes8 = _slicedToArray(_Editor$nodes7, 1),
      inlineMatch = _Editor$nodes8[0];
    var _inlineMatch = _slicedToArray(inlineMatch, 2),
      inlinePath = _inlineMatch[1];
    var isInlineStart = Editor.isStart(editor, at, inlinePath);
    var isInlineEnd = Editor.isEnd(editor, at, inlinePath);
    var middleRef = Editor.pathRef(editor, isBlockEnd && !ends.length ? Path.next(blockPath) : blockPath);
    var endRef = Editor.pathRef(editor, isInlineEnd ? Path.next(inlinePath) : inlinePath);
    Transforms.splitNodes(editor, {
      at: at,
      match: function match(n) {
        return hasBlocks ? Element.isElement(n) && Editor.isBlock(editor, n) : Text.isText(n) || Editor.isInline(editor, n);
      },
      mode: hasBlocks ? 'lowest' : 'highest',
      always: hasBlocks && (!isBlockStart || starts.length > 0) && (!isBlockEnd || ends.length > 0),
      voids: voids
    });
    var startRef = Editor.pathRef(editor, !isInlineStart || isInlineStart && isInlineEnd ? Path.next(inlinePath) : inlinePath);
    Transforms.insertNodes(editor, starts, {
      at: startRef.current,
      match: function match(n) {
        return Text.isText(n) || Editor.isInline(editor, n);
      },
      mode: 'highest',
      voids: voids
    });
    if (isBlockEmpty && !starts.length && middles.length && !ends.length) {
      Transforms["delete"](editor, {
        at: blockPath,
        voids: voids
      });
    }
    Transforms.insertNodes(editor, middles, {
      at: middleRef.current,
      match: function match(n) {
        return Element.isElement(n) && Editor.isBlock(editor, n);
      },
      mode: 'lowest',
      voids: voids
    });
    Transforms.insertNodes(editor, ends, {
      at: endRef.current,
      match: function match(n) {
        return Text.isText(n) || Editor.isInline(editor, n);
      },
      mode: 'highest',
      voids: voids
    });
    if (!options.at) {
      var path;
      if (ends.length > 0 && endRef.current) {
        path = Path.previous(endRef.current);
      } else if (middles.length > 0 && middleRef.current) {
        path = Path.previous(middleRef.current);
      } else if (startRef.current) {
        path = Path.previous(startRef.current);
      }
      if (path) {
        var _end = Editor.end(editor, path);
        Transforms.select(editor, _end);
      }
    }
    startRef.unref();
    middleRef.unref();
    endRef.unref();
  });
};
var collapse = function collapse(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$edge2 = options.edge,
    edge = _options$edge2 === void 0 ? 'anchor' : _options$edge2;
  var selection = editor.selection;
  if (!selection) {
    return;
  } else if (edge === 'anchor') {
    Transforms.select(editor, selection.anchor);
  } else if (edge === 'focus') {
    Transforms.select(editor, selection.focus);
  } else if (edge === 'start') {
    var _Range$edges33 = Range.edges(selection),
      _Range$edges34 = _slicedToArray(_Range$edges33, 1),
      start = _Range$edges34[0];
    Transforms.select(editor, start);
  } else if (edge === 'end') {
    var _Range$edges35 = Range.edges(selection),
      _Range$edges36 = _slicedToArray(_Range$edges35, 2),
      end = _Range$edges36[1];
    Transforms.select(editor, end);
  }
};
var deselect = function deselect(editor) {
  var selection = editor.selection;
  if (selection) {
    editor.apply({
      type: 'set_selection',
      properties: selection,
      newProperties: null
    });
  }
};
var move = function move(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var selection = editor.selection;
  var _options$distance4 = options.distance,
    distance = _options$distance4 === void 0 ? 1 : _options$distance4,
    _options$unit5 = options.unit,
    unit = _options$unit5 === void 0 ? 'character' : _options$unit5,
    _options$reverse10 = options.reverse,
    reverse = _options$reverse10 === void 0 ? false : _options$reverse10;
  var _options$edge3 = options.edge,
    edge = _options$edge3 === void 0 ? null : _options$edge3;
  if (!selection) {
    return;
  }
  if (edge === 'start') {
    edge = Range.isBackward(selection) ? 'focus' : 'anchor';
  }
  if (edge === 'end') {
    edge = Range.isBackward(selection) ? 'anchor' : 'focus';
  }
  var anchor = selection.anchor,
    focus = selection.focus;
  var opts = {
    distance: distance,
    unit: unit,
    ignoreNonSelectable: true
  };
  var props = {};
  if (edge == null || edge === 'anchor') {
    var point = reverse ? Editor.before(editor, anchor, opts) : Editor.after(editor, anchor, opts);
    if (point) {
      props.anchor = point;
    }
  }
  if (edge == null || edge === 'focus') {
    var _point = reverse ? Editor.before(editor, focus, opts) : Editor.after(editor, focus, opts);
    if (_point) {
      props.focus = _point;
    }
  }
  Transforms.setSelection(editor, props);
};
var select = function select(editor, target) {
  var selection = editor.selection;
  target = Editor.range(editor, target);
  if (selection) {
    Transforms.setSelection(editor, target);
    return;
  }
  if (!Range.isRange(target)) {
    throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(Scrubber.stringify(target)));
  }
  editor.apply({
    type: 'set_selection',
    properties: selection,
    newProperties: target
  });
};
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var setPoint = function setPoint(editor, props) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var selection = editor.selection;
  var _options$edge4 = options.edge,
    edge = _options$edge4 === void 0 ? 'both' : _options$edge4;
  if (!selection) {
    return;
  }
  if (edge === 'start') {
    edge = Range.isBackward(selection) ? 'focus' : 'anchor';
  }
  if (edge === 'end') {
    edge = Range.isBackward(selection) ? 'anchor' : 'focus';
  }
  var anchor = selection.anchor,
    focus = selection.focus;
  var point = edge === 'anchor' ? anchor : focus;
  Transforms.setSelection(editor, _defineProperty$1({}, edge === 'anchor' ? 'anchor' : 'focus', _objectSpread$1(_objectSpread$1({}, point), props)));
};
var setSelection = function setSelection(editor, props) {
  var selection = editor.selection;
  var oldProps = {};
  var newProps = {};
  if (!selection) {
    return;
  }
  for (var k in props) {
    if (k === 'anchor' && props.anchor != null && !Point.equals(props.anchor, selection.anchor) || k === 'focus' && props.focus != null && !Point.equals(props.focus, selection.focus) || k !== 'anchor' && k !== 'focus' && props[k] !== selection[k]) {
      oldProps[k] = selection[k];
      newProps[k] = props[k];
    }
  }
  if (Object.keys(oldProps).length > 0) {
    editor.apply({
      type: 'set_selection',
      properties: oldProps,
      newProperties: newProps
    });
  }
};
var insertNodes = function insertNodes(editor, nodes) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Editor.withoutNormalizing(editor, function () {
    var _options$hanging3 = options.hanging,
      hanging = _options$hanging3 === void 0 ? false : _options$hanging3,
      _options$voids12 = options.voids,
      voids = _options$voids12 === void 0 ? false : _options$voids12,
      _options$mode5 = options.mode,
      mode = _options$mode5 === void 0 ? 'lowest' : _options$mode5;
    var at = options.at,
      match = options.match,
      select = options.select;
    if (Node.isNode(nodes)) {
      nodes = [nodes];
    }
    if (nodes.length === 0) {
      return;
    }
    var _nodes = nodes,
      _nodes2 = _slicedToArray(_nodes, 1),
      node = _nodes2[0];
    if (!at) {
      at = getDefaultInsertLocation(editor);
      select = true;
    }
    if (select == null) {
      select = false;
    }
    if (Range.isRange(at)) {
      if (!hanging) {
        at = Editor.unhangRange(editor, at, {
          voids: voids
        });
      }
      if (Range.isCollapsed(at)) {
        at = at.anchor;
      } else {
        var _Range$edges37 = Range.edges(at),
          _Range$edges38 = _slicedToArray(_Range$edges37, 2),
          end = _Range$edges38[1];
        var pointRef = Editor.pointRef(editor, end);
        Transforms["delete"](editor, {
          at: at
        });
        at = pointRef.unref();
      }
    }
    if (Point.isPoint(at)) {
      if (match == null) {
        if (Text.isText(node)) {
          match = function match(n) {
            return Text.isText(n);
          };
        } else if (editor.isInline(node)) {
          match = function match(n) {
            return Text.isText(n) || Editor.isInline(editor, n);
          };
        } else {
          match = function match(n) {
            return Element.isElement(n) && Editor.isBlock(editor, n);
          };
        }
      }
      var _Editor$nodes9 = Editor.nodes(editor, {
          at: at.path,
          match: match,
          mode: mode,
          voids: voids
        }),
        _Editor$nodes10 = _slicedToArray(_Editor$nodes9, 1),
        entry = _Editor$nodes10[0];
      if (entry) {
        var _entry7 = _slicedToArray(entry, 2),
          matchPath = _entry7[1];
        var pathRef = Editor.pathRef(editor, matchPath);
        var isAtEnd = Editor.isEnd(editor, at, matchPath);
        Transforms.splitNodes(editor, {
          at: at,
          match: match,
          mode: mode,
          voids: voids
        });
        var path = pathRef.unref();
        at = isAtEnd ? Path.next(path) : path;
      } else {
        return;
      }
    }
    var parentPath = Path.parent(at);
    var index = at[at.length - 1];
    if (!voids && Editor["void"](editor, {
      at: parentPath
    })) {
      return;
    }
    var _iterator36 = _createForOfIteratorHelper(nodes),
      _step36;
    try {
      for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
        var _node = _step36.value;
        var _path = parentPath.concat(index);
        index++;
        editor.apply({
          type: 'insert_node',
          path: _path,
          node: _node
        });
        at = Path.next(at);
      }
    } catch (err) {
      _iterator36.e(err);
    } finally {
      _iterator36.f();
    }
    at = Path.previous(at);
    if (select) {
      var point = Editor.end(editor, at);
      if (point) {
        Transforms.select(editor, point);
      }
    }
  });
};
var liftNodes = function liftNodes(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Editor.withoutNormalizing(editor, function () {
    var _options$at10 = options.at,
      at = _options$at10 === void 0 ? editor.selection : _options$at10,
      _options$mode6 = options.mode,
      mode = _options$mode6 === void 0 ? 'lowest' : _options$mode6,
      _options$voids13 = options.voids,
      voids = _options$voids13 === void 0 ? false : _options$voids13;
    var match = options.match;
    if (match == null) {
      match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
        return Element.isElement(n) && Editor.isBlock(editor, n);
      };
    }
    if (!at) {
      return;
    }
    var matches = Editor.nodes(editor, {
      at: at,
      match: match,
      mode: mode,
      voids: voids
    });
    var pathRefs = Array.from(matches, function (_ref) {
      var _ref12 = _slicedToArray(_ref, 2),
        p = _ref12[1];
      return Editor.pathRef(editor, p);
    });
    for (var _i2 = 0, _pathRefs = pathRefs; _i2 < _pathRefs.length; _i2++) {
      var pathRef = _pathRefs[_i2];
      var path = pathRef.unref();
      if (path.length < 2) {
        throw new Error("Cannot lift node at a path [".concat(path, "] because it has a depth of less than `2`."));
      }
      var parentNodeEntry = Editor.node(editor, Path.parent(path));
      var _parentNodeEntry = parentNodeEntry,
        _parentNodeEntry2 = _slicedToArray(_parentNodeEntry, 2),
        parent = _parentNodeEntry2[0],
        parentPath = _parentNodeEntry2[1];
      var index = path[path.length - 1];
      var length = parent.children.length;
      if (length === 1) {
        var toPath = Path.next(parentPath);
        Transforms.moveNodes(editor, {
          at: path,
          to: toPath,
          voids: voids
        });
        Transforms.removeNodes(editor, {
          at: parentPath,
          voids: voids
        });
      } else if (index === 0) {
        Transforms.moveNodes(editor, {
          at: path,
          to: parentPath,
          voids: voids
        });
      } else if (index === length - 1) {
        var _toPath = Path.next(parentPath);
        Transforms.moveNodes(editor, {
          at: path,
          to: _toPath,
          voids: voids
        });
      } else {
        var splitPath = Path.next(path);
        var _toPath2 = Path.next(parentPath);
        Transforms.splitNodes(editor, {
          at: splitPath,
          voids: voids
        });
        Transforms.moveNodes(editor, {
          at: path,
          to: _toPath2,
          voids: voids
        });
      }
    }
  });
};
var _excluded = ["text"],
  _excluded2 = ["children"];
var _hasSingleChildNest = function hasSingleChildNest(editor, node) {
  if (Element.isElement(node)) {
    var element = node;
    if (Editor.isVoid(editor, node)) {
      return true;
    } else if (element.children.length === 1) {
      return _hasSingleChildNest(editor, element.children[0]);
    } else {
      return false;
    }
  } else if (Editor.isEditor(node)) {
    return false;
  } else {
    return true;
  }
};
var mergeNodes = function mergeNodes(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Editor.withoutNormalizing(editor, function () {
    var match = options.match,
      _options$at11 = options.at,
      at = _options$at11 === void 0 ? editor.selection : _options$at11;
    var _options$hanging4 = options.hanging,
      hanging = _options$hanging4 === void 0 ? false : _options$hanging4,
      _options$voids14 = options.voids,
      voids = _options$voids14 === void 0 ? false : _options$voids14,
      _options$mode7 = options.mode,
      mode = _options$mode7 === void 0 ? 'lowest' : _options$mode7;
    if (!at) {
      return;
    }
    if (match == null) {
      if (Path.isPath(at)) {
        var _Editor$parent13 = Editor.parent(editor, at),
          _Editor$parent14 = _slicedToArray(_Editor$parent13, 1),
          parent = _Editor$parent14[0];
        match = function match(n) {
          return parent.children.includes(n);
        };
      } else {
        match = function match(n) {
          return Element.isElement(n) && Editor.isBlock(editor, n);
        };
      }
    }
    if (!hanging && Range.isRange(at)) {
      at = Editor.unhangRange(editor, at, {
        voids: voids
      });
    }
    if (Range.isRange(at)) {
      if (Range.isCollapsed(at)) {
        at = at.anchor;
      } else {
        var _Range$edges39 = Range.edges(at),
          _Range$edges40 = _slicedToArray(_Range$edges39, 2),
          end = _Range$edges40[1];
        var pointRef = Editor.pointRef(editor, end);
        Transforms["delete"](editor, {
          at: at
        });
        at = pointRef.unref();
        if (options.at == null) {
          Transforms.select(editor, at);
        }
      }
    }
    var _Editor$nodes11 = Editor.nodes(editor, {
        at: at,
        match: match,
        voids: voids,
        mode: mode
      }),
      _Editor$nodes12 = _slicedToArray(_Editor$nodes11, 1),
      current = _Editor$nodes12[0];
    var prev = Editor.previous(editor, {
      at: at,
      match: match,
      voids: voids,
      mode: mode
    });
    if (!current || !prev) {
      return;
    }
    var _current = _slicedToArray(current, 2),
      node = _current[0],
      path = _current[1];
    var _prev3 = _slicedToArray(prev, 2),
      prevNode = _prev3[0],
      prevPath = _prev3[1];
    if (path.length === 0 || prevPath.length === 0) {
      return;
    }
    var newPath = Path.next(prevPath);
    var commonPath = Path.common(path, prevPath);
    var isPreviousSibling = Path.isSibling(path, prevPath);
    var levels = Array.from(Editor.levels(editor, {
      at: path
    }), function (_ref) {
      var _ref13 = _slicedToArray(_ref, 1),
        n = _ref13[0];
      return n;
    }).slice(commonPath.length).slice(0, -1); // Determine if the merge will leave an ancestor of the path empty as a
    // result, in which case we'll want to remove it after merging.

    var emptyAncestor = Editor.above(editor, {
      at: path,
      mode: 'highest',
      match: function match(n) {
        return levels.includes(n) && _hasSingleChildNest(editor, n);
      }
    });
    var emptyRef = emptyAncestor && Editor.pathRef(editor, emptyAncestor[1]);
    var properties;
    var position; // Ensure that the nodes are equivalent, and figure out what the position
    // and extra properties of the merge will be.

    if (Text.isText(node) && Text.isText(prevNode)) {
      var rest = _objectWithoutProperties(node, _excluded);
      position = prevNode.text.length;
      properties = rest;
    } else if (Element.isElement(node) && Element.isElement(prevNode)) {
      var rest = _objectWithoutProperties(node, _excluded2);
      position = prevNode.children.length;
      properties = rest;
    } else {
      throw new Error("Cannot merge the node at path [".concat(path, "] with the previous sibling because it is not the same kind: ").concat(Scrubber.stringify(node), " ").concat(Scrubber.stringify(prevNode)));
    } // If the node isn't already the next sibling of the previous node, move
    // it so that it is before merging.

    if (!isPreviousSibling) {
      Transforms.moveNodes(editor, {
        at: path,
        to: newPath,
        voids: voids
      });
    } // If there was going to be an empty ancestor of the node that was merged,
    // we remove it from the tree.

    if (emptyRef) {
      Transforms.removeNodes(editor, {
        at: emptyRef.current,
        voids: voids
      });
    } // If the target node that we're merging with is empty, remove it instead
    // of merging the two. This is a common rich text editor behavior to
    // prevent losing formatting when deleting entire nodes when you have a
    // hanging selection.
    // if prevNode is first child in parent,don't remove it.

    if (Element.isElement(prevNode) && Editor.isEmpty(editor, prevNode) || Text.isText(prevNode) && prevNode.text === '' && prevPath[prevPath.length - 1] !== 0) {
      Transforms.removeNodes(editor, {
        at: prevPath,
        voids: voids
      });
    } else {
      editor.apply({
        type: 'merge_node',
        path: newPath,
        position: position,
        properties: properties
      });
    }
    if (emptyRef) {
      emptyRef.unref();
    }
  });
};
var moveNodes = function moveNodes(editor, options) {
  Editor.withoutNormalizing(editor, function () {
    var to = options.to,
      _options$at12 = options.at,
      at = _options$at12 === void 0 ? editor.selection : _options$at12,
      _options$mode8 = options.mode,
      mode = _options$mode8 === void 0 ? 'lowest' : _options$mode8,
      _options$voids15 = options.voids,
      voids = _options$voids15 === void 0 ? false : _options$voids15;
    var match = options.match;
    if (!at) {
      return;
    }
    if (match == null) {
      match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
        return Element.isElement(n) && Editor.isBlock(editor, n);
      };
    }
    var toRef = Editor.pathRef(editor, to);
    var targets = Editor.nodes(editor, {
      at: at,
      match: match,
      mode: mode,
      voids: voids
    });
    var pathRefs = Array.from(targets, function (_ref) {
      var _ref14 = _slicedToArray(_ref, 2),
        p = _ref14[1];
      return Editor.pathRef(editor, p);
    });
    for (var _i3 = 0, _pathRefs2 = pathRefs; _i3 < _pathRefs2.length; _i3++) {
      var pathRef = _pathRefs2[_i3];
      var path = pathRef.unref();
      var newPath = toRef.current;
      if (path.length !== 0) {
        editor.apply({
          type: 'move_node',
          path: path,
          newPath: newPath
        });
      }
      if (toRef.current && Path.isSibling(newPath, path) && Path.isAfter(newPath, path)) {
        // When performing a sibling move to a later index, the path at the destination is shifted
        // to before the insertion point instead of after. To ensure our group of nodes are inserted
        // in the correct order we increment toRef to account for that
        toRef.current = Path.next(toRef.current);
      }
    }
    toRef.unref();
  });
};
var removeNodes = function removeNodes(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Editor.withoutNormalizing(editor, function () {
    var _options$hanging5 = options.hanging,
      hanging = _options$hanging5 === void 0 ? false : _options$hanging5,
      _options$voids16 = options.voids,
      voids = _options$voids16 === void 0 ? false : _options$voids16,
      _options$mode9 = options.mode,
      mode = _options$mode9 === void 0 ? 'lowest' : _options$mode9;
    var _options$at13 = options.at,
      at = _options$at13 === void 0 ? editor.selection : _options$at13,
      match = options.match;
    if (!at) {
      return;
    }
    if (match == null) {
      match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
        return Element.isElement(n) && Editor.isBlock(editor, n);
      };
    }
    if (!hanging && Range.isRange(at)) {
      at = Editor.unhangRange(editor, at, {
        voids: voids
      });
    }
    var depths = Editor.nodes(editor, {
      at: at,
      match: match,
      mode: mode,
      voids: voids
    });
    var pathRefs = Array.from(depths, function (_ref) {
      var _ref15 = _slicedToArray(_ref, 2),
        p = _ref15[1];
      return Editor.pathRef(editor, p);
    });
    for (var _i4 = 0, _pathRefs3 = pathRefs; _i4 < _pathRefs3.length; _i4++) {
      var pathRef = _pathRefs3[_i4];
      var path = pathRef.unref();
      if (path) {
        var _Editor$node7 = Editor.node(editor, path),
          _Editor$node8 = _slicedToArray(_Editor$node7, 1),
          node = _Editor$node8[0];
        editor.apply({
          type: 'remove_node',
          path: path,
          node: node
        });
      }
    }
  });
};
var setNodes = function setNodes(editor, props) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Editor.withoutNormalizing(editor, function () {
    var match = options.match,
      _options$at14 = options.at,
      at = _options$at14 === void 0 ? editor.selection : _options$at14,
      compare = options.compare,
      merge = options.merge;
    var _options$hanging6 = options.hanging,
      hanging = _options$hanging6 === void 0 ? false : _options$hanging6,
      _options$mode10 = options.mode,
      mode = _options$mode10 === void 0 ? 'lowest' : _options$mode10,
      _options$split = options.split,
      split = _options$split === void 0 ? false : _options$split,
      _options$voids17 = options.voids,
      voids = _options$voids17 === void 0 ? false : _options$voids17;
    if (!at) {
      return;
    }
    if (match == null) {
      match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
        return Element.isElement(n) && Editor.isBlock(editor, n);
      };
    }
    if (!hanging && Range.isRange(at)) {
      at = Editor.unhangRange(editor, at, {
        voids: voids
      });
    }
    if (split && Range.isRange(at)) {
      if (Range.isCollapsed(at) && Editor.leaf(editor, at.anchor)[0].text.length > 0) {
        // If the range is collapsed in a non-empty node and 'split' is true, there's nothing to
        // set that won't get normalized away
        return;
      }
      var rangeRef = Editor.rangeRef(editor, at, {
        affinity: 'inward'
      });
      var _Range$edges41 = Range.edges(at),
        _Range$edges42 = _slicedToArray(_Range$edges41, 2),
        start = _Range$edges42[0],
        end = _Range$edges42[1];
      var splitMode = mode === 'lowest' ? 'lowest' : 'highest';
      var endAtEndOfNode = Editor.isEnd(editor, end, end.path);
      Transforms.splitNodes(editor, {
        at: end,
        match: match,
        mode: splitMode,
        voids: voids,
        always: !endAtEndOfNode
      });
      var startAtStartOfNode = Editor.isStart(editor, start, start.path);
      Transforms.splitNodes(editor, {
        at: start,
        match: match,
        mode: splitMode,
        voids: voids,
        always: !startAtStartOfNode
      });
      at = rangeRef.unref();
      if (options.at == null) {
        Transforms.select(editor, at);
      }
    }
    if (!compare) {
      compare = function compare(prop, nodeProp) {
        return prop !== nodeProp;
      };
    }
    var _iterator37 = _createForOfIteratorHelper(Editor.nodes(editor, {
        at: at,
        match: match,
        mode: mode,
        voids: voids
      })),
      _step37;
    try {
      for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
        var _step37$value = _slicedToArray(_step37.value, 2),
          node = _step37$value[0],
          path = _step37$value[1];
        var properties = {};
        var newProperties = {}; // You can't set properties on the editor node.

        if (path.length === 0) {
          continue;
        }
        var hasChanges = false;
        for (var k in props) {
          if (k === 'children' || k === 'text') {
            continue;
          }
          if (compare(props[k], node[k])) {
            hasChanges = true; // Omit new properties from the old properties list

            if (node.hasOwnProperty(k)) properties[k] = node[k]; // Omit properties that have been removed from the new properties list

            if (merge) {
              if (props[k] != null) newProperties[k] = merge(node[k], props[k]);
            } else {
              if (props[k] != null) newProperties[k] = props[k];
            }
          }
        }
        if (hasChanges) {
          editor.apply({
            type: 'set_node',
            path: path,
            properties: properties,
            newProperties: newProperties
          });
        }
      }
    } catch (err) {
      _iterator37.e(err);
    } finally {
      _iterator37.f();
    }
  });
};

/**
 * Convert a range into a point by deleting it's content.
 */

var deleteRange = function deleteRange(editor, range) {
  if (Range.isCollapsed(range)) {
    return range.anchor;
  } else {
    var _Range$edges43 = Range.edges(range),
      _Range$edges44 = _slicedToArray(_Range$edges43, 2),
      end = _Range$edges44[1];
    var pointRef = Editor.pointRef(editor, end);
    Transforms["delete"](editor, {
      at: range
    });
    return pointRef.unref();
  }
};
var splitNodes = function splitNodes(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Editor.withoutNormalizing(editor, function () {
    var _options$mode11 = options.mode,
      mode = _options$mode11 === void 0 ? 'lowest' : _options$mode11,
      _options$voids18 = options.voids,
      voids = _options$voids18 === void 0 ? false : _options$voids18;
    var match = options.match,
      _options$at15 = options.at,
      at = _options$at15 === void 0 ? editor.selection : _options$at15,
      _options$height = options.height,
      height = _options$height === void 0 ? 0 : _options$height,
      _options$always = options.always,
      always = _options$always === void 0 ? false : _options$always;
    if (match == null) {
      match = function match(n) {
        return Element.isElement(n) && Editor.isBlock(editor, n);
      };
    }
    if (Range.isRange(at)) {
      at = deleteRange(editor, at);
    } // If the target is a path, the default height-skipping and position
    // counters need to account for us potentially splitting at a non-leaf.

    if (Path.isPath(at)) {
      var path = at;
      var point = Editor.point(editor, path);
      var _Editor$parent15 = Editor.parent(editor, path),
        _Editor$parent16 = _slicedToArray(_Editor$parent15, 1),
        parent = _Editor$parent16[0];
      match = function match(n) {
        return n === parent;
      };
      height = point.path.length - path.length + 1;
      at = point;
      always = true;
    }
    if (!at) {
      return;
    }
    var beforeRef = Editor.pointRef(editor, at, {
      affinity: 'backward'
    });
    var afterRef;
    try {
      var _Editor$nodes13 = Editor.nodes(editor, {
          at: at,
          match: match,
          mode: mode,
          voids: voids
        }),
        _Editor$nodes14 = _slicedToArray(_Editor$nodes13, 1),
        highest = _Editor$nodes14[0];
      if (!highest) {
        return;
      }
      var voidMatch = Editor["void"](editor, {
        at: at,
        mode: 'highest'
      });
      var nudge = 0;
      if (!voids && voidMatch) {
        var _voidMatch = _slicedToArray(voidMatch, 2),
          voidNode = _voidMatch[0],
          voidPath = _voidMatch[1];
        if (Element.isElement(voidNode) && editor.isInline(voidNode)) {
          var after = Editor.after(editor, voidPath);
          if (!after) {
            var text = {
              text: ''
            };
            var afterPath = Path.next(voidPath);
            Transforms.insertNodes(editor, text, {
              at: afterPath,
              voids: voids
            });
            after = Editor.point(editor, afterPath);
          }
          at = after;
          always = true;
        }
        var siblingHeight = at.path.length - voidPath.length;
        height = siblingHeight + 1;
        always = true;
      }
      afterRef = Editor.pointRef(editor, at);
      var depth = at.path.length - height;
      var _highest = _slicedToArray(highest, 2),
        highestPath = _highest[1];
      var lowestPath = at.path.slice(0, depth);
      var position = height === 0 ? at.offset : at.path[depth] + nudge;
      var _iterator38 = _createForOfIteratorHelper(Editor.levels(editor, {
          at: lowestPath,
          reverse: true,
          voids: voids
        })),
        _step38;
      try {
        for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
          var _step38$value = _slicedToArray(_step38.value, 2),
            node = _step38$value[0],
            _path = _step38$value[1];
          var split = false;
          if (_path.length < highestPath.length || _path.length === 0 || !voids && Element.isElement(node) && Editor.isVoid(editor, node)) {
            break;
          }
          var _point = beforeRef.current;
          var isEnd = Editor.isEnd(editor, _point, _path);
          if (always || !beforeRef || !Editor.isEdge(editor, _point, _path)) {
            split = true;
            var properties = Node.extractProps(node);
            editor.apply({
              type: 'split_node',
              path: _path,
              position: position,
              properties: properties
            });
          }
          position = _path[_path.length - 1] + (split || isEnd ? 1 : 0);
        }
      } catch (err) {
        _iterator38.e(err);
      } finally {
        _iterator38.f();
      }
      if (options.at == null) {
        var _point2 = afterRef.current || Editor.end(editor, []);
        Transforms.select(editor, _point2);
      }
    } finally {
      var _afterRef;
      beforeRef.unref();
      (_afterRef = afterRef) === null || _afterRef === void 0 ? void 0 : _afterRef.unref();
    }
  });
};
var unsetNodes = function unsetNodes(editor, props) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!Array.isArray(props)) {
    props = [props];
  }
  var obj = {};
  var _iterator39 = _createForOfIteratorHelper(props),
    _step39;
  try {
    for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
      var key = _step39.value;
      obj[key] = null;
    }
  } catch (err) {
    _iterator39.e(err);
  } finally {
    _iterator39.f();
  }
  Transforms.setNodes(editor, obj, options);
};
var unwrapNodes = function unwrapNodes(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Editor.withoutNormalizing(editor, function () {
    var _options$mode12 = options.mode,
      mode = _options$mode12 === void 0 ? 'lowest' : _options$mode12,
      _options$split2 = options.split,
      split = _options$split2 === void 0 ? false : _options$split2,
      _options$voids19 = options.voids,
      voids = _options$voids19 === void 0 ? false : _options$voids19;
    var _options$at16 = options.at,
      at = _options$at16 === void 0 ? editor.selection : _options$at16,
      match = options.match;
    if (!at) {
      return;
    }
    if (match == null) {
      match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
        return Element.isElement(n) && Editor.isBlock(editor, n);
      };
    }
    if (Path.isPath(at)) {
      at = Editor.range(editor, at);
    }
    var rangeRef = Range.isRange(at) ? Editor.rangeRef(editor, at) : null;
    var matches = Editor.nodes(editor, {
      at: at,
      match: match,
      mode: mode,
      voids: voids
    });
    var pathRefs = Array.from(matches, function (_ref) {
      var _ref16 = _slicedToArray(_ref, 2),
        p = _ref16[1];
      return Editor.pathRef(editor, p);
    } // unwrapNode will call liftNode which does not support splitting the node when nested.
    // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
    // that wrap target node. So we reverse the order.
    ).reverse();
    var _loop = function _loop(pathRef) {
      var path = pathRef.unref();
      var _Editor$node9 = Editor.node(editor, path),
        _Editor$node10 = _slicedToArray(_Editor$node9, 1),
        node = _Editor$node10[0];
      var range = Editor.range(editor, path);
      if (split && rangeRef) {
        range = Range.intersection(rangeRef.current, range);
      }
      Transforms.liftNodes(editor, {
        at: range,
        match: function match(n) {
          return Element.isAncestor(node) && node.children.includes(n);
        },
        voids: voids
      });
    };
    var _iterator40 = _createForOfIteratorHelper(pathRefs),
      _step40;
    try {
      for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
        var pathRef = _step40.value;
        _loop(pathRef);
      }
    } catch (err) {
      _iterator40.e(err);
    } finally {
      _iterator40.f();
    }
    if (rangeRef) {
      rangeRef.unref();
    }
  });
};
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var wrapNodes = function wrapNodes(editor, element) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Editor.withoutNormalizing(editor, function () {
    var _options$mode13 = options.mode,
      mode = _options$mode13 === void 0 ? 'lowest' : _options$mode13,
      _options$split3 = options.split,
      split = _options$split3 === void 0 ? false : _options$split3,
      _options$voids20 = options.voids,
      voids = _options$voids20 === void 0 ? false : _options$voids20;
    var match = options.match,
      _options$at17 = options.at,
      at = _options$at17 === void 0 ? editor.selection : _options$at17;
    if (!at) {
      return;
    }
    if (match == null) {
      if (Path.isPath(at)) {
        match = matchPath(editor, at);
      } else if (editor.isInline(element)) {
        match = function match(n) {
          return Element.isElement(n) && Editor.isInline(editor, n) || Text.isText(n);
        };
      } else {
        match = function match(n) {
          return Element.isElement(n) && Editor.isBlock(editor, n);
        };
      }
    }
    if (split && Range.isRange(at)) {
      var _Range$edges45 = Range.edges(at),
        _Range$edges46 = _slicedToArray(_Range$edges45, 2),
        start = _Range$edges46[0],
        end = _Range$edges46[1];
      var rangeRef = Editor.rangeRef(editor, at, {
        affinity: 'inward'
      });
      Transforms.splitNodes(editor, {
        at: end,
        match: match,
        voids: voids
      });
      Transforms.splitNodes(editor, {
        at: start,
        match: match,
        voids: voids
      });
      at = rangeRef.unref();
      if (options.at == null) {
        Transforms.select(editor, at);
      }
    }
    var roots = Array.from(Editor.nodes(editor, {
      at: at,
      match: editor.isInline(element) ? function (n) {
        return Element.isElement(n) && Editor.isBlock(editor, n);
      } : function (n) {
        return Editor.isEditor(n);
      },
      mode: 'lowest',
      voids: voids
    }));
    for (var _i5 = 0, _roots = roots; _i5 < _roots.length; _i5++) {
      var _roots$_i = _slicedToArray(_roots[_i5], 2),
        rootPath = _roots$_i[1];
      var a = Range.isRange(at) ? Range.intersection(at, Editor.range(editor, rootPath)) : at;
      if (!a) {
        continue;
      }
      var matches = Array.from(Editor.nodes(editor, {
        at: a,
        match: match,
        mode: mode,
        voids: voids
      }));
      if (matches.length > 0) {
        var _ret = function () {
          var _matches2 = matches,
            _matches3 = _slicedToArray(_matches2, 1),
            first = _matches3[0];
          var last = matches[matches.length - 1];
          var _first = _slicedToArray(first, 2),
            firstPath = _first[1];
          var _last = _slicedToArray(last, 2),
            lastPath = _last[1];
          if (firstPath.length === 0 && lastPath.length === 0) {
            // if there's no matching parent - usually means the node is an editor - don't do anything
            return "continue";
          }
          var commonPath = Path.equals(firstPath, lastPath) ? Path.parent(firstPath) : Path.common(firstPath, lastPath);
          var range = Editor.range(editor, firstPath, lastPath);
          var commonNodeEntry = Editor.node(editor, commonPath);
          var _commonNodeEntry = _slicedToArray(commonNodeEntry, 1),
            commonNode = _commonNodeEntry[0];
          var depth = commonPath.length + 1;
          var wrapperPath = Path.next(lastPath.slice(0, depth));
          var wrapper = _objectSpread(_objectSpread({}, element), {}, {
            children: []
          });
          Transforms.insertNodes(editor, wrapper, {
            at: wrapperPath,
            voids: voids
          });
          Transforms.moveNodes(editor, {
            at: range,
            match: function match(n) {
              return Element.isAncestor(commonNode) && commonNode.children.includes(n);
            },
            to: wrapperPath.concat(0),
            voids: voids
          });
        }();
        if (_ret === "continue") continue;
      }
    }
  });
};

/**
 * Create a new Slate `Editor` object.
 */

var createEditor = function createEditor() {
  var editor = {
    children: [],
    operations: [],
    selection: null,
    marks: null,
    isElementReadOnly: function isElementReadOnly() {
      return false;
    },
    isInline: function isInline() {
      return false;
    },
    isSelectable: function isSelectable() {
      return true;
    },
    isVoid: function isVoid() {
      return false;
    },
    markableVoid: function markableVoid() {
      return false;
    },
    onChange: function onChange() {},
    // Core
    apply: function apply$1() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return apply.apply(void 0, [editor].concat(args));
    },
    // Editor
    addMark: function addMark$1() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return addMark.apply(void 0, [editor].concat(args));
    },
    deleteBackward: function deleteBackward$1() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return deleteBackward.apply(void 0, [editor].concat(args));
    },
    deleteForward: function deleteForward$1() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return deleteForward.apply(void 0, [editor].concat(args));
    },
    deleteFragment: function deleteFragment$1() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      return deleteFragment.apply(void 0, [editor].concat(args));
    },
    getFragment: function getFragment$1() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }
      return getFragment.apply(void 0, [editor].concat(args));
    },
    insertBreak: function insertBreak$1() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      return insertBreak.apply(void 0, [editor].concat(args));
    },
    insertSoftBreak: function insertSoftBreak$1() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }
      return insertSoftBreak.apply(void 0, [editor].concat(args));
    },
    insertFragment: function insertFragment$1() {
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }
      return insertFragment.apply(void 0, [editor].concat(args));
    },
    insertNode: function insertNode$1() {
      for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        args[_key10] = arguments[_key10];
      }
      return insertNode.apply(void 0, [editor].concat(args));
    },
    insertText: function insertText$1() {
      for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        args[_key11] = arguments[_key11];
      }
      return insertText.apply(void 0, [editor].concat(args));
    },
    normalizeNode: function normalizeNode$1() {
      for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        args[_key12] = arguments[_key12];
      }
      return normalizeNode.apply(void 0, [editor].concat(args));
    },
    removeMark: function removeMark$1() {
      for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        args[_key13] = arguments[_key13];
      }
      return removeMark.apply(void 0, [editor].concat(args));
    },
    getDirtyPaths: function getDirtyPaths$1() {
      for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
        args[_key14] = arguments[_key14];
      }
      return getDirtyPaths.apply(void 0, [editor].concat(args));
    },
    shouldNormalize: function shouldNormalize$1() {
      for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
        args[_key15] = arguments[_key15];
      }
      return shouldNormalize.apply(void 0, [editor].concat(args));
    },
    // Editor interface
    above: function above$1() {
      for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
        args[_key16] = arguments[_key16];
      }
      return above.apply(void 0, [editor].concat(args));
    },
    after: function after$1() {
      for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
        args[_key17] = arguments[_key17];
      }
      return after.apply(void 0, [editor].concat(args));
    },
    before: function before$1() {
      for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
        args[_key18] = arguments[_key18];
      }
      return before.apply(void 0, [editor].concat(args));
    },
    collapse: function collapse$1() {
      for (var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
        args[_key19] = arguments[_key19];
      }
      return collapse.apply(void 0, [editor].concat(args));
    },
    "delete": function _delete() {
      for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
        args[_key20] = arguments[_key20];
      }
      return deleteText.apply(void 0, [editor].concat(args));
    },
    deselect: function deselect$1() {
      for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
        args[_key21] = arguments[_key21];
      }
      return deselect.apply(void 0, [editor].concat(args));
    },
    edges: function edges$1() {
      for (var _len22 = arguments.length, args = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
        args[_key22] = arguments[_key22];
      }
      return edges.apply(void 0, [editor].concat(args));
    },
    elementReadOnly: function elementReadOnly$1() {
      for (var _len23 = arguments.length, args = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
        args[_key23] = arguments[_key23];
      }
      return elementReadOnly.apply(void 0, [editor].concat(args));
    },
    end: function end$1() {
      for (var _len24 = arguments.length, args = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
        args[_key24] = arguments[_key24];
      }
      return end.apply(void 0, [editor].concat(args));
    },
    first: function first$1() {
      for (var _len25 = arguments.length, args = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
        args[_key25] = arguments[_key25];
      }
      return first.apply(void 0, [editor].concat(args));
    },
    fragment: function fragment$1() {
      for (var _len26 = arguments.length, args = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
        args[_key26] = arguments[_key26];
      }
      return fragment.apply(void 0, [editor].concat(args));
    },
    getMarks: function getMarks() {
      for (var _len27 = arguments.length, args = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
        args[_key27] = arguments[_key27];
      }
      return marks.apply(void 0, [editor].concat(args));
    },
    hasBlocks: function hasBlocks$1() {
      for (var _len28 = arguments.length, args = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
        args[_key28] = arguments[_key28];
      }
      return hasBlocks.apply(void 0, [editor].concat(args));
    },
    hasInlines: function hasInlines$1() {
      for (var _len29 = arguments.length, args = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
        args[_key29] = arguments[_key29];
      }
      return hasInlines.apply(void 0, [editor].concat(args));
    },
    hasPath: function hasPath$1() {
      for (var _len30 = arguments.length, args = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
        args[_key30] = arguments[_key30];
      }
      return hasPath.apply(void 0, [editor].concat(args));
    },
    hasTexts: function hasTexts$1() {
      for (var _len31 = arguments.length, args = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
        args[_key31] = arguments[_key31];
      }
      return hasTexts.apply(void 0, [editor].concat(args));
    },
    insertNodes: function insertNodes$1() {
      for (var _len32 = arguments.length, args = new Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {
        args[_key32] = arguments[_key32];
      }
      return insertNodes.apply(void 0, [editor].concat(args));
    },
    isBlock: function isBlock$1() {
      for (var _len33 = arguments.length, args = new Array(_len33), _key33 = 0; _key33 < _len33; _key33++) {
        args[_key33] = arguments[_key33];
      }
      return isBlock.apply(void 0, [editor].concat(args));
    },
    isEdge: function isEdge$1() {
      for (var _len34 = arguments.length, args = new Array(_len34), _key34 = 0; _key34 < _len34; _key34++) {
        args[_key34] = arguments[_key34];
      }
      return isEdge.apply(void 0, [editor].concat(args));
    },
    isEmpty: function isEmpty$1() {
      for (var _len35 = arguments.length, args = new Array(_len35), _key35 = 0; _key35 < _len35; _key35++) {
        args[_key35] = arguments[_key35];
      }
      return isEmpty.apply(void 0, [editor].concat(args));
    },
    isEnd: function isEnd$1() {
      for (var _len36 = arguments.length, args = new Array(_len36), _key36 = 0; _key36 < _len36; _key36++) {
        args[_key36] = arguments[_key36];
      }
      return isEnd.apply(void 0, [editor].concat(args));
    },
    isNormalizing: function isNormalizing$1() {
      for (var _len37 = arguments.length, args = new Array(_len37), _key37 = 0; _key37 < _len37; _key37++) {
        args[_key37] = arguments[_key37];
      }
      return isNormalizing.apply(void 0, [editor].concat(args));
    },
    isStart: function isStart$1() {
      for (var _len38 = arguments.length, args = new Array(_len38), _key38 = 0; _key38 < _len38; _key38++) {
        args[_key38] = arguments[_key38];
      }
      return isStart.apply(void 0, [editor].concat(args));
    },
    last: function last$1() {
      for (var _len39 = arguments.length, args = new Array(_len39), _key39 = 0; _key39 < _len39; _key39++) {
        args[_key39] = arguments[_key39];
      }
      return last.apply(void 0, [editor].concat(args));
    },
    leaf: function leaf$1() {
      for (var _len40 = arguments.length, args = new Array(_len40), _key40 = 0; _key40 < _len40; _key40++) {
        args[_key40] = arguments[_key40];
      }
      return leaf.apply(void 0, [editor].concat(args));
    },
    levels: function levels$1() {
      for (var _len41 = arguments.length, args = new Array(_len41), _key41 = 0; _key41 < _len41; _key41++) {
        args[_key41] = arguments[_key41];
      }
      return levels.apply(void 0, [editor].concat(args));
    },
    liftNodes: function liftNodes$1() {
      for (var _len42 = arguments.length, args = new Array(_len42), _key42 = 0; _key42 < _len42; _key42++) {
        args[_key42] = arguments[_key42];
      }
      return liftNodes.apply(void 0, [editor].concat(args));
    },
    mergeNodes: function mergeNodes$1() {
      for (var _len43 = arguments.length, args = new Array(_len43), _key43 = 0; _key43 < _len43; _key43++) {
        args[_key43] = arguments[_key43];
      }
      return mergeNodes.apply(void 0, [editor].concat(args));
    },
    move: function move$1() {
      for (var _len44 = arguments.length, args = new Array(_len44), _key44 = 0; _key44 < _len44; _key44++) {
        args[_key44] = arguments[_key44];
      }
      return move.apply(void 0, [editor].concat(args));
    },
    moveNodes: function moveNodes$1() {
      for (var _len45 = arguments.length, args = new Array(_len45), _key45 = 0; _key45 < _len45; _key45++) {
        args[_key45] = arguments[_key45];
      }
      return moveNodes.apply(void 0, [editor].concat(args));
    },
    next: function next$1() {
      for (var _len46 = arguments.length, args = new Array(_len46), _key46 = 0; _key46 < _len46; _key46++) {
        args[_key46] = arguments[_key46];
      }
      return next.apply(void 0, [editor].concat(args));
    },
    node: function node$1() {
      for (var _len47 = arguments.length, args = new Array(_len47), _key47 = 0; _key47 < _len47; _key47++) {
        args[_key47] = arguments[_key47];
      }
      return node.apply(void 0, [editor].concat(args));
    },
    nodes: function nodes$1() {
      for (var _len48 = arguments.length, args = new Array(_len48), _key48 = 0; _key48 < _len48; _key48++) {
        args[_key48] = arguments[_key48];
      }
      return nodes.apply(void 0, [editor].concat(args));
    },
    normalize: function normalize$1() {
      for (var _len49 = arguments.length, args = new Array(_len49), _key49 = 0; _key49 < _len49; _key49++) {
        args[_key49] = arguments[_key49];
      }
      return normalize.apply(void 0, [editor].concat(args));
    },
    parent: function parent$1() {
      for (var _len50 = arguments.length, args = new Array(_len50), _key50 = 0; _key50 < _len50; _key50++) {
        args[_key50] = arguments[_key50];
      }
      return parent.apply(void 0, [editor].concat(args));
    },
    path: function path$1() {
      for (var _len51 = arguments.length, args = new Array(_len51), _key51 = 0; _key51 < _len51; _key51++) {
        args[_key51] = arguments[_key51];
      }
      return path.apply(void 0, [editor].concat(args));
    },
    pathRef: function pathRef$1() {
      for (var _len52 = arguments.length, args = new Array(_len52), _key52 = 0; _key52 < _len52; _key52++) {
        args[_key52] = arguments[_key52];
      }
      return pathRef.apply(void 0, [editor].concat(args));
    },
    pathRefs: function pathRefs$1() {
      for (var _len53 = arguments.length, args = new Array(_len53), _key53 = 0; _key53 < _len53; _key53++) {
        args[_key53] = arguments[_key53];
      }
      return pathRefs.apply(void 0, [editor].concat(args));
    },
    point: function point$1() {
      for (var _len54 = arguments.length, args = new Array(_len54), _key54 = 0; _key54 < _len54; _key54++) {
        args[_key54] = arguments[_key54];
      }
      return point.apply(void 0, [editor].concat(args));
    },
    pointRef: function pointRef$1() {
      for (var _len55 = arguments.length, args = new Array(_len55), _key55 = 0; _key55 < _len55; _key55++) {
        args[_key55] = arguments[_key55];
      }
      return pointRef.apply(void 0, [editor].concat(args));
    },
    pointRefs: function pointRefs$1() {
      for (var _len56 = arguments.length, args = new Array(_len56), _key56 = 0; _key56 < _len56; _key56++) {
        args[_key56] = arguments[_key56];
      }
      return pointRefs.apply(void 0, [editor].concat(args));
    },
    positions: function positions$1() {
      for (var _len57 = arguments.length, args = new Array(_len57), _key57 = 0; _key57 < _len57; _key57++) {
        args[_key57] = arguments[_key57];
      }
      return positions.apply(void 0, [editor].concat(args));
    },
    previous: function previous$1() {
      for (var _len58 = arguments.length, args = new Array(_len58), _key58 = 0; _key58 < _len58; _key58++) {
        args[_key58] = arguments[_key58];
      }
      return previous.apply(void 0, [editor].concat(args));
    },
    range: function range$1() {
      for (var _len59 = arguments.length, args = new Array(_len59), _key59 = 0; _key59 < _len59; _key59++) {
        args[_key59] = arguments[_key59];
      }
      return range.apply(void 0, [editor].concat(args));
    },
    rangeRef: function rangeRef$1() {
      for (var _len60 = arguments.length, args = new Array(_len60), _key60 = 0; _key60 < _len60; _key60++) {
        args[_key60] = arguments[_key60];
      }
      return rangeRef.apply(void 0, [editor].concat(args));
    },
    rangeRefs: function rangeRefs$1() {
      for (var _len61 = arguments.length, args = new Array(_len61), _key61 = 0; _key61 < _len61; _key61++) {
        args[_key61] = arguments[_key61];
      }
      return rangeRefs.apply(void 0, [editor].concat(args));
    },
    removeNodes: function removeNodes$1() {
      for (var _len62 = arguments.length, args = new Array(_len62), _key62 = 0; _key62 < _len62; _key62++) {
        args[_key62] = arguments[_key62];
      }
      return removeNodes.apply(void 0, [editor].concat(args));
    },
    select: function select$1() {
      for (var _len63 = arguments.length, args = new Array(_len63), _key63 = 0; _key63 < _len63; _key63++) {
        args[_key63] = arguments[_key63];
      }
      return select.apply(void 0, [editor].concat(args));
    },
    setNodes: function setNodes$1() {
      for (var _len64 = arguments.length, args = new Array(_len64), _key64 = 0; _key64 < _len64; _key64++) {
        args[_key64] = arguments[_key64];
      }
      return setNodes.apply(void 0, [editor].concat(args));
    },
    setNormalizing: function setNormalizing$1() {
      for (var _len65 = arguments.length, args = new Array(_len65), _key65 = 0; _key65 < _len65; _key65++) {
        args[_key65] = arguments[_key65];
      }
      return setNormalizing.apply(void 0, [editor].concat(args));
    },
    setPoint: function setPoint$1() {
      for (var _len66 = arguments.length, args = new Array(_len66), _key66 = 0; _key66 < _len66; _key66++) {
        args[_key66] = arguments[_key66];
      }
      return setPoint.apply(void 0, [editor].concat(args));
    },
    setSelection: function setSelection$1() {
      for (var _len67 = arguments.length, args = new Array(_len67), _key67 = 0; _key67 < _len67; _key67++) {
        args[_key67] = arguments[_key67];
      }
      return setSelection.apply(void 0, [editor].concat(args));
    },
    splitNodes: function splitNodes$1() {
      for (var _len68 = arguments.length, args = new Array(_len68), _key68 = 0; _key68 < _len68; _key68++) {
        args[_key68] = arguments[_key68];
      }
      return splitNodes.apply(void 0, [editor].concat(args));
    },
    start: function start$1() {
      for (var _len69 = arguments.length, args = new Array(_len69), _key69 = 0; _key69 < _len69; _key69++) {
        args[_key69] = arguments[_key69];
      }
      return start.apply(void 0, [editor].concat(args));
    },
    string: function string$1() {
      for (var _len70 = arguments.length, args = new Array(_len70), _key70 = 0; _key70 < _len70; _key70++) {
        args[_key70] = arguments[_key70];
      }
      return string.apply(void 0, [editor].concat(args));
    },
    unhangRange: function unhangRange$1() {
      for (var _len71 = arguments.length, args = new Array(_len71), _key71 = 0; _key71 < _len71; _key71++) {
        args[_key71] = arguments[_key71];
      }
      return unhangRange.apply(void 0, [editor].concat(args));
    },
    unsetNodes: function unsetNodes$1() {
      for (var _len72 = arguments.length, args = new Array(_len72), _key72 = 0; _key72 < _len72; _key72++) {
        args[_key72] = arguments[_key72];
      }
      return unsetNodes.apply(void 0, [editor].concat(args));
    },
    unwrapNodes: function unwrapNodes$1() {
      for (var _len73 = arguments.length, args = new Array(_len73), _key73 = 0; _key73 < _len73; _key73++) {
        args[_key73] = arguments[_key73];
      }
      return unwrapNodes.apply(void 0, [editor].concat(args));
    },
    "void": function _void() {
      for (var _len74 = arguments.length, args = new Array(_len74), _key74 = 0; _key74 < _len74; _key74++) {
        args[_key74] = arguments[_key74];
      }
      return getVoid.apply(void 0, [editor].concat(args));
    },
    withoutNormalizing: function withoutNormalizing$1() {
      for (var _len75 = arguments.length, args = new Array(_len75), _key75 = 0; _key75 < _len75; _key75++) {
        args[_key75] = arguments[_key75];
      }
      return withoutNormalizing.apply(void 0, [editor].concat(args));
    },
    wrapNodes: function wrapNodes$1() {
      for (var _len76 = arguments.length, args = new Array(_len76), _key76 = 0; _key76 < _len76; _key76++) {
        args[_key76] = arguments[_key76];
      }
      return wrapNodes.apply(void 0, [editor].concat(args));
    }
  };
  return editor;
};

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}

function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject;

/** Detect free variable `global` from Node.js. */
var freeGlobal = _typeof(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return _root.Date.now();
};
var now_1 = now;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}
var _trimmedEndIndex = trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
var _baseTrim = baseTrim;

/** Built-in value references. */
var _Symbol2 = _root.Symbol;
var _Symbol = _Symbol2;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? _getRawTag(value) : _objectToString(value);
}
var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && _typeof(value) == 'object';
}
var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag;
}
var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }
  function debounced() {
    var time = now_1(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject_1(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce_1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}
var throttle_1 = throttle;

var lib = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  /**
   * Constants.
   */

  var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
  var MODIFIERS = {
    alt: 'altKey',
    control: 'ctrlKey',
    meta: 'metaKey',
    shift: 'shiftKey'
  };
  var ALIASES = {
    add: '+',
    "break": 'pause',
    cmd: 'meta',
    command: 'meta',
    ctl: 'control',
    ctrl: 'control',
    del: 'delete',
    down: 'arrowdown',
    esc: 'escape',
    ins: 'insert',
    left: 'arrowleft',
    mod: IS_MAC ? 'meta' : 'control',
    opt: 'alt',
    option: 'alt',
    "return": 'enter',
    right: 'arrowright',
    space: ' ',
    spacebar: ' ',
    up: 'arrowup',
    win: 'meta',
    windows: 'meta'
  };
  var CODES = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    control: 17,
    alt: 18,
    pause: 19,
    capslock: 20,
    escape: 27,
    ' ': 32,
    pageup: 33,
    pagedown: 34,
    end: 35,
    home: 36,
    arrowleft: 37,
    arrowup: 38,
    arrowright: 39,
    arrowdown: 40,
    insert: 45,
    "delete": 46,
    meta: 91,
    numlock: 144,
    scrolllock: 145,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    '\'': 222
  };
  for (var f = 1; f < 20; f++) {
    CODES['f' + f] = 111 + f;
  }

  /**
   * Is hotkey?
   */

  function isHotkey(hotkey, options, event) {
    if (options && !('byKey' in options)) {
      event = options;
      options = null;
    }
    if (!Array.isArray(hotkey)) {
      hotkey = [hotkey];
    }
    var array = hotkey.map(function (string) {
      return parseHotkey(string, options);
    });
    var check = function check(e) {
      return array.some(function (object) {
        return compareHotkey(object, e);
      });
    };
    var ret = event == null ? check : check(event);
    return ret;
  }
  function isCodeHotkey(hotkey, event) {
    return isHotkey(hotkey, event);
  }
  function isKeyHotkey(hotkey, event) {
    return isHotkey(hotkey, {
      byKey: true
    }, event);
  }

  /**
   * Parse.
   */

  function parseHotkey(hotkey, options) {
    var byKey = options && options.byKey;
    var ret = {};

    // Special case to handle the `+` key since we use it as a separator.
    hotkey = hotkey.replace('++', '+add');
    var values = hotkey.split('+');
    var length = values.length;

    // Ensure that all the modifiers are set to false unless the hotkey has them.

    for (var k in MODIFIERS) {
      ret[MODIFIERS[k]] = false;
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
      for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var value = _step.value;
        var optional = value.endsWith('?') && value.length > 1;
        if (optional) {
          value = value.slice(0, -1);
        }
        var name = toKeyName(value);
        var modifier = MODIFIERS[name];
        if (value.length > 1 && !modifier && !ALIASES[value] && !CODES[name]) {
          throw new TypeError('Unknown modifier: "' + value + '"');
        }
        if (length === 1 || !modifier) {
          if (byKey) {
            ret.key = name;
          } else {
            ret.which = toKeyCode(value);
          }
        }
        if (modifier) {
          ret[modifier] = optional ? null : true;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"]) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    return ret;
  }

  /**
   * Compare.
   */

  function compareHotkey(object, event) {
    for (var key in object) {
      var expected = object[key];
      var actual = void 0;
      if (expected == null) {
        continue;
      }
      if (key === 'key' && event.key != null) {
        actual = event.key.toLowerCase();
      } else if (key === 'which') {
        actual = expected === 91 && event.which === 93 ? 91 : event.which;
      } else {
        actual = event[key];
      }
      if (actual == null && expected === false) {
        continue;
      }
      if (actual !== expected) {
        return false;
      }
    }
    return true;
  }

  /**
   * Utils.
   */

  function toKeyCode(name) {
    name = toKeyName(name);
    var code = CODES[name] || name.toUpperCase().charCodeAt(0);
    return code;
  }
  function toKeyName(name) {
    name = name.toLowerCase();
    name = ALIASES[name] || name;
    return name;
  }

  /**
   * Export.
   */

  exports["default"] = isHotkey;
  exports.isHotkey = isHotkey;
  exports.isCodeHotkey = isCodeHotkey;
  exports.isKeyHotkey = isKeyHotkey;
  exports.parseHotkey = parseHotkey;
  exports.compareHotkey = compareHotkey;
  exports.toKeyCode = toKeyCode;
  exports.toKeyName = toKeyName;
});
unwrapExports(lib);
lib.isHotkey;
lib.isCodeHotkey;
var lib_3 = lib.isKeyHotkey;
lib.parseHotkey;
lib.compareHotkey;
lib.toKeyCode;
lib.toKeyName;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

export { AnchorType as A, BoxKind as B, CoordinateZero as C, DocumentNode as D, Editor as E, Text as F, __rest as G, Scrubber as H, InlineNode as I, _defineProperty$1 as J, _typeof as K, LineSpacingType as L, createEditor as M, ListFormat as N, DocSizeType as O, ParagraphNode as P, traverseLayoutBoxWithHandlers as Q, Range as R, SpanProperty as S, TextNode as T, traverseLayoutBoxesWithHandlers as U, VerticalType as V, WhiteSpaceType as W, _inherits as _, _createClass as a, _classCallCheck as b, _getPrototypeOf as c, _possibleConstructorReturn as d, _toConsumableArray as e, InlineProperty as f, TextAlignmentType as g, ParaProperty as h, ListProperty as i, DocumentProperty as j, TailWhitespaceCalculation as k, LineExpandDirection as l, TextRunMeasureEngine as m, TextLayoutEngine as n, AbstractLayoutAdapter as o, pxToTwips as p, _slicedToArray as q, throttle_1 as r, styleInject as s, twipsToPx as t, _get as u, Transforms as v, Point as w, lib_3 as x, Path as y, Element as z };
//# sourceMappingURL=vendor-bedf3a45.esm.js.map
